// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/projectdata.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, protoInt64, Timestamp } from "@bufbuild/protobuf";
import { DocumentBlock, PaginationRequest, PaginationResponse, RequestMetadata, ReviewItem, WriteAttribution } from "../../common/v1/types_pb";
import { PricingRateSelection, PricingReconciliationProposal, PricingScenarioVersion, PricingWorkbook } from "../../datagateway/v1/proposal_pricing_pb";
import { AwardedContractData, ParsedModificationV2, SourceMetadata } from "../../contractintel/v1/contractintel_pb";
import { IntelligenceRun } from "../../intelligence/v1/intelligence_pb";
import { GraphSourceStatus } from "../../datagateway/v1/govcon_graph_pb";
import { SolicitationImpact } from "../../datagateway/v1/proposal_amendment_pb";
import { AssignedAction } from "../../datagateway/v1/delivery_pb";
import { ComplianceResponseLocation } from "../../datagateway/v1/proposal_compliance_pb";
import { LandscapePatternState } from "../../datagateway/v1/landscape_pb";
/**
 * @generated from enum mono.projectdata.v1.ProjectType
 */ export var ProjectType = /*#__PURE__*/ function(ProjectType) {
    /**
   * @generated from enum value: PROJECT_TYPE_UNSPECIFIED = 0;
   */ ProjectType[ProjectType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: PROJECT_TYPE_GENERAL = 1;
   */ ProjectType[ProjectType["GENERAL"] = 1] = "GENERAL";
    /**
   * @generated from enum value: PROJECT_TYPE_PROPOSAL = 2;
   */ ProjectType[ProjectType["PROPOSAL"] = 2] = "PROPOSAL";
    /**
   * @generated from enum value: PROJECT_TYPE_CONTRACT = 3;
   */ ProjectType[ProjectType["CONTRACT"] = 3] = "CONTRACT";
    /**
   * Pre-solicitation capture workspace (Phase 1 — CTO vision §4). Holds
   * customer shaping, RFIs, vehicle hypotheses, and the 8 capture workstreams
   * before a solicitation exists. Backed by the govcon schema in pangaea.
   *
   * @generated from enum value: PROJECT_TYPE_CAPTURE = 4;
   */ ProjectType[ProjectType["CAPTURE"] = 4] = "CAPTURE";
    /**
   * Pre-Award readiness workspace spawned by ConvertProposalToPreAward. The
   * canonical SDS row lives in pangaea.delivery.pre_award_projects; this is
   * the sibling zou Project type tag. See major-push/phase-4.md (Phase 4a).
   * Value 5: PROJECT_TYPE_CAPTURE took 4 on the Phase 1a branch this rebased
   * onto (the enum-number coordination called out in phase-4.md).
   *
   * @generated from enum value: PROJECT_TYPE_PRE_AWARD = 5;
   */ ProjectType[ProjectType["PRE_AWARD"] = 5] = "PRE_AWARD";
    /**
   * Collaborative workspace for answering gov Notice(type=rfi). Spawned via
   * CreateRfiResponseProject; links M:N to pursuits (P-L3).
   *
   * @generated from enum value: PROJECT_TYPE_RFI_RESPONSE = 6;
   */ ProjectType[ProjectType["RFI_RESPONSE"] = 6] = "RFI_RESPONSE";
    return ProjectType;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ProjectType)
proto3.util.setEnumType(ProjectType, "mono.projectdata.v1.ProjectType", [
    {
        no: 0,
        name: "PROJECT_TYPE_UNSPECIFIED"
    },
    {
        no: 1,
        name: "PROJECT_TYPE_GENERAL"
    },
    {
        no: 2,
        name: "PROJECT_TYPE_PROPOSAL"
    },
    {
        no: 3,
        name: "PROJECT_TYPE_CONTRACT"
    },
    {
        no: 4,
        name: "PROJECT_TYPE_CAPTURE"
    },
    {
        no: 5,
        name: "PROJECT_TYPE_PRE_AWARD"
    },
    {
        no: 6,
        name: "PROJECT_TYPE_RFI_RESPONSE"
    }
]);
/**
 * CaptureWorkstreamType enumerates the 8 capture workstreams from CTO vision
 * §4. A capture_workstream_items row is typed by one of these values.
 *
 * @generated from enum mono.projectdata.v1.CaptureWorkstreamType
 */ export var CaptureWorkstreamType = /*#__PURE__*/ function(CaptureWorkstreamType) {
    /**
   * @generated from enum value: CAPTURE_WORKSTREAM_TYPE_UNSPECIFIED = 0;
   */ CaptureWorkstreamType[CaptureWorkstreamType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: CAPTURE_WORKSTREAM_TYPE_CUSTOMER_SHAPING = 1;
   */ CaptureWorkstreamType[CaptureWorkstreamType["CUSTOMER_SHAPING"] = 1] = "CUSTOMER_SHAPING";
    /**
   * @generated from enum value: CAPTURE_WORKSTREAM_TYPE_STRUCTURING_HYPOTHESIS = 2;
   */ CaptureWorkstreamType[CaptureWorkstreamType["STRUCTURING_HYPOTHESIS"] = 2] = "STRUCTURING_HYPOTHESIS";
    /**
   * @generated from enum value: CAPTURE_WORKSTREAM_TYPE_RFI_MARKET_RESEARCH = 3;
   */ CaptureWorkstreamType[CaptureWorkstreamType["RFI_MARKET_RESEARCH"] = 3] = "RFI_MARKET_RESEARCH";
    /**
   * @generated from enum value: CAPTURE_WORKSTREAM_TYPE_SOLUTIONING = 4;
   */ CaptureWorkstreamType[CaptureWorkstreamType["SOLUTIONING"] = 4] = "SOLUTIONING";
    /**
   * @generated from enum value: CAPTURE_WORKSTREAM_TYPE_BLACK_HAT = 5;
   */ CaptureWorkstreamType[CaptureWorkstreamType["BLACK_HAT"] = 5] = "BLACK_HAT";
    /**
   * @generated from enum value: CAPTURE_WORKSTREAM_TYPE_TEAM_BUILDING = 6;
   */ CaptureWorkstreamType[CaptureWorkstreamType["TEAM_BUILDING"] = 6] = "TEAM_BUILDING";
    /**
   * @generated from enum value: CAPTURE_WORKSTREAM_TYPE_HIRING_READINESS = 7;
   */ CaptureWorkstreamType[CaptureWorkstreamType["HIRING_READINESS"] = 7] = "HIRING_READINESS";
    /**
   * @generated from enum value: CAPTURE_WORKSTREAM_TYPE_CAPTURE_ARTIFACTS = 8;
   */ CaptureWorkstreamType[CaptureWorkstreamType["CAPTURE_ARTIFACTS"] = 8] = "CAPTURE_ARTIFACTS";
    return CaptureWorkstreamType;
}({});
// Retrieve enum metadata with: proto3.getEnumType(CaptureWorkstreamType)
proto3.util.setEnumType(CaptureWorkstreamType, "mono.projectdata.v1.CaptureWorkstreamType", [
    {
        no: 0,
        name: "CAPTURE_WORKSTREAM_TYPE_UNSPECIFIED"
    },
    {
        no: 1,
        name: "CAPTURE_WORKSTREAM_TYPE_CUSTOMER_SHAPING"
    },
    {
        no: 2,
        name: "CAPTURE_WORKSTREAM_TYPE_STRUCTURING_HYPOTHESIS"
    },
    {
        no: 3,
        name: "CAPTURE_WORKSTREAM_TYPE_RFI_MARKET_RESEARCH"
    },
    {
        no: 4,
        name: "CAPTURE_WORKSTREAM_TYPE_SOLUTIONING"
    },
    {
        no: 5,
        name: "CAPTURE_WORKSTREAM_TYPE_BLACK_HAT"
    },
    {
        no: 6,
        name: "CAPTURE_WORKSTREAM_TYPE_TEAM_BUILDING"
    },
    {
        no: 7,
        name: "CAPTURE_WORKSTREAM_TYPE_HIRING_READINESS"
    },
    {
        no: 8,
        name: "CAPTURE_WORKSTREAM_TYPE_CAPTURE_ARTIFACTS"
    }
]);
/**
 * Which contract document shape to re-run extraction for. BASE re-runs
 * AnalyzeContract/CLINs/sync; MODIFICATION re-runs AnalyzeModificationV2 and
 * stages a new Modification ContractChangeSet.
 *
 * @generated from enum mono.projectdata.v1.ReprocessDocumentKind
 */ export var ReprocessDocumentKind = /*#__PURE__*/ function(ReprocessDocumentKind) {
    /**
   * @generated from enum value: REPROCESS_DOCUMENT_KIND_UNSPECIFIED = 0;
   */ ReprocessDocumentKind[ReprocessDocumentKind["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: REPROCESS_DOCUMENT_KIND_BASE = 1;
   */ ReprocessDocumentKind[ReprocessDocumentKind["BASE"] = 1] = "BASE";
    /**
   * @generated from enum value: REPROCESS_DOCUMENT_KIND_MODIFICATION = 2;
   */ ReprocessDocumentKind[ReprocessDocumentKind["MODIFICATION"] = 2] = "MODIFICATION";
    /**
   * A SOW or execution plan for the project's program (S8): read against the
   * program's teams and duties when the tenant's robin_extraction flag is on.
   *
   * @generated from enum value: REPROCESS_DOCUMENT_KIND_SOW = 3;
   */ ReprocessDocumentKind[ReprocessDocumentKind["SOW"] = 3] = "SOW";
    /**
   * An attachment or addendum of the project's award (a deliverables
   * schedule, say): stored with its blocks and read with the award, never
   * built as a contract nor refused as one. Upload only; re-extract reads
   * awards and modifications.
   *
   * @generated from enum value: REPROCESS_DOCUMENT_KIND_ATTACHMENT = 4;
   */ ReprocessDocumentKind[ReprocessDocumentKind["ATTACHMENT"] = 4] = "ATTACHMENT";
    return ReprocessDocumentKind;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ReprocessDocumentKind)
proto3.util.setEnumType(ReprocessDocumentKind, "mono.projectdata.v1.ReprocessDocumentKind", [
    {
        no: 0,
        name: "REPROCESS_DOCUMENT_KIND_UNSPECIFIED"
    },
    {
        no: 1,
        name: "REPROCESS_DOCUMENT_KIND_BASE"
    },
    {
        no: 2,
        name: "REPROCESS_DOCUMENT_KIND_MODIFICATION"
    },
    {
        no: 3,
        name: "REPROCESS_DOCUMENT_KIND_SOW"
    },
    {
        no: 4,
        name: "REPROCESS_DOCUMENT_KIND_ATTACHMENT"
    }
]);
/**
 * @generated from message mono.projectdata.v1.GetProjectGovConSnapshotRequest
 */ export class GetProjectGovConSnapshotRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetProjectGovConSnapshotRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProjectGovConSnapshotRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProjectGovConSnapshotRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProjectGovConSnapshotRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProjectGovConSnapshotRequest, "runtime", proto3);
_define_property(GetProjectGovConSnapshotRequest, "typeName", "mono.projectdata.v1.GetProjectGovConSnapshotRequest");
_define_property(GetProjectGovConSnapshotRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetProjectGovConSnapshotResponse
 */ export class GetProjectGovConSnapshotResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetProjectGovConSnapshotResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProjectGovConSnapshotResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProjectGovConSnapshotResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProjectGovConSnapshotResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.ProjectInfo project = 1;
   */ _define_property(this, "project", void 0), /**
   * @generated from field: mono.projectdata.v1.ComplianceMatrixStats compliance_stats = 2;
   */ _define_property(this, "complianceStats", void 0), /**
   * @generated from field: mono.projectdata.v1.CLINSummaryStats clin_stats = 3;
   */ _define_property(this, "clinStats", void 0), /**
   * @generated from field: mono.projectdata.v1.DeliverableQueryStats deliverable_stats = 4;
   */ _define_property(this, "deliverableStats", void 0), /**
   * @generated from field: int32 total_source_documents = 5;
   */ _define_property(this, "totalSourceDocuments", 0), /**
   * @generated from field: int32 total_amendments = 6;
   */ _define_property(this, "totalAmendments", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProjectGovConSnapshotResponse, "runtime", proto3);
_define_property(GetProjectGovConSnapshotResponse, "typeName", "mono.projectdata.v1.GetProjectGovConSnapshotResponse");
_define_property(GetProjectGovConSnapshotResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project",
            kind: "message",
            T: ProjectInfo
        },
        {
            no: 2,
            name: "compliance_stats",
            kind: "message",
            T: ComplianceMatrixStats
        },
        {
            no: 3,
            name: "clin_stats",
            kind: "message",
            T: CLINSummaryStats
        },
        {
            no: 4,
            name: "deliverable_stats",
            kind: "message",
            T: DeliverableQueryStats
        },
        {
            no: 5,
            name: "total_source_documents",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "total_amendments",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * CLINSummaryStats provides aggregate CLIN metrics for the snapshot.
 *
 * @generated from message mono.projectdata.v1.CLINSummaryStats
 */ export class CLINSummaryStats extends Message {
    static fromBinary(bytes, options) {
        return new CLINSummaryStats().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CLINSummaryStats().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CLINSummaryStats().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CLINSummaryStats, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 total_clins = 1;
   */ _define_property(this, "totalClins", 0), /**
   * @generated from field: repeated string clin_numbers = 2;
   */ _define_property(this, "clinNumbers", []), /**
   * @generated from field: double total_value = 3;
   */ _define_property(this, "totalValue", 0), /**
   * @generated from field: double total_funded = 4;
   */ _define_property(this, "totalFunded", 0), /**
   * @generated from field: map<string, int32> by_option_type = 5;
   */ _define_property(this, "byOptionType", {}), /**
   * @generated from field: map<string, int32> by_contract_type = 6;
   */ _define_property(this, "byContractType", {}), /**
   * @generated from field: map<string, int32> by_funding_status = 7;
   */ _define_property(this, "byFundingStatus", {});
        proto3.util.initPartial(data, this);
    }
}
_define_property(CLINSummaryStats, "runtime", proto3);
_define_property(CLINSummaryStats, "typeName", "mono.projectdata.v1.CLINSummaryStats");
_define_property(CLINSummaryStats, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "total_clins",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "clin_numbers",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 3,
            name: "total_value",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 4,
            name: "total_funded",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 5,
            name: "by_option_type",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "scalar",
                T: 5 /* ScalarType.INT32 */ 
            }
        },
        {
            no: 6,
            name: "by_contract_type",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "scalar",
                T: 5 /* ScalarType.INT32 */ 
            }
        },
        {
            no: 7,
            name: "by_funding_status",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "scalar",
                T: 5 /* ScalarType.INT32 */ 
            }
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ProjectInfo
 */ export class ProjectInfo extends Message {
    static fromBinary(bytes, options) {
        return new ProjectInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProjectInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProjectInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProjectInfo, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string description = 3;
   */ _define_property(this, "description", ""), /**
   * @generated from field: mono.projectdata.v1.ProjectType type = 4;
   */ _define_property(this, "type", 0), /**
   * @generated from field: string company_id = 5;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string status = 6;
   */ _define_property(this, "status", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 8;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp last_activity_at = 9;
   */ _define_property(this, "lastActivityAt", void 0), /**
   * Type-specific data (only one populated based on type).
   *
   * @generated from field: mono.projectdata.v1.ProposalInfo proposal_info = 10;
   */ _define_property(this, "proposalInfo", void 0), /**
   * @generated from field: mono.projectdata.v1.ContractInfo contract_info = 11;
   */ _define_property(this, "contractInfo", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProjectInfo, "runtime", proto3);
_define_property(ProjectInfo, "typeName", "mono.projectdata.v1.ProjectInfo");
_define_property(ProjectInfo, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "type",
            kind: "enum",
            T: proto3.getEnumType(ProjectType)
        },
        {
            no: 5,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "last_activity_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "proposal_info",
            kind: "message",
            T: ProposalInfo
        },
        {
            no: 11,
            name: "contract_info",
            kind: "message",
            T: ContractInfo
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ProposalInfo
 */ export class ProposalInfo extends Message {
    static fromBinary(bytes, options) {
        return new ProposalInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposalInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposalInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposalInfo, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string solicitation_number = 1;
   */ _define_property(this, "solicitationNumber", ""), /**
   * @generated from field: string agency = 2;
   */ _define_property(this, "agency", ""), /**
   * @generated from field: google.protobuf.Timestamp due_date = 3;
   */ _define_property(this, "dueDate", void 0), /**
   * intake, analysis, drafting, review, submitted
   *
   * @generated from field: string stage = 4;
   */ _define_property(this, "stage", ""), /**
   * @generated from field: mono.projectdata.v1.ProcessingStatus processing = 5;
   */ _define_property(this, "processing", void 0), /**
   * Phase 3 additions
   *
   * @generated from field: mono.projectdata.v1.AgencyInfo agency_info = 6;
   */ _define_property(this, "agencyInfo", void 0), /**
   * @generated from field: string naics_code = 7;
   */ _define_property(this, "naicsCode", ""), /**
   * small_business, 8a, hubzone, sdvosb, wosb, unrestricted, other
   *
   * @generated from field: string set_aside = 8;
   */ _define_property(this, "setAside", ""), /**
   * 1 = legacy proposalData, 2 = proposalDataV2
   *
   * @generated from field: int32 data_version = 9;
   */ _define_property(this, "dataVersion", 0), /**
   * FFP, T&M, CPFF, etc.
   *
   * @generated from field: string contract_type = 10;
   */ _define_property(this, "contractType", ""), /**
   * e.g., "GSA OASIS", "SEWP V"
   *
   * @generated from field: string contract_vehicle = 11;
   */ _define_property(this, "contractVehicle", ""), /**
   * @generated from field: string contract_vehicle_id = 12;
   */ _define_property(this, "contractVehicleId", ""), /**
   * @generated from field: string office = 13;
   */ _define_property(this, "office", ""), /**
   * @generated from field: string gov_org_id = 14;
   */ _define_property(this, "govOrgId", ""), /**
   * @generated from field: string office_gov_org_id = 15;
   */ _define_property(this, "officeGovOrgId", ""), /**
   * IANA zone the deadline is stated in; "" = not stated
   *
   * @generated from field: string due_timezone = 16;
   */ _define_property(this, "dueTimezone", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposalInfo, "runtime", proto3);
_define_property(ProposalInfo, "typeName", "mono.projectdata.v1.ProposalInfo");
_define_property(ProposalInfo, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "solicitation_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "agency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "due_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 4,
            name: "stage",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "processing",
            kind: "message",
            T: ProcessingStatus
        },
        {
            no: 6,
            name: "agency_info",
            kind: "message",
            T: AgencyInfo
        },
        {
            no: 7,
            name: "naics_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "set_aside",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "data_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 10,
            name: "contract_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "contract_vehicle",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "contract_vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "office",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "gov_org_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "office_gov_org_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "due_timezone",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ContractInfo
 */ export class ContractInfo extends Message {
    static fromBinary(bytes, options) {
        return new ContractInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContractInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContractInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContractInfo, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string contract_number = 1;
   */ _define_property(this, "contractNumber", ""), /**
   * FFP, T&M, CPFF, CPIF, CPAF, IDIQ, BPA, HYBRID, OTHER
   *
   * @generated from field: string contract_type = 2;
   */ _define_property(this, "contractType", ""), /**
   * @generated from field: string solicitation_number = 3;
   */ _define_property(this, "solicitationNumber", ""), /**
   * @generated from field: mono.projectdata.v1.AgencyInfo agency = 4;
   */ _define_property(this, "agency", void 0), /**
   * @generated from field: mono.projectdata.v1.ContractorInfo prime_contractor = 5;
   */ _define_property(this, "primeContractor", void 0), /**
   * @generated from field: repeated mono.projectdata.v1.GovernmentContact government_contacts = 6;
   */ _define_property(this, "governmentContacts", []), /**
   * @generated from field: mono.projectdata.v1.PeriodOfPerformance period_of_performance = 7;
   */ _define_property(this, "periodOfPerformance", void 0), /**
   * @generated from field: mono.projectdata.v1.ContractValue total_value = 8;
   */ _define_property(this, "totalValue", void 0), /**
   * awarded, kickoff, active, modification, option_pending, closeout, closed
   *
   * @generated from field: string stage = 9;
   */ _define_property(this, "stage", ""), /**
   * @generated from field: mono.projectdata.v1.ProcessingStatus processing = 10;
   */ _define_property(this, "processing", void 0), /**
   * @generated from field: string contract_analysis_id = 11;
   */ _define_property(this, "contractAnalysisId", ""), /**
   * Phase 3 additions
   *
   * 1 = contractDataV1
   *
   * @generated from field: int32 data_version = 12;
   */ _define_property(this, "dataVersion", 0), /**
   * Phase 8: lifecycle linkage
   *
   * @generated from field: string source_proposal_project_id = 13;
   */ _define_property(this, "sourceProposalProjectId", ""), /**
   * ContractAnalysisV2 parity: new identity fields
   *
   * @generated from field: string contract_title = 14;
   */ _define_property(this, "contractTitle", ""), /**
   * @generated from field: mono.projectdata.v1.ContractingVehicle contracting_vehicle = 15;
   */ _define_property(this, "contractingVehicle", void 0), /**
   * @generated from field: google.protobuf.Timestamp award_date = 16;
   */ _define_property(this, "awardDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp effective_date = 17;
   */ _define_property(this, "effectiveDate", void 0), /**
   * @generated from field: mono.projectdata.v1.ConfidenceScores confidence_scores = 18;
   */ _define_property(this, "confidenceScores", void 0), /**
   * @generated from field: repeated string extraction_notes = 19;
   */ _define_property(this, "extractionNotes", []), /**
   * @generated from field: string extraction_version = 20;
   */ _define_property(this, "extractionVersion", ""), /**
   * Ryugu SoR linkage
   *
   * @generated from field: string ryugu_program_id = 21;
   */ _define_property(this, "ryuguProgramId", ""), /**
   * Task/call number for an IDIQ/BPA task order (the PIID's order suffix).
   * Empty for a standalone contract or an IDIQ parent. Threaded onto the
   * delivery program so an order shares (tenant, contract_number) with its
   * siblings but stays distinct under idx_programs_dedup's COALESCE(task_number,'').
   *
   * @generated from field: string task_number = 22;
   */ _define_property(this, "taskNumber", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContractInfo, "runtime", proto3);
_define_property(ContractInfo, "typeName", "mono.projectdata.v1.ContractInfo");
_define_property(ContractInfo, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contract_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "contract_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "solicitation_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "agency",
            kind: "message",
            T: AgencyInfo
        },
        {
            no: 5,
            name: "prime_contractor",
            kind: "message",
            T: ContractorInfo
        },
        {
            no: 6,
            name: "government_contacts",
            kind: "message",
            T: GovernmentContact,
            repeated: true
        },
        {
            no: 7,
            name: "period_of_performance",
            kind: "message",
            T: PeriodOfPerformance
        },
        {
            no: 8,
            name: "total_value",
            kind: "message",
            T: ContractValue
        },
        {
            no: 9,
            name: "stage",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "processing",
            kind: "message",
            T: ProcessingStatus
        },
        {
            no: 11,
            name: "contract_analysis_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "data_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 13,
            name: "source_proposal_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "contract_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "contracting_vehicle",
            kind: "message",
            T: ContractingVehicle
        },
        {
            no: 16,
            name: "award_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 17,
            name: "effective_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 18,
            name: "confidence_scores",
            kind: "message",
            T: ConfidenceScores
        },
        {
            no: 19,
            name: "extraction_notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 20,
            name: "extraction_version",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 21,
            name: "ryugu_program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 22,
            name: "task_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ProcessingStatus
 */ export class ProcessingStatus extends Message {
    static fromBinary(bytes, options) {
        return new ProcessingStatus().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProcessingStatus().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProcessingStatus().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProcessingStatus, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string job_id = 1;
   */ _define_property(this, "jobId", ""), /**
   * idle, pending, processing, completed, failed
   *
   * @generated from field: string status = 2;
   */ _define_property(this, "status", ""), /**
   * @generated from field: int32 progress_percentage = 3;
   */ _define_property(this, "progressPercentage", 0), /**
   * @generated from field: string current_step = 4;
   */ _define_property(this, "currentStep", ""), /**
   * @generated from field: google.protobuf.Timestamp completed_at = 5;
   */ _define_property(this, "completedAt", void 0), /**
   * @generated from field: string error = 6;
   */ _define_property(this, "error", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProcessingStatus, "runtime", proto3);
_define_property(ProcessingStatus, "typeName", "mono.projectdata.v1.ProcessingStatus");
_define_property(ProcessingStatus, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "job_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "progress_percentage",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "current_step",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "completed_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "error",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.AgencyInfo
 */ export class AgencyInfo extends Message {
    static fromBinary(bytes, options) {
        return new AgencyInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AgencyInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AgencyInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AgencyInfo, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string name = 1;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string acronym = 2;
   */ _define_property(this, "acronym", ""), /**
   * @generated from field: string sub_agency = 3;
   */ _define_property(this, "subAgency", ""), /**
   * @generated from field: string sub_agency_acronym = 4;
   */ _define_property(this, "subAgencyAcronym", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AgencyInfo, "runtime", proto3);
_define_property(AgencyInfo, "typeName", "mono.projectdata.v1.AgencyInfo");
_define_property(AgencyInfo, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "acronym",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "sub_agency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "sub_agency_acronym",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ContractorInfo
 */ export class ContractorInfo extends Message {
    static fromBinary(bytes, options) {
        return new ContractorInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContractorInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContractorInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContractorInfo, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string name = 1;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string duns = 2;
   */ _define_property(this, "duns", ""), /**
   * @generated from field: string uei = 3;
   */ _define_property(this, "uei", ""), /**
   * @generated from field: string cage_code = 4;
   */ _define_property(this, "cageCode", ""), /**
   * prime, subcontractor, teaming_partner
   *
   * @generated from field: string role = 5;
   */ _define_property(this, "role", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContractorInfo, "runtime", proto3);
_define_property(ContractorInfo, "typeName", "mono.projectdata.v1.ContractorInfo");
_define_property(ContractorInfo, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "duns",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "uei",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "cage_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GovernmentContact
 */ export class GovernmentContact extends Message {
    static fromBinary(bytes, options) {
        return new GovernmentContact().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GovernmentContact().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GovernmentContact().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GovernmentContact, a, b);
    }
    constructor(data){
        super(), /**
   * contracting_officer, cor, technical_poc, program_manager, other
   *
   * @generated from field: string role = 1;
   */ _define_property(this, "role", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string title = 3;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string email = 4;
   */ _define_property(this, "email", ""), /**
   * @generated from field: string phone = 5;
   */ _define_property(this, "phone", ""), /**
   * @generated from field: string organization = 6;
   */ _define_property(this, "organization", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GovernmentContact, "runtime", proto3);
_define_property(GovernmentContact, "typeName", "mono.projectdata.v1.GovernmentContact");
_define_property(GovernmentContact, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "email",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "phone",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "organization",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.PeriodOfPerformance
 */ export class PeriodOfPerformance extends Message {
    static fromBinary(bytes, options) {
        return new PeriodOfPerformance().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PeriodOfPerformance().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PeriodOfPerformance().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PeriodOfPerformance, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: google.protobuf.Timestamp start_date = 1;
   */ _define_property(this, "startDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp end_date = 2;
   */ _define_property(this, "endDate", void 0), /**
   * @generated from field: int32 duration_months = 3;
   */ _define_property(this, "durationMonths", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PeriodOfPerformance, "runtime", proto3);
_define_property(PeriodOfPerformance, "typeName", "mono.projectdata.v1.PeriodOfPerformance");
_define_property(PeriodOfPerformance, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "start_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 2,
            name: "end_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 3,
            name: "duration_months",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ContractingVehicle
 */ export class ContractingVehicle extends Message {
    static fromBinary(bytes, options) {
        return new ContractingVehicle().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContractingVehicle().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContractingVehicle().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContractingVehicle, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string name = 1;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string contract_number = 2;
   */ _define_property(this, "contractNumber", ""), /**
   * GSA_SCHEDULE, GWAC, BPA, IDIQ, OTHER
   *
   * @generated from field: string vehicle_type = 3;
   */ _define_property(this, "vehicleType", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContractingVehicle, "runtime", proto3);
_define_property(ContractingVehicle, "typeName", "mono.projectdata.v1.ContractingVehicle");
_define_property(ContractingVehicle, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "contract_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "vehicle_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ConfidenceScores
 */ export class ConfidenceScores extends Message {
    static fromBinary(bytes, options) {
        return new ConfidenceScores().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ConfidenceScores().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ConfidenceScores().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ConfidenceScores, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: double table_detection = 1;
   */ _define_property(this, "tableDetection", 0), /**
   * @generated from field: double enrichment = 2;
   */ _define_property(this, "enrichment", 0), /**
   * @generated from field: double overall = 3;
   */ _define_property(this, "overall", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ConfidenceScores, "runtime", proto3);
_define_property(ConfidenceScores, "typeName", "mono.projectdata.v1.ConfidenceScores");
_define_property(ConfidenceScores, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "table_detection",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 2,
            name: "enrichment",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 3,
            name: "overall",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        }
    ]));
/**
 * ContractParty stores extracted contractor info (prime + subcontractors).
 *
 * @generated from message mono.projectdata.v1.ContractPartyInfo
 */ export class ContractPartyInfo extends Message {
    static fromBinary(bytes, options) {
        return new ContractPartyInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContractPartyInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContractPartyInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContractPartyInfo, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string duns = 3;
   */ _define_property(this, "duns", ""), /**
   * @generated from field: string uei = 4;
   */ _define_property(this, "uei", ""), /**
   * @generated from field: string cage_code = 5;
   */ _define_property(this, "cageCode", ""), /**
   * prime, subcontractor, teaming_partner
   *
   * @generated from field: string role = 6;
   */ _define_property(this, "role", ""), /**
   * @generated from field: double percentage = 7;
   */ _define_property(this, "percentage", 0), /**
   * @generated from field: string street1 = 8;
   */ _define_property(this, "street1", ""), /**
   * @generated from field: string street2 = 9;
   */ _define_property(this, "street2", ""), /**
   * @generated from field: string city = 10;
   */ _define_property(this, "city", ""), /**
   * @generated from field: string state = 11;
   */ _define_property(this, "state", ""), /**
   * @generated from field: string zip_code = 12;
   */ _define_property(this, "zipCode", ""), /**
   * @generated from field: string country = 13;
   */ _define_property(this, "country", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContractPartyInfo, "runtime", proto3);
_define_property(ContractPartyInfo, "typeName", "mono.projectdata.v1.ContractPartyInfo");
_define_property(ContractPartyInfo, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "duns",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "uei",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "cage_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "percentage",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 8,
            name: "street1",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "street2",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "city",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "zip_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "country",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * PlaceOfPerformance stores extracted performance locations.
 *
 * @generated from message mono.projectdata.v1.PlaceOfPerformanceInfo
 */ export class PlaceOfPerformanceInfo extends Message {
    static fromBinary(bytes, options) {
        return new PlaceOfPerformanceInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PlaceOfPerformanceInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PlaceOfPerformanceInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PlaceOfPerformanceInfo, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: bool primary = 2;
   */ _define_property(this, "primary", false), /**
   * @generated from field: string description = 3;
   */ _define_property(this, "description", ""), /**
   * @generated from field: double percentage = 4;
   */ _define_property(this, "percentage", 0), /**
   * @generated from field: string city = 5;
   */ _define_property(this, "city", ""), /**
   * @generated from field: string state = 6;
   */ _define_property(this, "state", ""), /**
   * @generated from field: string zip_code = 7;
   */ _define_property(this, "zipCode", ""), /**
   * @generated from field: string country = 8;
   */ _define_property(this, "country", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PlaceOfPerformanceInfo, "runtime", proto3);
_define_property(PlaceOfPerformanceInfo, "typeName", "mono.projectdata.v1.PlaceOfPerformanceInfo");
_define_property(PlaceOfPerformanceInfo, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "primary",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 3,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "percentage",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 5,
            name: "city",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "zip_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "country",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ContractPeriod stores extracted base + option period breakdowns.
 *
 * @generated from message mono.projectdata.v1.ContractPeriodInfo
 */ export class ContractPeriodInfo extends Message {
    static fromBinary(bytes, options) {
        return new ContractPeriodInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContractPeriodInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContractPeriodInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContractPeriodInfo, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * "Base Period", "Option Period 1"
   *
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * base, option_period
   *
   * @generated from field: string type = 3;
   */ _define_property(this, "type", ""), /**
   * @generated from field: int32 option_number = 4;
   */ _define_property(this, "optionNumber", 0), /**
   * @generated from field: google.protobuf.Timestamp start_date = 5;
   */ _define_property(this, "startDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp end_date = 6;
   */ _define_property(this, "endDate", void 0), /**
   * @generated from field: int32 duration_months = 7;
   */ _define_property(this, "durationMonths", 0), /**
   * @generated from field: double total_value = 8;
   */ _define_property(this, "totalValue", 0), /**
   * @generated from field: int32 sort_order = 9;
   */ _define_property(this, "sortOrder", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContractPeriodInfo, "runtime", proto3);
_define_property(ContractPeriodInfo, "typeName", "mono.projectdata.v1.ContractPeriodInfo");
_define_property(ContractPeriodInfo, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "option_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "start_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "end_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "duration_months",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 8,
            name: "total_value",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 9,
            name: "sort_order",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * FundingHistoryEntry tracks per-CLIN funding changes from modifications.
 *
 * @generated from message mono.projectdata.v1.FundingHistoryEntry
 */ export class FundingHistoryEntry extends Message {
    static fromBinary(bytes, options) {
        return new FundingHistoryEntry().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FundingHistoryEntry().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FundingHistoryEntry().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FundingHistoryEntry, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string modification_id = 1;
   */ _define_property(this, "modificationId", ""), /**
   * @generated from field: string modification_number = 2;
   */ _define_property(this, "modificationNumber", ""), /**
   * @generated from field: google.protobuf.Timestamp effective_date = 3;
   */ _define_property(this, "effectiveDate", void 0), /**
   * @generated from field: double previous_funded_amount = 4;
   */ _define_property(this, "previousFundedAmount", 0), /**
   * @generated from field: double previous_unfunded_amount = 5;
   */ _define_property(this, "previousUnfundedAmount", 0), /**
   * @generated from field: double change_amount = 6;
   */ _define_property(this, "changeAmount", 0), /**
   * @generated from field: double new_funded_amount = 7;
   */ _define_property(this, "newFundedAmount", 0), /**
   * @generated from field: double new_unfunded_amount = 8;
   */ _define_property(this, "newUnfundedAmount", 0), /**
   * @generated from field: string change_reason = 9;
   */ _define_property(this, "changeReason", ""), /**
   * @generated from field: google.protobuf.Timestamp recorded_at = 10;
   */ _define_property(this, "recordedAt", void 0), /**
   * @generated from field: string recorded_by = 11;
   */ _define_property(this, "recordedBy", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(FundingHistoryEntry, "runtime", proto3);
_define_property(FundingHistoryEntry, "typeName", "mono.projectdata.v1.FundingHistoryEntry");
_define_property(FundingHistoryEntry, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "modification_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "modification_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "effective_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 4,
            name: "previous_funded_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 5,
            name: "previous_unfunded_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 6,
            name: "change_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 7,
            name: "new_funded_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 8,
            name: "new_unfunded_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 9,
            name: "change_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "recorded_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "recorded_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ContractValue
 */ export class ContractValue extends Message {
    static fromBinary(bytes, options) {
        return new ContractValue().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContractValue().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContractValue().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContractValue, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: double base_value = 1;
   */ _define_property(this, "baseValue", 0), /**
   * @generated from field: double total_ceiling = 2;
   */ _define_property(this, "totalCeiling", 0), /**
   * @generated from field: string currency = 3;
   */ _define_property(this, "currency", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContractValue, "runtime", proto3);
_define_property(ContractValue, "typeName", "mono.projectdata.v1.ContractValue");
_define_property(ContractValue, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "base_value",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 2,
            name: "total_ceiling",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 3,
            name: "currency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListSourceDocumentsRequest
 */ export class ListSourceDocumentsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListSourceDocumentsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListSourceDocumentsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListSourceDocumentsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListSourceDocumentsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * optional filter: source, amendment, reference
   *
   * @generated from field: string document_type = 3;
   */ _define_property(this, "documentType", ""), /**
   * @generated from field: mono.common.v1.PaginationRequest pagination = 4;
   */ _define_property(this, "pagination", void 0), /**
   * Phase 3 taxonomy filters
   *
   * optional filter: source_document, project_file
   *
   * @generated from field: string file_category = 5;
   */ _define_property(this, "fileCategory", ""), /**
   * optional filter: solicitation, amendment, qa, attachment, contract_mod
   *
   * @generated from field: string source_kind = 6;
   */ _define_property(this, "sourceKind", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListSourceDocumentsRequest, "runtime", proto3);
_define_property(ListSourceDocumentsRequest, "typeName", "mono.projectdata.v1.ListSourceDocumentsRequest");
_define_property(ListSourceDocumentsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "document_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "pagination",
            kind: "message",
            T: PaginationRequest
        },
        {
            no: 5,
            name: "file_category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "source_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListSourceDocumentsResponse
 */ export class ListSourceDocumentsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListSourceDocumentsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListSourceDocumentsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListSourceDocumentsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListSourceDocumentsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.ProjectDocument documents = 1;
   */ _define_property(this, "documents", []), /**
   * @generated from field: mono.common.v1.PaginationResponse pagination = 2;
   */ _define_property(this, "pagination", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListSourceDocumentsResponse, "runtime", proto3);
_define_property(ListSourceDocumentsResponse, "typeName", "mono.projectdata.v1.ListSourceDocumentsResponse");
_define_property(ListSourceDocumentsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "documents",
            kind: "message",
            T: ProjectDocument,
            repeated: true
        },
        {
            no: 2,
            name: "pagination",
            kind: "message",
            T: PaginationResponse
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ProjectDocument
 */ export class ProjectDocument extends Message {
    static fromBinary(bytes, options) {
        return new ProjectDocument().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProjectDocument().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProjectDocument().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProjectDocument, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string document_id = 1;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: string filename = 2;
   */ _define_property(this, "filename", ""), /**
   * @generated from field: string mime_type = 3;
   */ _define_property(this, "mimeType", ""), /**
   * @generated from field: int64 file_size = 4;
   */ _define_property(this, "fileSize", protoInt64.zero), /**
   * source, amendment, reference, unknown
   *
   * @generated from field: string document_type = 5;
   */ _define_property(this, "documentType", ""), /**
   * @generated from field: string subtype = 6;
   */ _define_property(this, "subtype", ""), /**
   * @generated from field: string amendment_number = 7;
   */ _define_property(this, "amendmentNumber", ""), /**
   * @generated from field: google.protobuf.Timestamp uploaded_at = 8;
   */ _define_property(this, "uploadedAt", void 0), /**
   * @generated from field: string uploaded_by = 9;
   */ _define_property(this, "uploadedBy", ""), /**
   * Phase 3 taxonomy additions
   *
   * source_document, project_file
   *
   * @generated from field: string file_category = 10;
   */ _define_property(this, "fileCategory", ""), /**
   * solicitation, amendment, qa, attachment, contract_mod
   *
   * @generated from field: string source_kind = 11;
   */ _define_property(this, "sourceKind", ""), /**
   * @generated from field: string classification_label = 12;
   */ _define_property(this, "classificationLabel", ""), /**
   * @generated from field: int32 page_count = 13;
   */ _define_property(this, "pageCount", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProjectDocument, "runtime", proto3);
_define_property(ProjectDocument, "typeName", "mono.projectdata.v1.ProjectDocument");
_define_property(ProjectDocument, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "mime_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "file_size",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 5,
            name: "document_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "subtype",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "amendment_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "uploaded_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "uploaded_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "file_category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "source_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "classification_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "page_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListProjectFilesRequest
 */ export class ListProjectFilesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListProjectFilesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProjectFilesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProjectFilesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProjectFilesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: mono.common.v1.PaginationRequest pagination = 3;
   */ _define_property(this, "pagination", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProjectFilesRequest, "runtime", proto3);
_define_property(ListProjectFilesRequest, "typeName", "mono.projectdata.v1.ListProjectFilesRequest");
_define_property(ListProjectFilesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "pagination",
            kind: "message",
            T: PaginationRequest
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListProjectFilesResponse
 */ export class ListProjectFilesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListProjectFilesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProjectFilesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProjectFilesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProjectFilesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.ProjectFile files = 1;
   */ _define_property(this, "files", []), /**
   * @generated from field: mono.common.v1.PaginationResponse pagination = 2;
   */ _define_property(this, "pagination", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProjectFilesResponse, "runtime", proto3);
_define_property(ListProjectFilesResponse, "typeName", "mono.projectdata.v1.ListProjectFilesResponse");
_define_property(ListProjectFilesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "files",
            kind: "message",
            T: ProjectFile,
            repeated: true
        },
        {
            no: 2,
            name: "pagination",
            kind: "message",
            T: PaginationResponse
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.EnsureArtifactForAttachmentRequest
 */ export class EnsureArtifactForAttachmentRequest extends Message {
    static fromBinary(bytes, options) {
        return new EnsureArtifactForAttachmentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EnsureArtifactForAttachmentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EnsureArtifactForAttachmentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EnsureArtifactForAttachmentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string attachment_id = 1;
   */ _define_property(this, "attachmentId", ""), /**
   * optional sanity scope; the attachment carries its own
   *
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * stamped onto the minted artifact row
   *
   * @generated from field: string tenant_id = 3;
   */ _define_property(this, "tenantId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(EnsureArtifactForAttachmentRequest, "runtime", proto3);
_define_property(EnsureArtifactForAttachmentRequest, "typeName", "mono.projectdata.v1.EnsureArtifactForAttachmentRequest");
_define_property(EnsureArtifactForAttachmentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "attachment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.EnsureArtifactForAttachmentResponse
 */ export class EnsureArtifactForAttachmentResponse extends Message {
    static fromBinary(bytes, options) {
        return new EnsureArtifactForAttachmentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EnsureArtifactForAttachmentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EnsureArtifactForAttachmentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EnsureArtifactForAttachmentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * existing or newly minted artifacts.artifacts id
   *
   * @generated from field: string artifact_id = 1;
   */ _define_property(this, "artifactId", ""), /**
   * true if this call minted a new artifact row
   *
   * @generated from field: bool created = 2;
   */ _define_property(this, "created", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(EnsureArtifactForAttachmentResponse, "runtime", proto3);
_define_property(EnsureArtifactForAttachmentResponse, "typeName", "mono.projectdata.v1.EnsureArtifactForAttachmentResponse");
_define_property(EnsureArtifactForAttachmentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "created",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ProjectFile
 */ export class ProjectFile extends Message {
    static fromBinary(bytes, options) {
        return new ProjectFile().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProjectFile().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProjectFile().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProjectFile, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string file_id = 1;
   */ _define_property(this, "fileId", ""), /**
   * @generated from field: string filename = 2;
   */ _define_property(this, "filename", ""), /**
   * @generated from field: string mime_type = 3;
   */ _define_property(this, "mimeType", ""), /**
   * @generated from field: int64 file_size = 4;
   */ _define_property(this, "fileSize", protoInt64.zero), /**
   * uploaded, processing, processed, failed
   *
   * @generated from field: string status = 5;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string document_type = 6;
   */ _define_property(this, "documentType", ""), /**
   * @generated from field: google.protobuf.Timestamp uploaded_at = 7;
   */ _define_property(this, "uploadedAt", void 0), /**
   * @generated from field: string uploaded_by = 8;
   */ _define_property(this, "uploadedBy", ""), /**
   * populated if tagged to an outline section
   *
   * @generated from field: string outline_section_id = 9;
   */ _define_property(this, "outlineSectionId", ""), /**
   * Phase 3 taxonomy additions
   *
   * source_document, project_file
   *
   * @generated from field: string file_category = 10;
   */ _define_property(this, "fileCategory", ""), /**
   * solicitation, amendment, qa, attachment, contract_mod
   *
   * @generated from field: string source_kind = 11;
   */ _define_property(this, "sourceKind", ""), /**
   * @generated from field: string classification_label = 12;
   */ _define_property(this, "classificationLabel", ""), /**
   * @generated from field: int32 page_count = 13;
   */ _define_property(this, "pageCount", 0), /**
   * e.g., LABOR_CATEGORIES, COST_VOLUME, PRICING
   *
   * @generated from field: string subtype = 14;
   */ _define_property(this, "subtype", ""), /**
   * e.g., "001", "002"
   *
   * @generated from field: string amendment_number = 15;
   */ _define_property(this, "amendmentNumber", ""), /**
   * attachment ID of the document this amends
   *
   * @generated from field: string source_document_id = 16;
   */ _define_property(this, "sourceDocumentId", ""), /**
   * 0 = base/non-amendment, 1+ = amendment order
   *
   * @generated from field: int32 amendment_sequence = 17;
   */ _define_property(this, "amendmentSequence", 0), /**
   * @generated from field: mono.projectdata.v1.FileClassification classification = 18;
   */ _define_property(this, "classification", void 0), /**
   * Amendment number this attachment belongs to (e.g., "001")
   *
   * @generated from field: string associated_amendment = 19;
   */ _define_property(this, "associatedAmendment", ""), /**
   * Baltigo processing ID — used for MinIO content paths
   *
   * @generated from field: string baltigo_doc_id = 20;
   */ _define_property(this, "baltigoDocId", ""), /**
   * Tenant/company ID — MinIO path prefix
   *
   * @generated from field: string company_id = 21;
   */ _define_property(this, "companyId", ""), /**
   * Original upload path in MinIO
   *
   * @generated from field: string file_path = 22;
   */ _define_property(this, "filePath", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProjectFile, "runtime", proto3);
_define_property(ProjectFile, "typeName", "mono.projectdata.v1.ProjectFile");
_define_property(ProjectFile, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "file_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "mime_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "file_size",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 5,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "document_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "uploaded_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "uploaded_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "outline_section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "file_category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "source_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "classification_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "page_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 14,
            name: "subtype",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "amendment_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "source_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "amendment_sequence",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 18,
            name: "classification",
            kind: "message",
            T: FileClassification
        },
        {
            no: 19,
            name: "associated_amendment",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "baltigo_doc_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 21,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 22,
            name: "file_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * Detailed classification from Baltigo/Reverie pipeline
 *
 * @generated from message mono.projectdata.v1.FileClassification
 */ export class FileClassification extends Message {
    static fromBinary(bytes, options) {
        return new FileClassification().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FileClassification().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FileClassification().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FileClassification, a, b);
    }
    constructor(data){
        super(), /**
   * From Baltigo: TECHNICAL_VOLUME, SECTION_L, PWS, SOW, etc.
   *
   * @generated from field: string document_type = 1;
   */ _define_property(this, "documentType", ""), /**
   * BASE, AMENDMENT, SUPPORT
   *
   * @generated from field: string primary_type = 2;
   */ _define_property(this, "primaryType", ""), /**
   * 0.0-1.0
   *
   * @generated from field: double confidence = 3;
   */ _define_property(this, "confidence", 0), /**
   * "llm", "filename-estimate", "fallback"
   *
   * @generated from field: string confidence_source = 4;
   */ _define_property(this, "confidenceSource", ""), /**
   * Deprecated: use classified_at_ts.
   *
   * @generated from field: string classified_at = 5 [deprecated = true];
   * @deprecated
   */ _define_property(this, "classifiedAt", ""), /**
   * @generated from field: string summary = 6;
   */ _define_property(this, "summary", ""), /**
   * @generated from field: repeated string key_topics = 7;
   */ _define_property(this, "keyTopics", []), /**
   * @generated from field: repeated string key_entities = 8;
   */ _define_property(this, "keyEntities", []), /**
   * @generated from field: string solicitation_number = 9;
   */ _define_property(this, "solicitationNumber", ""), /**
   * @generated from field: string agency = 10;
   */ _define_property(this, "agency", ""), /**
   * @generated from field: string due_date = 11;
   */ _define_property(this, "dueDate", ""), /**
   * @generated from field: string contract_number = 12;
   */ _define_property(this, "contractNumber", ""), /**
   * @generated from field: string parent_document_type = 13;
   */ _define_property(this, "parentDocumentType", ""), /**
   * @generated from field: repeated string additional_sections = 14;
   */ _define_property(this, "additionalSections", []), /**
   * @generated from field: google.protobuf.Timestamp classified_at_ts = 15;
   */ _define_property(this, "classifiedAtTs", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(FileClassification, "runtime", proto3);
_define_property(FileClassification, "typeName", "mono.projectdata.v1.FileClassification");
_define_property(FileClassification, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "primary_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 4,
            name: "confidence_source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "classified_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "summary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "key_topics",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 8,
            name: "key_entities",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 9,
            name: "solicitation_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "agency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "due_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "contract_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "parent_document_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "additional_sections",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 15,
            name: "classified_at_ts",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.QueryComplianceRequirementsRequest
 */ export class QueryComplianceRequirementsRequest extends Message {
    static fromBinary(bytes, options) {
        return new QueryComplianceRequirementsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new QueryComplianceRequirementsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new QueryComplianceRequirementsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(QueryComplianceRequirementsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * NOT_STARTED, IN_PROGRESS, ADDRESSED, PARTIAL, NON_COMPLIANT, N/A
   *
   * @generated from field: repeated string status = 3;
   */ _define_property(this, "status", []), /**
   * PROPOSAL_INSTRUCTION, SCOPE_REQUIREMENT, EVALUATION_CRITERION, etc.
   *
   * @generated from field: repeated string category = 4;
   */ _define_property(this, "category", []), /**
   * SHALL, MUST, WILL, SHOULD, MAY
   *
   * @generated from field: repeated string obligation_strength = 5;
   */ _define_property(this, "obligationStrength", []), /**
   * Source document type filter
   *
   * @generated from field: repeated string document_type = 6;
   */ _define_property(this, "documentType", []), /**
   * @generated from field: bool is_evaluated = 7;
   */ _define_property(this, "isEvaluated", false), /**
   * @generated from field: string search_text = 8;
   */ _define_property(this, "searchText", ""), /**
   * @generated from field: mono.common.v1.PaginationRequest pagination = 9;
   */ _define_property(this, "pagination", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(QueryComplianceRequirementsRequest, "runtime", proto3);
_define_property(QueryComplianceRequirementsRequest, "typeName", "mono.projectdata.v1.QueryComplianceRequirementsRequest");
_define_property(QueryComplianceRequirementsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 4,
            name: "category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 5,
            name: "obligation_strength",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 6,
            name: "document_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 7,
            name: "is_evaluated",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 8,
            name: "search_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "pagination",
            kind: "message",
            T: PaginationRequest
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.QueryComplianceRequirementsResponse
 */ export class QueryComplianceRequirementsResponse extends Message {
    static fromBinary(bytes, options) {
        return new QueryComplianceRequirementsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new QueryComplianceRequirementsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new QueryComplianceRequirementsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(QueryComplianceRequirementsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.StoredRequirement requirements = 1;
   */ _define_property(this, "requirements", []), /**
   * @generated from field: mono.projectdata.v1.ComplianceMatrixStats stats = 2;
   */ _define_property(this, "stats", void 0), /**
   * @generated from field: mono.common.v1.PaginationResponse pagination = 3;
   */ _define_property(this, "pagination", void 0), /**
   * Full evaluation criteria hierarchy extracted from the solicitation.
   *
   * @generated from field: mono.projectdata.v1.EvaluationScheme evaluation_scheme = 4;
   */ _define_property(this, "evaluationScheme", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(QueryComplianceRequirementsResponse, "runtime", proto3);
_define_property(QueryComplianceRequirementsResponse, "typeName", "mono.projectdata.v1.QueryComplianceRequirementsResponse");
_define_property(QueryComplianceRequirementsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "requirements",
            kind: "message",
            T: StoredRequirement,
            repeated: true
        },
        {
            no: 2,
            name: "stats",
            kind: "message",
            T: ComplianceMatrixStats
        },
        {
            no: 3,
            name: "pagination",
            kind: "message",
            T: PaginationResponse
        },
        {
            no: 4,
            name: "evaluation_scheme",
            kind: "message",
            T: EvaluationScheme
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.StoredRequirement
 */ export class StoredRequirement extends Message {
    static fromBinary(bytes, options) {
        return new StoredRequirement().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StoredRequirement().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StoredRequirement().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StoredRequirement, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string requirement_id = 1;
   */ _define_property(this, "requirementId", ""), /**
   * @generated from field: string matrix_id = 2;
   */ _define_property(this, "matrixId", ""), /**
   * @generated from field: int32 sequence_number = 3;
   */ _define_property(this, "sequenceNumber", 0), /**
   * @generated from field: string text = 4;
   */ _define_property(this, "text", ""), /**
   * PROPOSAL_INSTRUCTION, SCOPE_REQUIREMENT, etc.
   *
   * @generated from field: string category = 5;
   */ _define_property(this, "category", ""), /**
   * SHALL, MUST, WILL, SHOULD, MAY
   *
   * @generated from field: string obligation_strength = 6;
   */ _define_property(this, "obligationStrength", ""), /**
   * NOT_STARTED, IN_PROGRESS, ADDRESSED, PARTIAL, NON_COMPLIANT, N/A
   *
   * @generated from field: string status = 7;
   */ _define_property(this, "status", ""), /**
   * @generated from field: bool is_mandatory = 8;
   */ _define_property(this, "isMandatory", false), /**
   * @generated from field: bool is_evaluated = 9;
   */ _define_property(this, "isEvaluated", false), /**
   * @generated from field: string evaluation_factor = 10;
   */ _define_property(this, "evaluationFactor", ""), /**
   * @generated from field: string evaluation_subfactor = 11;
   */ _define_property(this, "evaluationSubfactor", ""), /**
   * @generated from field: mono.projectdata.v1.RequirementSourceInfo source = 12;
   */ _define_property(this, "source", void 0), /**
   * @generated from field: mono.projectdata.v1.RequirementMapping mapping = 13;
   */ _define_property(this, "mapping", void 0), /**
   * @generated from field: mono.projectdata.v1.AmendmentInfo amendment_info = 14;
   */ _define_property(this, "amendmentInfo", void 0), /**
   * @generated from field: double confidence = 15;
   */ _define_property(this, "confidence", 0), /**
   * @generated from field: string notes = 16;
   */ _define_property(this, "notes", ""), /**
   * @generated from field: repeated string tags = 17;
   */ _define_property(this, "tags", []), /**
   * Phase 3: enrichment fields from Go extraction pipeline
   *
   * @generated from field: double evaluation_weight = 18;
   */ _define_property(this, "evaluationWeight", 0), /**
   * @generated from field: repeated string entities = 19;
   */ _define_property(this, "entities", []), /**
   * @generated from field: repeated string related_clins = 20;
   */ _define_property(this, "relatedClins", []), /**
   * @generated from field: mono.projectdata.v1.SectionContext section_context = 21;
   */ _define_property(this, "sectionContext", void 0), /**
   * @generated from field: string response_action = 22;
   */ _define_property(this, "responseAction", ""), /**
   * @generated from field: string deliverable_type = 23;
   */ _define_property(this, "deliverableType", ""), /**
   * @generated from field: string action_owner = 24;
   */ _define_property(this, "actionOwner", ""), /**
   * all applicable categories (superset of category)
   *
   * @generated from field: repeated string categories = 25;
   */ _define_property(this, "categories", []), /**
   * Read-side fields populated from stored data
   *
   * @generated from field: repeated mono.projectdata.v1.StatusHistoryEntry status_history = 26;
   */ _define_property(this, "statusHistory", []), /**
   * ISO 8601 timestamp
   *
   * @generated from field: string extracted_at = 27;
   */ _define_property(this, "extractedAt", ""), /**
   * @generated from field: string extracted_by = 28;
   */ _define_property(this, "extractedBy", ""), /**
   * Insight hints feed the V2 insights pipeline. Allowed values are
   * VOLUME_STRUCTURE, PAGE_LIMIT, FORMAT_RULE, CONTENT_REQUIREMENT,
   * FILE_REQUIREMENT, KEY_PERSONNEL, RESUME_REQUIREMENT, PAST_PERFORMANCE_REQ,
   * CPARS_REQ, SUBCONTRACTING_GOAL, DEADLINE, QA_PROTOCOL, ORAL_PRESENTATION,
   * SITE_VISIT, PRE_PROPOSAL_CONF, SECURITY_CLEARANCE, BOND_REQUIREMENT,
   * TEAMING_RESTRICTION, AWARD_MECHANISM, CONTRACT_TYPE, PLACE_OF_PERFORMANCE.
   * Set during shred extraction; consumed by the insights pipeline.
   *
   * @generated from field: repeated string insight_hints = 29;
   */ _define_property(this, "insightHints", []), /**
   * The user this requirement is assigned to. Empty when unassigned.
   * Mutated via UpdateRequirementAssignment.
   *
   * @generated from field: string assigned_to_user_id = 30;
   */ _define_property(this, "assignedToUserId", ""), /**
   * ===== Amendment provenance + supersession (PR-A) =====
   * These supplement amendment_info with the merge-time provenance set by
   * baltigo's merge functions. Two requirements that refer to the same
   * logical rule across multiple amendments share the same logical_key
   * but only one is_current_version=true at a time.
   *
   * @generated from field: string source_document_id = 31;
   */ _define_property(this, "sourceDocumentId", ""), /**
   * @generated from field: string source_filename = 32;
   */ _define_property(this, "sourceFilename", ""), /**
   * @generated from field: int32 amendment_sequence = 33;
   */ _define_property(this, "amendmentSequence", 0), /**
   * @generated from field: string logical_key = 34;
   */ _define_property(this, "logicalKey", ""), /**
   * @generated from field: bool is_current_version = 35;
   */ _define_property(this, "isCurrentVersion", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(StoredRequirement, "runtime", proto3);
_define_property(StoredRequirement, "typeName", "mono.projectdata.v1.StoredRequirement");
_define_property(StoredRequirement, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "requirement_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "matrix_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "sequence_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "obligation_strength",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "is_mandatory",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 9,
            name: "is_evaluated",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 10,
            name: "evaluation_factor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "evaluation_subfactor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "source",
            kind: "message",
            T: RequirementSourceInfo
        },
        {
            no: 13,
            name: "mapping",
            kind: "message",
            T: RequirementMapping
        },
        {
            no: 14,
            name: "amendment_info",
            kind: "message",
            T: AmendmentInfo
        },
        {
            no: 15,
            name: "confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 16,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "tags",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 18,
            name: "evaluation_weight",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 19,
            name: "entities",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 20,
            name: "related_clins",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 21,
            name: "section_context",
            kind: "message",
            T: SectionContext
        },
        {
            no: 22,
            name: "response_action",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 23,
            name: "deliverable_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 24,
            name: "action_owner",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 25,
            name: "categories",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 26,
            name: "status_history",
            kind: "message",
            T: StatusHistoryEntry,
            repeated: true
        },
        {
            no: 27,
            name: "extracted_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 28,
            name: "extracted_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 29,
            name: "insight_hints",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 30,
            name: "assigned_to_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 31,
            name: "source_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 32,
            name: "source_filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 33,
            name: "amendment_sequence",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 34,
            name: "logical_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 35,
            name: "is_current_version",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.StatusHistoryEntry
 */ export class StatusHistoryEntry extends Message {
    static fromBinary(bytes, options) {
        return new StatusHistoryEntry().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StatusHistoryEntry().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StatusHistoryEntry().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StatusHistoryEntry, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string status = 1;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string changed_by = 2;
   */ _define_property(this, "changedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp changed_at = 3;
   */ _define_property(this, "changedAt", void 0), /**
   * @generated from field: string note = 4;
   */ _define_property(this, "note", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(StatusHistoryEntry, "runtime", proto3);
_define_property(StatusHistoryEntry, "typeName", "mono.projectdata.v1.StatusHistoryEntry");
_define_property(StatusHistoryEntry, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "changed_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "changed_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 4,
            name: "note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SectionContext
 */ export class SectionContext extends Message {
    static fromBinary(bytes, options) {
        return new SectionContext().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SectionContext().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SectionContext().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SectionContext, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string full_path = 1;
   */ _define_property(this, "fullPath", ""), /**
   * @generated from field: string top_level = 2;
   */ _define_property(this, "topLevel", ""), /**
   * @generated from field: string section_number = 3;
   */ _define_property(this, "sectionNumber", ""), /**
   * @generated from field: string title = 4;
   */ _define_property(this, "title", ""), /**
   * @generated from field: int32 depth = 5;
   */ _define_property(this, "depth", 0), /**
   * @generated from field: bool is_pws = 6;
   */ _define_property(this, "isPws", false), /**
   * @generated from field: bool is_addendum = 7;
   */ _define_property(this, "isAddendum", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SectionContext, "runtime", proto3);
_define_property(SectionContext, "typeName", "mono.projectdata.v1.SectionContext");
_define_property(SectionContext, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "full_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "top_level",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "section_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "depth",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "is_pws",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 7,
            name: "is_addendum",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RequirementSourceInfo
 */ export class RequirementSourceInfo extends Message {
    static fromBinary(bytes, options) {
        return new RequirementSourceInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RequirementSourceInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RequirementSourceInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RequirementSourceInfo, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string document_id = 1;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: string document_type = 2;
   */ _define_property(this, "documentType", ""), /**
   * @generated from field: string filename = 3;
   */ _define_property(this, "filename", ""), /**
   * @generated from field: int32 page_number = 4;
   */ _define_property(this, "pageNumber", 0), /**
   * @generated from field: string section_number = 5;
   */ _define_property(this, "sectionNumber", ""), /**
   * @generated from field: string block_id = 6;
   */ _define_property(this, "blockId", ""), /**
   * @generated from field: string exact_text = 7;
   */ _define_property(this, "exactText", ""), /**
   * @generated from field: repeated string source_block_ids = 8;
   */ _define_property(this, "sourceBlockIds", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RequirementSourceInfo, "runtime", proto3);
_define_property(RequirementSourceInfo, "typeName", "mono.projectdata.v1.RequirementSourceInfo");
_define_property(RequirementSourceInfo, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "document_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "page_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "section_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "block_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "exact_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "source_block_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RequirementMapping
 */ export class RequirementMapping extends Message {
    static fromBinary(bytes, options) {
        return new RequirementMapping().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RequirementMapping().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RequirementMapping().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RequirementMapping, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string proposal_section = 1;
   */ _define_property(this, "proposalSection", ""), /**
   * @generated from field: string response_text = 2;
   */ _define_property(this, "responseText", ""), /**
   * @generated from field: string page_reference = 3;
   */ _define_property(this, "pageReference", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RequirementMapping, "runtime", proto3);
_define_property(RequirementMapping, "typeName", "mono.projectdata.v1.RequirementMapping");
_define_property(RequirementMapping, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "proposal_section",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "response_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "page_reference",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.AmendmentInfo
 */ export class AmendmentInfo extends Message {
    static fromBinary(bytes, options) {
        return new AmendmentInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AmendmentInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AmendmentInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AmendmentInfo, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bool is_from_amendment = 1;
   */ _define_property(this, "isFromAmendment", false), /**
   * @generated from field: string amendment_number = 2;
   */ _define_property(this, "amendmentNumber", ""), /**
   * added, modified, removed
   *
   * @generated from field: string change_type = 3;
   */ _define_property(this, "changeType", ""), /**
   * @generated from field: string previous_version = 4;
   */ _define_property(this, "previousVersion", ""), /**
   * @generated from field: string superseded_by_id = 5;
   */ _define_property(this, "supersededById", ""), /**
   * @generated from field: string supersedes = 6;
   */ _define_property(this, "supersedes", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AmendmentInfo, "runtime", proto3);
_define_property(AmendmentInfo, "typeName", "mono.projectdata.v1.AmendmentInfo");
_define_property(AmendmentInfo, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "is_from_amendment",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 2,
            name: "amendment_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "change_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "previous_version",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "superseded_by_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "supersedes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ComplianceMatrixStats
 */ export class ComplianceMatrixStats extends Message {
    static fromBinary(bytes, options) {
        return new ComplianceMatrixStats().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ComplianceMatrixStats().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ComplianceMatrixStats().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ComplianceMatrixStats, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 total_requirements = 1;
   */ _define_property(this, "totalRequirements", 0), /**
   * @generated from field: map<string, int32> by_status = 2;
   */ _define_property(this, "byStatus", {}), /**
   * @generated from field: map<string, int32> by_category = 3;
   */ _define_property(this, "byCategory", {}), /**
   * @generated from field: map<string, int32> by_obligation = 4;
   */ _define_property(this, "byObligation", {}), /**
   * @generated from field: int32 evaluated_count = 5;
   */ _define_property(this, "evaluatedCount", 0), /**
   * @generated from field: int32 mandatory_count = 6;
   */ _define_property(this, "mandatoryCount", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ComplianceMatrixStats, "runtime", proto3);
_define_property(ComplianceMatrixStats, "typeName", "mono.projectdata.v1.ComplianceMatrixStats");
_define_property(ComplianceMatrixStats, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "total_requirements",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "by_status",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "scalar",
                T: 5 /* ScalarType.INT32 */ 
            }
        },
        {
            no: 3,
            name: "by_category",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "scalar",
                T: 5 /* ScalarType.INT32 */ 
            }
        },
        {
            no: 4,
            name: "by_obligation",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "scalar",
                T: 5 /* ScalarType.INT32 */ 
            }
        },
        {
            no: 5,
            name: "evaluated_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "mandatory_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * Full evaluation criteria hierarchy extracted from solicitation evaluation sections.
 *
 * @generated from message mono.projectdata.v1.EvaluationScheme
 */ export class EvaluationScheme extends Message {
    static fromBinary(bytes, options) {
        return new EvaluationScheme().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EvaluationScheme().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EvaluationScheme().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EvaluationScheme, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.EvaluationFactorDetail factors = 1;
   */ _define_property(this, "factors", []), /**
   * trade_off, lpta, adjectival, point_scoring, hybrid
   *
   * @generated from field: string method = 2;
   */ _define_property(this, "method", ""), /**
   * free text description of evaluation methodology
   *
   * @generated from field: string method_details = 3;
   */ _define_property(this, "methodDetails", ""), /**
   * how price relates to non-price factors
   *
   * @generated from field: string price_relation = 4;
   */ _define_property(this, "priceRelation", ""), /**
   * factors that are discriminators
   *
   * @generated from field: repeated string discriminators = 5;
   */ _define_property(this, "discriminators", []), /**
   * section numbers where criteria were found
   *
   * @generated from field: repeated string source_sections = 6;
   */ _define_property(this, "sourceSections", []), /**
   * @generated from field: int64 processing_time_ms = 7;
   */ _define_property(this, "processingTimeMs", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(EvaluationScheme, "runtime", proto3);
_define_property(EvaluationScheme, "typeName", "mono.projectdata.v1.EvaluationScheme");
_define_property(EvaluationScheme, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "factors",
            kind: "message",
            T: EvaluationFactorDetail,
            repeated: true
        },
        {
            no: 2,
            name: "method",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "method_details",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "price_relation",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "discriminators",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 6,
            name: "source_sections",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 7,
            name: "processing_time_ms",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * EvaluationRatingDefinition is a single entry in a factor's adjectival
 * rating scale (Outstanding / Good / Acceptable / Marginal / Unacceptable).
 * IsPassing flags whether this rating clears the factor's gate threshold.
 *
 * @generated from message mono.projectdata.v1.EvaluationRatingDefinition
 */ export class EvaluationRatingDefinition extends Message {
    static fromBinary(bytes, options) {
        return new EvaluationRatingDefinition().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EvaluationRatingDefinition().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EvaluationRatingDefinition().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EvaluationRatingDefinition, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string label = 1;
   */ _define_property(this, "label", ""), /**
   * narrative criteria from Section M
   *
   * @generated from field: string description = 2;
   */ _define_property(this, "description", ""), /**
   * 1 = worst, N = best
   *
   * @generated from field: int32 rank = 3;
   */ _define_property(this, "rank", 0), /**
   * @generated from field: bool is_passing = 4;
   */ _define_property(this, "isPassing", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(EvaluationRatingDefinition, "runtime", proto3);
_define_property(EvaluationRatingDefinition, "typeName", "mono.projectdata.v1.EvaluationRatingDefinition");
_define_property(EvaluationRatingDefinition, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "rank",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "is_passing",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.EvaluationFactorDetail
 */ export class EvaluationFactorDetail extends Message {
    static fromBinary(bytes, options) {
        return new EvaluationFactorDetail().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EvaluationFactorDetail().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EvaluationFactorDetail().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EvaluationFactorDetail, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string name = 1;
   */ _define_property(this, "name", ""), /**
   * "40 points", "most important", "25%"
   *
   * @generated from field: string weight = 2;
   */ _define_property(this, "weight", ""), /**
   * "numeric" | "relative" | "adjectival" | "go_no_go"
   *
   * @generated from field: string weight_type = 3;
   */ _define_property(this, "weightType", ""), /**
   * 1 = most important
   *
   * @generated from field: int32 importance_rank = 4;
   */ _define_property(this, "importanceRank", 0), /**
   * @generated from field: repeated mono.projectdata.v1.EvaluationFactorDetail subfactors = 5;
   */ _define_property(this, "subfactors", []), /**
   * what evaluators look for
   *
   * @generated from field: string description = 6;
   */ _define_property(this, "description", ""), /**
   * legacy flat list — kept for back-compat
   *
   * @generated from field: repeated string ratings = 7;
   */ _define_property(this, "ratings", []), /**
   * linked compliance requirement IDs
   *
   * @generated from field: repeated string requirement_ids = 8;
   */ _define_property(this, "requirementIds", []), /**
   * Structured rating ladder (replaces flat `ratings`).
   *
   * @generated from field: repeated mono.projectdata.v1.EvaluationRatingDefinition rating_scale = 9;
   */ _define_property(this, "ratingScale", []), /**
   * Relative weight statement when weight_type=relative.
   *
   * @generated from field: string relative_statement = 10;
   */ _define_property(this, "relativeStatement", ""), /**
   * Gates and thresholds:
   *
   * factor must be passed for evaluation to continue
   *
   * @generated from field: bool is_gate = 11;
   */ _define_property(this, "isGate", false), /**
   * minimum rating label that clears the gate
   *
   * @generated from field: string gate_threshold = 12;
   */ _define_property(this, "gateThreshold", ""), /**
   * step number this factor gates (multi-step evaluations)
   *
   * @generated from field: int32 gate_step = 13;
   */ _define_property(this, "gateStep", 0), /**
   * "advisory" | "go_no_go" | "minimum_qualification"
   *
   * @generated from field: string gate_purpose = 14;
   */ _define_property(this, "gatePurpose", ""), /**
   * Cross-link to volumes whose content is evaluated under this factor.
   *
   * @generated from field: repeated string volume_identifiers = 15;
   */ _define_property(this, "volumeIdentifiers", []), /**
   * Source grounding + amendment provenance:
   *
   * @generated from field: string source_document_id = 16;
   */ _define_property(this, "sourceDocumentId", ""), /**
   * @generated from field: string source_filename = 17;
   */ _define_property(this, "sourceFilename", ""), /**
   * @generated from field: string amendment_number = 18;
   */ _define_property(this, "amendmentNumber", ""), /**
   * @generated from field: int32 amendment_sequence = 19;
   */ _define_property(this, "amendmentSequence", 0), /**
   * @generated from field: string logical_key = 20;
   */ _define_property(this, "logicalKey", ""), /**
   * @generated from field: bool is_current_version = 21;
   */ _define_property(this, "isCurrentVersion", false), /**
   * @generated from field: string source_text = 22;
   */ _define_property(this, "sourceText", ""), /**
   * @generated from field: repeated string source_block_ids = 23;
   */ _define_property(this, "sourceBlockIds", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(EvaluationFactorDetail, "runtime", proto3);
_define_property(EvaluationFactorDetail, "typeName", "mono.projectdata.v1.EvaluationFactorDetail");
_define_property(EvaluationFactorDetail, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "weight",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "weight_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "importance_rank",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "subfactors",
            kind: "message",
            T: EvaluationFactorDetail,
            repeated: true
        },
        {
            no: 6,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "ratings",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 8,
            name: "requirement_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 9,
            name: "rating_scale",
            kind: "message",
            T: EvaluationRatingDefinition,
            repeated: true
        },
        {
            no: 10,
            name: "relative_statement",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "is_gate",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 12,
            name: "gate_threshold",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "gate_step",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 14,
            name: "gate_purpose",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "volume_identifiers",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 16,
            name: "source_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "source_filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "amendment_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "amendment_sequence",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 20,
            name: "logical_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 21,
            name: "is_current_version",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 22,
            name: "source_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 23,
            name: "source_block_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.QueryCLINsRequest
 */ export class QueryCLINsRequest extends Message {
    static fromBinary(bytes, options) {
        return new QueryCLINsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new QueryCLINsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new QueryCLINsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(QueryCLINsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string contract_id = 3;
   */ _define_property(this, "contractId", ""), /**
   * @generated from field: repeated string clin_numbers = 4;
   */ _define_property(this, "clinNumbers", []), /**
   * base, option_period, optional_task
   *
   * @generated from field: string option_type = 5;
   */ _define_property(this, "optionType", ""), /**
   * @generated from field: int32 option_period = 6;
   */ _define_property(this, "optionPeriod", 0), /**
   * @generated from field: bool include_funding = 7;
   */ _define_property(this, "includeFunding", false), /**
   * @generated from field: mono.common.v1.PaginationRequest pagination = 8;
   */ _define_property(this, "pagination", void 0), /**
   * @generated from field: string search_text = 9;
   */ _define_property(this, "searchText", ""), /**
   * number, title, amount
   *
   * @generated from field: string sort_by = 10;
   */ _define_property(this, "sortBy", ""), /**
   * asc, desc
   *
   * @generated from field: string sort_order = 11;
   */ _define_property(this, "sortOrder", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(QueryCLINsRequest, "runtime", proto3);
_define_property(QueryCLINsRequest, "typeName", "mono.projectdata.v1.QueryCLINsRequest");
_define_property(QueryCLINsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "contract_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "clin_numbers",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 5,
            name: "option_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "option_period",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "include_funding",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 8,
            name: "pagination",
            kind: "message",
            T: PaginationRequest
        },
        {
            no: 9,
            name: "search_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "sort_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "sort_order",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.QueryCLINsResponse
 */ export class QueryCLINsResponse extends Message {
    static fromBinary(bytes, options) {
        return new QueryCLINsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new QueryCLINsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new QueryCLINsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(QueryCLINsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.StoredCLIN clins = 1;
   */ _define_property(this, "clins", []), /**
   * @generated from field: mono.projectdata.v1.FundingSummary funding_summary = 2;
   */ _define_property(this, "fundingSummary", void 0), /**
   * @generated from field: mono.common.v1.PaginationResponse pagination = 3;
   */ _define_property(this, "pagination", void 0), /**
   * Resolved PWS section + attachment locations for click-to-highlight in the
   * UI. Keyed by raw section reference as it appears on a CLIN ("5.2.1"); each
   * entry carries the documentId/blockId/pageNumber needed to navigate the
   * viewer to the originating block.
   *
   * @generated from field: mono.projectdata.v1.CLINReferenceContent reference_content = 4;
   */ _define_property(this, "referenceContent", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(QueryCLINsResponse, "runtime", proto3);
_define_property(QueryCLINsResponse, "typeName", "mono.projectdata.v1.QueryCLINsResponse");
_define_property(QueryCLINsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "clins",
            kind: "message",
            T: StoredCLIN,
            repeated: true
        },
        {
            no: 2,
            name: "funding_summary",
            kind: "message",
            T: FundingSummary
        },
        {
            no: 3,
            name: "pagination",
            kind: "message",
            T: PaginationResponse
        },
        {
            no: 4,
            name: "reference_content",
            kind: "message",
            T: CLINReferenceContent
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CLINReferenceContent
 */ export class CLINReferenceContent extends Message {
    static fromBinary(bytes, options) {
        return new CLINReferenceContent().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CLINReferenceContent().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CLINReferenceContent().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CLINReferenceContent, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: map<string, mono.projectdata.v1.PWSSectionRef> pws_sections = 1;
   */ _define_property(this, "pwsSections", {}), /**
   * @generated from field: map<string, mono.projectdata.v1.AttachmentRef> attachments = 2;
   */ _define_property(this, "attachments", {});
        proto3.util.initPartial(data, this);
    }
}
_define_property(CLINReferenceContent, "runtime", proto3);
_define_property(CLINReferenceContent, "typeName", "mono.projectdata.v1.CLINReferenceContent");
_define_property(CLINReferenceContent, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "pws_sections",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "message",
                T: PWSSectionRef
            }
        },
        {
            no: 2,
            name: "attachments",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "message",
                T: AttachmentRef
            }
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.PWSSectionRef
 */ export class PWSSectionRef extends Message {
    static fromBinary(bytes, options) {
        return new PWSSectionRef().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PWSSectionRef().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PWSSectionRef().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PWSSectionRef, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string title = 1;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string text = 2;
   */ _define_property(this, "text", ""), /**
   * @generated from field: string document_id = 3;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: string filename = 4;
   */ _define_property(this, "filename", ""), /**
   * page_number / block_id remain the anchor (the page to jump to and the
   * primary block to scroll into view). block_ids enumerates every block
   * that belongs to this section — header, body, and any descendant
   * sections covered by `expandedSections` — so the viewer can paint a
   * bounding-box highlight around the whole grouping.
   *
   * @generated from field: int32 page_number = 5;
   */ _define_property(this, "pageNumber", 0), /**
   * @generated from field: string block_id = 6;
   */ _define_property(this, "blockId", ""), /**
   * @generated from field: repeated string block_ids = 7;
   */ _define_property(this, "blockIds", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PWSSectionRef, "runtime", proto3);
_define_property(PWSSectionRef, "typeName", "mono.projectdata.v1.PWSSectionRef");
_define_property(PWSSectionRef, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "page_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "block_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "block_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.AttachmentRef
 */ export class AttachmentRef extends Message {
    static fromBinary(bytes, options) {
        return new AttachmentRef().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AttachmentRef().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AttachmentRef().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AttachmentRef, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string filename = 1;
   */ _define_property(this, "filename", ""), /**
   * @generated from field: string document_type = 2;
   */ _define_property(this, "documentType", ""), /**
   * @generated from field: string summary = 3;
   */ _define_property(this, "summary", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AttachmentRef, "runtime", proto3);
_define_property(AttachmentRef, "typeName", "mono.projectdata.v1.AttachmentRef");
_define_property(AttachmentRef, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "document_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "summary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * StoredCLIN maps to IContractCLINV2 from express-backend.
 *
 * @generated from message mono.projectdata.v1.StoredCLIN
 */ export class StoredCLIN extends Message {
    static fromBinary(bytes, options) {
        return new StoredCLIN().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StoredCLIN().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StoredCLIN().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StoredCLIN, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string clin_id = 1;
   */ _define_property(this, "clinId", ""), /**
   * @generated from field: string contract_id = 2;
   */ _define_property(this, "contractId", ""), /**
   * @generated from field: string contract_number = 3;
   */ _define_property(this, "contractNumber", ""), /**
   * Identification
   *
   * @generated from field: string clin_number = 4;
   */ _define_property(this, "clinNumber", ""), /**
   * @generated from field: string parent_clin = 5;
   */ _define_property(this, "parentClin", ""), /**
   * @generated from field: bool is_subline_item = 6;
   */ _define_property(this, "isSublineItem", false), /**
   * separately_priced, informational, funding
   *
   * @generated from field: string subline_type = 7;
   */ _define_property(this, "sublineType", ""), /**
   * Classification
   *
   * base, option_period, optional_task
   *
   * @generated from field: string option_type = 8;
   */ _define_property(this, "optionType", ""), /**
   * @generated from field: int32 option_period_number = 9;
   */ _define_property(this, "optionPeriodNumber", 0), /**
   * FFP, T&M, CPFF, CPIF, CPAF, CR, HYBRID, OTHER
   *
   * @generated from field: string contract_type = 10;
   */ _define_property(this, "contractType", ""), /**
   * Description
   *
   * @generated from field: string description = 11;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string short_title = 12;
   */ _define_property(this, "shortTitle", ""), /**
   * @generated from field: repeated string pws_sections = 13;
   */ _define_property(this, "pwsSections", []), /**
   * Quantity & Pricing
   *
   * @generated from field: int32 quantity = 14;
   */ _define_property(this, "quantity", 0), /**
   * @generated from field: string unit = 15;
   */ _define_property(this, "unit", ""), /**
   * @generated from field: mono.projectdata.v1.StoredCLINPricing pricing = 16;
   */ _define_property(this, "pricing", void 0), /**
   * Period of Performance
   *
   * @generated from field: mono.projectdata.v1.StoredCLINPeriod period_of_performance = 17;
   */ _define_property(this, "periodOfPerformance", void 0), /**
   * Deliverables
   *
   * @generated from field: bool has_deliverables = 18;
   */ _define_property(this, "hasDeliverables", false), /**
   * @generated from field: repeated string deliverable_ids = 19;
   */ _define_property(this, "deliverableIds", []), /**
   * Labor Mix
   *
   * @generated from field: bool has_labor_mix = 20;
   */ _define_property(this, "hasLaborMix", false), /**
   * @generated from field: mono.projectdata.v1.StoredLaborMix labor_mix = 21;
   */ _define_property(this, "laborMix", void 0), /**
   * Funding
   *
   * funded, unfunded, incrementally_funded, partially_funded, unknown
   *
   * @generated from field: string funding_status = 22;
   */ _define_property(this, "fundingStatus", ""), /**
   * Cross-Period
   *
   * @generated from field: string corresponding_base_clin = 23;
   */ _define_property(this, "correspondingBaseClin", ""), /**
   * Ordering
   *
   * @generated from field: int32 sort_order = 24;
   */ _define_property(this, "sortOrder", 0), /**
   * Phase 3: proposal extraction fields
   *
   * @generated from field: repeated mono.projectdata.v1.ScopedPWSReference scoped_pws_refs = 25;
   */ _define_property(this, "scopedPwsRefs", []), /**
   * @generated from field: mono.projectdata.v1.CLINExerciseInfo exercise_info = 26;
   */ _define_property(this, "exerciseInfo", void 0), /**
   * FFP, T&M, CPFF, CPIF, CPAF, CR, HYBRID, OTHER
   *
   * @generated from field: string cost_type = 27;
   */ _define_property(this, "costType", ""), /**
   * @generated from field: bool needs_team_pricing = 28;
   */ _define_property(this, "needsTeamPricing", false), /**
   * @generated from field: repeated mono.projectdata.v1.ExtractedTeamTier extracted_team_tiers = 29;
   */ _define_property(this, "extractedTeamTiers", []), /**
   * @generated from field: mono.projectdata.v1.ExtractedFeeTarget extracted_fee_target = 30;
   */ _define_property(this, "extractedFeeTarget", void 0), /**
   * @generated from field: bool is_optional_task = 31;
   */ _define_property(this, "isOptionalTask", false), /**
   * @generated from field: int32 optional_task_number = 32;
   */ _define_property(this, "optionalTaskNumber", 0), /**
   * @generated from field: string optional_task_title = 33;
   */ _define_property(this, "optionalTaskTitle", ""), /**
   * @generated from field: repeated string attachment_references = 34;
   */ _define_property(this, "attachmentReferences", []), /**
   * User-editable / metadata fields
   *
   * @generated from field: double confidence = 35;
   */ _define_property(this, "confidence", 0), /**
   * extracted, reviewed, confirmed, disputed
   *
   * @generated from field: string status = 36;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string notes = 37;
   */ _define_property(this, "notes", ""), /**
   * @generated from field: repeated string tags = 38;
   */ _define_property(this, "tags", []), /**
   * ISO 8601 timestamp
   *
   * @generated from field: string extracted_at = 39;
   */ _define_property(this, "extractedAt", ""), /**
   * base, option_period
   *
   * @generated from field: string period_type = 40;
   */ _define_property(this, "periodType", ""), /**
   * @generated from field: mono.projectdata.v1.RequirementSourceInfo source = 41;
   */ _define_property(this, "source", void 0), /**
   * Amendment tracking
   *
   * UNCHANGED, MODIFIED, ADDED, REMOVED
   *
   * @generated from field: string amendment_status = 42;
   */ _define_property(this, "amendmentStatus", ""), /**
   * Amendment number that last modified this CLIN
   *
   * @generated from field: int32 last_modified_in = 43;
   */ _define_property(this, "lastModifiedIn", 0), /**
   * ===== Amendment provenance + supersession (PR-A) =====
   * Set by the amendment-aware merge in baltigo. Multiple versions of the
   * same logical CLIN (across base + amendments) share logical_key, but
   * only one is_current_version=true at a time.
   *
   * @generated from field: string source_document_id = 44;
   */ _define_property(this, "sourceDocumentId", ""), /**
   * @generated from field: string source_filename = 45;
   */ _define_property(this, "sourceFilename", ""), /**
   * @generated from field: bool is_from_amendment = 46;
   */ _define_property(this, "isFromAmendment", false), /**
   * @generated from field: string amendment_number = 47;
   */ _define_property(this, "amendmentNumber", ""), /**
   * @generated from field: int32 amendment_sequence = 48;
   */ _define_property(this, "amendmentSequence", 0), /**
   * @generated from field: string logical_key = 49;
   */ _define_property(this, "logicalKey", ""), /**
   * @generated from field: bool is_current_version = 50;
   */ _define_property(this, "isCurrentVersion", false), /**
   * ContractAnalysisV2 parity: funding history per modification
   *
   * @generated from field: repeated mono.projectdata.v1.FundingHistoryEntry funding_history = 51;
   */ _define_property(this, "fundingHistory", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(StoredCLIN, "runtime", proto3);
_define_property(StoredCLIN, "typeName", "mono.projectdata.v1.StoredCLIN");
_define_property(StoredCLIN, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "clin_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "contract_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "contract_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "clin_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "parent_clin",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "is_subline_item",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 7,
            name: "subline_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "option_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "option_period_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 10,
            name: "contract_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "short_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "pws_sections",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 14,
            name: "quantity",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 15,
            name: "unit",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "pricing",
            kind: "message",
            T: StoredCLINPricing
        },
        {
            no: 17,
            name: "period_of_performance",
            kind: "message",
            T: StoredCLINPeriod
        },
        {
            no: 18,
            name: "has_deliverables",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 19,
            name: "deliverable_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 20,
            name: "has_labor_mix",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 21,
            name: "labor_mix",
            kind: "message",
            T: StoredLaborMix
        },
        {
            no: 22,
            name: "funding_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 23,
            name: "corresponding_base_clin",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 24,
            name: "sort_order",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 25,
            name: "scoped_pws_refs",
            kind: "message",
            T: ScopedPWSReference,
            repeated: true
        },
        {
            no: 26,
            name: "exercise_info",
            kind: "message",
            T: CLINExerciseInfo
        },
        {
            no: 27,
            name: "cost_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 28,
            name: "needs_team_pricing",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 29,
            name: "extracted_team_tiers",
            kind: "message",
            T: ExtractedTeamTier,
            repeated: true
        },
        {
            no: 30,
            name: "extracted_fee_target",
            kind: "message",
            T: ExtractedFeeTarget
        },
        {
            no: 31,
            name: "is_optional_task",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 32,
            name: "optional_task_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 33,
            name: "optional_task_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 34,
            name: "attachment_references",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 35,
            name: "confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 36,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 37,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 38,
            name: "tags",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 39,
            name: "extracted_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 40,
            name: "period_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 41,
            name: "source",
            kind: "message",
            T: RequirementSourceInfo
        },
        {
            no: 42,
            name: "amendment_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 43,
            name: "last_modified_in",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 44,
            name: "source_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 45,
            name: "source_filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 46,
            name: "is_from_amendment",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 47,
            name: "amendment_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 48,
            name: "amendment_sequence",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 49,
            name: "logical_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 50,
            name: "is_current_version",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 51,
            name: "funding_history",
            kind: "message",
            T: FundingHistoryEntry,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ScopedPWSReference
 */ export class ScopedPWSReference extends Message {
    static fromBinary(bytes, options) {
        return new ScopedPWSReference().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ScopedPWSReference().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ScopedPWSReference().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ScopedPWSReference, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string section = 1;
   */ _define_property(this, "section", ""), /**
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * @generated from field: bool includes_all = 3;
   */ _define_property(this, "includesAll", false), /**
   * @generated from field: repeated string only_children = 4;
   */ _define_property(this, "onlyChildren", []), /**
   * @generated from field: repeated string excludes = 5;
   */ _define_property(this, "excludes", []), /**
   * @generated from field: repeated string expanded_sections = 6;
   */ _define_property(this, "expandedSections", []), /**
   * @generated from field: string raw_text = 7;
   */ _define_property(this, "rawText", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ScopedPWSReference, "runtime", proto3);
_define_property(ScopedPWSReference, "typeName", "mono.projectdata.v1.ScopedPWSReference");
_define_property(ScopedPWSReference, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "section",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "includes_all",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "only_children",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 5,
            name: "excludes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 6,
            name: "expanded_sections",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 7,
            name: "raw_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CLINExerciseInfo
 */ export class CLINExerciseInfo extends Message {
    static fromBinary(bytes, options) {
        return new CLINExerciseInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CLINExerciseInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CLINExerciseInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CLINExerciseInfo, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string far_clause = 1;
   */ _define_property(this, "farClause", ""), /**
   * @generated from field: string exercise_frequency = 2;
   */ _define_property(this, "exerciseFrequency", ""), /**
   * @generated from field: int32 pop_months = 3;
   */ _define_property(this, "popMonths", 0), /**
   * @generated from field: string pop_description = 4;
   */ _define_property(this, "popDescription", ""), /**
   * @generated from field: bool pop_is_conditional = 5;
   */ _define_property(this, "popIsConditional", false), /**
   * @generated from field: repeated mono.projectdata.v1.ConditionalPoP conditional_pops = 6;
   */ _define_property(this, "conditionalPops", []), /**
   * @generated from field: bool allows_cross_period = 7;
   */ _define_property(this, "allowsCrossPeriod", false), /**
   * @generated from field: string pop_upper_bound = 8;
   */ _define_property(this, "popUpperBound", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CLINExerciseInfo, "runtime", proto3);
_define_property(CLINExerciseInfo, "typeName", "mono.projectdata.v1.CLINExerciseInfo");
_define_property(CLINExerciseInfo, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "far_clause",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "exercise_frequency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "pop_months",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "pop_description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "pop_is_conditional",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 6,
            name: "conditional_pops",
            kind: "message",
            T: ConditionalPoP,
            repeated: true
        },
        {
            no: 7,
            name: "allows_cross_period",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 8,
            name: "pop_upper_bound",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ConditionalPoP
 */ export class ConditionalPoP extends Message {
    static fromBinary(bytes, options) {
        return new ConditionalPoP().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ConditionalPoP().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ConditionalPoP().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ConditionalPoP, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string during_period = 1;
   */ _define_property(this, "duringPeriod", ""), /**
   * @generated from field: int32 pop_months = 2;
   */ _define_property(this, "popMonths", 0), /**
   * @generated from field: string description = 3;
   */ _define_property(this, "description", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ConditionalPoP, "runtime", proto3);
_define_property(ConditionalPoP, "typeName", "mono.projectdata.v1.ConditionalPoP");
_define_property(ConditionalPoP, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "during_period",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "pop_months",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ExtractedTeamTier
 */ export class ExtractedTeamTier extends Message {
    static fromBinary(bytes, options) {
        return new ExtractedTeamTier().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExtractedTeamTier().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExtractedTeamTier().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExtractedTeamTier, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string label = 1;
   */ _define_property(this, "label", ""), /**
   * @generated from field: int32 tier_number = 2;
   */ _define_property(this, "tierNumber", 0), /**
   * @generated from field: string period = 3;
   */ _define_property(this, "period", ""), /**
   * @generated from field: string price_placeholder = 4;
   */ _define_property(this, "pricePlaceholder", ""), /**
   * @generated from field: mono.projectdata.v1.ExtractedTierDefinition definition = 5;
   */ _define_property(this, "definition", void 0), /**
   * @generated from field: string source = 6;
   */ _define_property(this, "source", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExtractedTeamTier, "runtime", proto3);
_define_property(ExtractedTeamTier, "typeName", "mono.projectdata.v1.ExtractedTeamTier");
_define_property(ExtractedTeamTier, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tier_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "period",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "price_placeholder",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "definition",
            kind: "message",
            T: ExtractedTierDefinition
        },
        {
            no: 6,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ExtractedTierDefinition
 */ export class ExtractedTierDefinition extends Message {
    static fromBinary(bytes, options) {
        return new ExtractedTierDefinition().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExtractedTierDefinition().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExtractedTierDefinition().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExtractedTierDefinition, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string raw_text = 1;
   */ _define_property(this, "rawText", ""), /**
   * @generated from field: repeated mono.projectdata.v1.ExtractedTierRole roles = 2;
   */ _define_property(this, "roles", []), /**
   * @generated from field: double total_ftes = 3;
   */ _define_property(this, "totalFtes", 0), /**
   * @generated from field: string source_location = 4;
   */ _define_property(this, "sourceLocation", ""), /**
   * Minimum FTEs when a range is specified (e.g., 30 in "30-35 FTEs").
   *
   * @generated from field: int32 fte_min = 5;
   */ _define_property(this, "fteMin", 0), /**
   * Maximum FTEs when a range is specified (e.g., 35 in "30-35 FTEs").
   *
   * @generated from field: int32 fte_max = 6;
   */ _define_property(this, "fteMax", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExtractedTierDefinition, "runtime", proto3);
_define_property(ExtractedTierDefinition, "typeName", "mono.projectdata.v1.ExtractedTierDefinition");
_define_property(ExtractedTierDefinition, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "raw_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "roles",
            kind: "message",
            T: ExtractedTierRole,
            repeated: true
        },
        {
            no: 3,
            name: "total_ftes",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 4,
            name: "source_location",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "fte_min",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "fte_max",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ExtractedTierRole
 */ export class ExtractedTierRole extends Message {
    static fromBinary(bytes, options) {
        return new ExtractedTierRole().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExtractedTierRole().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExtractedTierRole().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExtractedTierRole, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string title = 1;
   */ _define_property(this, "title", ""), /**
   * @generated from field: int32 count = 2;
   */ _define_property(this, "count", 0), /**
   * @generated from field: double ftes = 3;
   */ _define_property(this, "ftes", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExtractedTierRole, "runtime", proto3);
_define_property(ExtractedTierRole, "typeName", "mono.projectdata.v1.ExtractedTierRole");
_define_property(ExtractedTierRole, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "ftes",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ExtractedFeeTarget
 */ export class ExtractedFeeTarget extends Message {
    static fromBinary(bytes, options) {
        return new ExtractedFeeTarget().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExtractedFeeTarget().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExtractedFeeTarget().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExtractedFeeTarget, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string fee_type = 1;
   */ _define_property(this, "feeType", ""), /**
   * @generated from field: double target_percentage = 2;
   */ _define_property(this, "targetPercentage", 0), /**
   * @generated from field: double max_percentage = 3;
   */ _define_property(this, "maxPercentage", 0), /**
   * @generated from field: string raw_text = 4;
   */ _define_property(this, "rawText", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExtractedFeeTarget, "runtime", proto3);
_define_property(ExtractedFeeTarget, "typeName", "mono.projectdata.v1.ExtractedFeeTarget");
_define_property(ExtractedFeeTarget, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "fee_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "target_percentage",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 3,
            name: "max_percentage",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 4,
            name: "raw_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.StoredCLINPricing
 */ export class StoredCLINPricing extends Message {
    static fromBinary(bytes, options) {
        return new StoredCLINPricing().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StoredCLINPricing().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StoredCLINPricing().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StoredCLINPricing, a, b);
    }
    constructor(data){
        super(), /**
   * Numeric pricing (contract CLINs)
   *
   * @generated from field: double unit_price = 1;
   */ _define_property(this, "unitPrice", 0), /**
   * @generated from field: double extended_price = 2;
   */ _define_property(this, "extendedPrice", 0), /**
   * @generated from field: bool is_nsp = 3;
   */ _define_property(this, "isNsp", false), /**
   * @generated from field: bool is_nte = 4;
   */ _define_property(this, "isNte", false), /**
   * @generated from field: double nte_ceiling = 5;
   */ _define_property(this, "nteCeiling", 0), /**
   * @generated from field: double funded_amount = 6;
   */ _define_property(this, "fundedAmount", 0), /**
   * @generated from field: double unfunded_amount = 7;
   */ _define_property(this, "unfundedAmount", 0), /**
   * @generated from field: double handling_rate = 8;
   */ _define_property(this, "handlingRate", 0), /**
   * @generated from field: double award_amount = 9;
   */ _define_property(this, "awardAmount", 0), /**
   * @generated from field: double invoiced_amount = 10;
   */ _define_property(this, "invoicedAmount", 0), /**
   * @generated from field: double paid_amount = 11;
   */ _define_property(this, "paidAmount", 0), /**
   * Raw string pricing (proposal CLINs — preserves solicitation text)
   *
   * @generated from field: string raw_unit_price = 12;
   */ _define_property(this, "rawUnitPrice", ""), /**
   * @generated from field: string raw_extended_price = 13;
   */ _define_property(this, "rawExtendedPrice", ""), /**
   * @generated from field: string raw_quantity = 14;
   */ _define_property(this, "rawQuantity", ""), /**
   * @generated from field: string raw_ceiling = 15;
   */ _define_property(this, "rawCeiling", ""), /**
   * @generated from field: bool is_tbd = 16;
   */ _define_property(this, "isTbd", false), /**
   * @generated from field: mono.projectdata.v1.ParsedPricingValue unit_price_parsed = 17;
   */ _define_property(this, "unitPriceParsed", void 0), /**
   * @generated from field: mono.projectdata.v1.ParsedPricingValue extended_price_parsed = 18;
   */ _define_property(this, "extendedPriceParsed", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(StoredCLINPricing, "runtime", proto3);
_define_property(StoredCLINPricing, "typeName", "mono.projectdata.v1.StoredCLINPricing");
_define_property(StoredCLINPricing, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "unit_price",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 2,
            name: "extended_price",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 3,
            name: "is_nsp",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "is_nte",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "nte_ceiling",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 6,
            name: "funded_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 7,
            name: "unfunded_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 8,
            name: "handling_rate",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 9,
            name: "award_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 10,
            name: "invoiced_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 11,
            name: "paid_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 12,
            name: "raw_unit_price",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "raw_extended_price",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "raw_quantity",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "raw_ceiling",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "is_tbd",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 17,
            name: "unit_price_parsed",
            kind: "message",
            T: ParsedPricingValue
        },
        {
            no: 18,
            name: "extended_price_parsed",
            kind: "message",
            T: ParsedPricingValue
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ParsedPricingValue
 */ export class ParsedPricingValue extends Message {
    static fromBinary(bytes, options) {
        return new ParsedPricingValue().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ParsedPricingValue().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ParsedPricingValue().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ParsedPricingValue, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string raw_value = 1;
   */ _define_property(this, "rawValue", ""), /**
   * @generated from field: double numeric_value = 2;
   */ _define_property(this, "numericValue", 0), /**
   * @generated from field: bool is_nsp = 3;
   */ _define_property(this, "isNsp", false), /**
   * @generated from field: bool is_nte = 4;
   */ _define_property(this, "isNte", false), /**
   * @generated from field: double nte_ceiling = 5;
   */ _define_property(this, "nteCeiling", 0), /**
   * @generated from field: bool is_tbd = 6;
   */ _define_property(this, "isTbd", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ParsedPricingValue, "runtime", proto3);
_define_property(ParsedPricingValue, "typeName", "mono.projectdata.v1.ParsedPricingValue");
_define_property(ParsedPricingValue, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "raw_value",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "numeric_value",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 3,
            name: "is_nsp",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "is_nte",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "nte_ceiling",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 6,
            name: "is_tbd",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.StoredCLINPeriod
 */ export class StoredCLINPeriod extends Message {
    static fromBinary(bytes, options) {
        return new StoredCLINPeriod().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StoredCLINPeriod().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StoredCLINPeriod().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StoredCLINPeriod, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string start_date = 1;
   */ _define_property(this, "startDate", ""), /**
   * @generated from field: string end_date = 2;
   */ _define_property(this, "endDate", ""), /**
   * @generated from field: int32 duration_months = 3;
   */ _define_property(this, "durationMonths", 0), /**
   * @generated from field: string period_name = 4;
   */ _define_property(this, "periodName", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(StoredCLINPeriod, "runtime", proto3);
_define_property(StoredCLINPeriod, "typeName", "mono.projectdata.v1.StoredCLINPeriod");
_define_property(StoredCLINPeriod, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "start_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "end_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "duration_months",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "period_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.StoredLaborMix
 */ export class StoredLaborMix extends Message {
    static fromBinary(bytes, options) {
        return new StoredLaborMix().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StoredLaborMix().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StoredLaborMix().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StoredLaborMix, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.StoredLaborCategory categories = 1;
   */ _define_property(this, "categories", []), /**
   * @generated from field: double iteration_price = 2;
   */ _define_property(this, "iterationPrice", 0), /**
   * @generated from field: int32 max_iterations = 3;
   */ _define_property(this, "maxIterations", 0), /**
   * @generated from field: string notes = 4;
   */ _define_property(this, "notes", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(StoredLaborMix, "runtime", proto3);
_define_property(StoredLaborMix, "typeName", "mono.projectdata.v1.StoredLaborMix");
_define_property(StoredLaborMix, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "categories",
            kind: "message",
            T: StoredLaborCategory,
            repeated: true
        },
        {
            no: 2,
            name: "iteration_price",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 3,
            name: "max_iterations",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.StoredLaborCategory
 */ export class StoredLaborCategory extends Message {
    static fromBinary(bytes, options) {
        return new StoredLaborCategory().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StoredLaborCategory().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StoredLaborCategory().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StoredLaborCategory, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string title = 1;
   */ _define_property(this, "title", ""), /**
   * @generated from field: double rate = 2;
   */ _define_property(this, "rate", 0), /**
   * @generated from field: double estimated_hours = 3;
   */ _define_property(this, "estimatedHours", 0), /**
   * @generated from field: double estimated_cost = 4;
   */ _define_property(this, "estimatedCost", 0), /**
   * @generated from field: string hours_basis = 5;
   */ _define_property(this, "hoursBasis", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(StoredLaborCategory, "runtime", proto3);
_define_property(StoredLaborCategory, "typeName", "mono.projectdata.v1.StoredLaborCategory");
_define_property(StoredLaborCategory, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "rate",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 3,
            name: "estimated_hours",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 4,
            name: "estimated_cost",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 5,
            name: "hours_basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.FundingSummary
 */ export class FundingSummary extends Message {
    static fromBinary(bytes, options) {
        return new FundingSummary().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FundingSummary().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FundingSummary().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FundingSummary, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: double total_value = 1;
   */ _define_property(this, "totalValue", 0), /**
   * @generated from field: double total_funded = 2;
   */ _define_property(this, "totalFunded", 0), /**
   * @generated from field: double total_invoiced = 3;
   */ _define_property(this, "totalInvoiced", 0), /**
   * @generated from field: double total_remaining = 4;
   */ _define_property(this, "totalRemaining", 0), /**
   * @generated from field: string funding_status = 5;
   */ _define_property(this, "fundingStatus", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(FundingSummary, "runtime", proto3);
_define_property(FundingSummary, "typeName", "mono.projectdata.v1.FundingSummary");
_define_property(FundingSummary, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "total_value",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 2,
            name: "total_funded",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 3,
            name: "total_invoiced",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 4,
            name: "total_remaining",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 5,
            name: "funding_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.QueryLCATsRequest
 */ export class QueryLCATsRequest extends Message {
    static fromBinary(bytes, options) {
        return new QueryLCATsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new QueryLCATsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new QueryLCATsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(QueryLCATsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * None, Public Trust, Secret, TS, TS/SCI
   *
   * @generated from field: string clearance_level = 3;
   */ _define_property(this, "clearanceLevel", ""), /**
   * @generated from field: repeated string certifications = 4;
   */ _define_property(this, "certifications", []), /**
   * @generated from field: int32 min_experience = 5;
   */ _define_property(this, "minExperience", 0), /**
   * @generated from field: string search_text = 6;
   */ _define_property(this, "searchText", ""), /**
   * @generated from field: mono.common.v1.PaginationRequest pagination = 7;
   */ _define_property(this, "pagination", void 0), /**
   * CLIN number filter
   *
   * @generated from field: string category = 8;
   */ _define_property(this, "category", ""), /**
   * code, title, level, hours
   *
   * @generated from field: string sort_by = 9;
   */ _define_property(this, "sortBy", ""), /**
   * asc, desc
   *
   * @generated from field: string sort_order = 10;
   */ _define_property(this, "sortOrder", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(QueryLCATsRequest, "runtime", proto3);
_define_property(QueryLCATsRequest, "typeName", "mono.projectdata.v1.QueryLCATsRequest");
_define_property(QueryLCATsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "clearance_level",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "certifications",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 5,
            name: "min_experience",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "search_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "pagination",
            kind: "message",
            T: PaginationRequest
        },
        {
            no: 8,
            name: "category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "sort_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "sort_order",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.QueryLCATsResponse
 */ export class QueryLCATsResponse extends Message {
    static fromBinary(bytes, options) {
        return new QueryLCATsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new QueryLCATsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new QueryLCATsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(QueryLCATsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.StoredLCAT labor_categories = 1;
   */ _define_property(this, "laborCategories", []), /**
   * @generated from field: int32 total_count = 2;
   */ _define_property(this, "totalCount", 0), /**
   * @generated from field: mono.common.v1.PaginationResponse pagination = 3;
   */ _define_property(this, "pagination", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(QueryLCATsResponse, "runtime", proto3);
_define_property(QueryLCATsResponse, "typeName", "mono.projectdata.v1.QueryLCATsResponse");
_define_property(QueryLCATsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "labor_categories",
            kind: "message",
            T: StoredLCAT,
            repeated: true
        },
        {
            no: 2,
            name: "total_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "pagination",
            kind: "message",
            T: PaginationResponse
        }
    ]));
/**
 * StoredLCAT aggregates labor category data across CLINs and standalone extractions.
 *
 * @generated from message mono.projectdata.v1.StoredLCAT
 */ export class StoredLCAT extends Message {
    static fromBinary(bytes, options) {
        return new StoredLCAT().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StoredLCAT().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StoredLCAT().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StoredLCAT, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string lcat_id = 1;
   */ _define_property(this, "lcatId", ""), /**
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string description = 3;
   */ _define_property(this, "description", ""), /**
   * flat education level string (legacy)
   *
   * @generated from field: string education = 4;
   */ _define_property(this, "education", ""), /**
   * @generated from field: int32 experience_years = 5;
   */ _define_property(this, "experienceYears", 0), /**
   * @generated from field: repeated string certifications = 6;
   */ _define_property(this, "certifications", []), /**
   * @generated from field: string clearance_required = 7;
   */ _define_property(this, "clearanceRequired", ""), /**
   * @generated from field: repeated string linked_clins = 8;
   */ _define_property(this, "linkedClins", []), /**
   * @generated from field: repeated string pws_sections = 9;
   */ _define_property(this, "pwsSections", []), /**
   * @generated from field: mono.projectdata.v1.RequirementSourceInfo source = 10;
   */ _define_property(this, "source", void 0), /**
   * @generated from field: double hourly_rate = 11;
   */ _define_property(this, "hourlyRate", 0), /**
   * @generated from field: double estimated_hours = 12;
   */ _define_property(this, "estimatedHours", 0), /**
   * Phase 3: proposal extraction fields
   *
   * @generated from field: repeated string alternative_titles = 13;
   */ _define_property(this, "alternativeTitles", []), /**
   * @generated from field: mono.projectdata.v1.LCATEducation education_detail = 14;
   */ _define_property(this, "educationDetail", void 0), /**
   * @generated from field: mono.projectdata.v1.LCATExperience experience_detail = 15;
   */ _define_property(this, "experienceDetail", void 0), /**
   * @generated from field: double government_rate = 16;
   */ _define_property(this, "governmentRate", 0), /**
   * @generated from field: double ceiling_rate = 17;
   */ _define_property(this, "ceilingRate", 0), /**
   * primary linked CLIN
   *
   * @generated from field: string clin_number = 18;
   */ _define_property(this, "clinNumber", ""), /**
   * @generated from field: bool is_key_personnel = 19;
   */ _define_property(this, "isKeyPersonnel", false), /**
   * @generated from field: string team_name = 20;
   */ _define_property(this, "teamName", ""), /**
   * @generated from field: string reasoning = 21;
   */ _define_property(this, "reasoning", ""), /**
   * @generated from field: repeated string attachment_references = 22;
   */ _define_property(this, "attachmentReferences", []), /**
   * @generated from field: repeated mono.projectdata.v1.CLINLinkage clin_linkages = 23;
   */ _define_property(this, "clinLinkages", []), /**
   * User-editable / metadata fields
   *
   * @generated from field: double confidence = 24;
   */ _define_property(this, "confidence", 0), /**
   * extracted, reviewed, confirmed, disputed
   *
   * @generated from field: string status = 25;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string notes = 26;
   */ _define_property(this, "notes", ""), /**
   * @generated from field: repeated string tags = 27;
   */ _define_property(this, "tags", []), /**
   * ISO 8601 timestamp
   *
   * @generated from field: string extracted_at = 28;
   */ _define_property(this, "extractedAt", ""), /**
   * Seniority level from vehicle vocabulary (e.g., "Senior", "Journeyman", "II").
   * Distinct from education_detail.level which describes the education requirement.
   *
   * @generated from field: string level = 29;
   */ _define_property(this, "level", ""), /**
   * Amendment tracking
   *
   * UNCHANGED, MODIFIED, ADDED, REMOVED
   *
   * @generated from field: string amendment_status = 30;
   */ _define_property(this, "amendmentStatus", ""), /**
   * ===== Amendment provenance + supersession (PR-A) =====
   *
   * @generated from field: string source_document_id = 31;
   */ _define_property(this, "sourceDocumentId", ""), /**
   * @generated from field: string source_filename = 32;
   */ _define_property(this, "sourceFilename", ""), /**
   * @generated from field: bool is_from_amendment = 33;
   */ _define_property(this, "isFromAmendment", false), /**
   * @generated from field: string amendment_number = 34;
   */ _define_property(this, "amendmentNumber", ""), /**
   * @generated from field: int32 amendment_sequence = 35;
   */ _define_property(this, "amendmentSequence", 0), /**
   * @generated from field: string logical_key = 36;
   */ _define_property(this, "logicalKey", ""), /**
   * @generated from field: bool is_current_version = 37;
   */ _define_property(this, "isCurrentVersion", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(StoredLCAT, "runtime", proto3);
_define_property(StoredLCAT, "typeName", "mono.projectdata.v1.StoredLCAT");
_define_property(StoredLCAT, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "lcat_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "education",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "experience_years",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "certifications",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 7,
            name: "clearance_required",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "linked_clins",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 9,
            name: "pws_sections",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 10,
            name: "source",
            kind: "message",
            T: RequirementSourceInfo
        },
        {
            no: 11,
            name: "hourly_rate",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 12,
            name: "estimated_hours",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 13,
            name: "alternative_titles",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 14,
            name: "education_detail",
            kind: "message",
            T: LCATEducation
        },
        {
            no: 15,
            name: "experience_detail",
            kind: "message",
            T: LCATExperience
        },
        {
            no: 16,
            name: "government_rate",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 17,
            name: "ceiling_rate",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 18,
            name: "clin_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "is_key_personnel",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 20,
            name: "team_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 21,
            name: "reasoning",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 22,
            name: "attachment_references",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 23,
            name: "clin_linkages",
            kind: "message",
            T: CLINLinkage,
            repeated: true
        },
        {
            no: 24,
            name: "confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 25,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 26,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 27,
            name: "tags",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 28,
            name: "extracted_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 29,
            name: "level",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 30,
            name: "amendment_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 31,
            name: "source_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 32,
            name: "source_filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 33,
            name: "is_from_amendment",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 34,
            name: "amendment_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 35,
            name: "amendment_sequence",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 36,
            name: "logical_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 37,
            name: "is_current_version",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.LCATEducation
 */ export class LCATEducation extends Message {
    static fromBinary(bytes, options) {
        return new LCATEducation().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LCATEducation().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LCATEducation().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LCATEducation, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string level = 1;
   */ _define_property(this, "level", ""), /**
   * @generated from field: string field = 2;
   */ _define_property(this, "field", ""), /**
   * @generated from field: string substitution = 3;
   */ _define_property(this, "substitution", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LCATEducation, "runtime", proto3);
_define_property(LCATEducation, "typeName", "mono.projectdata.v1.LCATEducation");
_define_property(LCATEducation, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "level",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "field",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "substitution",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.LCATExperience
 */ export class LCATExperience extends Message {
    static fromBinary(bytes, options) {
        return new LCATExperience().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LCATExperience().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LCATExperience().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LCATExperience, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 minimum_years = 1;
   */ _define_property(this, "minimumYears", 0), /**
   * @generated from field: string type = 2;
   */ _define_property(this, "type", ""), /**
   * @generated from field: string description = 3;
   */ _define_property(this, "description", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LCATExperience, "runtime", proto3);
_define_property(LCATExperience, "typeName", "mono.projectdata.v1.LCATExperience");
_define_property(LCATExperience, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "minimum_years",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CLINLinkage
 */ export class CLINLinkage extends Message {
    static fromBinary(bytes, options) {
        return new CLINLinkage().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CLINLinkage().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CLINLinkage().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CLINLinkage, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string clin_number = 1;
   */ _define_property(this, "clinNumber", ""), /**
   * @generated from field: string reasoning = 2;
   */ _define_property(this, "reasoning", ""), /**
   * @generated from field: double confidence = 3;
   */ _define_property(this, "confidence", 0), /**
   * @generated from field: repeated string pws_references = 4;
   */ _define_property(this, "pwsReferences", []), /**
   * @generated from field: repeated string attachment_references = 5;
   */ _define_property(this, "attachmentReferences", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CLINLinkage, "runtime", proto3);
_define_property(CLINLinkage, "typeName", "mono.projectdata.v1.CLINLinkage");
_define_property(CLINLinkage, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "clin_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "reasoning",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 4,
            name: "pws_references",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 5,
            name: "attachment_references",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.QueryDeliverablesRequest
 */ export class QueryDeliverablesRequest extends Message {
    static fromBinary(bytes, options) {
        return new QueryDeliverablesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new QueryDeliverablesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new QueryDeliverablesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(QueryDeliverablesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string contract_id = 3;
   */ _define_property(this, "contractId", ""), /**
   * not_started, in_progress, draft_complete, submitted, under_review, accepted, rejected, resubmitted
   *
   * @generated from field: repeated string status = 4;
   */ _define_property(this, "status", []), /**
   * @generated from field: int32 due_within_days = 5;
   */ _define_property(this, "dueWithinDays", 0), /**
   * @generated from field: bool overdue_only = 6;
   */ _define_property(this, "overdueOnly", false), /**
   * @generated from field: string cdrl_number = 7;
   */ _define_property(this, "cdrlNumber", ""), /**
   * @generated from field: mono.common.v1.PaginationRequest pagination = 8;
   */ _define_property(this, "pagination", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(QueryDeliverablesRequest, "runtime", proto3);
_define_property(QueryDeliverablesRequest, "typeName", "mono.projectdata.v1.QueryDeliverablesRequest");
_define_property(QueryDeliverablesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "contract_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 5,
            name: "due_within_days",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "overdue_only",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 7,
            name: "cdrl_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "pagination",
            kind: "message",
            T: PaginationRequest
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.QueryDeliverablesResponse
 */ export class QueryDeliverablesResponse extends Message {
    static fromBinary(bytes, options) {
        return new QueryDeliverablesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new QueryDeliverablesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new QueryDeliverablesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(QueryDeliverablesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.StoredDeliverable deliverables = 1;
   */ _define_property(this, "deliverables", []), /**
   * @generated from field: mono.projectdata.v1.DeliverableQueryStats stats = 2;
   */ _define_property(this, "stats", void 0), /**
   * @generated from field: mono.common.v1.PaginationResponse pagination = 3;
   */ _define_property(this, "pagination", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(QueryDeliverablesResponse, "runtime", proto3);
_define_property(QueryDeliverablesResponse, "typeName", "mono.projectdata.v1.QueryDeliverablesResponse");
_define_property(QueryDeliverablesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "deliverables",
            kind: "message",
            T: StoredDeliverable,
            repeated: true
        },
        {
            no: 2,
            name: "stats",
            kind: "message",
            T: DeliverableQueryStats
        },
        {
            no: 3,
            name: "pagination",
            kind: "message",
            T: PaginationResponse
        }
    ]));
/**
 * StoredDeliverable maps to IDeliverable from express-backend.
 *
 * @generated from message mono.projectdata.v1.StoredDeliverable
 */ export class StoredDeliverable extends Message {
    static fromBinary(bytes, options) {
        return new StoredDeliverable().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StoredDeliverable().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StoredDeliverable().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StoredDeliverable, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string deliverable_id = 1;
   */ _define_property(this, "deliverableId", ""), /**
   * @generated from field: string contract_id = 2;
   */ _define_property(this, "contractId", ""), /**
   * @generated from field: string clin_id = 3;
   */ _define_property(this, "clinId", ""), /**
   * @generated from field: string clin_number = 4;
   */ _define_property(this, "clinNumber", ""), /**
   * Identification
   *
   * @generated from field: string cdrl_number = 5;
   */ _define_property(this, "cdrlNumber", ""), /**
   * @generated from field: string title = 6;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string description = 7;
   */ _define_property(this, "description", ""), /**
   * report, document, presentation, meeting, training, software, data, other
   *
   * @generated from field: string type = 8;
   */ _define_property(this, "type", ""), /**
   * Schedule
   *
   * one_time, daily, weekly, biweekly, monthly, quarterly, annually, as_needed, on_demand
   *
   * @generated from field: string cadence = 9;
   */ _define_property(this, "cadence", ""), /**
   * @generated from field: string due_date = 10;
   */ _define_property(this, "dueDate", ""), /**
   * @generated from field: int32 days_after_award = 11;
   */ _define_property(this, "daysAfterAward", 0), /**
   * @generated from field: string trigger_event = 12;
   */ _define_property(this, "triggerEvent", ""), /**
   * Requirements
   *
   * @generated from field: string format = 13;
   */ _define_property(this, "format", ""), /**
   * @generated from field: string submission_method = 14;
   */ _define_property(this, "submissionMethod", ""), /**
   * @generated from field: repeated string pws_sections = 15;
   */ _define_property(this, "pwsSections", []), /**
   * Status
   *
   * @generated from field: string status = 16;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string current_due_date = 17;
   */ _define_property(this, "currentDueDate", ""), /**
   * @generated from field: string next_due_date = 18;
   */ _define_property(this, "nextDueDate", ""), /**
   * @generated from field: bool is_overdue = 19;
   */ _define_property(this, "isOverdue", false), /**
   * @generated from field: int32 days_until_due = 20;
   */ _define_property(this, "daysUntilDue", 0), /**
   * Stats
   *
   * @generated from field: int32 total_submissions = 21;
   */ _define_property(this, "totalSubmissions", 0), /**
   * @generated from field: int32 accepted_submissions = 22;
   */ _define_property(this, "acceptedSubmissions", 0), /**
   * @generated from field: int32 rejected_submissions = 23;
   */ _define_property(this, "rejectedSubmissions", 0), /**
   * ===== Amendment provenance + supersession (PR-A) =====
   *
   * @generated from field: string source_document_id = 24;
   */ _define_property(this, "sourceDocumentId", ""), /**
   * @generated from field: string source_filename = 25;
   */ _define_property(this, "sourceFilename", ""), /**
   * @generated from field: bool is_from_amendment = 26;
   */ _define_property(this, "isFromAmendment", false), /**
   * @generated from field: string amendment_number = 27;
   */ _define_property(this, "amendmentNumber", ""), /**
   * @generated from field: int32 amendment_sequence = 28;
   */ _define_property(this, "amendmentSequence", 0), /**
   * @generated from field: string logical_key = 29;
   */ _define_property(this, "logicalKey", ""), /**
   * @generated from field: bool is_current_version = 30;
   */ _define_property(this, "isCurrentVersion", false), /**
   * ContractAnalysisV2 parity fields
   *
   * @generated from field: string recurring_detail = 31;
   */ _define_property(this, "recurringDetail", ""), /**
   * @generated from field: string acceptance_criteria = 32;
   */ _define_property(this, "acceptanceCriteria", ""), /**
   * @generated from field: bool is_cdrl = 33;
   */ _define_property(this, "isCdrl", false), /**
   * @generated from field: string slin_number = 34;
   */ _define_property(this, "slinNumber", ""), /**
   * @generated from field: int32 sort_order = 35;
   */ _define_property(this, "sortOrder", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(StoredDeliverable, "runtime", proto3);
_define_property(StoredDeliverable, "typeName", "mono.projectdata.v1.StoredDeliverable");
_define_property(StoredDeliverable, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "deliverable_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "contract_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "clin_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "clin_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "cdrl_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "cadence",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "due_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "days_after_award",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 12,
            name: "trigger_event",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "format",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "submission_method",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "pws_sections",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 16,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "current_due_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "next_due_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "is_overdue",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 20,
            name: "days_until_due",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 21,
            name: "total_submissions",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 22,
            name: "accepted_submissions",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 23,
            name: "rejected_submissions",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 24,
            name: "source_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 25,
            name: "source_filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 26,
            name: "is_from_amendment",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 27,
            name: "amendment_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 28,
            name: "amendment_sequence",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 29,
            name: "logical_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 30,
            name: "is_current_version",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 31,
            name: "recurring_detail",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 32,
            name: "acceptance_criteria",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 33,
            name: "is_cdrl",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 34,
            name: "slin_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 35,
            name: "sort_order",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.DeliverableQueryStats
 */ export class DeliverableQueryStats extends Message {
    static fromBinary(bytes, options) {
        return new DeliverableQueryStats().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeliverableQueryStats().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeliverableQueryStats().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeliverableQueryStats, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 total_deliverables = 1;
   */ _define_property(this, "totalDeliverables", 0), /**
   * @generated from field: map<string, int32> by_status = 2;
   */ _define_property(this, "byStatus", {}), /**
   * @generated from field: int32 overdue_count = 3;
   */ _define_property(this, "overdueCount", 0), /**
   * @generated from field: int32 due_this_month = 4;
   */ _define_property(this, "dueThisMonth", 0), /**
   * @generated from field: int32 due_next_month = 5;
   */ _define_property(this, "dueNextMonth", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeliverableQueryStats, "runtime", proto3);
_define_property(DeliverableQueryStats, "typeName", "mono.projectdata.v1.DeliverableQueryStats");
_define_property(DeliverableQueryStats, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "total_deliverables",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "by_status",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "scalar",
                T: 5 /* ScalarType.INT32 */ 
            }
        },
        {
            no: 3,
            name: "overdue_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "due_this_month",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "due_next_month",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * Requires project write access. Omitted fields are unchanged; present empty
 * strings clear assignments. Users must be active project members in the tenant.
 *
 * @generated from message mono.projectdata.v1.UpdateOutlineSectionAssignmentsRequest
 */ export class UpdateOutlineSectionAssignmentsRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateOutlineSectionAssignmentsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateOutlineSectionAssignmentsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateOutlineSectionAssignmentsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateOutlineSectionAssignmentsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string section_id = 3;
   */ _define_property(this, "sectionId", ""), /**
   * @generated from field: optional string writer_user_id = 4;
   */ _define_property(this, "writerUserId", void 0), /**
   * @generated from field: optional string reviewer_user_id = 5;
   */ _define_property(this, "reviewerUserId", void 0), /**
   * Strict YYYY-MM-DD calendar date; empty clears.
   *
   * @generated from field: optional string internal_date = 6;
   */ _define_property(this, "internalDate", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateOutlineSectionAssignmentsRequest, "runtime", proto3);
_define_property(UpdateOutlineSectionAssignmentsRequest, "typeName", "mono.projectdata.v1.UpdateOutlineSectionAssignmentsRequest");
_define_property(UpdateOutlineSectionAssignmentsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "writer_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 5,
            name: "reviewer_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 6,
            name: "internal_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpdateOutlineSectionAssignmentsResponse
 */ export class UpdateOutlineSectionAssignmentsResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateOutlineSectionAssignmentsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateOutlineSectionAssignmentsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateOutlineSectionAssignmentsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateOutlineSectionAssignmentsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.SectionNode section = 1;
   */ _define_property(this, "section", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateOutlineSectionAssignmentsResponse, "runtime", proto3);
_define_property(UpdateOutlineSectionAssignmentsResponse, "typeName", "mono.projectdata.v1.UpdateOutlineSectionAssignmentsResponse");
_define_property(UpdateOutlineSectionAssignmentsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "section",
            kind: "message",
            T: SectionNode
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetSectionMapRequest
 */ export class GetSectionMapRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetSectionMapRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetSectionMapRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetSectionMapRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetSectionMapRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * specific document, or all if empty
   *
   * @generated from field: string document_id = 3;
   */ _define_property(this, "documentId", ""), /**
   * filter outline sections by volume
   *
   * @generated from field: string volume_id = 4;
   */ _define_property(this, "volumeId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetSectionMapRequest, "runtime", proto3);
_define_property(GetSectionMapRequest, "typeName", "mono.projectdata.v1.GetSectionMapRequest");
_define_property(GetSectionMapRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "volume_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetSectionMapResponse
 */ export class GetSectionMapResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetSectionMapResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetSectionMapResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetSectionMapResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetSectionMapResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.SectionNode sections = 1;
   */ _define_property(this, "sections", []), /**
   * @generated from field: string document_id = 2;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: int32 total_sections = 3;
   */ _define_property(this, "totalSections", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetSectionMapResponse, "runtime", proto3);
_define_property(GetSectionMapResponse, "typeName", "mono.projectdata.v1.GetSectionMapResponse");
_define_property(GetSectionMapResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "sections",
            kind: "message",
            T: SectionNode,
            repeated: true
        },
        {
            no: 2,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "total_sections",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SectionNode
 */ export class SectionNode extends Message {
    static fromBinary(bytes, options) {
        return new SectionNode().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SectionNode().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SectionNode().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SectionNode, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string section_id = 1;
   */ _define_property(this, "sectionId", ""), /**
   * @generated from field: string section_number = 2;
   */ _define_property(this, "sectionNumber", ""), /**
   * @generated from field: string title = 3;
   */ _define_property(this, "title", ""), /**
   * @generated from field: int32 level = 4;
   */ _define_property(this, "level", 0), /**
   * @generated from field: int32 page_number = 5;
   */ _define_property(this, "pageNumber", 0), /**
   * @generated from field: repeated mono.projectdata.v1.SectionNode children = 6;
   */ _define_property(this, "children", []), /**
   * @generated from field: int32 block_count = 7;
   */ _define_property(this, "blockCount", 0), /**
   * @generated from field: string parent_section_id = 8;
   */ _define_property(this, "parentSectionId", ""), /**
   * @generated from field: int32 sort_order = 9;
   */ _define_property(this, "sortOrder", 0), /**
   * @generated from field: string description = 10;
   */ _define_property(this, "description", ""), /**
   * "extracted" (from document_blocks) or "user" (from outline_sections)
   *
   * @generated from field: string source = 11;
   */ _define_property(this, "source", ""), /**
   * @generated from field: repeated string requirement_ids = 12;
   */ _define_property(this, "requirementIds", []), /**
   * @generated from field: repeated string tagged_file_ids = 13;
   */ _define_property(this, "taggedFileIds", []), /**
   * @generated from field: optional string writer_user_id = 14;
   */ _define_property(this, "writerUserId", void 0), /**
   * @generated from field: optional string reviewer_user_id = 15;
   */ _define_property(this, "reviewerUserId", void 0), /**
   * Calendar date, YYYY-MM-DD, without a timezone.
   *
   * @generated from field: optional string internal_date = 16;
   */ _define_property(this, "internalDate", void 0), /**
   * WRT-29: anchor bookmark, orphaned time and content projection (inputs to
   * the section status and PRP's drafted predicate).
   *
   * @generated from field: string anchor_bookmark = 17;
   */ _define_property(this, "anchorBookmark", ""), /**
   * @generated from field: google.protobuf.Timestamp orphaned_at = 18;
   */ _define_property(this, "orphanedAt", void 0), /**
   * @generated from field: int32 content_words = 19;
   */ _define_property(this, "contentWords", 0), /**
   * @generated from field: string content_region_sha256 = 20;
   */ _define_property(this, "contentRegionSha256", ""), /**
   * WRT-17: the heading's document, and the "Mark ready" stamp (Ready while
   * ready_region_sha256 is non-empty and equals content_region_sha256).
   *
   * @generated from field: string source_document_id = 21;
   */ _define_property(this, "sourceDocumentId", ""), /**
   * @generated from field: string ready_region_sha256 = 22;
   */ _define_property(this, "readyRegionSha256", ""), /**
   * @generated from field: string ready_label = 23;
   */ _define_property(this, "readyLabel", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SectionNode, "runtime", proto3);
_define_property(SectionNode, "typeName", "mono.projectdata.v1.SectionNode");
_define_property(SectionNode, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "section_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "level",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "page_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "children",
            kind: "message",
            T: SectionNode,
            repeated: true
        },
        {
            no: 7,
            name: "block_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 8,
            name: "parent_section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "sort_order",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 10,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "requirement_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 13,
            name: "tagged_file_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 14,
            name: "writer_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 15,
            name: "reviewer_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 16,
            name: "internal_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 17,
            name: "anchor_bookmark",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "orphaned_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 19,
            name: "content_words",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 20,
            name: "content_region_sha256",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 21,
            name: "source_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 22,
            name: "ready_region_sha256",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 23,
            name: "ready_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetAmendmentHistoryRequest
 */ export class GetAmendmentHistoryRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetAmendmentHistoryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetAmendmentHistoryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetAmendmentHistoryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetAmendmentHistoryRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetAmendmentHistoryRequest, "runtime", proto3);
_define_property(GetAmendmentHistoryRequest, "typeName", "mono.projectdata.v1.GetAmendmentHistoryRequest");
_define_property(GetAmendmentHistoryRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetAmendmentHistoryResponse
 */ export class GetAmendmentHistoryResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetAmendmentHistoryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetAmendmentHistoryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetAmendmentHistoryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetAmendmentHistoryResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.AmendmentEvent events = 1;
   */ _define_property(this, "events", []), /**
   * @generated from field: int32 total_amendments = 2;
   */ _define_property(this, "totalAmendments", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetAmendmentHistoryResponse, "runtime", proto3);
_define_property(GetAmendmentHistoryResponse, "typeName", "mono.projectdata.v1.GetAmendmentHistoryResponse");
_define_property(GetAmendmentHistoryResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "events",
            kind: "message",
            T: AmendmentEvent,
            repeated: true
        },
        {
            no: 2,
            name: "total_amendments",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.AmendmentEvent
 */ export class AmendmentEvent extends Message {
    static fromBinary(bytes, options) {
        return new AmendmentEvent().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AmendmentEvent().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AmendmentEvent().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AmendmentEvent, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string amendment_id = 1;
   */ _define_property(this, "amendmentId", ""), /**
   * @generated from field: string amendment_number = 2;
   */ _define_property(this, "amendmentNumber", ""), /**
   * @generated from field: string document_id = 3;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: google.protobuf.Timestamp effective_date = 4;
   */ _define_property(this, "effectiveDate", void 0), /**
   * @generated from field: string summary = 5;
   */ _define_property(this, "summary", ""), /**
   * @generated from field: int32 requirements_added = 6;
   */ _define_property(this, "requirementsAdded", 0), /**
   * @generated from field: int32 requirements_modified = 7;
   */ _define_property(this, "requirementsModified", 0), /**
   * @generated from field: int32 requirements_removed = 8;
   */ _define_property(this, "requirementsRemoved", 0), /**
   * @generated from field: repeated mono.projectdata.v1.FundingChange funding_changes = 9;
   */ _define_property(this, "fundingChanges", []), /**
   * @generated from field: repeated mono.projectdata.v1.ScopeChange scope_changes = 10;
   */ _define_property(this, "scopeChanges", []), /**
   * @generated from field: repeated mono.projectdata.v1.PeriodChange period_changes = 11;
   */ _define_property(this, "periodChanges", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AmendmentEvent, "runtime", proto3);
_define_property(AmendmentEvent, "typeName", "mono.projectdata.v1.AmendmentEvent");
_define_property(AmendmentEvent, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "amendment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "amendment_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "effective_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "summary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "requirements_added",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "requirements_modified",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 8,
            name: "requirements_removed",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 9,
            name: "funding_changes",
            kind: "message",
            T: FundingChange,
            repeated: true
        },
        {
            no: 10,
            name: "scope_changes",
            kind: "message",
            T: ScopeChange,
            repeated: true
        },
        {
            no: 11,
            name: "period_changes",
            kind: "message",
            T: PeriodChange,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetAmbiguitiesRequest
 */ export class GetAmbiguitiesRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetAmbiguitiesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetAmbiguitiesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetAmbiguitiesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetAmbiguitiesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * optional filter: low, medium, high, critical
   *
   * @generated from field: string severity = 3;
   */ _define_property(this, "severity", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetAmbiguitiesRequest, "runtime", proto3);
_define_property(GetAmbiguitiesRequest, "typeName", "mono.projectdata.v1.GetAmbiguitiesRequest");
_define_property(GetAmbiguitiesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "severity",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetAmbiguitiesResponse
 */ export class GetAmbiguitiesResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetAmbiguitiesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetAmbiguitiesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetAmbiguitiesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetAmbiguitiesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.Ambiguity ambiguities = 1;
   */ _define_property(this, "ambiguities", []), /**
   * @generated from field: int32 total_count = 2;
   */ _define_property(this, "totalCount", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetAmbiguitiesResponse, "runtime", proto3);
_define_property(GetAmbiguitiesResponse, "typeName", "mono.projectdata.v1.GetAmbiguitiesResponse");
_define_property(GetAmbiguitiesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "ambiguities",
            kind: "message",
            T: Ambiguity,
            repeated: true
        },
        {
            no: 2,
            name: "total_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.Ambiguity
 */ export class Ambiguity extends Message {
    static fromBinary(bytes, options) {
        return new Ambiguity().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Ambiguity().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Ambiguity().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Ambiguity, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string ambiguity_id = 1;
   */ _define_property(this, "ambiguityId", ""), /**
   * @generated from field: string text = 2;
   */ _define_property(this, "text", ""), /**
   * conflicting_requirements, vague_language, missing_information, contradictory_terms
   *
   * @generated from field: string category = 3;
   */ _define_property(this, "category", ""), /**
   * low, medium, high, critical
   *
   * @generated from field: string severity = 4;
   */ _define_property(this, "severity", ""), /**
   * @generated from field: mono.projectdata.v1.RequirementSourceInfo source = 5;
   */ _define_property(this, "source", void 0), /**
   * @generated from field: repeated string related_requirement_ids = 6;
   */ _define_property(this, "relatedRequirementIds", []), /**
   * @generated from field: string explanation = 7;
   */ _define_property(this, "explanation", ""), /**
   * @generated from field: string suggested_resolution = 8;
   */ _define_property(this, "suggestedResolution", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(Ambiguity, "runtime", proto3);
_define_property(Ambiguity, "typeName", "mono.projectdata.v1.Ambiguity");
_define_property(Ambiguity, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "ambiguity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "severity",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "source",
            kind: "message",
            T: RequirementSourceInfo
        },
        {
            no: 6,
            name: "related_requirement_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 7,
            name: "explanation",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "suggested_resolution",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpdateRequirementStatusRequest
 */ export class UpdateRequirementStatusRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateRequirementStatusRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateRequirementStatusRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateRequirementStatusRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateRequirementStatusRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string requirement_id = 3;
   */ _define_property(this, "requirementId", ""), /**
   * NOT_STARTED, IN_PROGRESS, ADDRESSED, PARTIAL, NON_COMPLIANT, N/A
   *
   * @generated from field: string status = 4;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string notes = 5;
   */ _define_property(this, "notes", ""), /**
   * optional proposal section mapping
   *
   * @generated from field: mono.projectdata.v1.RequirementMapping mapping = 6;
   */ _define_property(this, "mapping", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateRequirementStatusRequest, "runtime", proto3);
_define_property(UpdateRequirementStatusRequest, "typeName", "mono.projectdata.v1.UpdateRequirementStatusRequest");
_define_property(UpdateRequirementStatusRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "requirement_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "mapping",
            kind: "message",
            T: RequirementMapping
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpdateRequirementStatusResponse
 */ export class UpdateRequirementStatusResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateRequirementStatusResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateRequirementStatusResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateRequirementStatusResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateRequirementStatusResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.StoredRequirement requirement = 1;
   */ _define_property(this, "requirement", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateRequirementStatusResponse, "runtime", proto3);
_define_property(UpdateRequirementStatusResponse, "typeName", "mono.projectdata.v1.UpdateRequirementStatusResponse");
_define_property(UpdateRequirementStatusResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "requirement",
            kind: "message",
            T: StoredRequirement
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpdateRequirementAssignmentRequest
 */ export class UpdateRequirementAssignmentRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateRequirementAssignmentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateRequirementAssignmentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateRequirementAssignmentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateRequirementAssignmentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string requirement_id = 3;
   */ _define_property(this, "requirementId", ""), /**
   * Empty string clears the assignment.
   *
   * @generated from field: string assigned_to_user_id = 4;
   */ _define_property(this, "assignedToUserId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateRequirementAssignmentRequest, "runtime", proto3);
_define_property(UpdateRequirementAssignmentRequest, "typeName", "mono.projectdata.v1.UpdateRequirementAssignmentRequest");
_define_property(UpdateRequirementAssignmentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "requirement_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "assigned_to_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpdateRequirementAssignmentResponse
 */ export class UpdateRequirementAssignmentResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateRequirementAssignmentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateRequirementAssignmentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateRequirementAssignmentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateRequirementAssignmentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.StoredRequirement requirement = 1;
   */ _define_property(this, "requirement", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateRequirementAssignmentResponse, "runtime", proto3);
_define_property(UpdateRequirementAssignmentResponse, "typeName", "mono.projectdata.v1.UpdateRequirementAssignmentResponse");
_define_property(UpdateRequirementAssignmentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "requirement",
            kind: "message",
            T: StoredRequirement
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpdateDeliverableStatusRequest
 */ export class UpdateDeliverableStatusRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateDeliverableStatusRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateDeliverableStatusRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateDeliverableStatusRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateDeliverableStatusRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string deliverable_id = 3;
   */ _define_property(this, "deliverableId", ""), /**
   * not_started, in_progress, draft_complete, submitted, under_review, accepted, rejected, resubmitted
   *
   * @generated from field: string status = 4;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string notes = 5;
   */ _define_property(this, "notes", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateDeliverableStatusRequest, "runtime", proto3);
_define_property(UpdateDeliverableStatusRequest, "typeName", "mono.projectdata.v1.UpdateDeliverableStatusRequest");
_define_property(UpdateDeliverableStatusRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "deliverable_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpdateDeliverableStatusResponse
 */ export class UpdateDeliverableStatusResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateDeliverableStatusResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateDeliverableStatusResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateDeliverableStatusResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateDeliverableStatusResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.StoredDeliverable deliverable = 1;
   */ _define_property(this, "deliverable", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateDeliverableStatusResponse, "runtime", proto3);
_define_property(UpdateDeliverableStatusResponse, "typeName", "mono.projectdata.v1.UpdateDeliverableStatusResponse");
_define_property(UpdateDeliverableStatusResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "deliverable",
            kind: "message",
            T: StoredDeliverable
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpdateCLINStatusRequest
 */ export class UpdateCLINStatusRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateCLINStatusRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateCLINStatusRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateCLINStatusRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateCLINStatusRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string clin_id = 3;
   */ _define_property(this, "clinId", ""), /**
   * funded, unfunded, incrementally_funded, partially_funded, unknown
   *
   * @generated from field: string funding_status = 4;
   */ _define_property(this, "fundingStatus", ""), /**
   * @generated from field: string notes = 5;
   */ _define_property(this, "notes", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateCLINStatusRequest, "runtime", proto3);
_define_property(UpdateCLINStatusRequest, "typeName", "mono.projectdata.v1.UpdateCLINStatusRequest");
_define_property(UpdateCLINStatusRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "clin_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "funding_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpdateCLINStatusResponse
 */ export class UpdateCLINStatusResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateCLINStatusResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateCLINStatusResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateCLINStatusResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateCLINStatusResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.StoredCLIN clin = 1;
   */ _define_property(this, "clin", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateCLINStatusResponse, "runtime", proto3);
_define_property(UpdateCLINStatusResponse, "typeName", "mono.projectdata.v1.UpdateCLINStatusResponse");
_define_property(UpdateCLINStatusResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "clin",
            kind: "message",
            T: StoredCLIN
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpdateOutlineSectionRequest
 */ export class UpdateOutlineSectionRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateOutlineSectionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateOutlineSectionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateOutlineSectionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateOutlineSectionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * empty to create a new section
   *
   * @generated from field: string section_id = 3;
   */ _define_property(this, "sectionId", ""), /**
   * @generated from field: string title = 4;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string description = 5;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string parent_section_id = 6;
   */ _define_property(this, "parentSectionId", ""), /**
   * @generated from field: int32 sort_order = 7;
   */ _define_property(this, "sortOrder", 0), /**
   * which volume this section belongs to
   *
   * @generated from field: string volume_id = 8;
   */ _define_property(this, "volumeId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateOutlineSectionRequest, "runtime", proto3);
_define_property(UpdateOutlineSectionRequest, "typeName", "mono.projectdata.v1.UpdateOutlineSectionRequest");
_define_property(UpdateOutlineSectionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "parent_section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "sort_order",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 8,
            name: "volume_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpdateOutlineSectionResponse
 */ export class UpdateOutlineSectionResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateOutlineSectionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateOutlineSectionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateOutlineSectionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateOutlineSectionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.OutlineSection section = 1;
   */ _define_property(this, "section", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateOutlineSectionResponse, "runtime", proto3);
_define_property(UpdateOutlineSectionResponse, "typeName", "mono.projectdata.v1.UpdateOutlineSectionResponse");
_define_property(UpdateOutlineSectionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "section",
            kind: "message",
            T: OutlineSection
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.OutlineSection
 */ export class OutlineSection extends Message {
    static fromBinary(bytes, options) {
        return new OutlineSection().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OutlineSection().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OutlineSection().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OutlineSection, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string section_id = 1;
   */ _define_property(this, "sectionId", ""), /**
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string description = 3;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string parent_section_id = 4;
   */ _define_property(this, "parentSectionId", ""), /**
   * @generated from field: int32 sort_order = 5;
   */ _define_property(this, "sortOrder", 0), /**
   * @generated from field: repeated string tagged_file_ids = 6;
   */ _define_property(this, "taggedFileIds", []), /**
   * @generated from field: repeated string requirement_ids = 7;
   */ _define_property(this, "requirementIds", []), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 8;
   */ _define_property(this, "updatedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(OutlineSection, "runtime", proto3);
_define_property(OutlineSection, "typeName", "mono.projectdata.v1.OutlineSection");
_define_property(OutlineSection, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "parent_section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "sort_order",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "tagged_file_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 7,
            name: "requirement_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 8,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpsertWritingPlanRequest
 */ export class UpsertWritingPlanRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertWritingPlanRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertWritingPlanRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertWritingPlanRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertWritingPlanRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: repeated mono.projectdata.v1.WritingPlanSection sections = 3;
   */ _define_property(this, "sections", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertWritingPlanRequest, "runtime", proto3);
_define_property(UpsertWritingPlanRequest, "typeName", "mono.projectdata.v1.UpsertWritingPlanRequest");
_define_property(UpsertWritingPlanRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "sections",
            kind: "message",
            T: WritingPlanSection,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpsertWritingPlanResponse
 */ export class UpsertWritingPlanResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertWritingPlanResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertWritingPlanResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertWritingPlanResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertWritingPlanResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.WritingPlan plan = 1;
   */ _define_property(this, "plan", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertWritingPlanResponse, "runtime", proto3);
_define_property(UpsertWritingPlanResponse, "typeName", "mono.projectdata.v1.UpsertWritingPlanResponse");
_define_property(UpsertWritingPlanResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "plan",
            kind: "message",
            T: WritingPlan
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.WritingPlan
 */ export class WritingPlan extends Message {
    static fromBinary(bytes, options) {
        return new WritingPlan().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WritingPlan().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WritingPlan().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WritingPlan, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string plan_id = 1;
   */ _define_property(this, "planId", ""), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: repeated mono.projectdata.v1.WritingPlanSection sections = 3;
   */ _define_property(this, "sections", []), /**
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 5;
   */ _define_property(this, "updatedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(WritingPlan, "runtime", proto3);
_define_property(WritingPlan, "typeName", "mono.projectdata.v1.WritingPlan");
_define_property(WritingPlan, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "plan_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "sections",
            kind: "message",
            T: WritingPlanSection,
            repeated: true
        },
        {
            no: 4,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.WritingPlanSection
 */ export class WritingPlanSection extends Message {
    static fromBinary(bytes, options) {
        return new WritingPlanSection().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WritingPlanSection().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WritingPlanSection().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WritingPlanSection, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string section_id = 1;
   */ _define_property(this, "sectionId", ""), /**
   * @generated from field: string outline_section_id = 2;
   */ _define_property(this, "outlineSectionId", ""), /**
   * @generated from field: string title = 3;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string instructions = 4;
   */ _define_property(this, "instructions", ""), /**
   * not_started, drafting, review, complete
   *
   * @generated from field: string status = 5;
   */ _define_property(this, "status", ""), /**
   * @generated from field: repeated string assigned_requirement_ids = 6;
   */ _define_property(this, "assignedRequirementIds", []), /**
   * @generated from field: int32 target_page_count = 7;
   */ _define_property(this, "targetPageCount", 0), /**
   * Tiptap document JSON, opaque to the backend. Empty until a section
   * has been edited via the PR9 writing pad. Always paired with
   * content_mime so consumers know how to interpret it.
   *
   * @generated from field: bytes content_blob = 8;
   */ _define_property(this, "contentBlob", new Uint8Array(0)), /**
   * MIME type for content_blob. The PR9 pad always uses
   * "application/x-tiptap+json"; reserved here for future formats.
   *
   * @generated from field: string content_mime = 9;
   */ _define_property(this, "contentMime", ""), /**
   * Plain-text projection of content_blob, generated on save. Used for
   * full-text search, exports, and previews so callers don't need a
   * Tiptap parser to display section content.
   *
   * @generated from field: string content_text = 10;
   */ _define_property(this, "contentText", ""), /**
   * Embedded file attachments, stored as a JSON array of
   * {file_id, label, position} objects.
   *
   * @generated from field: repeated mono.projectdata.v1.ContentAttachment attachments = 11;
   */ _define_property(this, "attachments", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(WritingPlanSection, "runtime", proto3);
_define_property(WritingPlanSection, "typeName", "mono.projectdata.v1.WritingPlanSection");
_define_property(WritingPlanSection, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "outline_section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "instructions",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "assigned_requirement_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 7,
            name: "target_page_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 8,
            name: "content_blob",
            kind: "scalar",
            T: 12 /* ScalarType.BYTES */ 
        },
        {
            no: 9,
            name: "content_mime",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "content_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "attachments",
            kind: "message",
            T: ContentAttachment,
            repeated: true
        }
    ]));
/**
 * ContentAttachment is one file embedded inside a writing pad section.
 * position is the Tiptap node offset where the attachment lives.
 *
 * @generated from message mono.projectdata.v1.ContentAttachment
 */ export class ContentAttachment extends Message {
    static fromBinary(bytes, options) {
        return new ContentAttachment().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContentAttachment().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContentAttachment().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContentAttachment, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string file_id = 1;
   */ _define_property(this, "fileId", ""), /**
   * @generated from field: string label = 2;
   */ _define_property(this, "label", ""), /**
   * @generated from field: int32 position = 3;
   */ _define_property(this, "position", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContentAttachment, "runtime", proto3);
_define_property(ContentAttachment, "typeName", "mono.projectdata.v1.ContentAttachment");
_define_property(ContentAttachment, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "file_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "position",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.TagProjectFileToOutlineRequest
 */ export class TagProjectFileToOutlineRequest extends Message {
    static fromBinary(bytes, options) {
        return new TagProjectFileToOutlineRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TagProjectFileToOutlineRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TagProjectFileToOutlineRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TagProjectFileToOutlineRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string file_id = 3;
   */ _define_property(this, "fileId", ""), /**
   * @generated from field: string outline_section_id = 4;
   */ _define_property(this, "outlineSectionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(TagProjectFileToOutlineRequest, "runtime", proto3);
_define_property(TagProjectFileToOutlineRequest, "typeName", "mono.projectdata.v1.TagProjectFileToOutlineRequest");
_define_property(TagProjectFileToOutlineRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "file_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "outline_section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.TagProjectFileToOutlineResponse
 */ export class TagProjectFileToOutlineResponse extends Message {
    static fromBinary(bytes, options) {
        return new TagProjectFileToOutlineResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TagProjectFileToOutlineResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TagProjectFileToOutlineResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TagProjectFileToOutlineResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.OutlineSection section = 1;
   */ _define_property(this, "section", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(TagProjectFileToOutlineResponse, "runtime", proto3);
_define_property(TagProjectFileToOutlineResponse, "typeName", "mono.projectdata.v1.TagProjectFileToOutlineResponse");
_define_property(TagProjectFileToOutlineResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "section",
            kind: "message",
            T: OutlineSection
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UploadProjectFilesRequest
 */ export class UploadProjectFilesRequest extends Message {
    static fromBinary(bytes, options) {
        return new UploadProjectFilesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UploadProjectFilesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UploadProjectFilesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UploadProjectFilesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * Legacy byte-upload mode. Prefer `artifact_ids` — the bytes have already
   * been uploaded to MinIO via tesoro, and zou just registers project
   * membership. Kept here for backward compatibility with older clients.
   *
   * @generated from field: repeated mono.projectdata.v1.FileUpload files = 3;
   */ _define_property(this, "files", []), /**
   * Tesoro-uploaded artifact IDs to attach to this project. When set,
   * `files` is ignored. zou creates one Attachment row per id, with
   * attachment_id == artifact_id, file_path = artifactstore.BuildOriginalKey(...).
   *
   * @generated from field: repeated string artifact_ids = 4;
   */ _define_property(this, "artifactIds", []), /**
   * @generated from field: string hub_category = 5;
   */ _define_property(this, "hubCategory", ""), /**
   * Empty defaults Teaming/NDA to legal_restricted.
   *
   * @generated from field: string sensitivity = 6;
   */ _define_property(this, "sensitivity", ""), /**
   * Existing adopted reuse on this proposal; artifact_ids must be its item references.
   *
   * @generated from field: string library_reuse_id = 7;
   */ _define_property(this, "libraryReuseId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UploadProjectFilesRequest, "runtime", proto3);
_define_property(UploadProjectFilesRequest, "typeName", "mono.projectdata.v1.UploadProjectFilesRequest");
_define_property(UploadProjectFilesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "files",
            kind: "message",
            T: FileUpload,
            repeated: true
        },
        {
            no: 4,
            name: "artifact_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 5,
            name: "hub_category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "sensitivity",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "library_reuse_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.FileUpload
 */ export class FileUpload extends Message {
    static fromBinary(bytes, options) {
        return new FileUpload().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FileUpload().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FileUpload().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FileUpload, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string filename = 1;
   */ _define_property(this, "filename", ""), /**
   * @generated from field: string content_type = 2;
   */ _define_property(this, "contentType", ""), /**
   * @generated from field: bytes content = 3;
   */ _define_property(this, "content", new Uint8Array(0));
        proto3.util.initPartial(data, this);
    }
}
_define_property(FileUpload, "runtime", proto3);
_define_property(FileUpload, "typeName", "mono.projectdata.v1.FileUpload");
_define_property(FileUpload, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "content_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "content",
            kind: "scalar",
            T: 12 /* ScalarType.BYTES */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UploadProjectFilesResponse
 */ export class UploadProjectFilesResponse extends Message {
    static fromBinary(bytes, options) {
        return new UploadProjectFilesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UploadProjectFilesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UploadProjectFilesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UploadProjectFilesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.ProjectFile files = 1;
   */ _define_property(this, "files", []), /**
   * @generated from field: repeated mono.projectdata.v1.FailedUpload failed = 2;
   */ _define_property(this, "failed", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UploadProjectFilesResponse, "runtime", proto3);
_define_property(UploadProjectFilesResponse, "typeName", "mono.projectdata.v1.UploadProjectFilesResponse");
_define_property(UploadProjectFilesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "files",
            kind: "message",
            T: ProjectFile,
            repeated: true
        },
        {
            no: 2,
            name: "failed",
            kind: "message",
            T: FailedUpload,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.FailedUpload
 */ export class FailedUpload extends Message {
    static fromBinary(bytes, options) {
        return new FailedUpload().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FailedUpload().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FailedUpload().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FailedUpload, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string filename = 1;
   */ _define_property(this, "filename", ""), /**
   * @generated from field: string error = 2;
   */ _define_property(this, "error", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(FailedUpload, "runtime", proto3);
_define_property(FailedUpload, "typeName", "mono.projectdata.v1.FailedUpload");
_define_property(FailedUpload, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "error",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.DeleteProjectFileRequest
 */ export class DeleteProjectFileRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteProjectFileRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteProjectFileRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteProjectFileRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteProjectFileRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * attachment_id of the file to soft-delete
   *
   * @generated from field: string file_id = 3;
   */ _define_property(this, "fileId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteProjectFileRequest, "runtime", proto3);
_define_property(DeleteProjectFileRequest, "typeName", "mono.projectdata.v1.DeleteProjectFileRequest");
_define_property(DeleteProjectFileRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "file_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.DeleteProjectFileResponse
 */ export class DeleteProjectFileResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteProjectFileResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteProjectFileResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteProjectFileResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteProjectFileResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string file_id = 1;
   */ _define_property(this, "fileId", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteProjectFileResponse, "runtime", proto3);
_define_property(DeleteProjectFileResponse, "typeName", "mono.projectdata.v1.DeleteProjectFileResponse");
_define_property(DeleteProjectFileResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "file_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListProjectsRequest
 */ export class ListProjectsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListProjectsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProjectsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProjectsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProjectsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string company_id = 2;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string user_id = 3;
   */ _define_property(this, "userId", ""), /**
   * "active", "archived", "all"
   *
   * @generated from field: string status = 4;
   */ _define_property(this, "status", ""), /**
   * @generated from field: int32 page = 5;
   */ _define_property(this, "page", 0), /**
   * @generated from field: int32 limit = 6;
   */ _define_property(this, "limit", 0), /**
   * @generated from field: string search = 7;
   */ _define_property(this, "search", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProjectsRequest, "runtime", proto3);
_define_property(ListProjectsRequest, "typeName", "mono.projectdata.v1.ListProjectsRequest");
_define_property(ListProjectsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "page",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "search",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListProjectsResponse
 */ export class ListProjectsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListProjectsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProjectsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProjectsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProjectsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.ProjectListItem projects = 1;
   */ _define_property(this, "projects", []), /**
   * @generated from field: int32 total = 2;
   */ _define_property(this, "total", 0), /**
   * @generated from field: int32 page = 3;
   */ _define_property(this, "page", 0), /**
   * @generated from field: int32 limit = 4;
   */ _define_property(this, "limit", 0), /**
   * @generated from field: bool has_more = 5;
   */ _define_property(this, "hasMore", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProjectsResponse, "runtime", proto3);
_define_property(ListProjectsResponse, "typeName", "mono.projectdata.v1.ListProjectsResponse");
_define_property(ListProjectsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "projects",
            kind: "message",
            T: ProjectListItem,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "page",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "has_more",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ProjectListItem
 */ export class ProjectListItem extends Message {
    static fromBinary(bytes, options) {
        return new ProjectListItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProjectListItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProjectListItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProjectListItem, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string description = 3;
   */ _define_property(this, "description", ""), /**
   * @generated from field: mono.projectdata.v1.ProjectType type = 4;
   */ _define_property(this, "type", 0), /**
   * @generated from field: string status = 5;
   */ _define_property(this, "status", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp last_activity_at = 7;
   */ _define_property(this, "lastActivityAt", void 0), /**
   * @generated from field: string created_by = 8;
   */ _define_property(this, "createdBy", ""), /**
   * @generated from field: int32 member_count = 9;
   */ _define_property(this, "memberCount", 0), /**
   * @generated from field: int32 file_count = 10;
   */ _define_property(this, "fileCount", 0), /**
   * Type-specific summary
   *
   * proposal
   *
   * @generated from field: string solicitation_number = 11;
   */ _define_property(this, "solicitationNumber", ""), /**
   * contract
   *
   * @generated from field: string contract_number = 12;
   */ _define_property(this, "contractNumber", ""), /**
   * @generated from field: string stage = 13;
   */ _define_property(this, "stage", ""), /**
   * Role of the requesting user
   *
   * @generated from field: string caller_role = 14;
   */ _define_property(this, "callerRole", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProjectListItem, "runtime", proto3);
_define_property(ProjectListItem, "typeName", "mono.projectdata.v1.ProjectListItem");
_define_property(ProjectListItem, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "type",
            kind: "enum",
            T: proto3.getEnumType(ProjectType)
        },
        {
            no: 5,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "last_activity_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "member_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 10,
            name: "file_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 11,
            name: "solicitation_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "contract_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "stage",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "caller_role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CreateProjectRequest
 */ export class CreateProjectRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateProjectRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateProjectRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateProjectRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateProjectRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string description = 3;
   */ _define_property(this, "description", ""), /**
   * @generated from field: mono.projectdata.v1.ProjectType type = 4;
   */ _define_property(this, "type", 0), /**
   * @generated from field: string company_id = 5;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string created_by = 6;
   */ _define_property(this, "createdBy", ""), /**
   * Optional type-specific info
   *
   * @generated from field: mono.projectdata.v1.ProposalInfo proposal_info = 7;
   */ _define_property(this, "proposalInfo", void 0), /**
   * @generated from field: mono.projectdata.v1.ContractInfo contract_info = 8;
   */ _define_property(this, "contractInfo", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateProjectRequest, "runtime", proto3);
_define_property(CreateProjectRequest, "typeName", "mono.projectdata.v1.CreateProjectRequest");
_define_property(CreateProjectRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "type",
            kind: "enum",
            T: proto3.getEnumType(ProjectType)
        },
        {
            no: 5,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "proposal_info",
            kind: "message",
            T: ProposalInfo
        },
        {
            no: 8,
            name: "contract_info",
            kind: "message",
            T: ContractInfo
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CreateProjectResponse
 */ export class CreateProjectResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateProjectResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateProjectResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateProjectResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateProjectResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.ProjectInfo project = 1;
   */ _define_property(this, "project", void 0), /**
   * @generated from field: repeated mono.projectdata.v1.ProjectMember members = 2;
   */ _define_property(this, "members", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateProjectResponse, "runtime", proto3);
_define_property(CreateProjectResponse, "typeName", "mono.projectdata.v1.CreateProjectResponse");
_define_property(CreateProjectResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project",
            kind: "message",
            T: ProjectInfo
        },
        {
            no: 2,
            name: "members",
            kind: "message",
            T: ProjectMember,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetProjectRequest
 */ export class GetProjectRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetProjectRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProjectRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProjectRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProjectRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProjectRequest, "runtime", proto3);
_define_property(GetProjectRequest, "typeName", "mono.projectdata.v1.GetProjectRequest");
_define_property(GetProjectRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetProjectResponse
 */ export class GetProjectResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetProjectResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProjectResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProjectResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProjectResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.ProjectInfo project = 1;
   */ _define_property(this, "project", void 0), /**
   * @generated from field: repeated mono.projectdata.v1.ProjectMember members = 2;
   */ _define_property(this, "members", []), /**
   * Role of the requesting user: "owner", "member", "view_only"
   *
   * @generated from field: string caller_role = 3;
   */ _define_property(this, "callerRole", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProjectResponse, "runtime", proto3);
_define_property(GetProjectResponse, "typeName", "mono.projectdata.v1.GetProjectResponse");
_define_property(GetProjectResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project",
            kind: "message",
            T: ProjectInfo
        },
        {
            no: 2,
            name: "members",
            kind: "message",
            T: ProjectMember,
            repeated: true
        },
        {
            no: 3,
            name: "caller_role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpdateProjectRequest
 */ export class UpdateProjectRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateProjectRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateProjectRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateProjectRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateProjectRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string description = 4;
   */ _define_property(this, "description", ""), /**
   * Proposal metadata fields — set any non-empty value to update.
   * Empty strings are ignored (no change). This lets the frontend
   * update individual fields without sending all of them.
   *
   * @generated from field: string contract_type = 5;
   */ _define_property(this, "contractType", ""), /**
   * @generated from field: string contract_vehicle = 6;
   */ _define_property(this, "contractVehicle", ""), /**
   * @generated from field: string set_aside = 7;
   */ _define_property(this, "setAside", ""), /**
   * @generated from field: string naics_code = 8;
   */ _define_property(this, "naicsCode", ""), /**
   * @generated from field: string agency = 9;
   */ _define_property(this, "agency", ""), /**
   * @generated from field: string office = 10;
   */ _define_property(this, "office", ""), /**
   * @generated from field: string solicitation_number = 11;
   */ _define_property(this, "solicitationNumber", ""), /**
   * @generated from field: string contract_vehicle_id = 12;
   */ _define_property(this, "contractVehicleId", ""), /**
   * @generated from field: string gov_org_id = 13;
   */ _define_property(this, "govOrgId", ""), /**
   * @generated from field: string office_gov_org_id = 14;
   */ _define_property(this, "officeGovOrgId", ""), /**
   * IANA zone; validated server-side
   *
   * @generated from field: string due_timezone = 15;
   */ _define_property(this, "dueTimezone", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateProjectRequest, "runtime", proto3);
_define_property(UpdateProjectRequest, "typeName", "mono.projectdata.v1.UpdateProjectRequest");
_define_property(UpdateProjectRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "contract_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "contract_vehicle",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "set_aside",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "naics_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "agency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "office",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "solicitation_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "contract_vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "gov_org_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "office_gov_org_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "due_timezone",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpdateProjectResponse
 */ export class UpdateProjectResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateProjectResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateProjectResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateProjectResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateProjectResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.ProjectInfo project = 1;
   */ _define_property(this, "project", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateProjectResponse, "runtime", proto3);
_define_property(UpdateProjectResponse, "typeName", "mono.projectdata.v1.UpdateProjectResponse");
_define_property(UpdateProjectResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project",
            kind: "message",
            T: ProjectInfo
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ArchiveProjectRequest
 */ export class ArchiveProjectRequest extends Message {
    static fromBinary(bytes, options) {
        return new ArchiveProjectRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ArchiveProjectRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ArchiveProjectRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ArchiveProjectRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string archived_by = 3;
   */ _define_property(this, "archivedBy", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ArchiveProjectRequest, "runtime", proto3);
_define_property(ArchiveProjectRequest, "typeName", "mono.projectdata.v1.ArchiveProjectRequest");
_define_property(ArchiveProjectRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "archived_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ArchiveProjectResponse
 */ export class ArchiveProjectResponse extends Message {
    static fromBinary(bytes, options) {
        return new ArchiveProjectResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ArchiveProjectResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ArchiveProjectResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ArchiveProjectResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.ProjectInfo project = 1;
   */ _define_property(this, "project", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ArchiveProjectResponse, "runtime", proto3);
_define_property(ArchiveProjectResponse, "typeName", "mono.projectdata.v1.ArchiveProjectResponse");
_define_property(ArchiveProjectResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project",
            kind: "message",
            T: ProjectInfo
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UnarchiveProjectRequest
 */ export class UnarchiveProjectRequest extends Message {
    static fromBinary(bytes, options) {
        return new UnarchiveProjectRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UnarchiveProjectRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UnarchiveProjectRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UnarchiveProjectRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UnarchiveProjectRequest, "runtime", proto3);
_define_property(UnarchiveProjectRequest, "typeName", "mono.projectdata.v1.UnarchiveProjectRequest");
_define_property(UnarchiveProjectRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UnarchiveProjectResponse
 */ export class UnarchiveProjectResponse extends Message {
    static fromBinary(bytes, options) {
        return new UnarchiveProjectResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UnarchiveProjectResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UnarchiveProjectResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UnarchiveProjectResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.ProjectInfo project = 1;
   */ _define_property(this, "project", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UnarchiveProjectResponse, "runtime", proto3);
_define_property(UnarchiveProjectResponse, "typeName", "mono.projectdata.v1.UnarchiveProjectResponse");
_define_property(UnarchiveProjectResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project",
            kind: "message",
            T: ProjectInfo
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.DeleteProjectRequest
 */ export class DeleteProjectRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteProjectRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteProjectRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteProjectRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteProjectRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteProjectRequest, "runtime", proto3);
_define_property(DeleteProjectRequest, "typeName", "mono.projectdata.v1.DeleteProjectRequest");
_define_property(DeleteProjectRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.DeleteProjectResponse
 */ export class DeleteProjectResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteProjectResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteProjectResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteProjectResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteProjectResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * RFC3339 timestamp
   *
   * @generated from field: string deleted_at = 2;
   */ _define_property(this, "deletedAt", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteProjectResponse, "runtime", proto3);
_define_property(DeleteProjectResponse, "typeName", "mono.projectdata.v1.DeleteProjectResponse");
_define_property(DeleteProjectResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "deleted_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ProjectMember
 */ export class ProjectMember extends Message {
    static fromBinary(bytes, options) {
        return new ProjectMember().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProjectMember().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProjectMember().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProjectMember, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string user_id = 1;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string email = 2;
   */ _define_property(this, "email", ""), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", ""), /**
   * "owner", "member", "view_only"
   *
   * @generated from field: string role = 4;
   */ _define_property(this, "role", ""), /**
   * @generated from field: google.protobuf.Timestamp added_at = 5;
   */ _define_property(this, "addedAt", void 0), /**
   * @generated from field: string added_by = 6;
   */ _define_property(this, "addedBy", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProjectMember, "runtime", proto3);
_define_property(ProjectMember, "typeName", "mono.projectdata.v1.ProjectMember");
_define_property(ProjectMember, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "email",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "added_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "added_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.AddMembersRequest
 */ export class AddMembersRequest extends Message {
    static fromBinary(bytes, options) {
        return new AddMembersRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddMembersRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddMembersRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddMembersRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: repeated mono.projectdata.v1.NewMember members = 3;
   */ _define_property(this, "members", []), /**
   * @generated from field: string added_by = 4;
   */ _define_property(this, "addedBy", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AddMembersRequest, "runtime", proto3);
_define_property(AddMembersRequest, "typeName", "mono.projectdata.v1.AddMembersRequest");
_define_property(AddMembersRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "members",
            kind: "message",
            T: NewMember,
            repeated: true
        },
        {
            no: 4,
            name: "added_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.NewMember
 */ export class NewMember extends Message {
    static fromBinary(bytes, options) {
        return new NewMember().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new NewMember().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new NewMember().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(NewMember, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string user_id = 1;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string email = 2;
   */ _define_property(this, "email", ""), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string role = 4;
   */ _define_property(this, "role", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(NewMember, "runtime", proto3);
_define_property(NewMember, "typeName", "mono.projectdata.v1.NewMember");
_define_property(NewMember, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "email",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.AddMembersResponse
 */ export class AddMembersResponse extends Message {
    static fromBinary(bytes, options) {
        return new AddMembersResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddMembersResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddMembersResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddMembersResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.ProjectMember members = 1;
   */ _define_property(this, "members", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AddMembersResponse, "runtime", proto3);
_define_property(AddMembersResponse, "typeName", "mono.projectdata.v1.AddMembersResponse");
_define_property(AddMembersResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "members",
            kind: "message",
            T: ProjectMember,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RemoveMemberRequest
 */ export class RemoveMemberRequest extends Message {
    static fromBinary(bytes, options) {
        return new RemoveMemberRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RemoveMemberRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RemoveMemberRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RemoveMemberRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string user_id = 3;
   */ _define_property(this, "userId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RemoveMemberRequest, "runtime", proto3);
_define_property(RemoveMemberRequest, "typeName", "mono.projectdata.v1.RemoveMemberRequest");
_define_property(RemoveMemberRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RemoveMemberResponse
 */ export class RemoveMemberResponse extends Message {
    static fromBinary(bytes, options) {
        return new RemoveMemberResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RemoveMemberResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RemoveMemberResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RemoveMemberResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(RemoveMemberResponse, "runtime", proto3);
_define_property(RemoveMemberResponse, "typeName", "mono.projectdata.v1.RemoveMemberResponse");
_define_property(RemoveMemberResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.projectdata.v1.UpdateMemberRoleRequest
 */ export class UpdateMemberRoleRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateMemberRoleRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateMemberRoleRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateMemberRoleRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateMemberRoleRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string user_id = 3;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string role = 4;
   */ _define_property(this, "role", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateMemberRoleRequest, "runtime", proto3);
_define_property(UpdateMemberRoleRequest, "typeName", "mono.projectdata.v1.UpdateMemberRoleRequest");
_define_property(UpdateMemberRoleRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpdateMemberRoleResponse
 */ export class UpdateMemberRoleResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateMemberRoleResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateMemberRoleResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateMemberRoleResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateMemberRoleResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.ProjectMember member = 1;
   */ _define_property(this, "member", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateMemberRoleResponse, "runtime", proto3);
_define_property(UpdateMemberRoleResponse, "typeName", "mono.projectdata.v1.UpdateMemberRoleResponse");
_define_property(UpdateMemberRoleResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "member",
            kind: "message",
            T: ProjectMember
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.TransferOwnershipRequest
 */ export class TransferOwnershipRequest extends Message {
    static fromBinary(bytes, options) {
        return new TransferOwnershipRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TransferOwnershipRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TransferOwnershipRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TransferOwnershipRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string new_owner_id = 3;
   */ _define_property(this, "newOwnerId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(TransferOwnershipRequest, "runtime", proto3);
_define_property(TransferOwnershipRequest, "typeName", "mono.projectdata.v1.TransferOwnershipRequest");
_define_property(TransferOwnershipRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "new_owner_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.TransferOwnershipResponse
 */ export class TransferOwnershipResponse extends Message {
    static fromBinary(bytes, options) {
        return new TransferOwnershipResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TransferOwnershipResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TransferOwnershipResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TransferOwnershipResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.ProjectMember members = 1;
   */ _define_property(this, "members", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(TransferOwnershipResponse, "runtime", proto3);
_define_property(TransferOwnershipResponse, "typeName", "mono.projectdata.v1.TransferOwnershipResponse");
_define_property(TransferOwnershipResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "members",
            kind: "message",
            T: ProjectMember,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.LeaveProjectRequest
 */ export class LeaveProjectRequest extends Message {
    static fromBinary(bytes, options) {
        return new LeaveProjectRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LeaveProjectRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LeaveProjectRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LeaveProjectRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string user_id = 3;
   */ _define_property(this, "userId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LeaveProjectRequest, "runtime", proto3);
_define_property(LeaveProjectRequest, "typeName", "mono.projectdata.v1.LeaveProjectRequest");
_define_property(LeaveProjectRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.LeaveProjectResponse
 */ export class LeaveProjectResponse extends Message {
    static fromBinary(bytes, options) {
        return new LeaveProjectResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LeaveProjectResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LeaveProjectResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LeaveProjectResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(LeaveProjectResponse, "runtime", proto3);
_define_property(LeaveProjectResponse, "typeName", "mono.projectdata.v1.LeaveProjectResponse");
_define_property(LeaveProjectResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.projectdata.v1.UpdateCLINRequest
 */ export class UpdateCLINRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateCLINRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateCLINRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateCLINRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateCLINRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string clin_id = 3;
   */ _define_property(this, "clinId", ""), /**
   * @generated from field: string funding_status = 4;
   */ _define_property(this, "fundingStatus", ""), /**
   * @generated from field: string notes = 5;
   */ _define_property(this, "notes", ""), /**
   * Editable detail fields surfaced by the CLIN detail drawer. The handler
   * skips any field left at its zero value (empty string) — matching the
   * existing `notes` patch convention so a caller can patch one column at a
   * time without nulling the rest.
   *
   * Pricing fields are carried as the raw strings the user typed
   * ("$187.42", "1,000,000") rather than floats so the wire is honest about
   * user intent. Zou parses to the float64 pricing_unit_price /
   * pricing_extended_price columns and also persists the raw string into
   * pricing_raw_unit_price / pricing_raw_extended_price.
   *
   * @generated from field: string title = 6;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string description = 7;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string unit_price = 8;
   */ _define_property(this, "unitPrice", ""), /**
   * @generated from field: string extended_price = 9;
   */ _define_property(this, "extendedPrice", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateCLINRequest, "runtime", proto3);
_define_property(UpdateCLINRequest, "typeName", "mono.projectdata.v1.UpdateCLINRequest");
_define_property(UpdateCLINRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "clin_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "funding_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "unit_price",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "extended_price",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpdateCLINResponse
 */ export class UpdateCLINResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateCLINResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateCLINResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateCLINResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateCLINResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.StoredCLIN clin = 1;
   */ _define_property(this, "clin", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateCLINResponse, "runtime", proto3);
_define_property(UpdateCLINResponse, "typeName", "mono.projectdata.v1.UpdateCLINResponse");
_define_property(UpdateCLINResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "clin",
            kind: "message",
            T: StoredCLIN
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpdateLCATRequest
 */ export class UpdateLCATRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateLCATRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateLCATRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateLCATRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateLCATRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string lcat_id = 3;
   */ _define_property(this, "lcatId", ""), /**
   * @generated from field: string notes = 4;
   */ _define_property(this, "notes", ""), /**
   * Editable detail fields surfaced by the LCAT detail drawer. The handler
   * skips any field left at its zero value (empty string / 0.0) — matching
   * the existing `notes` patch convention so a caller can patch one column
   * at a time without nulling the rest. If we later need to support
   * explicit "clear to zero" edits, these can be swapped for
   * google.protobuf.DoubleValue / StringValue wrappers.
   *
   * `category` is intentionally NOT included here. The LCAT model has no
   * dedicated category column today — the frontend's "category" UI is
   * a separate display bug (it currently shows clin_number) and gets its
   * own fix.
   *
   * @generated from field: string title = 5;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string description = 6;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string level = 7;
   */ _define_property(this, "level", ""), /**
   * @generated from field: double base_hourly_rate = 8;
   */ _define_property(this, "baseHourlyRate", 0), /**
   * @generated from field: double estimated_hours = 9;
   */ _define_property(this, "estimatedHours", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateLCATRequest, "runtime", proto3);
_define_property(UpdateLCATRequest, "typeName", "mono.projectdata.v1.UpdateLCATRequest");
_define_property(UpdateLCATRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "lcat_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "level",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "base_hourly_rate",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 9,
            name: "estimated_hours",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpdateLCATResponse
 */ export class UpdateLCATResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateLCATResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateLCATResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateLCATResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateLCATResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.StoredLCAT lcat = 1;
   */ _define_property(this, "lcat", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateLCATResponse, "runtime", proto3);
_define_property(UpdateLCATResponse, "typeName", "mono.projectdata.v1.UpdateLCATResponse");
_define_property(UpdateLCATResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "lcat",
            kind: "message",
            T: StoredLCAT
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.DeleteOutlineSectionRequest
 */ export class DeleteOutlineSectionRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteOutlineSectionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteOutlineSectionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteOutlineSectionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteOutlineSectionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string section_id = 3;
   */ _define_property(this, "sectionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteOutlineSectionRequest, "runtime", proto3);
_define_property(DeleteOutlineSectionRequest, "typeName", "mono.projectdata.v1.DeleteOutlineSectionRequest");
_define_property(DeleteOutlineSectionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.DeleteOutlineSectionResponse
 */ export class DeleteOutlineSectionResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteOutlineSectionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteOutlineSectionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteOutlineSectionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteOutlineSectionResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteOutlineSectionResponse, "runtime", proto3);
_define_property(DeleteOutlineSectionResponse, "typeName", "mono.projectdata.v1.DeleteOutlineSectionResponse");
_define_property(DeleteOutlineSectionResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.projectdata.v1.GetComplianceObligationsRequest
 */ export class GetComplianceObligationsRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetComplianceObligationsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetComplianceObligationsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetComplianceObligationsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetComplianceObligationsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string status = 3;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string frequency = 4;
   */ _define_property(this, "frequency", ""), /**
   * @generated from field: string search = 5;
   */ _define_property(this, "search", ""), /**
   * @generated from field: string regulatory_source = 6;
   */ _define_property(this, "regulatorySource", ""), /**
   * @generated from field: int32 upcoming_days = 7;
   */ _define_property(this, "upcomingDays", 0), /**
   * @generated from field: mono.common.v1.PaginationRequest pagination = 8;
   */ _define_property(this, "pagination", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetComplianceObligationsRequest, "runtime", proto3);
_define_property(GetComplianceObligationsRequest, "typeName", "mono.projectdata.v1.GetComplianceObligationsRequest");
_define_property(GetComplianceObligationsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "frequency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "search",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "regulatory_source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "upcoming_days",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 8,
            name: "pagination",
            kind: "message",
            T: PaginationRequest
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetComplianceObligationsResponse
 */ export class GetComplianceObligationsResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetComplianceObligationsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetComplianceObligationsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetComplianceObligationsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetComplianceObligationsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.ComplianceObligation obligations = 1;
   */ _define_property(this, "obligations", []), /**
   * @generated from field: int32 total = 2;
   */ _define_property(this, "total", 0), /**
   * @generated from field: string next_page_token = 3;
   */ _define_property(this, "nextPageToken", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetComplianceObligationsResponse, "runtime", proto3);
_define_property(GetComplianceObligationsResponse, "typeName", "mono.projectdata.v1.GetComplianceObligationsResponse");
_define_property(GetComplianceObligationsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "obligations",
            kind: "message",
            T: ComplianceObligation,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "next_page_token",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ComplianceObligation
 */ export class ComplianceObligation extends Message {
    static fromBinary(bytes, options) {
        return new ComplianceObligation().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ComplianceObligation().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ComplianceObligation().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ComplianceObligation, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string title = 3;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string description = 4;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string status = 5;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string frequency = 6;
   */ _define_property(this, "frequency", ""), /**
   * @generated from field: string regulatory_source = 7;
   */ _define_property(this, "regulatorySource", ""), /**
   * @generated from field: google.protobuf.Timestamp next_due_date = 8;
   */ _define_property(this, "nextDueDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp last_completed = 9;
   */ _define_property(this, "lastCompleted", void 0), /**
   * @generated from field: string assignee_id = 10;
   */ _define_property(this, "assigneeId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ComplianceObligation, "runtime", proto3);
_define_property(ComplianceObligation, "typeName", "mono.projectdata.v1.ComplianceObligation");
_define_property(ComplianceObligation, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "frequency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "regulatory_source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "next_due_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "last_completed",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "assignee_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpdateComplianceStatusRequest
 */ export class UpdateComplianceStatusRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateComplianceStatusRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateComplianceStatusRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateComplianceStatusRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateComplianceStatusRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string obligation_id = 3;
   */ _define_property(this, "obligationId", ""), /**
   * @generated from field: string status = 4;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string notes = 5;
   */ _define_property(this, "notes", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateComplianceStatusRequest, "runtime", proto3);
_define_property(UpdateComplianceStatusRequest, "typeName", "mono.projectdata.v1.UpdateComplianceStatusRequest");
_define_property(UpdateComplianceStatusRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "obligation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpdateComplianceStatusResponse
 */ export class UpdateComplianceStatusResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateComplianceStatusResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateComplianceStatusResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateComplianceStatusResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateComplianceStatusResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.ComplianceObligation obligation = 1;
   */ _define_property(this, "obligation", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateComplianceStatusResponse, "runtime", proto3);
_define_property(UpdateComplianceStatusResponse, "typeName", "mono.projectdata.v1.UpdateComplianceStatusResponse");
_define_property(UpdateComplianceStatusResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "obligation",
            kind: "message",
            T: ComplianceObligation
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetKeyPersonnelRequest
 */ export class GetKeyPersonnelRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetKeyPersonnelRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetKeyPersonnelRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetKeyPersonnelRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetKeyPersonnelRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetKeyPersonnelRequest, "runtime", proto3);
_define_property(GetKeyPersonnelRequest, "typeName", "mono.projectdata.v1.GetKeyPersonnelRequest");
_define_property(GetKeyPersonnelRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetKeyPersonnelResponse
 */ export class GetKeyPersonnelResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetKeyPersonnelResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetKeyPersonnelResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetKeyPersonnelResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetKeyPersonnelResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.KeyPerson personnel = 1;
   */ _define_property(this, "personnel", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetKeyPersonnelResponse, "runtime", proto3);
_define_property(GetKeyPersonnelResponse, "typeName", "mono.projectdata.v1.GetKeyPersonnelResponse");
_define_property(GetKeyPersonnelResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "personnel",
            kind: "message",
            T: KeyPerson,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.KeyPerson
 */ export class KeyPerson extends Message {
    static fromBinary(bytes, options) {
        return new KeyPerson().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new KeyPerson().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new KeyPerson().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(KeyPerson, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string role = 4;
   */ _define_property(this, "role", ""), /**
   * @generated from field: string title = 5;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string email = 6;
   */ _define_property(this, "email", ""), /**
   * @generated from field: string phone = 7;
   */ _define_property(this, "phone", ""), /**
   * @generated from field: string organization = 8;
   */ _define_property(this, "organization", ""), /**
   * @generated from field: string clearance_level = 9;
   */ _define_property(this, "clearanceLevel", ""), /**
   * @generated from field: string notes = 10;
   */ _define_property(this, "notes", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(KeyPerson, "runtime", proto3);
_define_property(KeyPerson, "typeName", "mono.projectdata.v1.KeyPerson");
_define_property(KeyPerson, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "email",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "phone",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "organization",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "clearance_level",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpdateKeyPersonnelRequest
 */ export class UpdateKeyPersonnelRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateKeyPersonnelRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateKeyPersonnelRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateKeyPersonnelRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateKeyPersonnelRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string personnel_id = 3;
   */ _define_property(this, "personnelId", ""), /**
   * @generated from field: string name = 4;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string role = 5;
   */ _define_property(this, "role", ""), /**
   * @generated from field: string title = 6;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string email = 7;
   */ _define_property(this, "email", ""), /**
   * @generated from field: string phone = 8;
   */ _define_property(this, "phone", ""), /**
   * @generated from field: string notes = 9;
   */ _define_property(this, "notes", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateKeyPersonnelRequest, "runtime", proto3);
_define_property(UpdateKeyPersonnelRequest, "typeName", "mono.projectdata.v1.UpdateKeyPersonnelRequest");
_define_property(UpdateKeyPersonnelRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "personnel_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "email",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "phone",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpdateKeyPersonnelResponse
 */ export class UpdateKeyPersonnelResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateKeyPersonnelResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateKeyPersonnelResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateKeyPersonnelResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateKeyPersonnelResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.KeyPerson person = 1;
   */ _define_property(this, "person", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateKeyPersonnelResponse, "runtime", proto3);
_define_property(UpdateKeyPersonnelResponse, "typeName", "mono.projectdata.v1.UpdateKeyPersonnelResponse");
_define_property(UpdateKeyPersonnelResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "person",
            kind: "message",
            T: KeyPerson
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetMasterMatrixRequest
 */ export class GetMasterMatrixRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetMasterMatrixRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetMasterMatrixRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetMasterMatrixRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetMasterMatrixRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetMasterMatrixRequest, "runtime", proto3);
_define_property(GetMasterMatrixRequest, "typeName", "mono.projectdata.v1.GetMasterMatrixRequest");
_define_property(GetMasterMatrixRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetMasterMatrixResponse
 */ export class GetMasterMatrixResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetMasterMatrixResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetMasterMatrixResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetMasterMatrixResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetMasterMatrixResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.MasterMatrixRequirement requirements = 1;
   */ _define_property(this, "requirements", []), /**
   * @generated from field: repeated mono.projectdata.v1.MasterMatrixAmendment amendments = 2;
   */ _define_property(this, "amendments", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetMasterMatrixResponse, "runtime", proto3);
_define_property(GetMasterMatrixResponse, "typeName", "mono.projectdata.v1.GetMasterMatrixResponse");
_define_property(GetMasterMatrixResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "requirements",
            kind: "message",
            T: MasterMatrixRequirement,
            repeated: true
        },
        {
            no: 2,
            name: "amendments",
            kind: "message",
            T: MasterMatrixAmendment,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.MasterMatrixRequirement
 */ export class MasterMatrixRequirement extends Message {
    static fromBinary(bytes, options) {
        return new MasterMatrixRequirement().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MasterMatrixRequirement().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MasterMatrixRequirement().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MasterMatrixRequirement, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string text = 2;
   */ _define_property(this, "text", ""), /**
   * unchanged, added, modified, removed
   *
   * @generated from field: string amendment_status = 3;
   */ _define_property(this, "amendmentStatus", ""), /**
   * @generated from field: string introduced_in = 4;
   */ _define_property(this, "introducedIn", ""), /**
   * @generated from field: repeated string modified_in = 5;
   */ _define_property(this, "modifiedIn", []), /**
   * @generated from field: string current_source_attachment_id = 6;
   */ _define_property(this, "currentSourceAttachmentId", ""), /**
   * @generated from field: string current_source_filename = 7;
   */ _define_property(this, "currentSourceFilename", ""), /**
   * @generated from field: string current_source_amendment_number = 8;
   */ _define_property(this, "currentSourceAmendmentNumber", ""), /**
   * @generated from field: string category = 9;
   */ _define_property(this, "category", ""), /**
   * @generated from field: string obligation_strength = 10;
   */ _define_property(this, "obligationStrength", ""), /**
   * @generated from field: string status = 11;
   */ _define_property(this, "status", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(MasterMatrixRequirement, "runtime", proto3);
_define_property(MasterMatrixRequirement, "typeName", "mono.projectdata.v1.MasterMatrixRequirement");
_define_property(MasterMatrixRequirement, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "amendment_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "introduced_in",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "modified_in",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 6,
            name: "current_source_attachment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "current_source_filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "current_source_amendment_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "obligation_strength",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.MasterMatrixAmendment
 */ export class MasterMatrixAmendment extends Message {
    static fromBinary(bytes, options) {
        return new MasterMatrixAmendment().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MasterMatrixAmendment().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MasterMatrixAmendment().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MasterMatrixAmendment, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string attachment_id = 1;
   */ _define_property(this, "attachmentId", ""), /**
   * @generated from field: string filename = 2;
   */ _define_property(this, "filename", ""), /**
   * @generated from field: string amendment_number = 3;
   */ _define_property(this, "amendmentNumber", ""), /**
   * @generated from field: google.protobuf.Timestamp processed_at = 4;
   */ _define_property(this, "processedAt", void 0), /**
   * @generated from field: int32 requirements_added = 5;
   */ _define_property(this, "requirementsAdded", 0), /**
   * @generated from field: int32 requirements_modified = 6;
   */ _define_property(this, "requirementsModified", 0), /**
   * @generated from field: int32 requirements_removed = 7;
   */ _define_property(this, "requirementsRemoved", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(MasterMatrixAmendment, "runtime", proto3);
_define_property(MasterMatrixAmendment, "typeName", "mono.projectdata.v1.MasterMatrixAmendment");
_define_property(MasterMatrixAmendment, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "attachment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "amendment_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "processed_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "requirements_added",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "requirements_modified",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "requirements_removed",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.PricingScenario
 */ export class PricingScenario extends Message {
    static fromBinary(bytes, options) {
        return new PricingScenario().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PricingScenario().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PricingScenario().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PricingScenario, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string scenario_name = 3;
   */ _define_property(this, "scenarioName", ""), /**
   * @generated from field: bool is_primary = 4;
   */ _define_property(this, "isPrimary", false), /**
   * JSON blob for full scenario data
   *
   * @generated from field: string data = 5;
   */ _define_property(this, "data", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 7;
   */ _define_property(this, "updatedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PricingScenario, "runtime", proto3);
_define_property(PricingScenario, "typeName", "mono.projectdata.v1.PricingScenario");
_define_property(PricingScenario, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "scenario_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "is_primary",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "data",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListPricingRequest
 */ export class ListPricingRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListPricingRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPricingRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPricingRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPricingRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListPricingRequest, "runtime", proto3);
_define_property(ListPricingRequest, "typeName", "mono.projectdata.v1.ListPricingRequest");
_define_property(ListPricingRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListPricingResponse
 */ export class ListPricingResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListPricingResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPricingResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPricingResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPricingResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.PricingScenario scenarios = 1;
   */ _define_property(this, "scenarios", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListPricingResponse, "runtime", proto3);
_define_property(ListPricingResponse, "typeName", "mono.projectdata.v1.ListPricingResponse");
_define_property(ListPricingResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "scenarios",
            kind: "message",
            T: PricingScenario,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetPricingRequest
 */ export class GetPricingRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetPricingRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPricingRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPricingRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPricingRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string pricing_id = 2;
   */ _define_property(this, "pricingId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetPricingRequest, "runtime", proto3);
_define_property(GetPricingRequest, "typeName", "mono.projectdata.v1.GetPricingRequest");
_define_property(GetPricingRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "pricing_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetPricingResponse
 */ export class GetPricingResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetPricingResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPricingResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPricingResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPricingResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.PricingScenario scenario = 1;
   */ _define_property(this, "scenario", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetPricingResponse, "runtime", proto3);
_define_property(GetPricingResponse, "typeName", "mono.projectdata.v1.GetPricingResponse");
_define_property(GetPricingResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "scenario",
            kind: "message",
            T: PricingScenario
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CreatePricingRequest
 */ export class CreatePricingRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreatePricingRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreatePricingRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreatePricingRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreatePricingRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string scenario_name = 2;
   */ _define_property(this, "scenarioName", ""), /**
   * @generated from field: bool seed_from_extractions = 3;
   */ _define_property(this, "seedFromExtractions", false), /**
   * @generated from field: string indirect_rate_config_id = 4;
   */ _define_property(this, "indirectRateConfigId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreatePricingRequest, "runtime", proto3);
_define_property(CreatePricingRequest, "typeName", "mono.projectdata.v1.CreatePricingRequest");
_define_property(CreatePricingRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "scenario_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "seed_from_extractions",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "indirect_rate_config_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CreatePricingResponse
 */ export class CreatePricingResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreatePricingResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreatePricingResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreatePricingResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreatePricingResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.PricingScenario scenario = 1;
   */ _define_property(this, "scenario", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreatePricingResponse, "runtime", proto3);
_define_property(CreatePricingResponse, "typeName", "mono.projectdata.v1.CreatePricingResponse");
_define_property(CreatePricingResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "scenario",
            kind: "message",
            T: PricingScenario
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpdatePricingRequest
 */ export class UpdatePricingRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdatePricingRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdatePricingRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdatePricingRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdatePricingRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string pricing_id = 2;
   */ _define_property(this, "pricingId", ""), /**
   * JSON blob
   *
   * @generated from field: string data = 3;
   */ _define_property(this, "data", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdatePricingRequest, "runtime", proto3);
_define_property(UpdatePricingRequest, "typeName", "mono.projectdata.v1.UpdatePricingRequest");
_define_property(UpdatePricingRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "pricing_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "data",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpdatePricingResponse
 */ export class UpdatePricingResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdatePricingResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdatePricingResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdatePricingResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdatePricingResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.PricingScenario scenario = 1;
   */ _define_property(this, "scenario", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdatePricingResponse, "runtime", proto3);
_define_property(UpdatePricingResponse, "typeName", "mono.projectdata.v1.UpdatePricingResponse");
_define_property(UpdatePricingResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "scenario",
            kind: "message",
            T: PricingScenario
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.DeletePricingRequest
 */ export class DeletePricingRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeletePricingRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeletePricingRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeletePricingRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeletePricingRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string pricing_id = 2;
   */ _define_property(this, "pricingId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeletePricingRequest, "runtime", proto3);
_define_property(DeletePricingRequest, "typeName", "mono.projectdata.v1.DeletePricingRequest");
_define_property(DeletePricingRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "pricing_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.DeletePricingResponse
 */ export class DeletePricingResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeletePricingResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeletePricingResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeletePricingResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeletePricingResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeletePricingResponse, "runtime", proto3);
_define_property(DeletePricingResponse, "typeName", "mono.projectdata.v1.DeletePricingResponse");
_define_property(DeletePricingResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.projectdata.v1.ListPricingEvidenceRequest
 */ export class ListPricingEvidenceRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListPricingEvidenceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPricingEvidenceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPricingEvidenceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPricingEvidenceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string pricing_id = 2;
   */ _define_property(this, "pricingId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListPricingEvidenceRequest, "runtime", proto3);
_define_property(ListPricingEvidenceRequest, "typeName", "mono.projectdata.v1.ListPricingEvidenceRequest");
_define_property(ListPricingEvidenceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "pricing_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListPricingEvidenceResponse
 */ export class ListPricingEvidenceResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListPricingEvidenceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPricingEvidenceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPricingEvidenceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPricingEvidenceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.PricingScenarioVersion versions = 1;
   */ _define_property(this, "versions", []), /**
   * @generated from field: repeated mono.datagateway.v1.PricingWorkbook workbooks = 2;
   */ _define_property(this, "workbooks", []), /**
   * @generated from field: repeated mono.datagateway.v1.PricingReconciliationProposal proposals = 3;
   */ _define_property(this, "proposals", []), /**
   * @generated from field: repeated mono.datagateway.v1.PricingRateSelection active_selections = 4;
   */ _define_property(this, "activeSelections", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListPricingEvidenceResponse, "runtime", proto3);
_define_property(ListPricingEvidenceResponse, "typeName", "mono.projectdata.v1.ListPricingEvidenceResponse");
_define_property(ListPricingEvidenceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "versions",
            kind: "message",
            T: PricingScenarioVersion,
            repeated: true
        },
        {
            no: 2,
            name: "workbooks",
            kind: "message",
            T: PricingWorkbook,
            repeated: true
        },
        {
            no: 3,
            name: "proposals",
            kind: "message",
            T: PricingReconciliationProposal,
            repeated: true
        },
        {
            no: 4,
            name: "active_selections",
            kind: "message",
            T: PricingRateSelection,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SnapshotPricingVersionRequest
 */ export class SnapshotPricingVersionRequest extends Message {
    static fromBinary(bytes, options) {
        return new SnapshotPricingVersionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SnapshotPricingVersionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SnapshotPricingVersionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SnapshotPricingVersionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string pricing_id = 2;
   */ _define_property(this, "pricingId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SnapshotPricingVersionRequest, "runtime", proto3);
_define_property(SnapshotPricingVersionRequest, "typeName", "mono.projectdata.v1.SnapshotPricingVersionRequest");
_define_property(SnapshotPricingVersionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "pricing_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SnapshotPricingVersionResponse
 */ export class SnapshotPricingVersionResponse extends Message {
    static fromBinary(bytes, options) {
        return new SnapshotPricingVersionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SnapshotPricingVersionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SnapshotPricingVersionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SnapshotPricingVersionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.PricingScenarioVersion version = 1;
   */ _define_property(this, "version", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SnapshotPricingVersionResponse, "runtime", proto3);
_define_property(SnapshotPricingVersionResponse, "typeName", "mono.projectdata.v1.SnapshotPricingVersionResponse");
_define_property(SnapshotPricingVersionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "version",
            kind: "message",
            T: PricingScenarioVersion
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RegisterPricingWorkbookRequest
 */ export class RegisterPricingWorkbookRequest extends Message {
    static fromBinary(bytes, options) {
        return new RegisterPricingWorkbookRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RegisterPricingWorkbookRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RegisterPricingWorkbookRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RegisterPricingWorkbookRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string pricing_id = 2;
   */ _define_property(this, "pricingId", ""), /**
   * @generated from field: string artifact_id = 3;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: string workbook_version_id = 4;
   */ _define_property(this, "workbookVersionId", ""), /**
   * empty = unmapped (reconciliation UNAVAILABLE)
   *
   * @generated from field: string mapping_json = 5;
   */ _define_property(this, "mappingJson", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RegisterPricingWorkbookRequest, "runtime", proto3);
_define_property(RegisterPricingWorkbookRequest, "typeName", "mono.projectdata.v1.RegisterPricingWorkbookRequest");
_define_property(RegisterPricingWorkbookRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "pricing_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "workbook_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "mapping_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RegisterPricingWorkbookResponse
 */ export class RegisterPricingWorkbookResponse extends Message {
    static fromBinary(bytes, options) {
        return new RegisterPricingWorkbookResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RegisterPricingWorkbookResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RegisterPricingWorkbookResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RegisterPricingWorkbookResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.PricingWorkbook workbook = 1;
   */ _define_property(this, "workbook", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RegisterPricingWorkbookResponse, "runtime", proto3);
_define_property(RegisterPricingWorkbookResponse, "typeName", "mono.projectdata.v1.RegisterPricingWorkbookResponse");
_define_property(RegisterPricingWorkbookResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "workbook",
            kind: "message",
            T: PricingWorkbook
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SubmitPricingWorkbookRevisionRequest
 */ export class SubmitPricingWorkbookRevisionRequest extends Message {
    static fromBinary(bytes, options) {
        return new SubmitPricingWorkbookRevisionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SubmitPricingWorkbookRevisionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SubmitPricingWorkbookRevisionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SubmitPricingWorkbookRevisionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string workbook_id = 2;
   */ _define_property(this, "workbookId", ""), /**
   * @generated from field: string revised_workbook_version_id = 3;
   */ _define_property(this, "revisedWorkbookVersionId", ""), /**
   * required when the workbook is mapped
   *
   * @generated from field: string proposed_diff_json = 4;
   */ _define_property(this, "proposedDiffJson", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SubmitPricingWorkbookRevisionRequest, "runtime", proto3);
_define_property(SubmitPricingWorkbookRevisionRequest, "typeName", "mono.projectdata.v1.SubmitPricingWorkbookRevisionRequest");
_define_property(SubmitPricingWorkbookRevisionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "workbook_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "revised_workbook_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "proposed_diff_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SubmitPricingWorkbookRevisionResponse
 */ export class SubmitPricingWorkbookRevisionResponse extends Message {
    static fromBinary(bytes, options) {
        return new SubmitPricingWorkbookRevisionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SubmitPricingWorkbookRevisionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SubmitPricingWorkbookRevisionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SubmitPricingWorkbookRevisionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.PricingWorkbook workbook = 1;
   */ _define_property(this, "workbook", void 0), /**
   * unset when unmapped
   *
   * @generated from field: mono.datagateway.v1.PricingReconciliationProposal proposal = 2;
   */ _define_property(this, "proposal", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SubmitPricingWorkbookRevisionResponse, "runtime", proto3);
_define_property(SubmitPricingWorkbookRevisionResponse, "typeName", "mono.projectdata.v1.SubmitPricingWorkbookRevisionResponse");
_define_property(SubmitPricingWorkbookRevisionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "workbook",
            kind: "message",
            T: PricingWorkbook
        },
        {
            no: 2,
            name: "proposal",
            kind: "message",
            T: PricingReconciliationProposal
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ResolvePricingProposalRequest
 */ export class ResolvePricingProposalRequest extends Message {
    static fromBinary(bytes, options) {
        return new ResolvePricingProposalRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResolvePricingProposalRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResolvePricingProposalRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResolvePricingProposalRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string proposal_id = 2;
   */ _define_property(this, "proposalId", ""), /**
   * @generated from field: bool accept = 3;
   */ _define_property(this, "accept", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResolvePricingProposalRequest, "runtime", proto3);
_define_property(ResolvePricingProposalRequest, "typeName", "mono.projectdata.v1.ResolvePricingProposalRequest");
_define_property(ResolvePricingProposalRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "proposal_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "accept",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ResolvePricingProposalResponse
 */ export class ResolvePricingProposalResponse extends Message {
    static fromBinary(bytes, options) {
        return new ResolvePricingProposalResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResolvePricingProposalResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResolvePricingProposalResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResolvePricingProposalResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.PricingReconciliationProposal proposal = 1;
   */ _define_property(this, "proposal", void 0), /**
   * set on accept
   *
   * @generated from field: mono.projectdata.v1.PricingScenario scenario = 2;
   */ _define_property(this, "scenario", void 0), /**
   * set on accept
   *
   * @generated from field: mono.datagateway.v1.PricingScenarioVersion version = 3;
   */ _define_property(this, "version", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResolvePricingProposalResponse, "runtime", proto3);
_define_property(ResolvePricingProposalResponse, "typeName", "mono.projectdata.v1.ResolvePricingProposalResponse");
_define_property(ResolvePricingProposalResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "proposal",
            kind: "message",
            T: PricingReconciliationProposal
        },
        {
            no: 2,
            name: "scenario",
            kind: "message",
            T: PricingScenario
        },
        {
            no: 3,
            name: "version",
            kind: "message",
            T: PricingScenarioVersion
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.IndirectRateConfig
 */ export class IndirectRateConfig extends Message {
    static fromBinary(bytes, options) {
        return new IndirectRateConfig().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new IndirectRateConfig().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new IndirectRateConfig().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(IndirectRateConfig, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string company_id = 2;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", ""), /**
   * @generated from field: bool is_default = 4;
   */ _define_property(this, "isDefault", false), /**
   * JSON array
   *
   * @generated from field: string pools = 5;
   */ _define_property(this, "pools", ""), /**
   * @generated from field: string ga_base_method = 6;
   */ _define_property(this, "gaBaseMethod", ""), /**
   * @generated from field: bool use_multiplicative = 7;
   */ _define_property(this, "useMultiplicative", false), /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 9;
   */ _define_property(this, "updatedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(IndirectRateConfig, "runtime", proto3);
_define_property(IndirectRateConfig, "typeName", "mono.projectdata.v1.IndirectRateConfig");
_define_property(IndirectRateConfig, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "is_default",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "pools",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "ga_base_method",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "use_multiplicative",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 8,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListIndirectRatesRequest
 */ export class ListIndirectRatesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListIndirectRatesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListIndirectRatesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListIndirectRatesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListIndirectRatesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListIndirectRatesRequest, "runtime", proto3);
_define_property(ListIndirectRatesRequest, "typeName", "mono.projectdata.v1.ListIndirectRatesRequest");
_define_property(ListIndirectRatesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListIndirectRatesResponse
 */ export class ListIndirectRatesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListIndirectRatesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListIndirectRatesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListIndirectRatesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListIndirectRatesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.IndirectRateConfig configs = 1;
   */ _define_property(this, "configs", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListIndirectRatesResponse, "runtime", proto3);
_define_property(ListIndirectRatesResponse, "typeName", "mono.projectdata.v1.ListIndirectRatesResponse");
_define_property(ListIndirectRatesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "configs",
            kind: "message",
            T: IndirectRateConfig,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CreateIndirectRateRequest
 */ export class CreateIndirectRateRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateIndirectRateRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateIndirectRateRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateIndirectRateRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateIndirectRateRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * @generated from field: bool is_default = 3;
   */ _define_property(this, "isDefault", false), /**
   * JSON array
   *
   * @generated from field: string pools = 4;
   */ _define_property(this, "pools", ""), /**
   * @generated from field: string ga_base_method = 5;
   */ _define_property(this, "gaBaseMethod", ""), /**
   * @generated from field: bool use_multiplicative = 6;
   */ _define_property(this, "useMultiplicative", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateIndirectRateRequest, "runtime", proto3);
_define_property(CreateIndirectRateRequest, "typeName", "mono.projectdata.v1.CreateIndirectRateRequest");
_define_property(CreateIndirectRateRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "is_default",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "pools",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "ga_base_method",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "use_multiplicative",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CreateIndirectRateResponse
 */ export class CreateIndirectRateResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateIndirectRateResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateIndirectRateResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateIndirectRateResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateIndirectRateResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.IndirectRateConfig config = 1;
   */ _define_property(this, "config", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateIndirectRateResponse, "runtime", proto3);
_define_property(CreateIndirectRateResponse, "typeName", "mono.projectdata.v1.CreateIndirectRateResponse");
_define_property(CreateIndirectRateResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "config",
            kind: "message",
            T: IndirectRateConfig
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpdateIndirectRateRequest
 */ export class UpdateIndirectRateRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateIndirectRateRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateIndirectRateRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateIndirectRateRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateIndirectRateRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string config_id = 1;
   */ _define_property(this, "configId", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * @generated from field: bool is_default = 3;
   */ _define_property(this, "isDefault", false), /**
   * @generated from field: string pools = 4;
   */ _define_property(this, "pools", ""), /**
   * @generated from field: string ga_base_method = 5;
   */ _define_property(this, "gaBaseMethod", ""), /**
   * @generated from field: bool use_multiplicative = 6;
   */ _define_property(this, "useMultiplicative", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateIndirectRateRequest, "runtime", proto3);
_define_property(UpdateIndirectRateRequest, "typeName", "mono.projectdata.v1.UpdateIndirectRateRequest");
_define_property(UpdateIndirectRateRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "config_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "is_default",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "pools",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "ga_base_method",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "use_multiplicative",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpdateIndirectRateResponse
 */ export class UpdateIndirectRateResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateIndirectRateResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateIndirectRateResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateIndirectRateResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateIndirectRateResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.IndirectRateConfig config = 1;
   */ _define_property(this, "config", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateIndirectRateResponse, "runtime", proto3);
_define_property(UpdateIndirectRateResponse, "typeName", "mono.projectdata.v1.UpdateIndirectRateResponse");
_define_property(UpdateIndirectRateResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "config",
            kind: "message",
            T: IndirectRateConfig
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.DeleteIndirectRateRequest
 */ export class DeleteIndirectRateRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteIndirectRateRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteIndirectRateRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteIndirectRateRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteIndirectRateRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string config_id = 1;
   */ _define_property(this, "configId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteIndirectRateRequest, "runtime", proto3);
_define_property(DeleteIndirectRateRequest, "typeName", "mono.projectdata.v1.DeleteIndirectRateRequest");
_define_property(DeleteIndirectRateRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "config_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.DeleteIndirectRateResponse
 */ export class DeleteIndirectRateResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteIndirectRateResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteIndirectRateResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteIndirectRateResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteIndirectRateResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteIndirectRateResponse, "runtime", proto3);
_define_property(DeleteIndirectRateResponse, "typeName", "mono.projectdata.v1.DeleteIndirectRateResponse");
_define_property(DeleteIndirectRateResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.projectdata.v1.ProjectChat
 */ export class ProjectChat extends Message {
    static fromBinary(bytes, options) {
        return new ProjectChat().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProjectChat().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProjectChat().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProjectChat, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string chat_id = 1;
   */ _define_property(this, "chatId", ""), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string title = 3;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string created_by_user_id = 4;
   */ _define_property(this, "createdByUserId", ""), /**
   * @generated from field: string created_by_name = 5;
   */ _define_property(this, "createdByName", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: int32 message_count = 7;
   */ _define_property(this, "messageCount", 0), /**
   * @generated from field: bool is_owner = 8;
   */ _define_property(this, "isOwner", false), /**
   * @generated from field: bool can_edit = 9;
   */ _define_property(this, "canEdit", false), /**
   * @generated from field: string forked_from_chat_id = 10;
   */ _define_property(this, "forkedFromChatId", ""), /**
   * @generated from field: string forked_from_title = 11;
   */ _define_property(this, "forkedFromTitle", ""), /**
   * V2 dashboard grounding context. The frontend stamps these on chat
   * creation so the backend can later answer "what was this chat about?"
   * and (in PR10+) feed them to the LLM for context-aware grounding.
   * PR5 stores them but does not act on them — that's the deliberate
   * skeleton-only V1 behavior described in the dashboard rewrite plan.
   *
   * e.g. "home", "compliance", "volume:abc", "sources:files"
   *
   * @generated from field: string context_workspace = 12;
   */ _define_property(this, "contextWorkspace", ""), /**
   * optional: requirement the chat is anchored to
   *
   * @generated from field: string context_requirement_id = 13;
   */ _define_property(this, "contextRequirementId", ""), /**
   * opaque JSON; structure owned by the frontend
   *
   * @generated from field: bytes context_blob = 14;
   */ _define_property(this, "contextBlob", new Uint8Array(0));
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProjectChat, "runtime", proto3);
_define_property(ProjectChat, "typeName", "mono.projectdata.v1.ProjectChat");
_define_property(ProjectChat, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "chat_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "created_by_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "created_by_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "message_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 8,
            name: "is_owner",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 9,
            name: "can_edit",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 10,
            name: "forked_from_chat_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "forked_from_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "context_workspace",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "context_requirement_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "context_blob",
            kind: "scalar",
            T: 12 /* ScalarType.BYTES */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListProjectChatsRequest
 */ export class ListProjectChatsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListProjectChatsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProjectChatsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProjectChatsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProjectChatsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * "createdAt"
   *
   * @generated from field: string sort = 3;
   */ _define_property(this, "sort", ""), /**
   * "asc" or "desc"
   *
   * @generated from field: string order = 4;
   */ _define_property(this, "order", ""), /**
   * @generated from field: string search = 5;
   */ _define_property(this, "search", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProjectChatsRequest, "runtime", proto3);
_define_property(ListProjectChatsRequest, "typeName", "mono.projectdata.v1.ListProjectChatsRequest");
_define_property(ListProjectChatsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "sort",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "order",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "search",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListProjectChatsResponse
 */ export class ListProjectChatsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListProjectChatsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProjectChatsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProjectChatsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProjectChatsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.ProjectChat chats = 1;
   */ _define_property(this, "chats", []), /**
   * @generated from field: int32 count = 2;
   */ _define_property(this, "count", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProjectChatsResponse, "runtime", proto3);
_define_property(ListProjectChatsResponse, "typeName", "mono.projectdata.v1.ListProjectChatsResponse");
_define_property(ListProjectChatsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "chats",
            kind: "message",
            T: ProjectChat,
            repeated: true
        },
        {
            no: 2,
            name: "count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetProjectChatRequest
 */ export class GetProjectChatRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetProjectChatRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProjectChatRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProjectChatRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProjectChatRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string chat_id = 3;
   */ _define_property(this, "chatId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProjectChatRequest, "runtime", proto3);
_define_property(GetProjectChatRequest, "typeName", "mono.projectdata.v1.GetProjectChatRequest");
_define_property(GetProjectChatRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "chat_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetProjectChatResponse
 */ export class GetProjectChatResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetProjectChatResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProjectChatResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProjectChatResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProjectChatResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.ProjectChat chat = 1;
   */ _define_property(this, "chat", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProjectChatResponse, "runtime", proto3);
_define_property(GetProjectChatResponse, "typeName", "mono.projectdata.v1.GetProjectChatResponse");
_define_property(GetProjectChatResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "chat",
            kind: "message",
            T: ProjectChat
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CreateProjectChatRequest
 */ export class CreateProjectChatRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateProjectChatRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateProjectChatRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateProjectChatRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateProjectChatRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string title = 3;
   */ _define_property(this, "title", ""), /**
   * V2 dashboard grounding context — see ProjectChat.context_* fields.
   * All optional; sent by the V2 AI sidebar so the chat is anchored to
   * whatever the user was looking at when they opened it.
   *
   * @generated from field: string context_workspace = 4;
   */ _define_property(this, "contextWorkspace", ""), /**
   * @generated from field: string context_requirement_id = 5;
   */ _define_property(this, "contextRequirementId", ""), /**
   * @generated from field: bytes context_blob = 6;
   */ _define_property(this, "contextBlob", new Uint8Array(0));
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateProjectChatRequest, "runtime", proto3);
_define_property(CreateProjectChatRequest, "typeName", "mono.projectdata.v1.CreateProjectChatRequest");
_define_property(CreateProjectChatRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "context_workspace",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "context_requirement_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "context_blob",
            kind: "scalar",
            T: 12 /* ScalarType.BYTES */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CreateProjectChatResponse
 */ export class CreateProjectChatResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateProjectChatResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateProjectChatResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateProjectChatResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateProjectChatResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.ProjectChat chat = 1;
   */ _define_property(this, "chat", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateProjectChatResponse, "runtime", proto3);
_define_property(CreateProjectChatResponse, "typeName", "mono.projectdata.v1.CreateProjectChatResponse");
_define_property(CreateProjectChatResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "chat",
            kind: "message",
            T: ProjectChat
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ForkProjectChatRequest
 */ export class ForkProjectChatRequest extends Message {
    static fromBinary(bytes, options) {
        return new ForkProjectChatRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ForkProjectChatRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ForkProjectChatRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ForkProjectChatRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string chat_id = 3;
   */ _define_property(this, "chatId", ""), /**
   * @generated from field: string title = 4;
   */ _define_property(this, "title", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ForkProjectChatRequest, "runtime", proto3);
_define_property(ForkProjectChatRequest, "typeName", "mono.projectdata.v1.ForkProjectChatRequest");
_define_property(ForkProjectChatRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "chat_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ForkProjectChatResponse
 */ export class ForkProjectChatResponse extends Message {
    static fromBinary(bytes, options) {
        return new ForkProjectChatResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ForkProjectChatResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ForkProjectChatResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ForkProjectChatResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.ProjectChat chat = 1;
   */ _define_property(this, "chat", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ForkProjectChatResponse, "runtime", proto3);
_define_property(ForkProjectChatResponse, "typeName", "mono.projectdata.v1.ForkProjectChatResponse");
_define_property(ForkProjectChatResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "chat",
            kind: "message",
            T: ProjectChat
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetDocumentsRequest
 */ export class GetDocumentsRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetDocumentsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetDocumentsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetDocumentsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetDocumentsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string document_type = 3;
   */ _define_property(this, "documentType", ""), /**
   * @generated from field: string processing_status = 4;
   */ _define_property(this, "processingStatus", ""), /**
   * @generated from field: mono.common.v1.PaginationRequest pagination = 5;
   */ _define_property(this, "pagination", void 0), /**
   * @generated from field: string sort_by = 6;
   */ _define_property(this, "sortBy", ""), /**
   * @generated from field: string sort_order = 7;
   */ _define_property(this, "sortOrder", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetDocumentsRequest, "runtime", proto3);
_define_property(GetDocumentsRequest, "typeName", "mono.projectdata.v1.GetDocumentsRequest");
_define_property(GetDocumentsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "document_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "processing_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "pagination",
            kind: "message",
            T: PaginationRequest
        },
        {
            no: 6,
            name: "sort_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "sort_order",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetDocumentsResponse
 */ export class GetDocumentsResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetDocumentsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetDocumentsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetDocumentsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetDocumentsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.ProcessedDocument documents = 1;
   */ _define_property(this, "documents", []), /**
   * @generated from field: int32 total = 2;
   */ _define_property(this, "total", 0), /**
   * @generated from field: string next_page_token = 3;
   */ _define_property(this, "nextPageToken", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetDocumentsResponse, "runtime", proto3);
_define_property(GetDocumentsResponse, "typeName", "mono.projectdata.v1.GetDocumentsResponse");
_define_property(GetDocumentsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "documents",
            kind: "message",
            T: ProcessedDocument,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "next_page_token",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ProcessedDocument
 */ export class ProcessedDocument extends Message {
    static fromBinary(bytes, options) {
        return new ProcessedDocument().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProcessedDocument().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProcessedDocument().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProcessedDocument, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string attachment_id = 1;
   */ _define_property(this, "attachmentId", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string content_type = 3;
   */ _define_property(this, "contentType", ""), /**
   * @generated from field: int64 size = 4;
   */ _define_property(this, "size", protoInt64.zero), /**
   * @generated from field: string classification = 5;
   */ _define_property(this, "classification", ""), /**
   * @generated from field: string processing_status = 6;
   */ _define_property(this, "processingStatus", ""), /**
   * @generated from field: int32 processing_progress = 7;
   */ _define_property(this, "processingProgress", 0), /**
   * @generated from field: int32 page_count = 8;
   */ _define_property(this, "pageCount", 0), /**
   * @generated from field: google.protobuf.Timestamp uploaded_at = 9;
   */ _define_property(this, "uploadedAt", void 0), /**
   * @generated from field: string uploaded_by = 10;
   */ _define_property(this, "uploadedBy", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProcessedDocument, "runtime", proto3);
_define_property(ProcessedDocument, "typeName", "mono.projectdata.v1.ProcessedDocument");
_define_property(ProcessedDocument, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "attachment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "content_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "size",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 5,
            name: "classification",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "processing_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "processing_progress",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 8,
            name: "page_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 9,
            name: "uploaded_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "uploaded_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetPageVisualizationRequest
 */ export class GetPageVisualizationRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetPageVisualizationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPageVisualizationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPageVisualizationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPageVisualizationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * attachment_id
   *
   * @generated from field: string document_id = 3;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: int32 page_number = 4;
   */ _define_property(this, "pageNumber", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetPageVisualizationRequest, "runtime", proto3);
_define_property(GetPageVisualizationRequest, "typeName", "mono.projectdata.v1.GetPageVisualizationRequest");
_define_property(GetPageVisualizationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "page_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetPageVisualizationResponse
 */ export class GetPageVisualizationResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetPageVisualizationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPageVisualizationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPageVisualizationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPageVisualizationResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 page_number = 1;
   */ _define_property(this, "pageNumber", 0), /**
   * @generated from field: int32 total_pages = 2;
   */ _define_property(this, "totalPages", 0), /**
   * @generated from field: int32 page_width = 3;
   */ _define_property(this, "pageWidth", 0), /**
   * @generated from field: int32 page_height = 4;
   */ _define_property(this, "pageHeight", 0), /**
   * @generated from field: repeated mono.common.v1.DocumentBlock blocks = 5;
   */ _define_property(this, "blocks", []), /**
   * Data URL for rendered page image (e.g. "data:image/png;base64,...").
   *
   * @generated from field: string image_data_url = 6;
   */ _define_property(this, "imageDataUrl", ""), /**
   * Mime type for rendered image payload, defaults to image/png.
   *
   * @generated from field: string image_mime_type = 7;
   */ _define_property(this, "imageMimeType", ""), /**
   * Effective rendering DPI used to generate image_data_url.
   *
   * @generated from field: int32 render_dpi = 8;
   */ _define_property(this, "renderDpi", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetPageVisualizationResponse, "runtime", proto3);
_define_property(GetPageVisualizationResponse, "typeName", "mono.projectdata.v1.GetPageVisualizationResponse");
_define_property(GetPageVisualizationResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "page_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "total_pages",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "page_width",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "page_height",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "blocks",
            kind: "message",
            T: DocumentBlock,
            repeated: true
        },
        {
            no: 6,
            name: "image_data_url",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "image_mime_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "render_dpi",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ProcessBatchRequest
 */ export class ProcessBatchRequest extends Message {
    static fromBinary(bytes, options) {
        return new ProcessBatchRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProcessBatchRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProcessBatchRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProcessBatchRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: repeated string attachment_ids = 3;
   */ _define_property(this, "attachmentIds", []), /**
   * Optional: declares the batch's contract shape up front (e.g. a Contract
   * re-upload through Docs -> Modifications) so reverie's content classifier
   * can be overridden rather than guessed from the document alone. Unset
   * preserves today's classify-by-content behavior.
   *
   * @generated from field: mono.projectdata.v1.ReprocessDocumentKind document_kind = 4;
   */ _define_property(this, "documentKind", 0), /**
   * Award intake prepares converted documents for the separate award extraction
   * workflow. It does not run proposal-wide requirements analysis or sync.
   *
   * @generated from field: bool award_intake_only = 5;
   */ _define_property(this, "awardIntakeOnly", false), /**
   * Optional: the program workstream a SOW / Execution Plan belongs to when
   * the uploader names it (SAD-898). Empty lets SOW intake propose the team
   * from the document. Ignored unless document_kind is SOW.
   *
   * @generated from field: string workstream_id = 6;
   */ _define_property(this, "workstreamId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProcessBatchRequest, "runtime", proto3);
_define_property(ProcessBatchRequest, "typeName", "mono.projectdata.v1.ProcessBatchRequest");
_define_property(ProcessBatchRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "attachment_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 4,
            name: "document_kind",
            kind: "enum",
            T: proto3.getEnumType(ReprocessDocumentKind)
        },
        {
            no: 5,
            name: "award_intake_only",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 6,
            name: "workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ProcessBatchResponse
 */ export class ProcessBatchResponse extends Message {
    static fromBinary(bytes, options) {
        return new ProcessBatchResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProcessBatchResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProcessBatchResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProcessBatchResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string batch_id = 1;
   */ _define_property(this, "batchId", ""), /**
   * @generated from field: string status = 2;
   */ _define_property(this, "status", ""), /**
   * @generated from field: int32 total_documents = 3;
   */ _define_property(this, "totalDocuments", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProcessBatchResponse, "runtime", proto3);
_define_property(ProcessBatchResponse, "typeName", "mono.projectdata.v1.ProcessBatchResponse");
_define_property(ProcessBatchResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "batch_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "total_documents",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RelinkProgramDocumentsRequest
 */ export class RelinkProgramDocumentsRequest extends Message {
    static fromBinary(bytes, options) {
        return new RelinkProgramDocumentsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RelinkProgramDocumentsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RelinkProgramDocumentsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RelinkProgramDocumentsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * Optional: the specific attachments to re-link. Empty means re-link every
   * document attached to the project.
   *
   * @generated from field: repeated string attachment_ids = 3;
   */ _define_property(this, "attachmentIds", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RelinkProgramDocumentsRequest, "runtime", proto3);
_define_property(RelinkProgramDocumentsRequest, "typeName", "mono.projectdata.v1.RelinkProgramDocumentsRequest");
_define_property(RelinkProgramDocumentsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "attachment_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RelinkProgramDocumentsResponse
 */ export class RelinkProgramDocumentsResponse extends Message {
    static fromBinary(bytes, options) {
        return new RelinkProgramDocumentsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RelinkProgramDocumentsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RelinkProgramDocumentsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RelinkProgramDocumentsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * The reverie job id running the link loop; poll GetBatchStatus-style flags
   * via the registered job, same as a batch.
   *
   * @generated from field: string batch_id = 1;
   */ _define_property(this, "batchId", ""), /**
   * @generated from field: string status = 2;
   */ _define_property(this, "status", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RelinkProgramDocumentsResponse, "runtime", proto3);
_define_property(RelinkProgramDocumentsResponse, "typeName", "mono.projectdata.v1.RelinkProgramDocumentsResponse");
_define_property(RelinkProgramDocumentsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "batch_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetBatchStatusRequest
 */ export class GetBatchStatusRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetBatchStatusRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetBatchStatusRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetBatchStatusRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetBatchStatusRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string batch_id = 3;
   */ _define_property(this, "batchId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetBatchStatusRequest, "runtime", proto3);
_define_property(GetBatchStatusRequest, "typeName", "mono.projectdata.v1.GetBatchStatusRequest");
_define_property(GetBatchStatusRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "batch_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetBatchStatusResponse
 */ export class GetBatchStatusResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetBatchStatusResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetBatchStatusResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetBatchStatusResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetBatchStatusResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string batch_id = 1;
   */ _define_property(this, "batchId", ""), /**
   * pending, processing, completed, failed
   *
   * @generated from field: string status = 2;
   */ _define_property(this, "status", ""), /**
   * @generated from field: int32 total_documents = 3;
   */ _define_property(this, "totalDocuments", 0), /**
   * @generated from field: int32 processed_documents = 4;
   */ _define_property(this, "processedDocuments", 0), /**
   * @generated from field: int32 failed_documents = 5;
   */ _define_property(this, "failedDocuments", 0), /**
   * @generated from field: google.protobuf.Timestamp started_at = 6;
   */ _define_property(this, "startedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp completed_at = 7;
   */ _define_property(this, "completedAt", void 0), /**
   * Project analysis (cross-document) phase tracking.
   *
   * pending, processing, completed, failed, or empty
   *
   * @generated from field: string project_analysis_status = 8;
   */ _define_property(this, "projectAnalysisStatus", ""), /**
   * 0-100
   *
   * @generated from field: float project_analysis_progress = 9;
   */ _define_property(this, "projectAnalysisProgress", 0), /**
   * e.g. "Extracting labor categories"
   *
   * @generated from field: string project_analysis_current_step = 10;
   */ _define_property(this, "projectAnalysisCurrentStep", ""), /**
   * True when document extraction completed but the delivery-program sync
   * failed — the batch is "completed" (docs are processed) yet no program was
   * created/linked, so the UI surfaces a non-fatal warning with a retry.
   *
   * @generated from field: bool program_sync_failed = 11;
   */ _define_property(this, "programSyncFailed", false), /**
   * The attachment ids that belong to THIS batch, so a retry re-processes only
   * this batch's documents rather than every file in the project.
   *
   * @generated from field: repeated string attachment_ids = 12;
   */ _define_property(this, "attachmentIds", []), /**
   * True when the batch stored its documents but analyzed no contract award
   * (e.g. only a PWS/SOW was uploaded), so no delivery program was created.
   * Non-retryable — the UI warns without a Retry action.
   *
   * @generated from field: bool no_contract_award = 13;
   */ _define_property(this, "noContractAward", false), /**
   * True when the delivery program WAS created but some source documents didn't
   * land in its Docs tab (a partial link failure). Distinct from
   * program_sync_failed so the UI can say "not fully linked yet" rather than "no
   * program was created". Retryable — the retry re-drives the sync + links, and
   * attachment_ids ride along for it.
   *
   * @generated from field: bool program_docs_incomplete = 14;
   */ _define_property(this, "programDocsIncomplete", false), /**
   * Canonical delivery program id after a successful contract sync (empty until then).
   *
   * @generated from field: string synced_program_id = 15;
   */ _define_property(this, "syncedProgramId", ""), /**
   * Set when the batch held no contract because an upload was refused as not a
   * signed contract: "solicitation", "not_a_contract", or "unconfirmed" (the
   * classifier could not confirm an award or modification). Nothing was synced;
   * the UI asks for the signed award. Empty otherwise.
   *
   * @generated from field: string not_a_contract = 16;
   */ _define_property(this, "notAContract", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetBatchStatusResponse, "runtime", proto3);
_define_property(GetBatchStatusResponse, "typeName", "mono.projectdata.v1.GetBatchStatusResponse");
_define_property(GetBatchStatusResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "batch_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "total_documents",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "processed_documents",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "failed_documents",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "started_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "completed_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "project_analysis_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "project_analysis_progress",
            kind: "scalar",
            T: 2 /* ScalarType.FLOAT */ 
        },
        {
            no: 10,
            name: "project_analysis_current_step",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "program_sync_failed",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 12,
            name: "attachment_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 13,
            name: "no_contract_award",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 14,
            name: "program_docs_incomplete",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 15,
            name: "synced_program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "not_a_contract",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ReprocessContractExtractionRequest
 */ export class ReprocessContractExtractionRequest extends Message {
    static fromBinary(bytes, options) {
        return new ReprocessContractExtractionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReprocessContractExtractionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReprocessContractExtractionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReprocessContractExtractionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * baltigo document id (CLIN source_document_id)
   *
   * @generated from field: string reextract_doc_id = 3;
   */ _define_property(this, "reextractDocId", ""), /**
   * @generated from field: mono.projectdata.v1.ReprocessDocumentKind document_kind = 4;
   */ _define_property(this, "documentKind", 0), /**
   * optional; used for mod jobs UI linkage
   *
   * @generated from field: string program_id = 5;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReprocessContractExtractionRequest, "runtime", proto3);
_define_property(ReprocessContractExtractionRequest, "typeName", "mono.projectdata.v1.ReprocessContractExtractionRequest");
_define_property(ReprocessContractExtractionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "reextract_doc_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "document_kind",
            kind: "enum",
            T: proto3.getEnumType(ReprocessDocumentKind)
        },
        {
            no: 5,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ReprocessContractExtractionResponse
 */ export class ReprocessContractExtractionResponse extends Message {
    static fromBinary(bytes, options) {
        return new ReprocessContractExtractionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReprocessContractExtractionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReprocessContractExtractionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReprocessContractExtractionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string batch_id = 1;
   */ _define_property(this, "batchId", ""), /**
   * processing
   *
   * @generated from field: string status = 2;
   */ _define_property(this, "status", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReprocessContractExtractionResponse, "runtime", proto3);
_define_property(ReprocessContractExtractionResponse, "typeName", "mono.projectdata.v1.ReprocessContractExtractionResponse");
_define_property(ReprocessContractExtractionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "batch_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ResyncExtractedDataRequest
 */ export class ResyncExtractedDataRequest extends Message {
    static fromBinary(bytes, options) {
        return new ResyncExtractedDataRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResyncExtractedDataRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResyncExtractedDataRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResyncExtractedDataRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * Required to locate MinIO artifacts
   *
   * @generated from field: string company_id = 3;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResyncExtractedDataRequest, "runtime", proto3);
_define_property(ResyncExtractedDataRequest, "typeName", "mono.projectdata.v1.ResyncExtractedDataRequest");
_define_property(ResyncExtractedDataRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ResyncExtractedDataResponse
 */ export class ResyncExtractedDataResponse extends Message {
    static fromBinary(bytes, options) {
        return new ResyncExtractedDataResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResyncExtractedDataResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResyncExtractedDataResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResyncExtractedDataResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 requirements_synced = 1;
   */ _define_property(this, "requirementsSynced", 0), /**
   * @generated from field: int32 clins_synced = 2;
   */ _define_property(this, "clinsSynced", 0), /**
   * @generated from field: int32 lcats_synced = 3;
   */ _define_property(this, "lcatsSynced", 0), /**
   * @generated from field: int32 classifications_synced = 4;
   */ _define_property(this, "classificationsSynced", 0), /**
   * @generated from field: bool opportunity_synced = 5;
   */ _define_property(this, "opportunitySynced", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResyncExtractedDataResponse, "runtime", proto3);
_define_property(ResyncExtractedDataResponse, "typeName", "mono.projectdata.v1.ResyncExtractedDataResponse");
_define_property(ResyncExtractedDataResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "requirements_synced",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "clins_synced",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "lcats_synced",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "classifications_synced",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "opportunity_synced",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CreateContractProjectFromProposalRequest
 */ export class CreateContractProjectFromProposalRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateContractProjectFromProposalRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateContractProjectFromProposalRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateContractProjectFromProposalRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateContractProjectFromProposalRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string proposal_project_id = 2;
   */ _define_property(this, "proposalProjectId", ""), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string description = 4;
   */ _define_property(this, "description", ""), /**
   * @generated from field: mono.projectdata.v1.ContractInfo contract_data = 5;
   */ _define_property(this, "contractData", void 0), /**
   * @generated from field: bool archive_source_proposal = 6;
   */ _define_property(this, "archiveSourceProposal", false), /**
   * Optional (empty = tenant-wide, matching today's behavior). When set, the
   * minted delivery program is scoped to this business unit — narrows the
   * `create_program` authority target to the unit's scope node instead of
   * the tenant root, and the program's own scope node parents under it. See
   * requireCreateProgramAuthority in services/zou/pkg/connecthandlers.
   *
   * @generated from field: string business_unit_id = 7;
   */ _define_property(this, "businessUnitId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateContractProjectFromProposalRequest, "runtime", proto3);
_define_property(CreateContractProjectFromProposalRequest, "typeName", "mono.projectdata.v1.CreateContractProjectFromProposalRequest");
_define_property(CreateContractProjectFromProposalRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "proposal_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "contract_data",
            kind: "message",
            T: ContractInfo
        },
        {
            no: 6,
            name: "archive_source_proposal",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 7,
            name: "business_unit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ConversionSummary
 */ export class ConversionSummary extends Message {
    static fromBinary(bytes, options) {
        return new ConversionSummary().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ConversionSummary().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ConversionSummary().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ConversionSummary, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 requirements_copied = 1;
   */ _define_property(this, "requirementsCopied", 0), /**
   * @generated from field: int32 attachments_copied = 2;
   */ _define_property(this, "attachmentsCopied", 0), /**
   * @generated from field: int32 clins_copied = 3;
   */ _define_property(this, "clinsCopied", 0), /**
   * @generated from field: int32 deliverables_copied = 4;
   */ _define_property(this, "deliverablesCopied", 0), /**
   * @generated from field: repeated string warnings = 5;
   */ _define_property(this, "warnings", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ConversionSummary, "runtime", proto3);
_define_property(ConversionSummary, "typeName", "mono.projectdata.v1.ConversionSummary");
_define_property(ConversionSummary, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "requirements_copied",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "attachments_copied",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "clins_copied",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "deliverables_copied",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "warnings",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.EnsureDeliveryProgramRequest
 */ export class EnsureDeliveryProgramRequest extends Message {
    static fromBinary(bytes, options) {
        return new EnsureDeliveryProgramRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EnsureDeliveryProgramRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EnsureDeliveryProgramRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EnsureDeliveryProgramRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(EnsureDeliveryProgramRequest, "runtime", proto3);
_define_property(EnsureDeliveryProgramRequest, "typeName", "mono.projectdata.v1.EnsureDeliveryProgramRequest");
_define_property(EnsureDeliveryProgramRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.EnsureDeliveryProgramResponse
 */ export class EnsureDeliveryProgramResponse extends Message {
    static fromBinary(bytes, options) {
        return new EnsureDeliveryProgramResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EnsureDeliveryProgramResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EnsureDeliveryProgramResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EnsureDeliveryProgramResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * True when this call minted the program (false: it already existed).
   *
   * @generated from field: bool created = 2;
   */ _define_property(this, "created", false), /**
   * True when the program existed BEFORE this call ran — as opposed to
   * losing the accepted race with the creation-time background attach,
   * where the program was just minted for this caller and is accessible.
   * The UI uses this to distinguish "projection-hidden from you" from
   * "created a moment ago, go there".
   *
   * @generated from field: bool preexisting = 3;
   */ _define_property(this, "preexisting", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(EnsureDeliveryProgramResponse, "runtime", proto3);
_define_property(EnsureDeliveryProgramResponse, "typeName", "mono.projectdata.v1.EnsureDeliveryProgramResponse");
_define_property(EnsureDeliveryProgramResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "created",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 3,
            name: "preexisting",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CreateContractProjectFromProposalResponse
 */ export class CreateContractProjectFromProposalResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateContractProjectFromProposalResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateContractProjectFromProposalResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateContractProjectFromProposalResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateContractProjectFromProposalResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.ProjectInfo project = 1;
   */ _define_property(this, "project", void 0), /**
   * @generated from field: mono.projectdata.v1.ConversionSummary conversion_summary = 2;
   */ _define_property(this, "conversionSummary", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateContractProjectFromProposalResponse, "runtime", proto3);
_define_property(CreateContractProjectFromProposalResponse, "typeName", "mono.projectdata.v1.CreateContractProjectFromProposalResponse");
_define_property(CreateContractProjectFromProposalResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project",
            kind: "message",
            T: ProjectInfo
        },
        {
            no: 2,
            name: "conversion_summary",
            kind: "message",
            T: ConversionSummary
        }
    ]));
/**
 * StoredModification maps to IContractModification from express-backend.
 *
 * @generated from message mono.projectdata.v1.StoredModification
 */ export class StoredModification extends Message {
    static fromBinary(bytes, options) {
        return new StoredModification().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StoredModification().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StoredModification().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StoredModification, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string modification_id = 1;
   */ _define_property(this, "modificationId", ""), /**
   * @generated from field: string contract_id = 2;
   */ _define_property(this, "contractId", ""), /**
   * @generated from field: string contract_number = 3;
   */ _define_property(this, "contractNumber", ""), /**
   * Identification
   *
   * P00001, A00001, etc.
   *
   * @generated from field: string modification_number = 4;
   */ _define_property(this, "modificationNumber", ""), /**
   * bilateral, unilateral, administrative, change_order, supplemental
   *
   * @generated from field: string modification_type = 5;
   */ _define_property(this, "modificationType", ""), /**
   * draft, applied, rejected, pending
   *
   * @generated from field: string status = 6;
   */ _define_property(this, "status", ""), /**
   * Classification
   *
   * @generated from field: repeated string change_categories = 7;
   */ _define_property(this, "changeCategories", []), /**
   * Dates
   *
   * @generated from field: google.protobuf.Timestamp effective_date = 8;
   */ _define_property(this, "effectiveDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp signed_date = 9;
   */ _define_property(this, "signedDate", void 0), /**
   * Changes summary
   *
   * @generated from field: repeated mono.projectdata.v1.FundingChange funding_changes = 10;
   */ _define_property(this, "fundingChanges", []), /**
   * @generated from field: repeated mono.projectdata.v1.ScopeChange scope_changes = 11;
   */ _define_property(this, "scopeChanges", []), /**
   * @generated from field: repeated mono.projectdata.v1.PeriodChange period_changes = 12;
   */ _define_property(this, "periodChanges", []), /**
   * Impact
   *
   * @generated from field: double total_funding_change = 13;
   */ _define_property(this, "totalFundingChange", 0), /**
   * @generated from field: double cumulative_contract_value = 14;
   */ _define_property(this, "cumulativeContractValue", 0), /**
   * Extraction
   *
   * @generated from field: double extraction_confidence = 15;
   */ _define_property(this, "extractionConfidence", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(StoredModification, "runtime", proto3);
_define_property(StoredModification, "typeName", "mono.projectdata.v1.StoredModification");
_define_property(StoredModification, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "modification_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "contract_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "contract_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "modification_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "modification_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "change_categories",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 8,
            name: "effective_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "signed_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "funding_changes",
            kind: "message",
            T: FundingChange,
            repeated: true
        },
        {
            no: 11,
            name: "scope_changes",
            kind: "message",
            T: ScopeChange,
            repeated: true
        },
        {
            no: 12,
            name: "period_changes",
            kind: "message",
            T: PeriodChange,
            repeated: true
        },
        {
            no: 13,
            name: "total_funding_change",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 14,
            name: "cumulative_contract_value",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 15,
            name: "extraction_confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.FundingChange
 */ export class FundingChange extends Message {
    static fromBinary(bytes, options) {
        return new FundingChange().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FundingChange().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FundingChange().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FundingChange, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string clin_number = 1;
   */ _define_property(this, "clinNumber", ""), /**
   * addition, deduction, deobligation
   *
   * @generated from field: string change_type = 2;
   */ _define_property(this, "changeType", ""), /**
   * @generated from field: double amount = 3;
   */ _define_property(this, "amount", 0), /**
   * @generated from field: double previous_amount = 4;
   */ _define_property(this, "previousAmount", 0), /**
   * @generated from field: double new_amount = 5;
   */ _define_property(this, "newAmount", 0), /**
   * @generated from field: string description = 6;
   */ _define_property(this, "description", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(FundingChange, "runtime", proto3);
_define_property(FundingChange, "typeName", "mono.projectdata.v1.FundingChange");
_define_property(FundingChange, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "clin_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "change_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 4,
            name: "previous_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 5,
            name: "new_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 6,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ScopeChange
 */ export class ScopeChange extends Message {
    static fromBinary(bytes, options) {
        return new ScopeChange().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ScopeChange().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ScopeChange().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ScopeChange, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string clin_number = 1;
   */ _define_property(this, "clinNumber", ""), /**
   * added, removed, modified
   *
   * @generated from field: string change_type = 2;
   */ _define_property(this, "changeType", ""), /**
   * @generated from field: string description = 3;
   */ _define_property(this, "description", ""), /**
   * @generated from field: repeated string pws_sections = 4;
   */ _define_property(this, "pwsSections", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ScopeChange, "runtime", proto3);
_define_property(ScopeChange, "typeName", "mono.projectdata.v1.ScopeChange");
_define_property(ScopeChange, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "clin_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "change_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "pws_sections",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.PeriodChange
 */ export class PeriodChange extends Message {
    static fromBinary(bytes, options) {
        return new PeriodChange().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PeriodChange().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PeriodChange().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PeriodChange, a, b);
    }
    constructor(data){
        super(), /**
   * extension, option_exercise, reduction
   *
   * @generated from field: string change_type = 1;
   */ _define_property(this, "changeType", ""), /**
   * @generated from field: google.protobuf.Timestamp previous_end_date = 2;
   */ _define_property(this, "previousEndDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp new_end_date = 3;
   */ _define_property(this, "newEndDate", void 0), /**
   * @generated from field: int32 option_period = 4;
   */ _define_property(this, "optionPeriod", 0), /**
   * @generated from field: repeated string clin_numbers = 5;
   */ _define_property(this, "clinNumbers", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PeriodChange, "runtime", proto3);
_define_property(PeriodChange, "typeName", "mono.projectdata.v1.PeriodChange");
_define_property(PeriodChange, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "change_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "previous_end_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 3,
            name: "new_end_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 4,
            name: "option_period",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "clin_numbers",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * BlockContent is a lightweight block representation for inline use.
 *
 * @generated from message mono.projectdata.v1.BlockContent
 */ export class BlockContent extends Message {
    static fromBinary(bytes, options) {
        return new BlockContent().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BlockContent().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BlockContent().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BlockContent, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string block_id = 1;
   */ _define_property(this, "blockId", ""), /**
   * @generated from field: string type = 2;
   */ _define_property(this, "type", ""), /**
   * @generated from field: string content = 3;
   */ _define_property(this, "content", ""), /**
   * @generated from field: string section_number = 4;
   */ _define_property(this, "sectionNumber", ""), /**
   * @generated from field: int32 page_number = 5;
   */ _define_property(this, "pageNumber", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(BlockContent, "runtime", proto3);
_define_property(BlockContent, "typeName", "mono.projectdata.v1.BlockContent");
_define_property(BlockContent, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "block_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "content",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "section_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "page_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ImportProjectDataRequest
 */ export class ImportProjectDataRequest extends Message {
    static fromBinary(bytes, options) {
        return new ImportProjectDataRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ImportProjectDataRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ImportProjectDataRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ImportProjectDataRequest, a, b);
    }
    constructor(data){
        super(), /**
   * Core project info
   *
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string description = 3;
   */ _define_property(this, "description", ""), /**
   * general, proposal, contract
   *
   * @generated from field: string type = 4;
   */ _define_property(this, "type", ""), /**
   * @generated from field: string company_id = 5;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string status = 6;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string created_by = 7;
   */ _define_property(this, "createdBy", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 9;
   */ _define_property(this, "updatedAt", void 0), /**
   * Type-specific sub-info (one populated based on type)
   *
   * @generated from field: mono.projectdata.v1.ProposalInfo proposal_info = 10;
   */ _define_property(this, "proposalInfo", void 0), /**
   * @generated from field: mono.projectdata.v1.ContractInfo contract_info = 11;
   */ _define_property(this, "contractInfo", void 0), /**
   * Members
   *
   * @generated from field: repeated mono.projectdata.v1.ImportProjectMember members = 12;
   */ _define_property(this, "members", []), /**
   * Related entities
   *
   * @generated from field: repeated mono.projectdata.v1.ImportRequirement requirements = 13;
   */ _define_property(this, "requirements", []), /**
   * @generated from field: repeated mono.projectdata.v1.ImportAttachment attachments = 14;
   */ _define_property(this, "attachments", []), /**
   * @generated from field: repeated mono.projectdata.v1.ImportCLIN clins = 15;
   */ _define_property(this, "clins", []), /**
   * @generated from field: repeated mono.projectdata.v1.ImportDeliverable deliverables = 16;
   */ _define_property(this, "deliverables", []), /**
   * @generated from field: repeated mono.projectdata.v1.ImportDocumentBlock document_blocks = 17;
   */ _define_property(this, "documentBlocks", []), /**
   * @generated from field: repeated mono.projectdata.v1.Ambiguity ambiguities = 18;
   */ _define_property(this, "ambiguities", []), /**
   * @generated from field: repeated mono.projectdata.v1.StoredModification modifications = 19;
   */ _define_property(this, "modifications", []), /**
   * @generated from field: repeated mono.projectdata.v1.OutlineSection outline_sections = 20;
   */ _define_property(this, "outlineSections", []), /**
   * @generated from field: mono.projectdata.v1.ImportWritingPlan writing_plan = 21;
   */ _define_property(this, "writingPlan", void 0), /**
   * When true, re-import even if project already exists (delete + reimport).
   * User-modified fields (requirement status/notes) are preserved.
   *
   * @generated from field: bool force = 22;
   */ _define_property(this, "force", false), /**
   * Labor categories (proposal projects)
   *
   * @generated from field: repeated mono.projectdata.v1.ImportLCAT lcats = 23;
   */ _define_property(this, "lcats", []), /**
   * Contract enrichment entities (ContractAnalysisV2 parity)
   *
   * @generated from field: repeated mono.projectdata.v1.ContractPartyInfo contract_parties = 24;
   */ _define_property(this, "contractParties", []), /**
   * @generated from field: repeated mono.projectdata.v1.GovernmentContact government_contacts_import = 25;
   */ _define_property(this, "governmentContactsImport", []), /**
   * @generated from field: repeated mono.projectdata.v1.PlaceOfPerformanceInfo places_of_performance = 26;
   */ _define_property(this, "placesOfPerformance", []), /**
   * @generated from field: repeated mono.projectdata.v1.ContractPeriodInfo contract_periods = 27;
   */ _define_property(this, "contractPeriods", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ImportProjectDataRequest, "runtime", proto3);
_define_property(ImportProjectDataRequest, "typeName", "mono.projectdata.v1.ImportProjectDataRequest");
_define_property(ImportProjectDataRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "proposal_info",
            kind: "message",
            T: ProposalInfo
        },
        {
            no: 11,
            name: "contract_info",
            kind: "message",
            T: ContractInfo
        },
        {
            no: 12,
            name: "members",
            kind: "message",
            T: ImportProjectMember,
            repeated: true
        },
        {
            no: 13,
            name: "requirements",
            kind: "message",
            T: ImportRequirement,
            repeated: true
        },
        {
            no: 14,
            name: "attachments",
            kind: "message",
            T: ImportAttachment,
            repeated: true
        },
        {
            no: 15,
            name: "clins",
            kind: "message",
            T: ImportCLIN,
            repeated: true
        },
        {
            no: 16,
            name: "deliverables",
            kind: "message",
            T: ImportDeliverable,
            repeated: true
        },
        {
            no: 17,
            name: "document_blocks",
            kind: "message",
            T: ImportDocumentBlock,
            repeated: true
        },
        {
            no: 18,
            name: "ambiguities",
            kind: "message",
            T: Ambiguity,
            repeated: true
        },
        {
            no: 19,
            name: "modifications",
            kind: "message",
            T: StoredModification,
            repeated: true
        },
        {
            no: 20,
            name: "outline_sections",
            kind: "message",
            T: OutlineSection,
            repeated: true
        },
        {
            no: 21,
            name: "writing_plan",
            kind: "message",
            T: ImportWritingPlan
        },
        {
            no: 22,
            name: "force",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 23,
            name: "lcats",
            kind: "message",
            T: ImportLCAT,
            repeated: true
        },
        {
            no: 24,
            name: "contract_parties",
            kind: "message",
            T: ContractPartyInfo,
            repeated: true
        },
        {
            no: 25,
            name: "government_contacts_import",
            kind: "message",
            T: GovernmentContact,
            repeated: true
        },
        {
            no: 26,
            name: "places_of_performance",
            kind: "message",
            T: PlaceOfPerformanceInfo,
            repeated: true
        },
        {
            no: 27,
            name: "contract_periods",
            kind: "message",
            T: ContractPeriodInfo,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ImportProjectDataResponse
 */ export class ImportProjectDataResponse extends Message {
    static fromBinary(bytes, options) {
        return new ImportProjectDataResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ImportProjectDataResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ImportProjectDataResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ImportProjectDataResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bool already_existed = 1;
   */ _define_property(this, "alreadyExisted", false), /**
   * @generated from field: mono.projectdata.v1.ImportSummary summary = 2;
   */ _define_property(this, "summary", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ImportProjectDataResponse, "runtime", proto3);
_define_property(ImportProjectDataResponse, "typeName", "mono.projectdata.v1.ImportProjectDataResponse");
_define_property(ImportProjectDataResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "already_existed",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 2,
            name: "summary",
            kind: "message",
            T: ImportSummary
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ImportSummary
 */ export class ImportSummary extends Message {
    static fromBinary(bytes, options) {
        return new ImportSummary().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ImportSummary().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ImportSummary().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ImportSummary, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 members_imported = 1;
   */ _define_property(this, "membersImported", 0), /**
   * @generated from field: int32 requirements_imported = 2;
   */ _define_property(this, "requirementsImported", 0), /**
   * @generated from field: int32 attachments_imported = 3;
   */ _define_property(this, "attachmentsImported", 0), /**
   * @generated from field: int32 clins_imported = 4;
   */ _define_property(this, "clinsImported", 0), /**
   * @generated from field: int32 deliverables_imported = 5;
   */ _define_property(this, "deliverablesImported", 0), /**
   * @generated from field: int32 document_blocks_imported = 6;
   */ _define_property(this, "documentBlocksImported", 0), /**
   * @generated from field: int32 ambiguities_imported = 7;
   */ _define_property(this, "ambiguitiesImported", 0), /**
   * @generated from field: int32 modifications_imported = 8;
   */ _define_property(this, "modificationsImported", 0), /**
   * @generated from field: int32 outline_sections_imported = 9;
   */ _define_property(this, "outlineSectionsImported", 0), /**
   * @generated from field: bool writing_plan_imported = 10;
   */ _define_property(this, "writingPlanImported", false), /**
   * @generated from field: int32 lcats_imported = 11;
   */ _define_property(this, "lcatsImported", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ImportSummary, "runtime", proto3);
_define_property(ImportSummary, "typeName", "mono.projectdata.v1.ImportSummary");
_define_property(ImportSummary, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "members_imported",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "requirements_imported",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "attachments_imported",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "clins_imported",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "deliverables_imported",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "document_blocks_imported",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "ambiguities_imported",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 8,
            name: "modifications_imported",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 9,
            name: "outline_sections_imported",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 10,
            name: "writing_plan_imported",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 11,
            name: "lcats_imported",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ImportProjectMember
 */ export class ImportProjectMember extends Message {
    static fromBinary(bytes, options) {
        return new ImportProjectMember().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ImportProjectMember().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ImportProjectMember().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ImportProjectMember, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string user_id = 1;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string email = 2;
   */ _define_property(this, "email", ""), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string role = 4;
   */ _define_property(this, "role", ""), /**
   * @generated from field: google.protobuf.Timestamp added_at = 5;
   */ _define_property(this, "addedAt", void 0), /**
   * @generated from field: string added_by = 6;
   */ _define_property(this, "addedBy", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ImportProjectMember, "runtime", proto3);
_define_property(ImportProjectMember, "typeName", "mono.projectdata.v1.ImportProjectMember");
_define_property(ImportProjectMember, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "email",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "added_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "added_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ImportRequirement
 */ export class ImportRequirement extends Message {
    static fromBinary(bytes, options) {
        return new ImportRequirement().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ImportRequirement().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ImportRequirement().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ImportRequirement, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.StoredRequirement requirement = 1;
   */ _define_property(this, "requirement", void 0), /**
   * @generated from field: repeated mono.projectdata.v1.ImportStatusHistory status_history = 2;
   */ _define_property(this, "statusHistory", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ImportRequirement, "runtime", proto3);
_define_property(ImportRequirement, "typeName", "mono.projectdata.v1.ImportRequirement");
_define_property(ImportRequirement, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "requirement",
            kind: "message",
            T: StoredRequirement
        },
        {
            no: 2,
            name: "status_history",
            kind: "message",
            T: ImportStatusHistory,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ImportStatusHistory
 */ export class ImportStatusHistory extends Message {
    static fromBinary(bytes, options) {
        return new ImportStatusHistory().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ImportStatusHistory().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ImportStatusHistory().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ImportStatusHistory, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string status = 1;
   */ _define_property(this, "status", ""), /**
   * @generated from field: google.protobuf.Timestamp changed_at = 2;
   */ _define_property(this, "changedAt", void 0), /**
   * @generated from field: string changed_by = 3;
   */ _define_property(this, "changedBy", ""), /**
   * @generated from field: string note = 4;
   */ _define_property(this, "note", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ImportStatusHistory, "runtime", proto3);
_define_property(ImportStatusHistory, "typeName", "mono.projectdata.v1.ImportStatusHistory");
_define_property(ImportStatusHistory, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "changed_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 3,
            name: "changed_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ImportAttachment
 */ export class ImportAttachment extends Message {
    static fromBinary(bytes, options) {
        return new ImportAttachment().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ImportAttachment().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ImportAttachment().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ImportAttachment, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string attachment_id = 1;
   */ _define_property(this, "attachmentId", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string content_type = 3;
   */ _define_property(this, "contentType", ""), /**
   * @generated from field: int64 size = 4;
   */ _define_property(this, "size", protoInt64.zero), /**
   * @generated from field: string document_type = 5;
   */ _define_property(this, "documentType", ""), /**
   * @generated from field: string file_category = 6;
   */ _define_property(this, "fileCategory", ""), /**
   * @generated from field: string source_kind = 7;
   */ _define_property(this, "sourceKind", ""), /**
   * @generated from field: string classification_label = 8;
   */ _define_property(this, "classificationLabel", ""), /**
   * @generated from field: int32 page_count = 9;
   */ _define_property(this, "pageCount", 0), /**
   * @generated from field: string processing_status = 10;
   */ _define_property(this, "processingStatus", ""), /**
   * @generated from field: string gridfs_file_id = 11;
   */ _define_property(this, "gridfsFileId", ""), /**
   * @generated from field: string original_blob_url = 12;
   */ _define_property(this, "originalBlobUrl", ""), /**
   * @generated from field: string subtype = 13;
   */ _define_property(this, "subtype", ""), /**
   * @generated from field: string amendment_number = 14;
   */ _define_property(this, "amendmentNumber", ""), /**
   * @generated from field: string source_document_id = 15;
   */ _define_property(this, "sourceDocumentId", ""), /**
   * @generated from field: string outline_section_id = 16;
   */ _define_property(this, "outlineSectionId", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 17;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 18;
   */ _define_property(this, "updatedAt", void 0), /**
   * 0 = base/non-amendment, 1+ = amendment order
   *
   * @generated from field: int32 amendment_sequence = 19;
   */ _define_property(this, "amendmentSequence", 0), /**
   * @generated from field: mono.projectdata.v1.FileClassification classification = 20;
   */ _define_property(this, "classification", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ImportAttachment, "runtime", proto3);
_define_property(ImportAttachment, "typeName", "mono.projectdata.v1.ImportAttachment");
_define_property(ImportAttachment, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "attachment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "content_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "size",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 5,
            name: "document_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "file_category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "source_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "classification_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "page_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 10,
            name: "processing_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "gridfs_file_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "original_blob_url",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "subtype",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "amendment_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "source_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "outline_section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 18,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 19,
            name: "amendment_sequence",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 20,
            name: "classification",
            kind: "message",
            T: FileClassification
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ImportCLIN
 */ export class ImportCLIN extends Message {
    static fromBinary(bytes, options) {
        return new ImportCLIN().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ImportCLIN().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ImportCLIN().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ImportCLIN, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.StoredCLIN clin = 1;
   */ _define_property(this, "clin", void 0), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ImportCLIN, "runtime", proto3);
_define_property(ImportCLIN, "typeName", "mono.projectdata.v1.ImportCLIN");
_define_property(ImportCLIN, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "clin",
            kind: "message",
            T: StoredCLIN
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ImportLCAT
 */ export class ImportLCAT extends Message {
    static fromBinary(bytes, options) {
        return new ImportLCAT().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ImportLCAT().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ImportLCAT().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ImportLCAT, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.StoredLCAT lcat = 1;
   */ _define_property(this, "lcat", void 0), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ImportLCAT, "runtime", proto3);
_define_property(ImportLCAT, "typeName", "mono.projectdata.v1.ImportLCAT");
_define_property(ImportLCAT, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "lcat",
            kind: "message",
            T: StoredLCAT
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ImportDeliverable
 */ export class ImportDeliverable extends Message {
    static fromBinary(bytes, options) {
        return new ImportDeliverable().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ImportDeliverable().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ImportDeliverable().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ImportDeliverable, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.StoredDeliverable deliverable = 1;
   */ _define_property(this, "deliverable", void 0), /**
   * @generated from field: string notes = 2;
   */ _define_property(this, "notes", ""), /**
   * @generated from field: string format = 3;
   */ _define_property(this, "format", ""), /**
   * @generated from field: string submission_method = 4;
   */ _define_property(this, "submissionMethod", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ImportDeliverable, "runtime", proto3);
_define_property(ImportDeliverable, "typeName", "mono.projectdata.v1.ImportDeliverable");
_define_property(ImportDeliverable, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "deliverable",
            kind: "message",
            T: StoredDeliverable
        },
        {
            no: 2,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "format",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "submission_method",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ImportDocumentBlock
 */ export class ImportDocumentBlock extends Message {
    static fromBinary(bytes, options) {
        return new ImportDocumentBlock().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ImportDocumentBlock().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ImportDocumentBlock().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ImportDocumentBlock, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string block_id = 1;
   */ _define_property(this, "blockId", ""), /**
   * @generated from field: string document_id = 2;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: string company_id = 3;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string type = 4;
   */ _define_property(this, "type", ""), /**
   * @generated from field: string content = 5;
   */ _define_property(this, "content", ""), /**
   * @generated from field: int32 page_number = 6;
   */ _define_property(this, "pageNumber", 0), /**
   * @generated from field: string section_number = 7;
   */ _define_property(this, "sectionNumber", ""), /**
   * @generated from field: int32 level = 8;
   */ _define_property(this, "level", 0), /**
   * @generated from field: string parent_block_id = 9;
   */ _define_property(this, "parentBlockId", ""), /**
   * @generated from field: double confidence = 10;
   */ _define_property(this, "confidence", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ImportDocumentBlock, "runtime", proto3);
_define_property(ImportDocumentBlock, "typeName", "mono.projectdata.v1.ImportDocumentBlock");
_define_property(ImportDocumentBlock, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "block_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "content",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "page_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "section_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "level",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 9,
            name: "parent_block_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ImportWritingPlan
 */ export class ImportWritingPlan extends Message {
    static fromBinary(bytes, options) {
        return new ImportWritingPlan().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ImportWritingPlan().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ImportWritingPlan().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ImportWritingPlan, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string plan_id = 1;
   */ _define_property(this, "planId", ""), /**
   * @generated from field: repeated mono.projectdata.v1.WritingPlanSection sections = 2;
   */ _define_property(this, "sections", []), /**
   * @generated from field: google.protobuf.Timestamp created_at = 3;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 4;
   */ _define_property(this, "updatedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ImportWritingPlan, "runtime", proto3);
_define_property(ImportWritingPlan, "typeName", "mono.projectdata.v1.ImportWritingPlan");
_define_property(ImportWritingPlan, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "plan_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "sections",
            kind: "message",
            T: WritingPlanSection,
            repeated: true
        },
        {
            no: 3,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 4,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetSolicitationInsightsRequest
 */ export class GetSolicitationInsightsRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetSolicitationInsightsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetSolicitationInsightsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetSolicitationInsightsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetSolicitationInsightsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetSolicitationInsightsRequest, "runtime", proto3);
_define_property(GetSolicitationInsightsRequest, "typeName", "mono.projectdata.v1.GetSolicitationInsightsRequest");
_define_property(GetSolicitationInsightsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetSolicitationInsightsResponse
 */ export class GetSolicitationInsightsResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetSolicitationInsightsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetSolicitationInsightsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetSolicitationInsightsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetSolicitationInsightsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.EvaluationScheme evaluation_scheme = 1;
   */ _define_property(this, "evaluationScheme", void 0), /**
   * LEGACY: 5 flat repeated fields produced by the single-call extractor.
   * Deleted in PR13 once the frontend is reading insights_pipeline_json.
   *
   * @generated from field: repeated mono.projectdata.v1.PageLimitInsight page_limits = 2;
   */ _define_property(this, "pageLimits", []), /**
   * @generated from field: repeated mono.projectdata.v1.KeyPersonnelInsight key_personnel = 3;
   */ _define_property(this, "keyPersonnel", []), /**
   * @generated from field: repeated mono.projectdata.v1.DeadlineInsight deadlines = 4;
   */ _define_property(this, "deadlines", []), /**
   * @generated from field: repeated mono.projectdata.v1.FormatRuleInsight format_rules = 5;
   */ _define_property(this, "formatRules", []), /**
   * @generated from field: repeated mono.projectdata.v1.SecurityInsight security_requirements = 6;
   */ _define_property(this, "securityRequirements", []), /**
   * insights_pipeline_json is the new per-type, source-grounded payload from
   * the insights.Pipeline. Carries 21 grounded categories (volumes, page
   * limits, format rules, content requirements, file requirements, key
   * personnel, resume requirements, past performance, CPARS, subcontracting,
   * deadlines, Q&A protocol, oral presentations, site visits, pre-proposal
   * conferences, security clearances, bonds, teaming restrictions, award
   * mechanisms, contract types, places of performance) with full provenance
   * (sourceBlockIds, sourceText, page numbers, section numbers, source
   * document ID, amendment number).
   *
   * Stored as an opaque JSON string to keep this proto small. The frontend
   * deserializes via TypeScript types matching insights.SolicitationInsights
   * in baltigo. Empty when the insights pipeline didn't run for this project.
   *
   * @generated from field: string insights_pipeline_json = 7;
   */ _define_property(this, "insightsPipelineJson", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetSolicitationInsightsResponse, "runtime", proto3);
_define_property(GetSolicitationInsightsResponse, "typeName", "mono.projectdata.v1.GetSolicitationInsightsResponse");
_define_property(GetSolicitationInsightsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "evaluation_scheme",
            kind: "message",
            T: EvaluationScheme
        },
        {
            no: 2,
            name: "page_limits",
            kind: "message",
            T: PageLimitInsight,
            repeated: true
        },
        {
            no: 3,
            name: "key_personnel",
            kind: "message",
            T: KeyPersonnelInsight,
            repeated: true
        },
        {
            no: 4,
            name: "deadlines",
            kind: "message",
            T: DeadlineInsight,
            repeated: true
        },
        {
            no: 5,
            name: "format_rules",
            kind: "message",
            T: FormatRuleInsight,
            repeated: true
        },
        {
            no: 6,
            name: "security_requirements",
            kind: "message",
            T: SecurityInsight,
            repeated: true
        },
        {
            no: 7,
            name: "insights_pipeline_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.PageLimitInsight
 */ export class PageLimitInsight extends Message {
    static fromBinary(bytes, options) {
        return new PageLimitInsight().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PageLimitInsight().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PageLimitInsight().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PageLimitInsight, a, b);
    }
    constructor(data){
        super(), /**
   * "Volume I", "Resume", "Overall", "Past Performance"
   *
   * @generated from field: string scope = 1;
   */ _define_property(this, "scope", ""), /**
   * @generated from field: int32 limit = 2;
   */ _define_property(this, "limit", 0), /**
   * "pages", "slides", "minutes"
   *
   * @generated from field: string unit = 3;
   */ _define_property(this, "unit", ""), /**
   * source requirement for traceability
   *
   * @generated from field: string requirement_id = 4;
   */ _define_property(this, "requirementId", ""), /**
   * original requirement text
   *
   * @generated from field: string source_text = 5;
   */ _define_property(this, "sourceText", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PageLimitInsight, "runtime", proto3);
_define_property(PageLimitInsight, "typeName", "mono.projectdata.v1.PageLimitInsight");
_define_property(PageLimitInsight, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "scope",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "unit",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "requirement_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "source_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.KeyPersonnelInsight
 */ export class KeyPersonnelInsight extends Message {
    static fromBinary(bytes, options) {
        return new KeyPersonnelInsight().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new KeyPersonnelInsight().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new KeyPersonnelInsight().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(KeyPersonnelInsight, a, b);
    }
    constructor(data){
        super(), /**
   * "Program Manager", "Technical Lead"
   *
   * @generated from field: string role = 1;
   */ _define_property(this, "role", ""), /**
   * summary of quals
   *
   * @generated from field: string qualifications = 2;
   */ _define_property(this, "qualifications", ""), /**
   * "Secret", "Top Secret", "Public Trust"
   *
   * @generated from field: string clearance_level = 3;
   */ _define_property(this, "clearanceLevel", ""), /**
   * @generated from field: bool resume_required = 4;
   */ _define_property(this, "resumeRequired", false), /**
   * source requirements
   *
   * @generated from field: repeated string requirement_ids = 5;
   */ _define_property(this, "requirementIds", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(KeyPersonnelInsight, "runtime", proto3);
_define_property(KeyPersonnelInsight, "typeName", "mono.projectdata.v1.KeyPersonnelInsight");
_define_property(KeyPersonnelInsight, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "qualifications",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "clearance_level",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "resume_required",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "requirement_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.DeadlineInsight
 */ export class DeadlineInsight extends Message {
    static fromBinary(bytes, options) {
        return new DeadlineInsight().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeadlineInsight().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeadlineInsight().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeadlineInsight, a, b);
    }
    constructor(data){
        super(), /**
   * "proposal_due", "questions_due", "oral_presentation", "other"
   *
   * @generated from field: string type = 1;
   */ _define_property(this, "type", ""), /**
   * extracted date string
   *
   * @generated from field: string date = 2;
   */ _define_property(this, "date", ""), /**
   * full context
   *
   * @generated from field: string description = 3;
   */ _define_property(this, "description", ""), /**
   * source requirement
   *
   * @generated from field: string requirement_id = 4;
   */ _define_property(this, "requirementId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeadlineInsight, "runtime", proto3);
_define_property(DeadlineInsight, "typeName", "mono.projectdata.v1.DeadlineInsight");
_define_property(DeadlineInsight, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "requirement_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.FormatRuleInsight
 */ export class FormatRuleInsight extends Message {
    static fromBinary(bytes, options) {
        return new FormatRuleInsight().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FormatRuleInsight().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FormatRuleInsight().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FormatRuleInsight, a, b);
    }
    constructor(data){
        super(), /**
   * "12-point Times New Roman", "1-inch margins"
   *
   * @generated from field: string rule = 1;
   */ _define_property(this, "rule", ""), /**
   * "all volumes", "technical volume"
   *
   * @generated from field: string scope = 2;
   */ _define_property(this, "scope", ""), /**
   * source requirement
   *
   * @generated from field: string requirement_id = 3;
   */ _define_property(this, "requirementId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(FormatRuleInsight, "runtime", proto3);
_define_property(FormatRuleInsight, "typeName", "mono.projectdata.v1.FormatRuleInsight");
_define_property(FormatRuleInsight, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rule",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "scope",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "requirement_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SecurityInsight
 */ export class SecurityInsight extends Message {
    static fromBinary(bytes, options) {
        return new SecurityInsight().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SecurityInsight().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SecurityInsight().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SecurityInsight, a, b);
    }
    constructor(data){
        super(), /**
   * "Secret", "Top Secret/SCI", "Public Trust"
   *
   * @generated from field: string clearance_level = 1;
   */ _define_property(this, "clearanceLevel", ""), /**
   * "all personnel", "key personnel", "facility"
   *
   * @generated from field: string scope = 2;
   */ _define_property(this, "scope", ""), /**
   * source requirements
   *
   * @generated from field: repeated string requirement_ids = 3;
   */ _define_property(this, "requirementIds", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SecurityInsight, "runtime", proto3);
_define_property(SecurityInsight, "typeName", "mono.projectdata.v1.SecurityInsight");
_define_property(SecurityInsight, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "clearance_level",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "scope",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "requirement_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * ProjectActivityEntry is one row in the unified activity feed. It is
 * produced by UNIONing rows from RequirementStatusHistory and AuditLog so
 * the V2 Home page can show one chronological stream.
 *
 * @generated from message mono.projectdata.v1.ProjectActivityEntry
 */ export class ProjectActivityEntry extends Message {
    static fromBinary(bytes, options) {
        return new ProjectActivityEntry().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProjectActivityEntry().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProjectActivityEntry().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProjectActivityEntry, a, b);
    }
    constructor(data){
        super(), /**
   * Stable id (e.g. "rsh_..." or "audit_...") for React keys / dedup.
   *
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * Discriminator: "requirement_status_change" | "audit".
   *
   * @generated from field: string entry_type = 2;
   */ _define_property(this, "entryType", ""), /**
   * ISO 8601 timestamp; clients sort by this.
   *
   * @generated from field: google.protobuf.Timestamp at = 3;
   */ _define_property(this, "at", void 0), /**
   * The user who caused the change. May be empty for system-driven actions.
   *
   * @generated from field: string actor_user_id = 4;
   */ _define_property(this, "actorUserId", ""), /**
   * Resource type / id the entry pertains to (e.g. "requirement", "volume").
   *
   * @generated from field: string resource_type = 5;
   */ _define_property(this, "resourceType", ""), /**
   * @generated from field: string resource_id = 6;
   */ _define_property(this, "resourceId", ""), /**
   * Short, denormalized verb-phrase suitable for direct rendering, e.g.
   * "Marked as ADDRESSED" or "Created custom volume Cost Volume".
   *
   * @generated from field: string summary = 7;
   */ _define_property(this, "summary", ""), /**
   * Free-form JSON payload (e.g. status before/after, audit details). UI
   * can render this in a "show details" disclosure.
   *
   * @generated from field: string details_json = 8;
   */ _define_property(this, "detailsJson", ""), /**
   * Who performed the action: "user" | "system" | "ai".
   *
   * @generated from field: string actor_type = 9;
   */ _define_property(this, "actorType", ""), /**
   * Event category for filtering: "extraction" | "edit" | "review" |
   * "ai_output" | "admin" | "reversion".
   *
   * @generated from field: string category = 10;
   */ _define_property(this, "category", ""), /**
   * FND-27 AWR-4: who made the change and how; via = "specra_assist" renders
   * "<approver> via Specra Assist". Set on audit entries; nil otherwise.
   *
   * @generated from field: mono.common.v1.WriteAttribution attribution = 11;
   */ _define_property(this, "attribution", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProjectActivityEntry, "runtime", proto3);
_define_property(ProjectActivityEntry, "typeName", "mono.projectdata.v1.ProjectActivityEntry");
_define_property(ProjectActivityEntry, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "entry_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 4,
            name: "actor_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "resource_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "resource_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "summary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "details_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "actor_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "attribution",
            kind: "message",
            T: WriteAttribution
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListProjectActivityRequest
 */ export class ListProjectActivityRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListProjectActivityRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProjectActivityRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProjectActivityRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProjectActivityRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: mono.common.v1.PaginationRequest pagination = 3;
   */ _define_property(this, "pagination", void 0), /**
   * Optional filter — only include the named entry types. Empty = all.
   *
   * @generated from field: repeated string entry_types = 4;
   */ _define_property(this, "entryTypes", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProjectActivityRequest, "runtime", proto3);
_define_property(ListProjectActivityRequest, "typeName", "mono.projectdata.v1.ListProjectActivityRequest");
_define_property(ListProjectActivityRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "pagination",
            kind: "message",
            T: PaginationRequest
        },
        {
            no: 4,
            name: "entry_types",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListProjectActivityResponse
 */ export class ListProjectActivityResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListProjectActivityResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProjectActivityResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProjectActivityResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProjectActivityResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.ProjectActivityEntry entries = 1;
   */ _define_property(this, "entries", []), /**
   * @generated from field: mono.common.v1.PaginationResponse pagination = 2;
   */ _define_property(this, "pagination", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProjectActivityResponse, "runtime", proto3);
_define_property(ListProjectActivityResponse, "typeName", "mono.projectdata.v1.ListProjectActivityResponse");
_define_property(ListProjectActivityResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "entries",
            kind: "message",
            T: ProjectActivityEntry,
            repeated: true
        },
        {
            no: 2,
            name: "pagination",
            kind: "message",
            T: PaginationResponse
        }
    ]));
/**
 * ProjectVolume is the canonical record for a proposal volume. The set of
 * volumes for a project is the union of:
 *   - volumes derived from the insights pipeline (is_custom = false)
 *   - user-created custom volumes        (is_custom = true)
 * Both share the same UUID-keyed identity so writing plans, custom labels,
 * and assignments survive reprocessing.
 *
 * @generated from message mono.projectdata.v1.ProjectVolume
 */ export class ProjectVolume extends Message {
    static fromBinary(bytes, options) {
        return new ProjectVolume().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProjectVolume().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProjectVolume().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProjectVolume, a, b);
    }
    constructor(data){
        super(), /**
   * server-generated UUID, stable forever
   *
   * @generated from field: string volume_id = 1;
   */ _define_property(this, "volumeId", ""), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * The original identifier the insights pipeline saw (e.g. "Volume I",
   * "VOLUME II — TECHNICAL"). Empty for custom volumes.
   *
   * @generated from field: string original_identifier = 3;
   */ _define_property(this, "originalIdentifier", ""), /**
   * Display label shown in the rail. Defaults to original_identifier on
   * first sync; can be overridden via RenameVolume.
   *
   * @generated from field: string display_name = 4;
   */ _define_property(this, "displayName", ""), /**
   * @generated from field: bool is_custom = 5;
   */ _define_property(this, "isCustom", false), /**
   * @generated from field: int32 sort_order = 6;
   */ _define_property(this, "sortOrder", 0), /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 8;
   */ _define_property(this, "updatedAt", void 0), /**
   * File format extracted from the insights pipeline (PDF, DOCX, XLSX, ...).
   * Empty for custom volumes until the user picks one.
   *
   * @generated from field: string file_format = 9;
   */ _define_property(this, "fileFormat", ""), /**
   * Source attachment label as it appears in the solicitation
   * (e.g. "Attachment 0001"). Empty when the volume is pure prose.
   *
   * @generated from field: string source_attachment = 10;
   */ _define_property(this, "sourceAttachment", ""), /**
   * Derived workspace kind. The frontend branches its workspace UI on this:
   *   "prose"     — TOC + writing pad
   *   "workbook"  — spreadsheet workbook (gov-provided XLSX template)
   *   "template"  — fillable form (download → fill → upload)
   *   "unknown"   — fall back to a "pick a workspace mode" empty state
   * Computed server-side via deriveVolumeKind.
   *
   * @generated from field: string kind = 11;
   */ _define_property(this, "kind", ""), /**
   * Free-text due date as the insights pipeline saw it. May differ from
   * the proposal-level due date when a sub-volume has its own deadline.
   *
   * @generated from field: string due_date = 12;
   */ _define_property(this, "dueDate", ""), /**
   * "required" | "optional" | "" — from the insights pipeline.
   *
   * @generated from field: string required_optional = 13;
   */ _define_property(this, "requiredOptional", ""), /**
   * Latest versions of the gov-provided source documents associated with
   * this volume, resolved server-side at list time. Empty when the volume
   * has no source attachments or when no candidates were found in the
   * project's attachment table.
   *
   * A volume can have multiple source documents — e.g., "Volume VI —
   * Solicitation, Offer and Award Documents and Certifications/Reps" is
   * typically the main solicitation PDF PLUS one or more standalone
   * certification forms. The resolver picks the latest version of each
   * logical document via the document relationship graph.
   *
   * @generated from field: repeated mono.projectdata.v1.SourceAttachmentRef source_attachment_refs = 14;
   */ _define_property(this, "sourceAttachmentRefs", []), /**
   * PR-B.5 fuzzy join: written by joinAttachmentsToVolumes during sync.
   * source_attachment_id is the high-confidence (>= 0.85) auto-link to a
   * real attachments.attachment_id row. suggested_attachment_id is a
   * lower-confidence (0.5..0.85) suggestion the UI shows as a "did you
   * mean?" prompt rather than a committed link. Both are empty when no
   * plausible match exists. Distinct from source_attachment_refs above:
   * refs come from the relationship-graph resolver (latest version of
   * each logical doc); the suggestion comes from filename similarity
   * scoring against the LLM's free-text source attachment label.
   *
   * @generated from field: string source_attachment_id = 15;
   */ _define_property(this, "sourceAttachmentId", ""), /**
   * @generated from field: string suggested_attachment_id = 16;
   */ _define_property(this, "suggestedAttachmentId", ""), /**
   * @generated from field: double suggested_confidence = 17;
   */ _define_property(this, "suggestedConfidence", 0), /**
   * PR-B.8 — source-driven volume composition.
   *
   * required_items is the explicit "this volume shall contain: a. ___ b.
   * ___ c. ___" enumeration the volume_structure extractor pulled from
   * the solicitation. This is the user's actionable submission checklist
   * — what they literally have to assemble — and replaces the previous
   * failure mode where Volume VI's "Purpose" was a one-line LLM rephrase
   * of the title. Each item carries its own per-bullet source grounding
   * so the UI can render "Show source" alongside each line.
   *
   * @generated from field: repeated mono.projectdata.v1.VolumeRequiredItem required_items = 18;
   */ _define_property(this, "requiredItems", []), /**
   * attachment_assignments is the explicit (attachment label → this
   * volume) mapping the LLM extracted from sentences like "the
   * Procurement Integrity Certification (Attachment 0003) shall be
   * submitted with Volume I — Case Study". The resolver in
   * projectdata_v2.go uses this list as the SOLE source of truth for
   * joining attachment files to volumes — there is no keyword fallback
   * anymore. Volumes whose content lives inside the main solicitation
   * (Volume VI / Reps & Certs) intentionally end up with an empty
   * assignments list and the UI surfaces a "no standalone templates"
   * callout instead of guessing.
   *
   * @generated from field: repeated mono.projectdata.v1.VolumeAttachmentAssignment attachment_assignments = 19;
   */ _define_property(this, "attachmentAssignments", []), /**
   * Documents linked to this volume via the VolumeDocument join table.
   * Populated at list time. A volume can have multiple working documents
   * (e.g. 4 case studies from a template) plus an optional merged
   * submission document.
   *
   * @generated from field: repeated mono.projectdata.v1.VolumeDocument documents = 20;
   */ _define_property(this, "documents", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProjectVolume, "runtime", proto3);
_define_property(ProjectVolume, "typeName", "mono.projectdata.v1.ProjectVolume");
_define_property(ProjectVolume, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "volume_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "original_identifier",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "is_custom",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 6,
            name: "sort_order",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "file_format",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "source_attachment",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "due_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "required_optional",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "source_attachment_refs",
            kind: "message",
            T: SourceAttachmentRef,
            repeated: true
        },
        {
            no: 15,
            name: "source_attachment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "suggested_attachment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "suggested_confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 18,
            name: "required_items",
            kind: "message",
            T: VolumeRequiredItem,
            repeated: true
        },
        {
            no: 19,
            name: "attachment_assignments",
            kind: "message",
            T: VolumeAttachmentAssignment,
            repeated: true
        },
        {
            no: 20,
            name: "documents",
            kind: "message",
            T: VolumeDocument,
            repeated: true
        }
    ]));
/**
 * VolumeDocument links a shirohige document to a project volume.
 *
 * @generated from message mono.projectdata.v1.VolumeDocument
 */ export class VolumeDocument extends Message {
    static fromBinary(bytes, options) {
        return new VolumeDocument().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new VolumeDocument().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new VolumeDocument().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(VolumeDocument, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string volume_document_id = 1;
   */ _define_property(this, "volumeDocumentId", ""), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string volume_id = 3;
   */ _define_property(this, "volumeId", ""), /**
   * @generated from field: string shirohige_document_id = 4;
   */ _define_property(this, "shirohigeDocumentId", ""), /**
   * "Case Study 1", "Pricing Spreadsheet"
   *
   * @generated from field: string label = 5;
   */ _define_property(this, "label", ""), /**
   * merge order for submission
   *
   * @generated from field: int32 sort_order = 6;
   */ _define_property(this, "sortOrder", 0), /**
   * gov template it was created from
   *
   * @generated from field: string source_attachment_id = 7;
   */ _define_property(this, "sourceAttachmentId", ""), /**
   * docx / xlsx / pptx
   *
   * @generated from field: string document_type = 8;
   */ _define_property(this, "documentType", ""), /**
   * "CaseStudy.pdf" from insight facts
   *
   * @generated from field: string submission_filename = 9;
   */ _define_property(this, "submissionFilename", ""), /**
   * true = merged output, not working doc
   *
   * @generated from field: bool is_submission_doc = 10;
   */ _define_property(this, "isSubmissionDoc", false), /**
   * @generated from field: string created_by = 11;
   */ _define_property(this, "createdBy", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 12;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(VolumeDocument, "runtime", proto3);
_define_property(VolumeDocument, "typeName", "mono.projectdata.v1.VolumeDocument");
_define_property(VolumeDocument, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "volume_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "volume_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "shirohige_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "sort_order",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "source_attachment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "document_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "submission_filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "is_submission_doc",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 11,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * VolumeRequiredItem is one entry in a volume's "shall contain" list,
 * with its own per-bullet source grounding (block ids + verbatim
 * sourceText quote). Required is true when the source uses mandatory
 * language ("shall"/"must"); false for "may"/"if any"/"optional".
 *
 * reference is free text — usually a section number, attachment label,
 * or "main solicitation §K". Empty when not stated. The frontend
 * renders it as muted text after the label.
 *
 * @generated from message mono.projectdata.v1.VolumeRequiredItem
 */ export class VolumeRequiredItem extends Message {
    static fromBinary(bytes, options) {
        return new VolumeRequiredItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new VolumeRequiredItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new VolumeRequiredItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(VolumeRequiredItem, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string label = 1;
   */ _define_property(this, "label", ""), /**
   * @generated from field: string reference = 2;
   */ _define_property(this, "reference", ""), /**
   * @generated from field: bool required = 3;
   */ _define_property(this, "required", false), /**
   * @generated from field: repeated string source_block_ids = 4;
   */ _define_property(this, "sourceBlockIds", []), /**
   * @generated from field: string source_text = 5;
   */ _define_property(this, "sourceText", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(VolumeRequiredItem, "runtime", proto3);
_define_property(VolumeRequiredItem, "typeName", "mono.projectdata.v1.VolumeRequiredItem");
_define_property(VolumeRequiredItem, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "reference",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "required",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "source_block_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 5,
            name: "source_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * VolumeAttachmentAssignment is one explicit attachment-to-volume
 * mapping extracted from the source text. attachment_number is the
 * 4-digit number parsed from the label (e.g. "0001"); empty when none.
 * note carries optional context from the source ("submitted with the
 * Case Study", "for evaluation under Past Performance"). Source
 * grounding required — the validator drops ungrounded assignments.
 *
 * @generated from message mono.projectdata.v1.VolumeAttachmentAssignment
 */ export class VolumeAttachmentAssignment extends Message {
    static fromBinary(bytes, options) {
        return new VolumeAttachmentAssignment().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new VolumeAttachmentAssignment().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new VolumeAttachmentAssignment().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(VolumeAttachmentAssignment, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string attachment_label = 1;
   */ _define_property(this, "attachmentLabel", ""), /**
   * @generated from field: string attachment_number = 2;
   */ _define_property(this, "attachmentNumber", ""), /**
   * @generated from field: bool required = 3;
   */ _define_property(this, "required", false), /**
   * @generated from field: string note = 4;
   */ _define_property(this, "note", ""), /**
   * @generated from field: repeated string source_block_ids = 5;
   */ _define_property(this, "sourceBlockIds", []), /**
   * @generated from field: string source_text = 6;
   */ _define_property(this, "sourceText", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(VolumeAttachmentAssignment, "runtime", proto3);
_define_property(VolumeAttachmentAssignment, "typeName", "mono.projectdata.v1.VolumeAttachmentAssignment");
_define_property(VolumeAttachmentAssignment, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "attachment_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "attachment_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "required",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "source_block_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 6,
            name: "source_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * SourceAttachmentRef is the latest version of a gov-provided template
 * resolved through the document relationship graph. ListProjectVolumes
 * resolves these once per call so the workspace UI can render the
 * download cards without a follow-up RPC.
 *
 * @generated from message mono.projectdata.v1.SourceAttachmentRef
 */ export class SourceAttachmentRef extends Message {
    static fromBinary(bytes, options) {
        return new SourceAttachmentRef().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SourceAttachmentRef().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SourceAttachmentRef().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SourceAttachmentRef, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string attachment_id = 1;
   */ _define_property(this, "attachmentId", ""), /**
   * @generated from field: string filename = 2;
   */ _define_property(this, "filename", ""), /**
   * Empty when the latest version is the base solicitation (no amendment).
   *
   * @generated from field: string amendment_number = 3;
   */ _define_property(this, "amendmentNumber", ""), /**
   * @generated from field: string content_type = 4;
   */ _define_property(this, "contentType", ""), /**
   * @generated from field: int64 size = 5;
   */ _define_property(this, "size", protoInt64.zero), /**
   * How this ref was matched to the volume — surfaced in the UI as a
   * small caption so users can tell explicit refs from inferred ones.
   * One of: "explicit" | "name_match" | "solicitation" | "certification".
   *
   * @generated from field: string match_reason = 6;
   */ _define_property(this, "matchReason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SourceAttachmentRef, "runtime", proto3);
_define_property(SourceAttachmentRef, "typeName", "mono.projectdata.v1.SourceAttachmentRef");
_define_property(SourceAttachmentRef, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "attachment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "amendment_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "content_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "size",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 6,
            name: "match_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListProjectVolumesRequest
 */ export class ListProjectVolumesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListProjectVolumesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProjectVolumesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProjectVolumesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProjectVolumesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProjectVolumesRequest, "runtime", proto3);
_define_property(ListProjectVolumesRequest, "typeName", "mono.projectdata.v1.ListProjectVolumesRequest");
_define_property(ListProjectVolumesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListProjectVolumesResponse
 */ export class ListProjectVolumesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListProjectVolumesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProjectVolumesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProjectVolumesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProjectVolumesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.ProjectVolume volumes = 1;
   */ _define_property(this, "volumes", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProjectVolumesResponse, "runtime", proto3);
_define_property(ListProjectVolumesResponse, "typeName", "mono.projectdata.v1.ListProjectVolumesResponse");
_define_property(ListProjectVolumesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "volumes",
            kind: "message",
            T: ProjectVolume,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CreateCustomVolumeRequest
 */ export class CreateCustomVolumeRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateCustomVolumeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateCustomVolumeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateCustomVolumeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateCustomVolumeRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * Required, 1-200 chars after trimming.
   *
   * @generated from field: string display_name = 3;
   */ _define_property(this, "displayName", ""), /**
   * Working artifact choice; never changes solicitation source authority.
   *
   * prose | workbook | template | presentation; default prose
   *
   * @generated from field: string kind = 4;
   */ _define_property(this, "kind", ""), /**
   * docx | xlsx | pdf | pptx; default from kind
   *
   * @generated from field: string file_format = 5;
   */ _define_property(this, "fileFormat", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateCustomVolumeRequest, "runtime", proto3);
_define_property(CreateCustomVolumeRequest, "typeName", "mono.projectdata.v1.CreateCustomVolumeRequest");
_define_property(CreateCustomVolumeRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "file_format",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CreateCustomVolumeResponse
 */ export class CreateCustomVolumeResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateCustomVolumeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateCustomVolumeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateCustomVolumeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateCustomVolumeResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.ProjectVolume volume = 1;
   */ _define_property(this, "volume", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateCustomVolumeResponse, "runtime", proto3);
_define_property(CreateCustomVolumeResponse, "typeName", "mono.projectdata.v1.CreateCustomVolumeResponse");
_define_property(CreateCustomVolumeResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "volume",
            kind: "message",
            T: ProjectVolume
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.DeleteCustomVolumeRequest
 */ export class DeleteCustomVolumeRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteCustomVolumeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteCustomVolumeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteCustomVolumeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteCustomVolumeRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string volume_id = 3;
   */ _define_property(this, "volumeId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteCustomVolumeRequest, "runtime", proto3);
_define_property(DeleteCustomVolumeRequest, "typeName", "mono.projectdata.v1.DeleteCustomVolumeRequest");
_define_property(DeleteCustomVolumeRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "volume_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.DeleteCustomVolumeResponse
 */ export class DeleteCustomVolumeResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteCustomVolumeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteCustomVolumeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteCustomVolumeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteCustomVolumeResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteCustomVolumeResponse, "runtime", proto3);
_define_property(DeleteCustomVolumeResponse, "typeName", "mono.projectdata.v1.DeleteCustomVolumeResponse");
_define_property(DeleteCustomVolumeResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.projectdata.v1.RenameVolumeRequest
 */ export class RenameVolumeRequest extends Message {
    static fromBinary(bytes, options) {
        return new RenameVolumeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RenameVolumeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RenameVolumeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RenameVolumeRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string volume_id = 3;
   */ _define_property(this, "volumeId", ""), /**
   * Required, 1-200 chars after trimming.
   *
   * @generated from field: string display_name = 4;
   */ _define_property(this, "displayName", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RenameVolumeRequest, "runtime", proto3);
_define_property(RenameVolumeRequest, "typeName", "mono.projectdata.v1.RenameVolumeRequest");
_define_property(RenameVolumeRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "volume_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RenameVolumeResponse
 */ export class RenameVolumeResponse extends Message {
    static fromBinary(bytes, options) {
        return new RenameVolumeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RenameVolumeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RenameVolumeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RenameVolumeResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.ProjectVolume volume = 1;
   */ _define_property(this, "volume", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RenameVolumeResponse, "runtime", proto3);
_define_property(RenameVolumeResponse, "typeName", "mono.projectdata.v1.RenameVolumeResponse");
_define_property(RenameVolumeResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "volume",
            kind: "message",
            T: ProjectVolume
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.AddVolumeDocumentRequest
 */ export class AddVolumeDocumentRequest extends Message {
    static fromBinary(bytes, options) {
        return new AddVolumeDocumentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddVolumeDocumentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddVolumeDocumentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddVolumeDocumentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string volume_id = 3;
   */ _define_property(this, "volumeId", ""), /**
   * Human-readable label for this document, e.g. "Case Study 1", "Pricing".
   *
   * @generated from field: string label = 4;
   */ _define_property(this, "label", ""), /**
   * Document type: "docx" | "xlsx" | "pptx". Defaults to volume's file_format or "docx".
   *
   * @generated from field: string document_type = 5;
   */ _define_property(this, "documentType", ""), /**
   * When set, the document is created from this gov-provided template's bytes
   * (fetched from MinIO). When empty, a blank document is created.
   *
   * @generated from field: string source_attachment_id = 6;
   */ _define_property(this, "sourceAttachmentId", ""), /**
   * Override for the submission filename. When empty, derived from
   * insight_facts file_requirements naming convention or label + extension.
   *
   * @generated from field: string submission_filename = 7;
   */ _define_property(this, "submissionFilename", ""), /**
   * Optional idempotency key: a retried call with the same key returns the
   * volume document the first call made instead of adding a second one.
   *
   * @generated from field: string operation_id = 8;
   */ _define_property(this, "operationId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AddVolumeDocumentRequest, "runtime", proto3);
_define_property(AddVolumeDocumentRequest, "typeName", "mono.projectdata.v1.AddVolumeDocumentRequest");
_define_property(AddVolumeDocumentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "volume_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "document_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "source_attachment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "submission_filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "operation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CheckProjectWriteAccessRequest
 */ export class CheckProjectWriteAccessRequest extends Message {
    static fromBinary(bytes, options) {
        return new CheckProjectWriteAccessRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CheckProjectWriteAccessRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CheckProjectWriteAccessRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CheckProjectWriteAccessRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CheckProjectWriteAccessRequest, "runtime", proto3);
_define_property(CheckProjectWriteAccessRequest, "typeName", "mono.projectdata.v1.CheckProjectWriteAccessRequest");
_define_property(CheckProjectWriteAccessRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CheckProjectWriteAccessResponse
 */ export class CheckProjectWriteAccessResponse extends Message {
    static fromBinary(bytes, options) {
        return new CheckProjectWriteAccessResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CheckProjectWriteAccessResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CheckProjectWriteAccessResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CheckProjectWriteAccessResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(CheckProjectWriteAccessResponse, "runtime", proto3);
_define_property(CheckProjectWriteAccessResponse, "typeName", "mono.projectdata.v1.CheckProjectWriteAccessResponse");
_define_property(CheckProjectWriteAccessResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.projectdata.v1.AddVolumeDocumentResponse
 */ export class AddVolumeDocumentResponse extends Message {
    static fromBinary(bytes, options) {
        return new AddVolumeDocumentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddVolumeDocumentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddVolumeDocumentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddVolumeDocumentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.VolumeDocument document = 1;
   */ _define_property(this, "document", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AddVolumeDocumentResponse, "runtime", proto3);
_define_property(AddVolumeDocumentResponse, "typeName", "mono.projectdata.v1.AddVolumeDocumentResponse");
_define_property(AddVolumeDocumentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document",
            kind: "message",
            T: VolumeDocument
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RemoveVolumeDocumentRequest
 */ export class RemoveVolumeDocumentRequest extends Message {
    static fromBinary(bytes, options) {
        return new RemoveVolumeDocumentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RemoveVolumeDocumentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RemoveVolumeDocumentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RemoveVolumeDocumentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string volume_document_id = 3;
   */ _define_property(this, "volumeDocumentId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RemoveVolumeDocumentRequest, "runtime", proto3);
_define_property(RemoveVolumeDocumentRequest, "typeName", "mono.projectdata.v1.RemoveVolumeDocumentRequest");
_define_property(RemoveVolumeDocumentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "volume_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RemoveVolumeDocumentResponse
 */ export class RemoveVolumeDocumentResponse extends Message {
    static fromBinary(bytes, options) {
        return new RemoveVolumeDocumentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RemoveVolumeDocumentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RemoveVolumeDocumentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RemoveVolumeDocumentResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(RemoveVolumeDocumentResponse, "runtime", proto3);
_define_property(RemoveVolumeDocumentResponse, "typeName", "mono.projectdata.v1.RemoveVolumeDocumentResponse");
_define_property(RemoveVolumeDocumentResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.projectdata.v1.ListVolumeDocumentsRequest
 */ export class ListVolumeDocumentsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListVolumeDocumentsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListVolumeDocumentsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListVolumeDocumentsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListVolumeDocumentsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string volume_id = 2;
   */ _define_property(this, "volumeId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListVolumeDocumentsRequest, "runtime", proto3);
_define_property(ListVolumeDocumentsRequest, "typeName", "mono.projectdata.v1.ListVolumeDocumentsRequest");
_define_property(ListVolumeDocumentsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "volume_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListVolumeDocumentsResponse
 */ export class ListVolumeDocumentsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListVolumeDocumentsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListVolumeDocumentsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListVolumeDocumentsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListVolumeDocumentsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.VolumeDocument documents = 1;
   */ _define_property(this, "documents", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListVolumeDocumentsResponse, "runtime", proto3);
_define_property(ListVolumeDocumentsResponse, "typeName", "mono.projectdata.v1.ListVolumeDocumentsResponse");
_define_property(ListVolumeDocumentsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "documents",
            kind: "message",
            T: VolumeDocument,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpdateVolumeDocumentRequest
 */ export class UpdateVolumeDocumentRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateVolumeDocumentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateVolumeDocumentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateVolumeDocumentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateVolumeDocumentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string volume_document_id = 3;
   */ _define_property(this, "volumeDocumentId", ""), /**
   * New label for the document. Empty string = no change.
   *
   * @generated from field: string label = 4;
   */ _define_property(this, "label", ""), /**
   * New submission filename. Empty string = no change.
   *
   * @generated from field: string submission_filename = 5;
   */ _define_property(this, "submissionFilename", ""), /**
   * @generated from field: optional bool is_submission_doc = 6;
   */ _define_property(this, "isSubmissionDoc", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateVolumeDocumentRequest, "runtime", proto3);
_define_property(UpdateVolumeDocumentRequest, "typeName", "mono.projectdata.v1.UpdateVolumeDocumentRequest");
_define_property(UpdateVolumeDocumentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "volume_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "submission_filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "is_submission_doc",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ ,
            opt: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpdateVolumeDocumentResponse
 */ export class UpdateVolumeDocumentResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateVolumeDocumentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateVolumeDocumentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateVolumeDocumentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateVolumeDocumentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.VolumeDocument document = 1;
   */ _define_property(this, "document", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateVolumeDocumentResponse, "runtime", proto3);
_define_property(UpdateVolumeDocumentResponse, "typeName", "mono.projectdata.v1.UpdateVolumeDocumentResponse");
_define_property(UpdateVolumeDocumentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document",
            kind: "message",
            T: VolumeDocument
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ReorderVolumeDocumentsRequest
 */ export class ReorderVolumeDocumentsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ReorderVolumeDocumentsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReorderVolumeDocumentsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReorderVolumeDocumentsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReorderVolumeDocumentsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string volume_id = 3;
   */ _define_property(this, "volumeId", ""), /**
   * Ordered list of volume_document_ids. Position = sort_order.
   *
   * @generated from field: repeated string volume_document_ids = 4;
   */ _define_property(this, "volumeDocumentIds", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReorderVolumeDocumentsRequest, "runtime", proto3);
_define_property(ReorderVolumeDocumentsRequest, "typeName", "mono.projectdata.v1.ReorderVolumeDocumentsRequest");
_define_property(ReorderVolumeDocumentsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "volume_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "volume_document_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ReorderVolumeDocumentsResponse
 */ export class ReorderVolumeDocumentsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ReorderVolumeDocumentsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReorderVolumeDocumentsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReorderVolumeDocumentsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReorderVolumeDocumentsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.VolumeDocument documents = 1;
   */ _define_property(this, "documents", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReorderVolumeDocumentsResponse, "runtime", proto3);
_define_property(ReorderVolumeDocumentsResponse, "typeName", "mono.projectdata.v1.ReorderVolumeDocumentsResponse");
_define_property(ReorderVolumeDocumentsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "documents",
            kind: "message",
            T: VolumeDocument,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.NotifyDocumentSavedRequest
 */ export class NotifyDocumentSavedRequest extends Message {
    static fromBinary(bytes, options) {
        return new NotifyDocumentSavedRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new NotifyDocumentSavedRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new NotifyDocumentSavedRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(NotifyDocumentSavedRequest, a, b);
    }
    constructor(data){
        super(), /**
   * Shirohige document ID that was saved.
   *
   * @generated from field: string shirohige_document_id = 1;
   */ _define_property(this, "shirohigeDocumentId", ""), /**
   * MinIO key for the current version (e.g., "tenant/docid/current.docx").
   *
   * @generated from field: string minio_key = 2;
   */ _define_property(this, "minioKey", ""), /**
   * Document type: "docx", "xlsx", "pptx".
   *
   * @generated from field: string document_type = 3;
   */ _define_property(this, "documentType", ""), /**
   * User who triggered the save.
   *
   * @generated from field: string user_id = 4;
   */ _define_property(this, "userId", ""), /**
   * Tenant ID for scoping.
   *
   * @generated from field: string tenant_id = 5;
   */ _define_property(this, "tenantId", ""), /**
   * WRT-29: the shirohige version that was saved (content projection).
   *
   * @generated from field: string version_id = 6;
   */ _define_property(this, "versionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(NotifyDocumentSavedRequest, "runtime", proto3);
_define_property(NotifyDocumentSavedRequest, "typeName", "mono.projectdata.v1.NotifyDocumentSavedRequest");
_define_property(NotifyDocumentSavedRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "shirohige_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "minio_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "document_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.NotifyDocumentSavedResponse
 */ export class NotifyDocumentSavedResponse extends Message {
    static fromBinary(bytes, options) {
        return new NotifyDocumentSavedResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new NotifyDocumentSavedResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new NotifyDocumentSavedResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(NotifyDocumentSavedResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(NotifyDocumentSavedResponse, "runtime", proto3);
_define_property(NotifyDocumentSavedResponse, "typeName", "mono.projectdata.v1.NotifyDocumentSavedResponse");
_define_property(NotifyDocumentSavedResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.projectdata.v1.RemeasureOutlineBodiesRequest
 */ export class RemeasureOutlineBodiesRequest extends Message {
    static fromBinary(bytes, options) {
        return new RemeasureOutlineBodiesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RemeasureOutlineBodiesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RemeasureOutlineBodiesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RemeasureOutlineBodiesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * Tenant whose documents are measured (required).
   *
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * One proposal project; empty = every proposal project of the tenant.
   *
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * Extract and count, but write nothing.
   *
   * @generated from field: bool dry_run = 3;
   */ _define_property(this, "dryRun", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RemeasureOutlineBodiesRequest, "runtime", proto3);
_define_property(RemeasureOutlineBodiesRequest, "typeName", "mono.projectdata.v1.RemeasureOutlineBodiesRequest");
_define_property(RemeasureOutlineBodiesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "dry_run",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RemeasureOutlineBodiesResponse
 */ export class RemeasureOutlineBodiesResponse extends Message {
    static fromBinary(bytes, options) {
        return new RemeasureOutlineBodiesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RemeasureOutlineBodiesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RemeasureOutlineBodiesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RemeasureOutlineBodiesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * Volume main documents measured.
   *
   * @generated from field: int32 documents = 1;
   */ _define_property(this, "documents", 0), /**
   * Outline entries extracted across those documents.
   *
   * @generated from field: int32 entries = 2;
   */ _define_property(this, "entries", 0), /**
   * Entries with body_chars > 0.
   *
   * @generated from field: int32 drafted_entries = 3;
   */ _define_property(this, "draftedEntries", 0), /**
   * Sections whose measure was written (0 on a dry run).
   *
   * @generated from field: int32 sections_updated = 4;
   */ _define_property(this, "sectionsUpdated", 0), /**
   * Documents that could not be measured, as "<volume_document_id>: <error>".
   *
   * @generated from field: repeated string failures = 5;
   */ _define_property(this, "failures", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RemeasureOutlineBodiesResponse, "runtime", proto3);
_define_property(RemeasureOutlineBodiesResponse, "typeName", "mono.projectdata.v1.RemeasureOutlineBodiesResponse");
_define_property(RemeasureOutlineBodiesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "documents",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "entries",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "drafted_entries",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "sections_updated",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "failures",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetVolumeDocumentContentRequest
 */ export class GetVolumeDocumentContentRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetVolumeDocumentContentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetVolumeDocumentContentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetVolumeDocumentContentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetVolumeDocumentContentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string volume_id = 2;
   */ _define_property(this, "volumeId", ""), /**
   * volume_document_id
   *
   * @generated from field: string document_id = 3;
   */ _define_property(this, "documentId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetVolumeDocumentContentRequest, "runtime", proto3);
_define_property(GetVolumeDocumentContentRequest, "typeName", "mono.projectdata.v1.GetVolumeDocumentContentRequest");
_define_property(GetVolumeDocumentContentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "volume_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetVolumeDocumentContentResponse
 */ export class GetVolumeDocumentContentResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetVolumeDocumentContentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetVolumeDocumentContentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetVolumeDocumentContentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetVolumeDocumentContentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string text = 1;
   */ _define_property(this, "text", ""), /**
   * @generated from field: int32 character_count = 2;
   */ _define_property(this, "characterCount", 0), /**
   * @generated from field: string document_type = 3;
   */ _define_property(this, "documentType", ""), /**
   * @generated from field: string label = 4;
   */ _define_property(this, "label", ""), /**
   * The shirohige document UUID backing this volume document. The apply path
   * (shirohige ApplyDocumentOperations) is keyed on this UUID, not the vdoc_ id,
   * so callers thread it through to apply AI edits to a proposal-volume document.
   *
   * @generated from field: string shirohige_document_id = 5;
   */ _define_property(this, "shirohigeDocumentId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetVolumeDocumentContentResponse, "runtime", proto3);
_define_property(GetVolumeDocumentContentResponse, "typeName", "mono.projectdata.v1.GetVolumeDocumentContentResponse");
_define_property(GetVolumeDocumentContentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "character_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "document_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "shirohige_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetVolumeLegacyTextStateRequest
 */ export class GetVolumeLegacyTextStateRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetVolumeLegacyTextStateRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetVolumeLegacyTextStateRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetVolumeLegacyTextStateRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetVolumeLegacyTextStateRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string volume_id = 2;
   */ _define_property(this, "volumeId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetVolumeLegacyTextStateRequest, "runtime", proto3);
_define_property(GetVolumeLegacyTextStateRequest, "typeName", "mono.projectdata.v1.GetVolumeLegacyTextStateRequest");
_define_property(GetVolumeLegacyTextStateRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "volume_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetVolumeLegacyTextStateResponse
 */ export class GetVolumeLegacyTextStateResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetVolumeLegacyTextStateResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetVolumeLegacyTextStateResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetVolumeLegacyTextStateResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetVolumeLegacyTextStateResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated string section_ids = 1;
   */ _define_property(this, "sectionIds", []), /**
   * @generated from field: int32 orphan_text_count = 2;
   */ _define_property(this, "orphanTextCount", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetVolumeLegacyTextStateResponse, "runtime", proto3);
_define_property(GetVolumeLegacyTextStateResponse, "typeName", "mono.projectdata.v1.GetVolumeLegacyTextStateResponse");
_define_property(GetVolumeLegacyTextStateResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "section_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 2,
            name: "orphan_text_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SaveDraftRequest
 */ export class SaveDraftRequest extends Message {
    static fromBinary(bytes, options) {
        return new SaveDraftRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveDraftRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveDraftRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveDraftRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string section_id = 2;
   */ _define_property(this, "sectionId", ""), /**
   * which draft to save into (empty = default "Main" draft)
   *
   * @generated from field: string draft_id = 3;
   */ _define_property(this, "draftId", ""), /**
   * Tiptap document JSON
   *
   * @generated from field: string content_json = 4;
   */ _define_property(this, "contentJson", ""), /**
   * plain-text projection
   *
   * @generated from field: string content_text = 5;
   */ _define_property(this, "contentText", ""), /**
   * Present: the head version id the editor loaded or last saved. A different
   * head means someone else saved since (Aborted).
   *
   * @generated from field: optional string base_version_id = 6;
   */ _define_property(this, "baseVersionId", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveDraftRequest, "runtime", proto3);
_define_property(SaveDraftRequest, "typeName", "mono.projectdata.v1.SaveDraftRequest");
_define_property(SaveDraftRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "draft_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "content_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "content_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "base_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SaveDraftResponse
 */ export class SaveDraftResponse extends Message {
    static fromBinary(bytes, options) {
        return new SaveDraftResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveDraftResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveDraftResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveDraftResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string draft_id = 1;
   */ _define_property(this, "draftId", ""), /**
   * false if hash-identical to previous save
   *
   * @generated from field: bool content_changed = 2;
   */ _define_property(this, "contentChanged", false), /**
   * @generated from field: string head_version_id = 3;
   */ _define_property(this, "headVersionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveDraftResponse, "runtime", proto3);
_define_property(SaveDraftResponse, "typeName", "mono.projectdata.v1.SaveDraftResponse");
_define_property(SaveDraftResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "draft_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "content_changed",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 3,
            name: "head_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListDraftsRequest
 */ export class ListDraftsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListDraftsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListDraftsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListDraftsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListDraftsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string section_id = 2;
   */ _define_property(this, "sectionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListDraftsRequest, "runtime", proto3);
_define_property(ListDraftsRequest, "typeName", "mono.projectdata.v1.ListDraftsRequest");
_define_property(ListDraftsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListDraftsResponse
 */ export class ListDraftsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListDraftsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListDraftsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListDraftsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListDraftsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.SectionDraftEntry drafts = 1;
   */ _define_property(this, "drafts", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListDraftsResponse, "runtime", proto3);
_define_property(ListDraftsResponse, "typeName", "mono.projectdata.v1.ListDraftsResponse");
_define_property(ListDraftsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "drafts",
            kind: "message",
            T: SectionDraftEntry,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SectionDraftEntry
 */ export class SectionDraftEntry extends Message {
    static fromBinary(bytes, options) {
        return new SectionDraftEntry().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SectionDraftEntry().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SectionDraftEntry().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SectionDraftEntry, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string draft_id = 1;
   */ _define_property(this, "draftId", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * full content (needed for editor init)
   *
   * @generated from field: string content_json = 3;
   */ _define_property(this, "contentJson", ""), /**
   * preview
   *
   * @generated from field: string content_text = 4;
   */ _define_property(this, "contentText", ""), /**
   * the section's head version (content_json is its text)
   *
   * @generated from field: string head_version_id = 8;
   */ _define_property(this, "headVersionId", ""), /**
   * @generated from field: string updated_by = 5;
   */ _define_property(this, "updatedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SectionDraftEntry, "runtime", proto3);
_define_property(SectionDraftEntry, "typeName", "mono.projectdata.v1.SectionDraftEntry");
_define_property(SectionDraftEntry, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "draft_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "content_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "content_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "head_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "updated_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CreateDraftRequest
 */ export class CreateDraftRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateDraftRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateDraftRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateDraftRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateDraftRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string section_id = 2;
   */ _define_property(this, "sectionId", ""), /**
   * e.g. "Aggressive tone"
   *
   * @generated from field: string name = 3;
   */ _define_property(this, "name", ""), /**
   * optional: copy content from existing draft
   *
   * @generated from field: string fork_from_draft_id = 4;
   */ _define_property(this, "forkFromDraftId", ""), /**
   * optional: copy content from committed version
   *
   * @generated from field: int32 fork_from_version = 5;
   */ _define_property(this, "forkFromVersion", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateDraftRequest, "runtime", proto3);
_define_property(CreateDraftRequest, "typeName", "mono.projectdata.v1.CreateDraftRequest");
_define_property(CreateDraftRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "fork_from_draft_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "fork_from_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CreateDraftResponse
 */ export class CreateDraftResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateDraftResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateDraftResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateDraftResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateDraftResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.SectionDraftEntry draft = 1;
   */ _define_property(this, "draft", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateDraftResponse, "runtime", proto3);
_define_property(CreateDraftResponse, "typeName", "mono.projectdata.v1.CreateDraftResponse");
_define_property(CreateDraftResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "draft",
            kind: "message",
            T: SectionDraftEntry
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.DeleteDraftRequest
 */ export class DeleteDraftRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteDraftRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteDraftRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteDraftRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteDraftRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string draft_id = 2;
   */ _define_property(this, "draftId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteDraftRequest, "runtime", proto3);
_define_property(DeleteDraftRequest, "typeName", "mono.projectdata.v1.DeleteDraftRequest");
_define_property(DeleteDraftRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "draft_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.DeleteDraftResponse
 */ export class DeleteDraftResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteDraftResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteDraftResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteDraftResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteDraftResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteDraftResponse, "runtime", proto3);
_define_property(DeleteDraftResponse, "typeName", "mono.projectdata.v1.DeleteDraftResponse");
_define_property(DeleteDraftResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.projectdata.v1.RenameDraftRequest
 */ export class RenameDraftRequest extends Message {
    static fromBinary(bytes, options) {
        return new RenameDraftRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RenameDraftRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RenameDraftRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RenameDraftRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string draft_id = 2;
   */ _define_property(this, "draftId", ""), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RenameDraftRequest, "runtime", proto3);
_define_property(RenameDraftRequest, "typeName", "mono.projectdata.v1.RenameDraftRequest");
_define_property(RenameDraftRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "draft_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RenameDraftResponse
 */ export class RenameDraftResponse extends Message {
    static fromBinary(bytes, options) {
        return new RenameDraftResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RenameDraftResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RenameDraftResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RenameDraftResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.SectionDraftEntry draft = 1;
   */ _define_property(this, "draft", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RenameDraftResponse, "runtime", proto3);
_define_property(RenameDraftResponse, "typeName", "mono.projectdata.v1.RenameDraftResponse");
_define_property(RenameDraftResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "draft",
            kind: "message",
            T: SectionDraftEntry
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CommitDraftRequest
 */ export class CommitDraftRequest extends Message {
    static fromBinary(bytes, options) {
        return new CommitDraftRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CommitDraftRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CommitDraftRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CommitDraftRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string section_id = 2;
   */ _define_property(this, "sectionId", ""), /**
   * which draft to commit
   *
   * @generated from field: string draft_id = 3;
   */ _define_property(this, "draftId", ""), /**
   * optional commit message
   *
   * @generated from field: string message = 4;
   */ _define_property(this, "message", ""), /**
   * @generated from field: string label = 5;
   */ _define_property(this, "label", ""), /**
   * @generated from field: optional string base_version_id = 6;
   */ _define_property(this, "baseVersionId", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CommitDraftRequest, "runtime", proto3);
_define_property(CommitDraftRequest, "typeName", "mono.projectdata.v1.CommitDraftRequest");
_define_property(CommitDraftRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "draft_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "message",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "base_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CommitDraftResponse
 */ export class CommitDraftResponse extends Message {
    static fromBinary(bytes, options) {
        return new CommitDraftResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CommitDraftResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CommitDraftResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CommitDraftResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 version = 1;
   */ _define_property(this, "version", 0), /**
   * @generated from field: string version_id = 2;
   */ _define_property(this, "versionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CommitDraftResponse, "runtime", proto3);
_define_property(CommitDraftResponse, "typeName", "mono.projectdata.v1.CommitDraftResponse");
_define_property(CommitDraftResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RestoreVersionRequest
 */ export class RestoreVersionRequest extends Message {
    static fromBinary(bytes, options) {
        return new RestoreVersionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RestoreVersionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RestoreVersionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RestoreVersionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string section_id = 2;
   */ _define_property(this, "sectionId", ""), /**
   * version number to restore
   *
   * @generated from field: int32 version = 3;
   */ _define_property(this, "version", 0), /**
   * unused: a restore appends a version, it overwrites no draft
   *
   * @generated from field: string target_draft_id = 4;
   */ _define_property(this, "targetDraftId", ""), /**
   * @generated from field: optional string base_version_id = 5;
   */ _define_property(this, "baseVersionId", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RestoreVersionRequest, "runtime", proto3);
_define_property(RestoreVersionRequest, "typeName", "mono.projectdata.v1.RestoreVersionRequest");
_define_property(RestoreVersionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "target_draft_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "base_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        }
    ]));
/**
 * The restore appended version_id on top of the head; the restored version is
 * unchanged.
 *
 * @generated from message mono.projectdata.v1.RestoreVersionResponse
 */ export class RestoreVersionResponse extends Message {
    static fromBinary(bytes, options) {
        return new RestoreVersionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RestoreVersionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RestoreVersionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RestoreVersionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string draft_id = 1;
   */ _define_property(this, "draftId", ""), /**
   * @generated from field: string version_id = 2;
   */ _define_property(this, "versionId", ""), /**
   * @generated from field: int32 version = 3;
   */ _define_property(this, "version", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RestoreVersionResponse, "runtime", proto3);
_define_property(RestoreVersionResponse, "typeName", "mono.projectdata.v1.RestoreVersionResponse");
_define_property(RestoreVersionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "draft_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListSectionVersionsRequest
 */ export class ListSectionVersionsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListSectionVersionsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListSectionVersionsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListSectionVersionsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListSectionVersionsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string section_id = 2;
   */ _define_property(this, "sectionId", ""), /**
   * default 20
   *
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListSectionVersionsRequest, "runtime", proto3);
_define_property(ListSectionVersionsRequest, "typeName", "mono.projectdata.v1.ListSectionVersionsRequest");
_define_property(ListSectionVersionsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListSectionVersionsResponse
 */ export class ListSectionVersionsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListSectionVersionsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListSectionVersionsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListSectionVersionsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListSectionVersionsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.SectionVersionEntry versions = 1;
   */ _define_property(this, "versions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListSectionVersionsResponse, "runtime", proto3);
_define_property(ListSectionVersionsResponse, "typeName", "mono.projectdata.v1.ListSectionVersionsResponse");
_define_property(ListSectionVersionsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "versions",
            kind: "message",
            T: SectionVersionEntry,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SectionVersionEntry
 */ export class SectionVersionEntry extends Message {
    static fromBinary(bytes, options) {
        return new SectionVersionEntry().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SectionVersionEntry().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SectionVersionEntry().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SectionVersionEntry, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: int32 version = 2;
   */ _define_property(this, "version", 0), /**
   * @generated from field: string created_by = 3;
   */ _define_property(this, "createdBy", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */ _define_property(this, "createdAt", void 0), /**
   * preview — first ~200 chars
   *
   * @generated from field: string content_text = 5;
   */ _define_property(this, "contentText", ""), /**
   * jsondiffpatch delta from previous version
   *
   * @generated from field: string diff_json = 6;
   */ _define_property(this, "diffJson", ""), /**
   * commit message
   *
   * @generated from field: string message = 7;
   */ _define_property(this, "message", ""), /**
   * which draft was committed
   *
   * @generated from field: string draft_name = 8;
   */ _define_property(this, "draftName", ""), /**
   * working | milestone | review
   *
   * @generated from field: string kind = 9;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string label = 10;
   */ _define_property(this, "label", ""), /**
   * @generated from field: string parent_version_id = 11;
   */ _define_property(this, "parentVersionId", ""), /**
   * @generated from field: string source_version_id = 12;
   */ _define_property(this, "sourceVersionId", ""), /**
   * manual | paste | import | external_file
   *
   * @generated from field: string provenance = 13;
   */ _define_property(this, "provenance", ""), /**
   * @generated from field: string provenance_artifact_id = 14;
   */ _define_property(this, "provenanceArtifactId", ""), /**
   * @generated from field: string provenance_file_name = 15;
   */ _define_property(this, "provenanceFileName", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SectionVersionEntry, "runtime", proto3);
_define_property(SectionVersionEntry, "typeName", "mono.projectdata.v1.SectionVersionEntry");
_define_property(SectionVersionEntry, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "content_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "diff_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "message",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "draft_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "parent_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "source_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "provenance",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "provenance_artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "provenance_file_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetSectionVersionRequest
 */ export class GetSectionVersionRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetSectionVersionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetSectionVersionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetSectionVersionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetSectionVersionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string section_id = 2;
   */ _define_property(this, "sectionId", ""), /**
   * @generated from field: int32 version = 3;
   */ _define_property(this, "version", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetSectionVersionRequest, "runtime", proto3);
_define_property(GetSectionVersionRequest, "typeName", "mono.projectdata.v1.GetSectionVersionRequest");
_define_property(GetSectionVersionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetSectionVersionResponse
 */ export class GetSectionVersionResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetSectionVersionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetSectionVersionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetSectionVersionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetSectionVersionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string content_json = 1;
   */ _define_property(this, "contentJson", ""), /**
   * @generated from field: string content_text = 2;
   */ _define_property(this, "contentText", ""), /**
   * @generated from field: int32 version = 3;
   */ _define_property(this, "version", 0), /**
   * @generated from field: string created_by = 4;
   */ _define_property(this, "createdBy", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: string message = 6;
   */ _define_property(this, "message", ""), /**
   * @generated from field: string id = 7;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string kind = 8;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string label = 9;
   */ _define_property(this, "label", ""), /**
   * @generated from field: string parent_version_id = 10;
   */ _define_property(this, "parentVersionId", ""), /**
   * @generated from field: string source_version_id = 11;
   */ _define_property(this, "sourceVersionId", ""), /**
   * @generated from field: string provenance = 12;
   */ _define_property(this, "provenance", ""), /**
   * @generated from field: string provenance_artifact_id = 13;
   */ _define_property(this, "provenanceArtifactId", ""), /**
   * @generated from field: string provenance_file_name = 14;
   */ _define_property(this, "provenanceFileName", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetSectionVersionResponse, "runtime", proto3);
_define_property(GetSectionVersionResponse, "typeName", "mono.projectdata.v1.GetSectionVersionResponse");
_define_property(GetSectionVersionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "content_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "content_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "message",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "parent_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "source_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "provenance",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "provenance_artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "provenance_file_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CreateReviewSnapshotRequest
 */ export class CreateReviewSnapshotRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateReviewSnapshotRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateReviewSnapshotRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateReviewSnapshotRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateReviewSnapshotRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string section_id = 2;
   */ _define_property(this, "sectionId", ""), /**
   * @generated from field: string label = 3;
   */ _define_property(this, "label", ""), /**
   * @generated from field: string comment = 4;
   */ _define_property(this, "comment", ""), /**
   * @generated from field: optional string base_version_id = 5;
   */ _define_property(this, "baseVersionId", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateReviewSnapshotRequest, "runtime", proto3);
_define_property(CreateReviewSnapshotRequest, "typeName", "mono.projectdata.v1.CreateReviewSnapshotRequest");
_define_property(CreateReviewSnapshotRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "comment",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "base_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CreateReviewSnapshotResponse
 */ export class CreateReviewSnapshotResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateReviewSnapshotResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateReviewSnapshotResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateReviewSnapshotResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateReviewSnapshotResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string version_id = 1;
   */ _define_property(this, "versionId", ""), /**
   * @generated from field: int32 version = 2;
   */ _define_property(this, "version", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateReviewSnapshotResponse, "runtime", proto3);
_define_property(CreateReviewSnapshotResponse, "typeName", "mono.projectdata.v1.CreateReviewSnapshotResponse");
_define_property(CreateReviewSnapshotResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CompareSectionVersionsRequest
 */ export class CompareSectionVersionsRequest extends Message {
    static fromBinary(bytes, options) {
        return new CompareSectionVersionsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompareSectionVersionsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompareSectionVersionsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompareSectionVersionsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string section_id = 2;
   */ _define_property(this, "sectionId", ""), /**
   * @generated from field: int32 from_version = 3;
   */ _define_property(this, "fromVersion", 0), /**
   * @generated from field: int32 to_version = 4;
   */ _define_property(this, "toVersion", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CompareSectionVersionsRequest, "runtime", proto3);
_define_property(CompareSectionVersionsRequest, "typeName", "mono.projectdata.v1.CompareSectionVersionsRequest");
_define_property(CompareSectionVersionsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "from_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "to_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CompareSectionVersionsResponse
 */ export class CompareSectionVersionsResponse extends Message {
    static fromBinary(bytes, options) {
        return new CompareSectionVersionsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompareSectionVersionsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompareSectionVersionsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompareSectionVersionsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.GetSectionVersionResponse from = 1;
   */ _define_property(this, "from", void 0), /**
   * @generated from field: mono.projectdata.v1.GetSectionVersionResponse to = 2;
   */ _define_property(this, "to", void 0), /**
   * @generated from field: repeated mono.projectdata.v1.SectionDiffLine lines = 3;
   */ _define_property(this, "lines", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CompareSectionVersionsResponse, "runtime", proto3);
_define_property(CompareSectionVersionsResponse, "typeName", "mono.projectdata.v1.CompareSectionVersionsResponse");
_define_property(CompareSectionVersionsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "from",
            kind: "message",
            T: GetSectionVersionResponse
        },
        {
            no: 2,
            name: "to",
            kind: "message",
            T: GetSectionVersionResponse
        },
        {
            no: 3,
            name: "lines",
            kind: "message",
            T: SectionDiffLine,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SectionDiffLine
 */ export class SectionDiffLine extends Message {
    static fromBinary(bytes, options) {
        return new SectionDiffLine().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SectionDiffLine().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SectionDiffLine().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SectionDiffLine, a, b);
    }
    constructor(data){
        super(), /**
   * equal | add | remove
   *
   * @generated from field: string op = 1;
   */ _define_property(this, "op", ""), /**
   * @generated from field: string text = 2;
   */ _define_property(this, "text", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SectionDiffLine, "runtime", proto3);
_define_property(SectionDiffLine, "typeName", "mono.projectdata.v1.SectionDiffLine");
_define_property(SectionDiffLine, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "op",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * file_name and artifact_id say where the revised text came from; the text is
 * what the caller extracted from it.
 *
 * @generated from message mono.projectdata.v1.ImportSectionRevisionRequest
 */ export class ImportSectionRevisionRequest extends Message {
    static fromBinary(bytes, options) {
        return new ImportSectionRevisionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ImportSectionRevisionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ImportSectionRevisionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ImportSectionRevisionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string section_id = 2;
   */ _define_property(this, "sectionId", ""), /**
   * @generated from field: string file_name = 3;
   */ _define_property(this, "fileName", ""), /**
   * @generated from field: string artifact_id = 4;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: string content_json = 5;
   */ _define_property(this, "contentJson", ""), /**
   * @generated from field: string content_text = 6;
   */ _define_property(this, "contentText", ""), /**
   * @generated from field: string comment = 7;
   */ _define_property(this, "comment", ""), /**
   * @generated from field: optional string base_version_id = 8;
   */ _define_property(this, "baseVersionId", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ImportSectionRevisionRequest, "runtime", proto3);
_define_property(ImportSectionRevisionRequest, "typeName", "mono.projectdata.v1.ImportSectionRevisionRequest");
_define_property(ImportSectionRevisionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "file_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "content_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "content_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "comment",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "base_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ImportSectionRevisionResponse
 */ export class ImportSectionRevisionResponse extends Message {
    static fromBinary(bytes, options) {
        return new ImportSectionRevisionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ImportSectionRevisionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ImportSectionRevisionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ImportSectionRevisionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string version_id = 1;
   */ _define_property(this, "versionId", ""), /**
   * @generated from field: int32 version = 2;
   */ _define_property(this, "version", 0), /**
   * @generated from field: string parent_version_id = 3;
   */ _define_property(this, "parentVersionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ImportSectionRevisionResponse, "runtime", proto3);
_define_property(ImportSectionRevisionResponse, "typeName", "mono.projectdata.v1.ImportSectionRevisionResponse");
_define_property(ImportSectionRevisionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "parent_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.LoadTemplateIntoWorkbookRequest
 */ export class LoadTemplateIntoWorkbookRequest extends Message {
    static fromBinary(bytes, options) {
        return new LoadTemplateIntoWorkbookRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LoadTemplateIntoWorkbookRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LoadTemplateIntoWorkbookRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LoadTemplateIntoWorkbookRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string volume_id = 2;
   */ _define_property(this, "volumeId", ""), /**
   * @generated from field: string attachment_id = 3;
   */ _define_property(this, "attachmentId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LoadTemplateIntoWorkbookRequest, "runtime", proto3);
_define_property(LoadTemplateIntoWorkbookRequest, "typeName", "mono.projectdata.v1.LoadTemplateIntoWorkbookRequest");
_define_property(LoadTemplateIntoWorkbookRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "volume_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "attachment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.LoadTemplateIntoWorkbookResponse
 */ export class LoadTemplateIntoWorkbookResponse extends Message {
    static fromBinary(bytes, options) {
        return new LoadTemplateIntoWorkbookResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LoadTemplateIntoWorkbookResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LoadTemplateIntoWorkbookResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LoadTemplateIntoWorkbookResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 version = 1;
   */ _define_property(this, "version", 0), /**
   * @generated from field: repeated string sheet_names = 2;
   */ _define_property(this, "sheetNames", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(LoadTemplateIntoWorkbookResponse, "runtime", proto3);
_define_property(LoadTemplateIntoWorkbookResponse, "typeName", "mono.projectdata.v1.LoadTemplateIntoWorkbookResponse");
_define_property(LoadTemplateIntoWorkbookResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "sheet_names",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.LoadWorkbookRequest
 */ export class LoadWorkbookRequest extends Message {
    static fromBinary(bytes, options) {
        return new LoadWorkbookRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LoadWorkbookRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LoadWorkbookRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LoadWorkbookRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string volume_id = 2;
   */ _define_property(this, "volumeId", ""), /**
   * 0 = latest
   *
   * @generated from field: int32 version = 3;
   */ _define_property(this, "version", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(LoadWorkbookRequest, "runtime", proto3);
_define_property(LoadWorkbookRequest, "typeName", "mono.projectdata.v1.LoadWorkbookRequest");
_define_property(LoadWorkbookRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "volume_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.LoadWorkbookResponse
 */ export class LoadWorkbookResponse extends Message {
    static fromBinary(bytes, options) {
        return new LoadWorkbookResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LoadWorkbookResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LoadWorkbookResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LoadWorkbookResponse, a, b);
    }
    constructor(data){
        super(), /**
   * raw XLSX file bytes
   *
   * @generated from field: bytes xlsx_data = 1;
   */ _define_property(this, "xlsxData", new Uint8Array(0)), /**
   * @generated from field: int32 version = 2;
   */ _define_property(this, "version", 0), /**
   * @generated from field: repeated string sheet_names = 3;
   */ _define_property(this, "sheetNames", []), /**
   * @generated from field: string content_hash = 4;
   */ _define_property(this, "contentHash", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LoadWorkbookResponse, "runtime", proto3);
_define_property(LoadWorkbookResponse, "typeName", "mono.projectdata.v1.LoadWorkbookResponse");
_define_property(LoadWorkbookResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "xlsx_data",
            kind: "scalar",
            T: 12 /* ScalarType.BYTES */ 
        },
        {
            no: 2,
            name: "version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "sheet_names",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 4,
            name: "content_hash",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SaveWorkbookRequest
 */ export class SaveWorkbookRequest extends Message {
    static fromBinary(bytes, options) {
        return new SaveWorkbookRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveWorkbookRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveWorkbookRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveWorkbookRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string volume_id = 2;
   */ _define_property(this, "volumeId", ""), /**
   * raw XLSX file bytes from frontend
   *
   * @generated from field: bytes xlsx_data = 3;
   */ _define_property(this, "xlsxData", new Uint8Array(0)), /**
   * optional commit message
   *
   * @generated from field: string message = 4;
   */ _define_property(this, "message", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveWorkbookRequest, "runtime", proto3);
_define_property(SaveWorkbookRequest, "typeName", "mono.projectdata.v1.SaveWorkbookRequest");
_define_property(SaveWorkbookRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "volume_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "xlsx_data",
            kind: "scalar",
            T: 12 /* ScalarType.BYTES */ 
        },
        {
            no: 4,
            name: "message",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SaveWorkbookResponse
 */ export class SaveWorkbookResponse extends Message {
    static fromBinary(bytes, options) {
        return new SaveWorkbookResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveWorkbookResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveWorkbookResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveWorkbookResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 version = 1;
   */ _define_property(this, "version", 0), /**
   * false if content hash identical
   *
   * @generated from field: bool was_new_version = 2;
   */ _define_property(this, "wasNewVersion", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveWorkbookResponse, "runtime", proto3);
_define_property(SaveWorkbookResponse, "typeName", "mono.projectdata.v1.SaveWorkbookResponse");
_define_property(SaveWorkbookResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "was_new_version",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListWorkbookVersionsRequest
 */ export class ListWorkbookVersionsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListWorkbookVersionsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListWorkbookVersionsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListWorkbookVersionsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListWorkbookVersionsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string volume_id = 2;
   */ _define_property(this, "volumeId", ""), /**
   * default 20
   *
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListWorkbookVersionsRequest, "runtime", proto3);
_define_property(ListWorkbookVersionsRequest, "typeName", "mono.projectdata.v1.ListWorkbookVersionsRequest");
_define_property(ListWorkbookVersionsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "volume_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListWorkbookVersionsResponse
 */ export class ListWorkbookVersionsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListWorkbookVersionsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListWorkbookVersionsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListWorkbookVersionsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListWorkbookVersionsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.WorkbookVersionEntry versions = 1;
   */ _define_property(this, "versions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListWorkbookVersionsResponse, "runtime", proto3);
_define_property(ListWorkbookVersionsResponse, "typeName", "mono.projectdata.v1.ListWorkbookVersionsResponse");
_define_property(ListWorkbookVersionsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "versions",
            kind: "message",
            T: WorkbookVersionEntry,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.WorkbookVersionEntry
 */ export class WorkbookVersionEntry extends Message {
    static fromBinary(bytes, options) {
        return new WorkbookVersionEntry().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WorkbookVersionEntry().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WorkbookVersionEntry().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WorkbookVersionEntry, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: int32 version = 2;
   */ _define_property(this, "version", 0), /**
   * @generated from field: string created_by = 3;
   */ _define_property(this, "createdBy", ""), /**
   * "user" or "ai"
   *
   * @generated from field: string actor_type = 4;
   */ _define_property(this, "actorType", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: string message = 6;
   */ _define_property(this, "message", ""), /**
   * @generated from field: repeated string sheet_names = 7;
   */ _define_property(this, "sheetNames", []), /**
   * @generated from field: int64 size_bytes = 8;
   */ _define_property(this, "sizeBytes", protoInt64.zero), /**
   * human-readable: "changed 12 cells in Section B"
   *
   * @generated from field: string diff_summary = 9;
   */ _define_property(this, "diffSummary", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(WorkbookVersionEntry, "runtime", proto3);
_define_property(WorkbookVersionEntry, "typeName", "mono.projectdata.v1.WorkbookVersionEntry");
_define_property(WorkbookVersionEntry, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "actor_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "message",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "sheet_names",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 8,
            name: "size_bytes",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 9,
            name: "diff_summary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetWorkbookVersionRequest
 */ export class GetWorkbookVersionRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetWorkbookVersionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetWorkbookVersionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetWorkbookVersionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetWorkbookVersionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string volume_id = 2;
   */ _define_property(this, "volumeId", ""), /**
   * @generated from field: int32 version = 3;
   */ _define_property(this, "version", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetWorkbookVersionRequest, "runtime", proto3);
_define_property(GetWorkbookVersionRequest, "typeName", "mono.projectdata.v1.GetWorkbookVersionRequest");
_define_property(GetWorkbookVersionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "volume_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetWorkbookVersionResponse
 */ export class GetWorkbookVersionResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetWorkbookVersionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetWorkbookVersionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetWorkbookVersionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetWorkbookVersionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bytes xlsx_data = 1;
   */ _define_property(this, "xlsxData", new Uint8Array(0)), /**
   * @generated from field: int32 version = 2;
   */ _define_property(this, "version", 0), /**
   * @generated from field: string created_by = 3;
   */ _define_property(this, "createdBy", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: string message = 5;
   */ _define_property(this, "message", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetWorkbookVersionResponse, "runtime", proto3);
_define_property(GetWorkbookVersionResponse, "typeName", "mono.projectdata.v1.GetWorkbookVersionResponse");
_define_property(GetWorkbookVersionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "xlsx_data",
            kind: "scalar",
            T: 12 /* ScalarType.BYTES */ 
        },
        {
            no: 2,
            name: "version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "message",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListWorkbookSheetsRequest
 */ export class ListWorkbookSheetsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListWorkbookSheetsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListWorkbookSheetsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListWorkbookSheetsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListWorkbookSheetsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string volume_id = 2;
   */ _define_property(this, "volumeId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListWorkbookSheetsRequest, "runtime", proto3);
_define_property(ListWorkbookSheetsRequest, "typeName", "mono.projectdata.v1.ListWorkbookSheetsRequest");
_define_property(ListWorkbookSheetsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "volume_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListWorkbookSheetsResponse
 */ export class ListWorkbookSheetsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListWorkbookSheetsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListWorkbookSheetsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListWorkbookSheetsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListWorkbookSheetsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.WorkbookSheetEntry sheets = 1;
   */ _define_property(this, "sheets", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListWorkbookSheetsResponse, "runtime", proto3);
_define_property(ListWorkbookSheetsResponse, "typeName", "mono.projectdata.v1.ListWorkbookSheetsResponse");
_define_property(ListWorkbookSheetsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "sheets",
            kind: "message",
            T: WorkbookSheetEntry,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.WorkbookSheetEntry
 */ export class WorkbookSheetEntry extends Message {
    static fromBinary(bytes, options) {
        return new WorkbookSheetEntry().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WorkbookSheetEntry().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WorkbookSheetEntry().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WorkbookSheetEntry, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string sheet_name = 2;
   */ _define_property(this, "sheetName", ""), /**
   * @generated from field: int32 sort_order = 3;
   */ _define_property(this, "sortOrder", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(WorkbookSheetEntry, "runtime", proto3);
_define_property(WorkbookSheetEntry, "typeName", "mono.projectdata.v1.WorkbookSheetEntry");
_define_property(WorkbookSheetEntry, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "sheet_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "sort_order",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.DiffWorkbookVersionsRequest
 */ export class DiffWorkbookVersionsRequest extends Message {
    static fromBinary(bytes, options) {
        return new DiffWorkbookVersionsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DiffWorkbookVersionsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DiffWorkbookVersionsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DiffWorkbookVersionsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string volume_id = 2;
   */ _define_property(this, "volumeId", ""), /**
   * older version (0 = empty)
   *
   * @generated from field: int32 from_version = 3;
   */ _define_property(this, "fromVersion", 0), /**
   * newer version
   *
   * @generated from field: int32 to_version = 4;
   */ _define_property(this, "toVersion", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DiffWorkbookVersionsRequest, "runtime", proto3);
_define_property(DiffWorkbookVersionsRequest, "typeName", "mono.projectdata.v1.DiffWorkbookVersionsRequest");
_define_property(DiffWorkbookVersionsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "volume_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "from_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "to_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.DiffWorkbookVersionsResponse
 */ export class DiffWorkbookVersionsResponse extends Message {
    static fromBinary(bytes, options) {
        return new DiffWorkbookVersionsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DiffWorkbookVersionsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DiffWorkbookVersionsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DiffWorkbookVersionsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.SheetDiff sheets = 1;
   */ _define_property(this, "sheets", []), /**
   * @generated from field: int32 total_changes = 2;
   */ _define_property(this, "totalChanges", 0), /**
   * sheets in to but not from
   *
   * @generated from field: repeated string added_sheets = 3;
   */ _define_property(this, "addedSheets", []), /**
   * sheets in from but not to
   *
   * @generated from field: repeated string removed_sheets = 4;
   */ _define_property(this, "removedSheets", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DiffWorkbookVersionsResponse, "runtime", proto3);
_define_property(DiffWorkbookVersionsResponse, "typeName", "mono.projectdata.v1.DiffWorkbookVersionsResponse");
_define_property(DiffWorkbookVersionsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "sheets",
            kind: "message",
            T: SheetDiff,
            repeated: true
        },
        {
            no: 2,
            name: "total_changes",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "added_sheets",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 4,
            name: "removed_sheets",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SheetDiff
 */ export class SheetDiff extends Message {
    static fromBinary(bytes, options) {
        return new SheetDiff().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SheetDiff().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SheetDiff().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SheetDiff, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string sheet_name = 1;
   */ _define_property(this, "sheetName", ""), /**
   * @generated from field: repeated mono.projectdata.v1.CellChange changes = 2;
   */ _define_property(this, "changes", []), /**
   * @generated from field: int32 cells_added = 3;
   */ _define_property(this, "cellsAdded", 0), /**
   * @generated from field: int32 cells_modified = 4;
   */ _define_property(this, "cellsModified", 0), /**
   * @generated from field: int32 cells_removed = 5;
   */ _define_property(this, "cellsRemoved", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SheetDiff, "runtime", proto3);
_define_property(SheetDiff, "typeName", "mono.projectdata.v1.SheetDiff");
_define_property(SheetDiff, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "sheet_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "changes",
            kind: "message",
            T: CellChange,
            repeated: true
        },
        {
            no: 3,
            name: "cells_added",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "cells_modified",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "cells_removed",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CellChange
 */ export class CellChange extends Message {
    static fromBinary(bytes, options) {
        return new CellChange().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CellChange().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CellChange().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CellChange, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 row = 1;
   */ _define_property(this, "row", 0), /**
   * @generated from field: int32 col = 2;
   */ _define_property(this, "col", 0), /**
   * @generated from field: string old_value = 3;
   */ _define_property(this, "oldValue", ""), /**
   * @generated from field: string new_value = 4;
   */ _define_property(this, "newValue", ""), /**
   * "added" | "modified" | "removed"
   *
   * @generated from field: string change_type = 5;
   */ _define_property(this, "changeType", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CellChange, "runtime", proto3);
_define_property(CellChange, "typeName", "mono.projectdata.v1.CellChange");
_define_property(CellChange, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "row",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "col",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "old_value",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "new_value",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "change_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * PreAwardSummary — frontend-facing wrapper combining the pangaea PreAward
 * row, the spawned zou Project ID, the frozen BidBaseline ID, and the 8
 * readiness rows. The full pangaea protos are imported by the client; here
 * we surface only the ids + a denormalised JSON-friendly readiness map so
 * the proposal/contract page can render without a second round-trip.
 *
 * @generated from message mono.projectdata.v1.PreAwardSummary
 */ export class PreAwardSummary extends Message {
    static fromBinary(bytes, options) {
        return new PreAwardSummary().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PreAwardSummary().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PreAwardSummary().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PreAwardSummary, a, b);
    }
    constructor(data){
        super(), /**
   * pangaea.PreAwardProject.id
   *
   * @generated from field: string pre_award_project_id = 1;
   */ _define_property(this, "preAwardProjectId", ""), /**
   * zou.Project.id (type=pre_award)
   *
   * @generated from field: string zou_project_id = 2;
   */ _define_property(this, "zouProjectId", ""), /**
   * @generated from field: string proposal_project_id = 3;
   */ _define_property(this, "proposalProjectId", ""), /**
   * @generated from field: string bid_baseline_id = 4;
   */ _define_property(this, "bidBaselineId", ""), /**
   * Draft|InProgress|ReadyForAward|Converted|Archived
   *
   * @generated from field: string state = 5;
   */ _define_property(this, "state", ""), /**
   * @generated from field: string tenant_id = 6;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: repeated mono.projectdata.v1.PreAwardReadinessAreaStatus readiness = 7;
   */ _define_property(this, "readiness", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PreAwardSummary, "runtime", proto3);
_define_property(PreAwardSummary, "typeName", "mono.projectdata.v1.PreAwardSummary");
_define_property(PreAwardSummary, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "pre_award_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "zou_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "proposal_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "bid_baseline_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "readiness",
            kind: "message",
            T: PreAwardReadinessAreaStatus,
            repeated: true
        }
    ]));
/**
 * PreAwardReadinessAreaStatus — readiness-row projection. `area` is one of
 * the 8 SDS §3.3 enum values; `status` is NotStarted|InProgress|Ready|Blocked.
 *
 * @generated from message mono.projectdata.v1.PreAwardReadinessAreaStatus
 */ export class PreAwardReadinessAreaStatus extends Message {
    static fromBinary(bytes, options) {
        return new PreAwardReadinessAreaStatus().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PreAwardReadinessAreaStatus().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PreAwardReadinessAreaStatus().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PreAwardReadinessAreaStatus, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string area = 1;
   */ _define_property(this, "area", ""), /**
   * @generated from field: string status = 2;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string data_json = 3;
   */ _define_property(this, "dataJson", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PreAwardReadinessAreaStatus, "runtime", proto3);
_define_property(PreAwardReadinessAreaStatus, "typeName", "mono.projectdata.v1.PreAwardReadinessAreaStatus");
_define_property(PreAwardReadinessAreaStatus, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "area",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "data_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ConvertProposalToPreAwardRequest
 */ export class ConvertProposalToPreAwardRequest extends Message {
    static fromBinary(bytes, options) {
        return new ConvertProposalToPreAwardRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ConvertProposalToPreAwardRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ConvertProposalToPreAwardRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ConvertProposalToPreAwardRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string proposal_project_id = 1;
   */ _define_property(this, "proposalProjectId", ""), /**
   * ignored when gateway principal is present
   *
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * ignored when gateway principal is present
   *
   * @generated from field: string company_id = 3;
   */ _define_property(this, "companyId", ""), /**
   * required recorded PROP-14 submission in this Proposal
   *
   * @generated from field: string submission_id = 4;
   */ _define_property(this, "submissionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ConvertProposalToPreAwardRequest, "runtime", proto3);
_define_property(ConvertProposalToPreAwardRequest, "typeName", "mono.projectdata.v1.ConvertProposalToPreAwardRequest");
_define_property(ConvertProposalToPreAwardRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "proposal_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "submission_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ConvertProposalToPreAwardResponse
 */ export class ConvertProposalToPreAwardResponse extends Message {
    static fromBinary(bytes, options) {
        return new ConvertProposalToPreAwardResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ConvertProposalToPreAwardResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ConvertProposalToPreAwardResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ConvertProposalToPreAwardResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.PreAwardSummary summary = 1;
   */ _define_property(this, "summary", void 0), /**
   * selected immutable handoff (also returned on retry)
   *
   * @generated from field: mono.projectdata.v1.BidBaselineView handoff = 2;
   */ _define_property(this, "handoff", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ConvertProposalToPreAwardResponse, "runtime", proto3);
_define_property(ConvertProposalToPreAwardResponse, "typeName", "mono.projectdata.v1.ConvertProposalToPreAwardResponse");
_define_property(ConvertProposalToPreAwardResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "summary",
            kind: "message",
            T: PreAwardSummary
        },
        {
            no: 2,
            name: "handoff",
            kind: "message",
            T: BidBaselineView
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ConvertCaptureToProposalRequest
 */ export class ConvertCaptureToProposalRequest extends Message {
    static fromBinary(bytes, options) {
        return new ConvertCaptureToProposalRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ConvertCaptureToProposalRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ConvertCaptureToProposalRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ConvertCaptureToProposalRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * ignored when gateway principal is present
   *
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * ignored when gateway principal is present
   *
   * @generated from field: string company_id = 3;
   */ _define_property(this, "companyId", ""), /**
   * SAD-521: idempotency key for ONE opening action. A retry with the same key
   * returns (and heals) the same proposal; empty = legacy behaviour.
   *
   * @generated from field: string open_request_key = 4;
   */ _define_property(this, "openRequestKey", ""), /**
   * SAD-521: open ANOTHER bid from this pursuit even if one already exists.
   * The pursuit's stage/lifecycle is never changed.
   *
   * @generated from field: bool deliberate_new_bid = 5;
   */ _define_property(this, "deliberateNewBid", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ConvertCaptureToProposalRequest, "runtime", proto3);
_define_property(ConvertCaptureToProposalRequest, "typeName", "mono.projectdata.v1.ConvertCaptureToProposalRequest");
_define_property(ConvertCaptureToProposalRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "open_request_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "deliberate_new_bid",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ConvertCaptureToProposalResponse
 */ export class ConvertCaptureToProposalResponse extends Message {
    static fromBinary(bytes, options) {
        return new ConvertCaptureToProposalResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ConvertCaptureToProposalResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ConvertCaptureToProposalResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ConvertCaptureToProposalResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.ProposalSummary summary = 1;
   */ _define_property(this, "summary", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ConvertCaptureToProposalResponse, "runtime", proto3);
_define_property(ConvertCaptureToProposalResponse, "typeName", "mono.projectdata.v1.ConvertCaptureToProposalResponse");
_define_property(ConvertCaptureToProposalResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "summary",
            kind: "message",
            T: ProposalSummary
        }
    ]));
/**
 * ProposalSummary is the spawned proposal's identity + its source-capture link,
 * returned so the UI can navigate to /proposal/:id after conversion.
 *
 * @generated from message mono.projectdata.v1.ProposalSummary
 */ export class ProposalSummary extends Message {
    static fromBinary(bytes, options) {
        return new ProposalSummary().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposalSummary().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposalSummary().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposalSummary, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string proposal_project_id = 1;
   */ _define_property(this, "proposalProjectId", ""), /**
   * @generated from field: string source_capture_project_id = 2;
   */ _define_property(this, "sourceCaptureProjectId", ""), /**
   * mirrors proposal_project_id (zou dual-id)
   *
   * @generated from field: string zou_project_id = 3;
   */ _define_property(this, "zouProjectId", ""), /**
   * @generated from field: string tenant_id = 4;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string name = 5;
   */ _define_property(this, "name", ""), /**
   * SAD-521: the proposal's own source + access (independent of the pursuit).
   *
   * pursuit | direct | legacy_conversion
   *
   * @generated from field: string source_kind = 6;
   */ _define_property(this, "sourceKind", ""), /**
   * @generated from field: string owner_user_id = 7;
   */ _define_property(this, "ownerUserId", ""), /**
   * e.g. proposal_members
   *
   * @generated from field: string access_mode = 8;
   */ _define_property(this, "accessMode", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposalSummary, "runtime", proto3);
_define_property(ProposalSummary, "typeName", "mono.projectdata.v1.ProposalSummary");
_define_property(ProposalSummary, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "proposal_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "source_capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "zou_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "source_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "owner_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "access_mode",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpsertPreAwardReadinessRequest
 */ export class UpsertPreAwardReadinessRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertPreAwardReadinessRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertPreAwardReadinessRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertPreAwardReadinessRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertPreAwardReadinessRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string pre_award_project_id = 1;
   */ _define_property(this, "preAwardProjectId", ""), /**
   * Staffing|Financial|Subcontractor|Schedule|Governance|Customer|Artifacts|Risk
   *
   * @generated from field: string area = 2;
   */ _define_property(this, "area", ""), /**
   * NotStarted|InProgress|Ready|Blocked
   *
   * @generated from field: string status = 3;
   */ _define_property(this, "status", ""), /**
   * area-specific shape, validated app-side
   *
   * @generated from field: string data_json = 4;
   */ _define_property(this, "dataJson", ""), /**
   * @generated from field: string user_id = 5;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 6;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertPreAwardReadinessRequest, "runtime", proto3);
_define_property(UpsertPreAwardReadinessRequest, "typeName", "mono.projectdata.v1.UpsertPreAwardReadinessRequest");
_define_property(UpsertPreAwardReadinessRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "pre_award_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "area",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "data_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpsertPreAwardReadinessResponse
 */ export class UpsertPreAwardReadinessResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertPreAwardReadinessResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertPreAwardReadinessResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertPreAwardReadinessResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertPreAwardReadinessResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.PreAwardReadinessAreaStatus readiness = 1;
   */ _define_property(this, "readiness", void 0), /**
   * @generated from field: bool created = 2;
   */ _define_property(this, "created", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertPreAwardReadinessResponse, "runtime", proto3);
_define_property(UpsertPreAwardReadinessResponse, "typeName", "mono.projectdata.v1.UpsertPreAwardReadinessResponse");
_define_property(UpsertPreAwardReadinessResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "readiness",
            kind: "message",
            T: PreAwardReadinessAreaStatus
        },
        {
            no: 2,
            name: "created",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetPreAwardWorkspaceRequest
 */ export class GetPreAwardWorkspaceRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetPreAwardWorkspaceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPreAwardWorkspaceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPreAwardWorkspaceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPreAwardWorkspaceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string pre_award_project_id = 1;
   */ _define_property(this, "preAwardProjectId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 3;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetPreAwardWorkspaceRequest, "runtime", proto3);
_define_property(GetPreAwardWorkspaceRequest, "typeName", "mono.projectdata.v1.GetPreAwardWorkspaceRequest");
_define_property(GetPreAwardWorkspaceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "pre_award_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetPreAwardWorkspaceResponse
 */ export class GetPreAwardWorkspaceResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetPreAwardWorkspaceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPreAwardWorkspaceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPreAwardWorkspaceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPreAwardWorkspaceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.PreAwardSummary summary = 1;
   */ _define_property(this, "summary", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetPreAwardWorkspaceResponse, "runtime", proto3);
_define_property(GetPreAwardWorkspaceResponse, "typeName", "mono.projectdata.v1.GetPreAwardWorkspaceResponse");
_define_property(GetPreAwardWorkspaceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "summary",
            kind: "message",
            T: PreAwardSummary
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetBidBaselineRequest
 */ export class GetBidBaselineRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetBidBaselineRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetBidBaselineRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetBidBaselineRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetBidBaselineRequest, a, b);
    }
    constructor(data){
        super(), /**
   * Identity is taken from the gateway principal, never the request — this RPC
   * scopes on the pre-award's own tenant, so it deliberately carries no
   * user_id/company_id that a caller could spoof to widen the read.
   *
   * authz scope + baseline-id source
   *
   * @generated from field: string pre_award_project_id = 1;
   */ _define_property(this, "preAwardProjectId", ""), /**
   * nonnegative; newest first
   *
   * @generated from field: int32 history_offset = 2;
   */ _define_property(this, "historyOffset", 0), /**
   * defaults to 20, maximum 100
   *
   * @generated from field: int32 history_limit = 3;
   */ _define_property(this, "historyLimit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetBidBaselineRequest, "runtime", proto3);
_define_property(GetBidBaselineRequest, "typeName", "mono.projectdata.v1.GetBidBaselineRequest");
_define_property(GetBidBaselineRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "pre_award_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "history_offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "history_limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetBidBaselineResponse
 */ export class GetBidBaselineResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetBidBaselineResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetBidBaselineResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetBidBaselineResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetBidBaselineResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.BidBaselineView baseline = 1;
   */ _define_property(this, "baseline", void 0), /**
   * newest first; receiving authorization
   *
   * @generated from field: repeated mono.projectdata.v1.BidBaselineView handoff_history = 2;
   */ _define_property(this, "handoffHistory", []), /**
   * @generated from field: int64 history_total = 3;
   */ _define_property(this, "historyTotal", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetBidBaselineResponse, "runtime", proto3);
_define_property(GetBidBaselineResponse, "typeName", "mono.projectdata.v1.GetBidBaselineResponse");
_define_property(GetBidBaselineResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "baseline",
            kind: "message",
            T: BidBaselineView
        },
        {
            no: 2,
            name: "handoff_history",
            kind: "message",
            T: BidBaselineView,
            repeated: true
        },
        {
            no: 3,
            name: "history_total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * BidBaselineView — read-only projection of the frozen pangaea BidBaseline
 * the Pre-Award workspace renders. `frozen_at` is a pre-formatted RFC3339
 * string (empty when unset) so the browser doesn't carry a protobuf
 * Timestamp through the snapshot screen. The *_json fields pass through
 * pangaea's stored JSON verbatim; the UI parses them client-side.
 *
 * @generated from message mono.projectdata.v1.BidBaselineView
 */ export class BidBaselineView extends Message {
    static fromBinary(bytes, options) {
        return new BidBaselineView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BidBaselineView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BidBaselineView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BidBaselineView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string proposal_project_id = 2;
   */ _define_property(this, "proposalProjectId", ""), /**
   * @generated from field: int32 version = 3;
   */ _define_property(this, "version", 0), /**
   * @generated from field: string frozen_at = 4;
   */ _define_property(this, "frozenAt", ""), /**
   * @generated from field: string frozen_by = 5;
   */ _define_property(this, "frozenBy", ""), /**
   * @generated from field: string technical_commitments_json = 6;
   */ _define_property(this, "technicalCommitmentsJson", ""), /**
   * @generated from field: string staffing_plan_json = 7;
   */ _define_property(this, "staffingPlanJson", ""), /**
   * @generated from field: string pricing_baseline_json = 8;
   */ _define_property(this, "pricingBaselineJson", ""), /**
   * @generated from field: string planned_deliverables_json = 9;
   */ _define_property(this, "plannedDeliverablesJson", ""), /**
   * @generated from field: string assumptions_json = 10;
   */ _define_property(this, "assumptionsJson", ""), /**
   * @generated from field: repeated string source_artifact_ids = 11;
   */ _define_property(this, "sourceArtifactIds", []), /**
   * @generated from field: string submission_id = 12;
   */ _define_property(this, "submissionId", ""), /**
   * @generated from field: string pre_award_project_id = 13;
   */ _define_property(this, "preAwardProjectId", ""), /**
   * @generated from field: string submission_snapshot_json = 14;
   */ _define_property(this, "submissionSnapshotJson", ""), /**
   * @generated from field: string pricing_version_id = 15;
   */ _define_property(this, "pricingVersionId", ""), /**
   * @generated from field: string staffing_version_id = 16;
   */ _define_property(this, "staffingVersionId", ""), /**
   * @generated from field: string solicitation_version_id = 17;
   */ _define_property(this, "solicitationVersionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(BidBaselineView, "runtime", proto3);
_define_property(BidBaselineView, "typeName", "mono.projectdata.v1.BidBaselineView");
_define_property(BidBaselineView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "proposal_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "frozen_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "frozen_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "technical_commitments_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "staffing_plan_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "pricing_baseline_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "planned_deliverables_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "assumptions_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "source_artifact_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 12,
            name: "submission_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "pre_award_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "submission_snapshot_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "pricing_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "staffing_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "solicitation_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * AwardComparisonDiscrepancy — UI-facing projection of one pangaea
 * DiscrepancyRecord row produced by BeginAwardComparison. Keeps the
 * fields the discrepancy table reads in a single round-trip; full
 * DiscrepancyRecord lookups go through pangaea's
 * `DiscrepancyRecordRepository.List`.
 *
 * @generated from message mono.projectdata.v1.AwardComparisonDiscrepancy
 */ export class AwardComparisonDiscrepancy extends Message {
    static fromBinary(bytes, options) {
        return new AwardComparisonDiscrepancy().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AwardComparisonDiscrepancy().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AwardComparisonDiscrepancy().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AwardComparisonDiscrepancy, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string change_set_id = 2;
   */ _define_property(this, "changeSetId", ""), /**
   * ScopePws|Deliverables|PricingFunding|StaffingKeyPersonnel|VehicleTaskOrder|SubkAtp|DatesCalendar|CustomerPocs|ComplianceReporting
   *
   * @generated from field: string comparison_area = 3;
   */ _define_property(this, "comparisonArea", ""), /**
   * @generated from field: string target_sds_record_type = 4;
   */ _define_property(this, "targetSdsRecordType", ""), /**
   * @generated from field: string target_record_locator_json = 5;
   */ _define_property(this, "targetRecordLocatorJson", ""), /**
   * @generated from field: string baseline_value_json = 6;
   */ _define_property(this, "baselineValueJson", ""), /**
   * @generated from field: string final_contract_value_json = 7;
   */ _define_property(this, "finalContractValueJson", ""), /**
   * @generated from field: string proposed_value_json = 8;
   */ _define_property(this, "proposedValueJson", ""), /**
   * Informational|Moderate|High|Blocking
   *
   * @generated from field: string severity = 9;
   */ _define_property(this, "severity", ""), /**
   * Delivery|Contracts|Finance|Subcontracts|HrOnboarding|Quality|Deliverables|GrowthHandoff
   *
   * @generated from field: string functional_owner = 10;
   */ _define_property(this, "functionalOwner", ""), /**
   * Open after BeginAwardComparison
   *
   * @generated from field: string resolution_state = 11;
   */ _define_property(this, "resolutionState", ""), /**
   * human-readable summary attached by the rule pack
   *
   * @generated from field: string narrative = 12;
   */ _define_property(this, "narrative", ""), /**
   * Side-by-side source provenance (modification review): resolved from the
   * item's before/after source references — the document (pipeline doc id),
   * page, and block span in each. Empty when the extraction recorded no refs.
   *
   * @generated from field: string source_before_artifact_id = 13;
   */ _define_property(this, "sourceBeforeArtifactId", ""), /**
   * @generated from field: int32 source_before_page = 14;
   */ _define_property(this, "sourceBeforePage", 0), /**
   * e.g. {"blockId":"/page/4/Table/2"}
   *
   * @generated from field: string source_before_span = 15;
   */ _define_property(this, "sourceBeforeSpan", ""), /**
   * @generated from field: string source_after_artifact_id = 16;
   */ _define_property(this, "sourceAfterArtifactId", ""), /**
   * @generated from field: int32 source_after_page = 17;
   */ _define_property(this, "sourceAfterPage", 0), /**
   * @generated from field: string source_after_span = 18;
   */ _define_property(this, "sourceAfterSpan", ""), /**
   * Resolved source reference's verbatim quote plus extractor confidence,
   * surfaced so a reviewer sees provenance DURING review rather than only
   * after apply. Empty/zero when the extraction recorded no ref.
   *
   * @generated from field: string source_before_quote = 19;
   */ _define_property(this, "sourceBeforeQuote", ""), /**
   * @generated from field: double source_before_confidence = 20;
   */ _define_property(this, "sourceBeforeConfidence", 0), /**
   * @generated from field: string source_after_quote = 21;
   */ _define_property(this, "sourceAfterQuote", ""), /**
   * @generated from field: double source_after_confidence = 22;
   */ _define_property(this, "sourceAfterConfidence", 0), /**
   * Set when the row is a review item (D93): decoded from the change item's
   * impact_json.review.
   *
   * @generated from field: mono.common.v1.ReviewItem review = 23;
   */ _define_property(this, "review", void 0), /**
   * Whether accepting this review item writes its value back
   * (reviewitem.SettleWritable, the table pangaea's strict apply refuses
   * by): the UI offers Accept only when it is set.
   *
   * @generated from field: bool review_settle_write = 24;
   */ _define_property(this, "reviewSettleWrite", false), /**
   * Whether accepting this row is an acknowledgement only
   * (reviewitem.AcknowledgeOnly): the comparison is recorded as Acknowledged
   * and nothing is written to the contract. The UI's Accept reads
   * "Acknowledge".
   *
   * @generated from field: bool acknowledges = 25;
   */ _define_property(this, "acknowledges", false), /**
   * Whether this row settles only with the reviewer's own value
   * (reviewitem.AwardCorrectOnly): its staged value is missing or impossible,
   * so accepting it as staged refuses and the UI offers Correct or Leave
   * blank only.
   *
   * @generated from field: bool correct_only = 26;
   */ _define_property(this, "correctOnly", false), /**
   * Whether this ordinary change item has no writer in pangaea's apply
   * (reviewitem.ChangeWritable, the table strict apply refuses by, SAD-700):
   * its target type, field, set type or missing target lands nowhere, so
   * accepting it would refuse at commit. The UI offers Leave blank only, and
   * Approve all skips it. Never set on a review item (review_settle_write
   * answers those) or an acknowledge-only row.
   *
   * @generated from field: bool no_writer = 27;
   */ _define_property(this, "noWriter", false), /**
   * The value a settled row's decision writes (the change item's
   * approved_value_json), so a reviewer reads what will be written, not only
   * that it was accepted. Empty while open, and for a decision that writes
   * nothing.
   *
   * @generated from field: string decided_value_json = 28;
   */ _define_property(this, "decidedValueJson", ""), /**
   * Why it was settled (the change item's decision_rationale): the
   * reviewer's pick, or the code or later document that settled it.
   *
   * @generated from field: string decision_rationale = 29;
   */ _define_property(this, "decisionRationale", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AwardComparisonDiscrepancy, "runtime", proto3);
_define_property(AwardComparisonDiscrepancy, "typeName", "mono.projectdata.v1.AwardComparisonDiscrepancy");
_define_property(AwardComparisonDiscrepancy, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "comparison_area",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "target_sds_record_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "target_record_locator_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "baseline_value_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "final_contract_value_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "proposed_value_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "severity",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "functional_owner",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "resolution_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "narrative",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "source_before_artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "source_before_page",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 15,
            name: "source_before_span",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "source_after_artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "source_after_page",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 18,
            name: "source_after_span",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "source_before_quote",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "source_before_confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 21,
            name: "source_after_quote",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 22,
            name: "source_after_confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 23,
            name: "review",
            kind: "message",
            T: ReviewItem
        },
        {
            no: 24,
            name: "review_settle_write",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 25,
            name: "acknowledges",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 26,
            name: "correct_only",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 27,
            name: "no_writer",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 28,
            name: "decided_value_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 29,
            name: "decision_rationale",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.AwardComparisonSummary
 */ export class AwardComparisonSummary extends Message {
    static fromBinary(bytes, options) {
        return new AwardComparisonSummary().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AwardComparisonSummary().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AwardComparisonSummary().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AwardComparisonSummary, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string change_set_id = 1;
   */ _define_property(this, "changeSetId", ""), /**
   * @generated from field: string pre_award_project_id = 2;
   */ _define_property(this, "preAwardProjectId", ""), /**
   * Draft after BeginAwardComparison
   *
   * @generated from field: string state = 3;
   */ _define_property(this, "state", ""), /**
   * @generated from field: int32 discrepancy_count = 4;
   */ _define_property(this, "discrepancyCount", 0), /**
   * Discrepancies with severity=Blocking
   *
   * @generated from field: int32 blocking_count = 5;
   */ _define_property(this, "blockingCount", 0), /**
   * @generated from field: repeated mono.projectdata.v1.AwardComparisonDiscrepancy discrepancies = 6;
   */ _define_property(this, "discrepancies", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AwardComparisonSummary, "runtime", proto3);
_define_property(AwardComparisonSummary, "typeName", "mono.projectdata.v1.AwardComparisonSummary");
_define_property(AwardComparisonSummary, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "pre_award_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "discrepancy_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "blocking_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "discrepancies",
            kind: "message",
            T: AwardComparisonDiscrepancy,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.BeginAwardComparisonRequest
 */ export class BeginAwardComparisonRequest extends Message {
    static fromBinary(bytes, options) {
        return new BeginAwardComparisonRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BeginAwardComparisonRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BeginAwardComparisonRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BeginAwardComparisonRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string pre_award_project_id = 1;
   */ _define_property(this, "preAwardProjectId", ""), /**
   * Legacy/fallback path: a fully-extracted awarded contract supplied by the
   * caller (the original Phase 0b stub). When award_doc_id is set this is
   * ignored — zou extracts server-side instead (Phase 4d award intake).
   *
   * @generated from field: mono.contractintel.v1.AwardedContractData awarded_contract = 2;
   */ _define_property(this, "awardedContract", void 0), /**
   * Source PDF artifact ids the awarded_contract was extracted from.
   * Persisted on the change_set so reviewers can jump back to the source.
   *
   * @generated from field: repeated string award_artifact_ids = 3;
   */ _define_property(this, "awardArtifactIds", []), /**
   * @generated from field: string user_id = 4;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 5;
   */ _define_property(this, "companyId", ""), /**
   * Phase 4d award intake: the zou attachment id of the uploaded award
   * document (the value UploadProjectFiles returns). When set, zou resolves
   * that attachment's baltigo doc id, runs baltigo ExtractAwardedContractV2
   * server-side against its processed blocks, persists the per-value
   * source_references, and compares off the real extraction rather than the
   * awarded_contract stub above. The document must already be processed.
   *
   * @generated from field: string award_doc_id = 6;
   */ _define_property(this, "awardDocId", ""), /**
   * @generated from field: bool skip_extraction_cache = 7;
   */ _define_property(this, "skipExtractionCache", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(BeginAwardComparisonRequest, "runtime", proto3);
_define_property(BeginAwardComparisonRequest, "typeName", "mono.projectdata.v1.BeginAwardComparisonRequest");
_define_property(BeginAwardComparisonRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "pre_award_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "awarded_contract",
            kind: "message",
            T: AwardedContractData
        },
        {
            no: 3,
            name: "award_artifact_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 4,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "award_doc_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "skip_extraction_cache",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.BeginAwardComparisonResponse
 */ export class BeginAwardComparisonResponse extends Message {
    static fromBinary(bytes, options) {
        return new BeginAwardComparisonResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BeginAwardComparisonResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BeginAwardComparisonResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BeginAwardComparisonResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.AwardComparisonSummary summary = 1;
   */ _define_property(this, "summary", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(BeginAwardComparisonResponse, "runtime", proto3);
_define_property(BeginAwardComparisonResponse, "typeName", "mono.projectdata.v1.BeginAwardComparisonResponse");
_define_property(BeginAwardComparisonResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "summary",
            kind: "message",
            T: AwardComparisonSummary
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.StartAwardComparisonRequest
 */ export class StartAwardComparisonRequest extends Message {
    static fromBinary(bytes, options) {
        return new StartAwardComparisonRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StartAwardComparisonRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StartAwardComparisonRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StartAwardComparisonRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string pre_award_project_id = 1;
   */ _define_property(this, "preAwardProjectId", ""), /**
   * @generated from field: string award_doc_id = 2;
   */ _define_property(this, "awardDocId", ""), /**
   * @generated from field: repeated string award_artifact_ids = 3;
   */ _define_property(this, "awardArtifactIds", []), /**
   * @generated from field: bool skip_extraction_cache = 4;
   */ _define_property(this, "skipExtractionCache", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(StartAwardComparisonRequest, "runtime", proto3);
_define_property(StartAwardComparisonRequest, "typeName", "mono.projectdata.v1.StartAwardComparisonRequest");
_define_property(StartAwardComparisonRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "pre_award_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "award_doc_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "award_artifact_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 4,
            name: "skip_extraction_cache",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.StartAwardComparisonResponse
 */ export class StartAwardComparisonResponse extends Message {
    static fromBinary(bytes, options) {
        return new StartAwardComparisonResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StartAwardComparisonResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StartAwardComparisonResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StartAwardComparisonResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.intelligence.v1.IntelligenceRun run = 1;
   */ _define_property(this, "run", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(StartAwardComparisonResponse, "runtime", proto3);
_define_property(StartAwardComparisonResponse, "typeName", "mono.projectdata.v1.StartAwardComparisonResponse");
_define_property(StartAwardComparisonResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "run",
            kind: "message",
            T: IntelligenceRun
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetAwardComparisonRunRequest
 */ export class GetAwardComparisonRunRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetAwardComparisonRunRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetAwardComparisonRunRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetAwardComparisonRunRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetAwardComparisonRunRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string pre_award_project_id = 1;
   */ _define_property(this, "preAwardProjectId", ""), /**
   * Empty selects the most recent run for this workspace.
   *
   * @generated from field: string run_id = 2;
   */ _define_property(this, "runId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetAwardComparisonRunRequest, "runtime", proto3);
_define_property(GetAwardComparisonRunRequest, "typeName", "mono.projectdata.v1.GetAwardComparisonRunRequest");
_define_property(GetAwardComparisonRunRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "pre_award_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "run_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetAwardComparisonRunResponse
 */ export class GetAwardComparisonRunResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetAwardComparisonRunResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetAwardComparisonRunResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetAwardComparisonRunResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetAwardComparisonRunResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.intelligence.v1.IntelligenceRun run = 1;
   */ _define_property(this, "run", void 0), /**
   * Remains available while a newer extraction runs, fails, or is cancelled.
   *
   * @generated from field: string last_completed_change_set_id = 2;
   */ _define_property(this, "lastCompletedChangeSetId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetAwardComparisonRunResponse, "runtime", proto3);
_define_property(GetAwardComparisonRunResponse, "typeName", "mono.projectdata.v1.GetAwardComparisonRunResponse");
_define_property(GetAwardComparisonRunResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "run",
            kind: "message",
            T: IntelligenceRun
        },
        {
            no: 2,
            name: "last_completed_change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CancelAwardComparisonRunRequest
 */ export class CancelAwardComparisonRunRequest extends Message {
    static fromBinary(bytes, options) {
        return new CancelAwardComparisonRunRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CancelAwardComparisonRunRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CancelAwardComparisonRunRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CancelAwardComparisonRunRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string pre_award_project_id = 1;
   */ _define_property(this, "preAwardProjectId", ""), /**
   * @generated from field: string run_id = 2;
   */ _define_property(this, "runId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CancelAwardComparisonRunRequest, "runtime", proto3);
_define_property(CancelAwardComparisonRunRequest, "typeName", "mono.projectdata.v1.CancelAwardComparisonRunRequest");
_define_property(CancelAwardComparisonRunRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "pre_award_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "run_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CancelAwardComparisonRunResponse
 */ export class CancelAwardComparisonRunResponse extends Message {
    static fromBinary(bytes, options) {
        return new CancelAwardComparisonRunResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CancelAwardComparisonRunResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CancelAwardComparisonRunResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CancelAwardComparisonRunResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.intelligence.v1.IntelligenceRun run = 1;
   */ _define_property(this, "run", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CancelAwardComparisonRunResponse, "runtime", proto3);
_define_property(CancelAwardComparisonRunResponse, "typeName", "mono.projectdata.v1.CancelAwardComparisonRunResponse");
_define_property(CancelAwardComparisonRunResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "run",
            kind: "message",
            T: IntelligenceRun
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListChangeSetDiscrepanciesRequest
 */ export class ListChangeSetDiscrepanciesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListChangeSetDiscrepanciesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListChangeSetDiscrepanciesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListChangeSetDiscrepanciesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListChangeSetDiscrepanciesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string change_set_id = 1;
   */ _define_property(this, "changeSetId", ""), /**
   * Optional filters; empty values are ignored. Useful for the
   * "Open only" / "Blocking only" UI pills.
   *
   * Informational|Moderate|High|Blocking
   *
   * @generated from field: string severity = 2;
   */ _define_property(this, "severity", ""), /**
   * Open|Accepted|Corrected|...
   *
   * @generated from field: string resolution_state = 3;
   */ _define_property(this, "resolutionState", ""), /**
   * ScopePws|Deliverables|...
   *
   * @generated from field: string comparison_area = 4;
   */ _define_property(this, "comparisonArea", ""), /**
   * @generated from field: string functional_owner = 5;
   */ _define_property(this, "functionalOwner", ""), /**
   * @generated from field: string user_id = 6;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 7;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListChangeSetDiscrepanciesRequest, "runtime", proto3);
_define_property(ListChangeSetDiscrepanciesRequest, "typeName", "mono.projectdata.v1.ListChangeSetDiscrepanciesRequest");
_define_property(ListChangeSetDiscrepanciesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "severity",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "resolution_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "comparison_area",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "functional_owner",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListChangeSetDiscrepanciesResponse
 */ export class ListChangeSetDiscrepanciesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListChangeSetDiscrepanciesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListChangeSetDiscrepanciesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListChangeSetDiscrepanciesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListChangeSetDiscrepanciesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.AwardComparisonSummary summary = 1;
   */ _define_property(this, "summary", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListChangeSetDiscrepanciesResponse, "runtime", proto3);
_define_property(ListChangeSetDiscrepanciesResponse, "typeName", "mono.projectdata.v1.ListChangeSetDiscrepanciesResponse");
_define_property(ListChangeSetDiscrepanciesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "summary",
            kind: "message",
            T: AwardComparisonSummary
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ResolveDiscrepancyRequest
 */ export class ResolveDiscrepancyRequest extends Message {
    static fromBinary(bytes, options) {
        return new ResolveDiscrepancyRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResolveDiscrepancyRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResolveDiscrepancyRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResolveDiscrepancyRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string discrepancy_id = 1;
   */ _define_property(this, "discrepancyId", ""), /**
   * Reviewer decision. Must be one of: Accepted, Corrected, Clarified,
   * Waived, Rejected, Escalated, Resolved. Validated handler-side.
   *
   * @generated from field: string resolution_state = 2;
   */ _define_property(this, "resolutionState", ""), /**
   * @generated from field: string decision_rationale = 3;
   */ _define_property(this, "decisionRationale", ""), /**
   * Optional: the actual decided value (free-form JSON) when the
   * reviewer overrides both baseline and awarded. Stored on the
   * DiscrepancyRecord as `decided_value_json` for future lineage writes.
   *
   * @generated from field: string decided_value_json = 4;
   */ _define_property(this, "decidedValueJson", ""), /**
   * @generated from field: string user_id = 5;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 6;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResolveDiscrepancyRequest, "runtime", proto3);
_define_property(ResolveDiscrepancyRequest, "typeName", "mono.projectdata.v1.ResolveDiscrepancyRequest");
_define_property(ResolveDiscrepancyRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "discrepancy_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "resolution_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "decision_rationale",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "decided_value_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ResolveDiscrepancyResponse
 */ export class ResolveDiscrepancyResponse extends Message {
    static fromBinary(bytes, options) {
        return new ResolveDiscrepancyResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResolveDiscrepancyResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResolveDiscrepancyResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResolveDiscrepancyResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.AwardComparisonDiscrepancy discrepancy = 1;
   */ _define_property(this, "discrepancy", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResolveDiscrepancyResponse, "runtime", proto3);
_define_property(ResolveDiscrepancyResponse, "typeName", "mono.projectdata.v1.ResolveDiscrepancyResponse");
_define_property(ResolveDiscrepancyResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "discrepancy",
            kind: "message",
            T: AwardComparisonDiscrepancy
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RouteDiscrepancyRequest
 */ export class RouteDiscrepancyRequest extends Message {
    static fromBinary(bytes, options) {
        return new RouteDiscrepancyRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RouteDiscrepancyRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RouteDiscrepancyRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RouteDiscrepancyRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string discrepancy_id = 1;
   */ _define_property(this, "discrepancyId", ""), /**
   * New owner — Delivery|Contracts|Finance|Subcontracts|HrOnboarding|
   * Quality|Deliverables|GrowthHandoff. Empty value rejected.
   *
   * @generated from field: string functional_owner = 2;
   */ _define_property(this, "functionalOwner", ""), /**
   * @generated from field: string user_id = 3;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 4;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RouteDiscrepancyRequest, "runtime", proto3);
_define_property(RouteDiscrepancyRequest, "typeName", "mono.projectdata.v1.RouteDiscrepancyRequest");
_define_property(RouteDiscrepancyRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "discrepancy_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "functional_owner",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RouteDiscrepancyResponse
 */ export class RouteDiscrepancyResponse extends Message {
    static fromBinary(bytes, options) {
        return new RouteDiscrepancyResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RouteDiscrepancyResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RouteDiscrepancyResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RouteDiscrepancyResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.AwardComparisonDiscrepancy discrepancy = 1;
   */ _define_property(this, "discrepancy", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RouteDiscrepancyResponse, "runtime", proto3);
_define_property(RouteDiscrepancyResponse, "typeName", "mono.projectdata.v1.RouteDiscrepancyResponse");
_define_property(RouteDiscrepancyResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "discrepancy",
            kind: "message",
            T: AwardComparisonDiscrepancy
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SetDiscrepancyTargetPeriodRequest
 */ export class SetDiscrepancyTargetPeriodRequest extends Message {
    static fromBinary(bytes, options) {
        return new SetDiscrepancyTargetPeriodRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetDiscrepancyTargetPeriodRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetDiscrepancyTargetPeriodRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetDiscrepancyTargetPeriodRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string discrepancy_id = 1;
   */ _define_property(this, "discrepancyId", ""), /**
   * delivery.periods_of_performance row id, for a PeriodOfPerformance item.
   * Exactly one of period_id and target_object_id is set.
   *
   * @generated from field: string period_id = 2;
   */ _define_property(this, "periodId", ""), /**
   * @generated from field: string user_id = 3;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 4;
   */ _define_property(this, "companyId", ""), /**
   * The row a ContractCLIN or OptionalTask item (or a PeriodOfPerformance
   * one) applies to: a delivery.contract_clins or delivery.optional_tasks row
   * id (RI-3b1).
   *
   * @generated from field: string target_object_id = 5;
   */ _define_property(this, "targetObjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetDiscrepancyTargetPeriodRequest, "runtime", proto3);
_define_property(SetDiscrepancyTargetPeriodRequest, "typeName", "mono.projectdata.v1.SetDiscrepancyTargetPeriodRequest");
_define_property(SetDiscrepancyTargetPeriodRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "discrepancy_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "period_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "target_object_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SetDiscrepancyTargetPeriodResponse
 */ export class SetDiscrepancyTargetPeriodResponse extends Message {
    static fromBinary(bytes, options) {
        return new SetDiscrepancyTargetPeriodResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetDiscrepancyTargetPeriodResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetDiscrepancyTargetPeriodResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetDiscrepancyTargetPeriodResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.AwardComparisonDiscrepancy discrepancy = 1;
   */ _define_property(this, "discrepancy", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetDiscrepancyTargetPeriodResponse, "runtime", proto3);
_define_property(SetDiscrepancyTargetPeriodResponse, "typeName", "mono.projectdata.v1.SetDiscrepancyTargetPeriodResponse");
_define_property(SetDiscrepancyTargetPeriodResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "discrepancy",
            kind: "message",
            T: AwardComparisonDiscrepancy
        }
    ]));
/**
 * OciFlag — a raised conflict-of-interest flag on a project.
 *
 * @generated from message mono.projectdata.v1.OciFlag
 */ export class OciFlag extends Message {
    static fromBinary(bytes, options) {
        return new OciFlag().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OciFlag().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OciFlag().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OciFlag, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string signal_kind = 3;
   */ _define_property(this, "signalKind", ""), /**
   * @generated from field: string title = 4;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string description = 5;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string source_refs_json = 6;
   */ _define_property(this, "sourceRefsJson", ""), /**
   * open|routed|mitigating|cleared|waived
   *
   * @generated from field: string status = 7;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string functional_owner = 8;
   */ _define_property(this, "functionalOwner", ""), /**
   * @generated from field: string raised_by_user_id = 9;
   */ _define_property(this, "raisedByUserId", ""), /**
   * @generated from field: string routed_to_user_id = 10;
   */ _define_property(this, "routedToUserId", ""), /**
   * @generated from field: string decided_by_user_id = 11;
   */ _define_property(this, "decidedByUserId", ""), /**
   * @generated from field: string decision_reason = 12;
   */ _define_property(this, "decisionReason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(OciFlag, "runtime", proto3);
_define_property(OciFlag, "typeName", "mono.projectdata.v1.OciFlag");
_define_property(OciFlag, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "signal_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "source_refs_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "functional_owner",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "raised_by_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "routed_to_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "decided_by_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "decision_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * OciMitigation — the firewall plan resolving a flag.
 *
 * @generated from message mono.projectdata.v1.OciMitigation
 */ export class OciMitigation extends Message {
    static fromBinary(bytes, options) {
        return new OciMitigation().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OciMitigation().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OciMitigation().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OciMitigation, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string oci_flag_id = 2;
   */ _define_property(this, "ociFlagId", ""), /**
   * @generated from field: string firewall_plan = 3;
   */ _define_property(this, "firewallPlan", ""), /**
   * @generated from field: repeated string restricted_user_ids = 4;
   */ _define_property(this, "restrictedUserIds", []), /**
   * @generated from field: repeated string restricted_artifact_ids = 5;
   */ _define_property(this, "restrictedArtifactIds", []), /**
   * open|active|closed
   *
   * @generated from field: string status = 6;
   */ _define_property(this, "status", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(OciMitigation, "runtime", proto3);
_define_property(OciMitigation, "typeName", "mono.projectdata.v1.OciMitigation");
_define_property(OciMitigation, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "oci_flag_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "firewall_plan",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "restricted_user_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 5,
            name: "restricted_artifact_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 6,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RaiseOciFlagRequest
 */ export class RaiseOciFlagRequest extends Message {
    static fromBinary(bytes, options) {
        return new RaiseOciFlagRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RaiseOciFlagRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RaiseOciFlagRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RaiseOciFlagRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string signal_kind = 2;
   */ _define_property(this, "signalKind", ""), /**
   * @generated from field: string title = 3;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string description = 4;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string source_refs_json = 5;
   */ _define_property(this, "sourceRefsJson", ""), /**
   * optional initial routing
   *
   * @generated from field: string functional_owner = 6;
   */ _define_property(this, "functionalOwner", ""), /**
   * @generated from field: string user_id = 7;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 8;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RaiseOciFlagRequest, "runtime", proto3);
_define_property(RaiseOciFlagRequest, "typeName", "mono.projectdata.v1.RaiseOciFlagRequest");
_define_property(RaiseOciFlagRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "signal_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "source_refs_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "functional_owner",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RaiseOciFlagResponse
 */ export class RaiseOciFlagResponse extends Message {
    static fromBinary(bytes, options) {
        return new RaiseOciFlagResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RaiseOciFlagResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RaiseOciFlagResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RaiseOciFlagResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.OciFlag oci_flag = 1;
   */ _define_property(this, "ociFlag", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RaiseOciFlagResponse, "runtime", proto3);
_define_property(RaiseOciFlagResponse, "typeName", "mono.projectdata.v1.RaiseOciFlagResponse");
_define_property(RaiseOciFlagResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "oci_flag",
            kind: "message",
            T: OciFlag
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RouteOciFlagRequest
 */ export class RouteOciFlagRequest extends Message {
    static fromBinary(bytes, options) {
        return new RouteOciFlagRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RouteOciFlagRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RouteOciFlagRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RouteOciFlagRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string oci_flag_id = 1;
   */ _define_property(this, "ociFlagId", ""), /**
   * SDS functional owner — same roster as RouteDiscrepancy. Empty rejected.
   *
   * @generated from field: string functional_owner = 2;
   */ _define_property(this, "functionalOwner", ""), /**
   * @generated from field: string user_id = 3;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 4;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RouteOciFlagRequest, "runtime", proto3);
_define_property(RouteOciFlagRequest, "typeName", "mono.projectdata.v1.RouteOciFlagRequest");
_define_property(RouteOciFlagRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "oci_flag_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "functional_owner",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RouteOciFlagResponse
 */ export class RouteOciFlagResponse extends Message {
    static fromBinary(bytes, options) {
        return new RouteOciFlagResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RouteOciFlagResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RouteOciFlagResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RouteOciFlagResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.OciFlag oci_flag = 1;
   */ _define_property(this, "ociFlag", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RouteOciFlagResponse, "runtime", proto3);
_define_property(RouteOciFlagResponse, "typeName", "mono.projectdata.v1.RouteOciFlagResponse");
_define_property(RouteOciFlagResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "oci_flag",
            kind: "message",
            T: OciFlag
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.DecideOciFlagRequest
 */ export class DecideOciFlagRequest extends Message {
    static fromBinary(bytes, options) {
        return new DecideOciFlagRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DecideOciFlagRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DecideOciFlagRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DecideOciFlagRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string oci_flag_id = 1;
   */ _define_property(this, "ociFlagId", ""), /**
   * cleared|waived
   *
   * @generated from field: string decision = 2;
   */ _define_property(this, "decision", ""), /**
   * required
   *
   * @generated from field: string reason = 3;
   */ _define_property(this, "reason", ""), /**
   * @generated from field: string user_id = 4;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 5;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DecideOciFlagRequest, "runtime", proto3);
_define_property(DecideOciFlagRequest, "typeName", "mono.projectdata.v1.DecideOciFlagRequest");
_define_property(DecideOciFlagRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "oci_flag_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "decision",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.DecideOciFlagResponse
 */ export class DecideOciFlagResponse extends Message {
    static fromBinary(bytes, options) {
        return new DecideOciFlagResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DecideOciFlagResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DecideOciFlagResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DecideOciFlagResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.OciFlag oci_flag = 1;
   */ _define_property(this, "ociFlag", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DecideOciFlagResponse, "runtime", proto3);
_define_property(DecideOciFlagResponse, "typeName", "mono.projectdata.v1.DecideOciFlagResponse");
_define_property(DecideOciFlagResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "oci_flag",
            kind: "message",
            T: OciFlag
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListOciFlagsRequest
 */ export class ListOciFlagsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListOciFlagsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListOciFlagsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListOciFlagsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListOciFlagsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 3;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListOciFlagsRequest, "runtime", proto3);
_define_property(ListOciFlagsRequest, "typeName", "mono.projectdata.v1.ListOciFlagsRequest");
_define_property(ListOciFlagsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListOciFlagsResponse
 */ export class ListOciFlagsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListOciFlagsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListOciFlagsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListOciFlagsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListOciFlagsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.OciFlag oci_flags = 1;
   */ _define_property(this, "ociFlags", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListOciFlagsResponse, "runtime", proto3);
_define_property(ListOciFlagsResponse, "typeName", "mono.projectdata.v1.ListOciFlagsResponse");
_define_property(ListOciFlagsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "oci_flags",
            kind: "message",
            T: OciFlag,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.OpenOciMitigationRequest
 */ export class OpenOciMitigationRequest extends Message {
    static fromBinary(bytes, options) {
        return new OpenOciMitigationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OpenOciMitigationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OpenOciMitigationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OpenOciMitigationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string oci_flag_id = 1;
   */ _define_property(this, "ociFlagId", ""), /**
   * @generated from field: string firewall_plan = 2;
   */ _define_property(this, "firewallPlan", ""), /**
   * @generated from field: repeated string restricted_user_ids = 3;
   */ _define_property(this, "restrictedUserIds", []), /**
   * @generated from field: repeated string restricted_artifact_ids = 4;
   */ _define_property(this, "restrictedArtifactIds", []), /**
   * @generated from field: string user_id = 5;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 6;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(OpenOciMitigationRequest, "runtime", proto3);
_define_property(OpenOciMitigationRequest, "typeName", "mono.projectdata.v1.OpenOciMitigationRequest");
_define_property(OpenOciMitigationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "oci_flag_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "firewall_plan",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "restricted_user_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 4,
            name: "restricted_artifact_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 5,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.OpenOciMitigationResponse
 */ export class OpenOciMitigationResponse extends Message {
    static fromBinary(bytes, options) {
        return new OpenOciMitigationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OpenOciMitigationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OpenOciMitigationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OpenOciMitigationResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.OciMitigation oci_mitigation = 1;
   */ _define_property(this, "ociMitigation", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(OpenOciMitigationResponse, "runtime", proto3);
_define_property(OpenOciMitigationResponse, "typeName", "mono.projectdata.v1.OpenOciMitigationResponse");
_define_property(OpenOciMitigationResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "oci_mitigation",
            kind: "message",
            T: OciMitigation
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ProtestWatch
 */ export class ProtestWatch extends Message {
    static fromBinary(bytes, options) {
        return new ProtestWatch().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProtestWatch().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProtestWatch().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProtestWatch, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: google.protobuf.Timestamp award_notice_date = 3;
   */ _define_property(this, "awardNoticeDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp debrief_date = 4;
   */ _define_property(this, "debriefDate", void 0), /**
   * debrief + 10 days (server-computed)
   *
   * @generated from field: google.protobuf.Timestamp awareness_window_end = 5;
   */ _define_property(this, "awarenessWindowEnd", void 0), /**
   * low|medium|high
   *
   * @generated from field: string protest_likelihood = 6;
   */ _define_property(this, "protestLikelihood", ""), /**
   * @generated from field: string competitor_posture = 7;
   */ _define_property(this, "competitorPosture", ""), /**
   * @generated from field: string delivery_impact = 8;
   */ _define_property(this, "deliveryImpact", ""), /**
   * @generated from field: string status = 9;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string notes = 10;
   */ _define_property(this, "notes", ""), /**
   * @generated from field: string opened_by_user_id = 11;
   */ _define_property(this, "openedByUserId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProtestWatch, "runtime", proto3);
_define_property(ProtestWatch, "typeName", "mono.projectdata.v1.ProtestWatch");
_define_property(ProtestWatch, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "award_notice_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 4,
            name: "debrief_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "awareness_window_end",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "protest_likelihood",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "competitor_posture",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "delivery_impact",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "opened_by_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.PublicProtestDecision
 */ export class PublicProtestDecision extends Message {
    static fromBinary(bytes, options) {
        return new PublicProtestDecision().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PublicProtestDecision().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PublicProtestDecision().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PublicProtestDecision, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string protest_watch_id = 2;
   */ _define_property(this, "protestWatchId", ""), /**
   * @generated from field: string docket_number = 3;
   */ _define_property(this, "docketNumber", ""), /**
   * @generated from field: string agency = 4;
   */ _define_property(this, "agency", ""), /**
   * @generated from field: string protester = 5;
   */ _define_property(this, "protester", ""), /**
   * @generated from field: string awardee = 6;
   */ _define_property(this, "awardee", ""), /**
   * @generated from field: string outcome = 7;
   */ _define_property(this, "outcome", ""), /**
   * @generated from field: google.protobuf.Timestamp decision_date = 8;
   */ _define_property(this, "decisionDate", void 0), /**
   * @generated from field: string corrective_action_pattern = 9;
   */ _define_property(this, "correctiveActionPattern", ""), /**
   * @generated from field: string public_summary = 10;
   */ _define_property(this, "publicSummary", ""), /**
   * @generated from field: string source_url = 11;
   */ _define_property(this, "sourceUrl", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PublicProtestDecision, "runtime", proto3);
_define_property(PublicProtestDecision, "typeName", "mono.projectdata.v1.PublicProtestDecision");
_define_property(PublicProtestDecision, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "protest_watch_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "docket_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "agency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "protester",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "awardee",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "outcome",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "decision_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "corrective_action_pattern",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "public_summary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "source_url",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.OpenProtestWatchRequest
 */ export class OpenProtestWatchRequest extends Message {
    static fromBinary(bytes, options) {
        return new OpenProtestWatchRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OpenProtestWatchRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OpenProtestWatchRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OpenProtestWatchRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: google.protobuf.Timestamp award_notice_date = 2;
   */ _define_property(this, "awardNoticeDate", void 0), /**
   * window = this + 10 days
   *
   * @generated from field: google.protobuf.Timestamp debrief_date = 3;
   */ _define_property(this, "debriefDate", void 0), /**
   * @generated from field: string protest_likelihood = 4;
   */ _define_property(this, "protestLikelihood", ""), /**
   * @generated from field: string competitor_posture = 5;
   */ _define_property(this, "competitorPosture", ""), /**
   * @generated from field: string delivery_impact = 6;
   */ _define_property(this, "deliveryImpact", ""), /**
   * @generated from field: string notes = 7;
   */ _define_property(this, "notes", ""), /**
   * @generated from field: string user_id = 8;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 9;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(OpenProtestWatchRequest, "runtime", proto3);
_define_property(OpenProtestWatchRequest, "typeName", "mono.projectdata.v1.OpenProtestWatchRequest");
_define_property(OpenProtestWatchRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "award_notice_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 3,
            name: "debrief_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 4,
            name: "protest_likelihood",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "competitor_posture",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "delivery_impact",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.OpenProtestWatchResponse
 */ export class OpenProtestWatchResponse extends Message {
    static fromBinary(bytes, options) {
        return new OpenProtestWatchResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OpenProtestWatchResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OpenProtestWatchResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OpenProtestWatchResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.ProtestWatch protest_watch = 1;
   */ _define_property(this, "protestWatch", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(OpenProtestWatchResponse, "runtime", proto3);
_define_property(OpenProtestWatchResponse, "typeName", "mono.projectdata.v1.OpenProtestWatchResponse");
_define_property(OpenProtestWatchResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "protest_watch",
            kind: "message",
            T: ProtestWatch
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpdateProtestWatchRequest
 */ export class UpdateProtestWatchRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateProtestWatchRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateProtestWatchRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateProtestWatchRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateProtestWatchRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string protest_watch_id = 1;
   */ _define_property(this, "protestWatchId", ""), /**
   * @generated from field: string status = 2;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string protest_likelihood = 3;
   */ _define_property(this, "protestLikelihood", ""), /**
   * @generated from field: string competitor_posture = 4;
   */ _define_property(this, "competitorPosture", ""), /**
   * @generated from field: string delivery_impact = 5;
   */ _define_property(this, "deliveryImpact", ""), /**
   * @generated from field: string notes = 6;
   */ _define_property(this, "notes", ""), /**
   * @generated from field: string user_id = 7;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 8;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateProtestWatchRequest, "runtime", proto3);
_define_property(UpdateProtestWatchRequest, "typeName", "mono.projectdata.v1.UpdateProtestWatchRequest");
_define_property(UpdateProtestWatchRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "protest_watch_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "protest_likelihood",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "competitor_posture",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "delivery_impact",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpdateProtestWatchResponse
 */ export class UpdateProtestWatchResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateProtestWatchResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateProtestWatchResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateProtestWatchResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateProtestWatchResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.ProtestWatch protest_watch = 1;
   */ _define_property(this, "protestWatch", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateProtestWatchResponse, "runtime", proto3);
_define_property(UpdateProtestWatchResponse, "typeName", "mono.projectdata.v1.UpdateProtestWatchResponse");
_define_property(UpdateProtestWatchResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "protest_watch",
            kind: "message",
            T: ProtestWatch
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListProtestWatchesRequest
 */ export class ListProtestWatchesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListProtestWatchesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProtestWatchesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProtestWatchesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProtestWatchesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 3;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProtestWatchesRequest, "runtime", proto3);
_define_property(ListProtestWatchesRequest, "typeName", "mono.projectdata.v1.ListProtestWatchesRequest");
_define_property(ListProtestWatchesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListProtestWatchesResponse
 */ export class ListProtestWatchesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListProtestWatchesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProtestWatchesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProtestWatchesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProtestWatchesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.ProtestWatch protest_watches = 1;
   */ _define_property(this, "protestWatches", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProtestWatchesResponse, "runtime", proto3);
_define_property(ListProtestWatchesResponse, "typeName", "mono.projectdata.v1.ListProtestWatchesResponse");
_define_property(ListProtestWatchesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "protest_watches",
            kind: "message",
            T: ProtestWatch,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.AddPublicProtestDecisionRequest
 */ export class AddPublicProtestDecisionRequest extends Message {
    static fromBinary(bytes, options) {
        return new AddPublicProtestDecisionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddPublicProtestDecisionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddPublicProtestDecisionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddPublicProtestDecisionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string protest_watch_id = 1;
   */ _define_property(this, "protestWatchId", ""), /**
   * @generated from field: string docket_number = 2;
   */ _define_property(this, "docketNumber", ""), /**
   * @generated from field: string agency = 3;
   */ _define_property(this, "agency", ""), /**
   * @generated from field: string protester = 4;
   */ _define_property(this, "protester", ""), /**
   * @generated from field: string awardee = 5;
   */ _define_property(this, "awardee", ""), /**
   * @generated from field: string outcome = 6;
   */ _define_property(this, "outcome", ""), /**
   * @generated from field: google.protobuf.Timestamp decision_date = 7;
   */ _define_property(this, "decisionDate", void 0), /**
   * @generated from field: string corrective_action_pattern = 8;
   */ _define_property(this, "correctiveActionPattern", ""), /**
   * @generated from field: string public_summary = 9;
   */ _define_property(this, "publicSummary", ""), /**
   * @generated from field: string source_url = 10;
   */ _define_property(this, "sourceUrl", ""), /**
   * @generated from field: string user_id = 11;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 12;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AddPublicProtestDecisionRequest, "runtime", proto3);
_define_property(AddPublicProtestDecisionRequest, "typeName", "mono.projectdata.v1.AddPublicProtestDecisionRequest");
_define_property(AddPublicProtestDecisionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "protest_watch_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "docket_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "agency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "protester",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "awardee",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "outcome",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "decision_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "corrective_action_pattern",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "public_summary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "source_url",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.AddPublicProtestDecisionResponse
 */ export class AddPublicProtestDecisionResponse extends Message {
    static fromBinary(bytes, options) {
        return new AddPublicProtestDecisionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddPublicProtestDecisionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddPublicProtestDecisionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddPublicProtestDecisionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.PublicProtestDecision decision = 1;
   */ _define_property(this, "decision", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AddPublicProtestDecisionResponse, "runtime", proto3);
_define_property(AddPublicProtestDecisionResponse, "typeName", "mono.projectdata.v1.AddPublicProtestDecisionResponse");
_define_property(AddPublicProtestDecisionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "decision",
            kind: "message",
            T: PublicProtestDecision
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListPublicProtestDecisionsRequest
 */ export class ListPublicProtestDecisionsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListPublicProtestDecisionsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPublicProtestDecisionsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPublicProtestDecisionsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPublicProtestDecisionsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string protest_watch_id = 1;
   */ _define_property(this, "protestWatchId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 3;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListPublicProtestDecisionsRequest, "runtime", proto3);
_define_property(ListPublicProtestDecisionsRequest, "typeName", "mono.projectdata.v1.ListPublicProtestDecisionsRequest");
_define_property(ListPublicProtestDecisionsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "protest_watch_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListPublicProtestDecisionsResponse
 */ export class ListPublicProtestDecisionsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListPublicProtestDecisionsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPublicProtestDecisionsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPublicProtestDecisionsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPublicProtestDecisionsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.PublicProtestDecision decisions = 1;
   */ _define_property(this, "decisions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListPublicProtestDecisionsResponse, "runtime", proto3);
_define_property(ListPublicProtestDecisionsResponse, "typeName", "mono.projectdata.v1.ListPublicProtestDecisionsResponse");
_define_property(ListPublicProtestDecisionsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "decisions",
            kind: "message",
            T: PublicProtestDecision,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CommitImportRequest
 */ export class CommitImportRequest extends Message {
    static fromBinary(bytes, options) {
        return new CommitImportRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CommitImportRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CommitImportRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CommitImportRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string change_set_id = 1;
   */ _define_property(this, "changeSetId", ""), /**
   * Name for the new contract project. Defaults to "Contract — <ProposalName>"
   * when empty; the frontend usually pre-fills it.
   *
   * @generated from field: string contract_project_name = 2;
   */ _define_property(this, "contractProjectName", ""), /**
   * @generated from field: string user_id = 3;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 4;
   */ _define_property(this, "companyId", ""), /**
   * Optional (empty = tenant-wide, matching today's behavior). When set, the
   * minted delivery program is scoped to this business unit — see
   * CreateContractProjectFromProposalRequest.business_unit_id.
   *
   * @generated from field: string business_unit_id = 5;
   */ _define_property(this, "businessUnitId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CommitImportRequest, "runtime", proto3);
_define_property(CommitImportRequest, "typeName", "mono.projectdata.v1.CommitImportRequest");
_define_property(CommitImportRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "contract_project_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "business_unit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * CommitImportViolation explains why a CommitImport call was rejected.
 * One row per failed invariant — the UI groups them by `kind` and shows
 * the reviewer exactly which discrepancies still need work.
 *
 * @generated from message mono.projectdata.v1.CommitImportViolation
 */ export class CommitImportViolation extends Message {
    static fromBinary(bytes, options) {
        return new CommitImportViolation().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CommitImportViolation().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CommitImportViolation().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CommitImportViolation, a, b);
    }
    constructor(data){
        super(), /**
   * OpenDiscrepancies | UnresolvedBlocking | InvalidChangeSetState
   *
   * @generated from field: string kind = 1;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string detail = 2;
   */ _define_property(this, "detail", ""), /**
   * @generated from field: repeated string discrepancy_ids = 3;
   */ _define_property(this, "discrepancyIds", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CommitImportViolation, "runtime", proto3);
_define_property(CommitImportViolation, "typeName", "mono.projectdata.v1.CommitImportViolation");
_define_property(CommitImportViolation, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "detail",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "discrepancy_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CommitImportSummary
 */ export class CommitImportSummary extends Message {
    static fromBinary(bytes, options) {
        return new CommitImportSummary().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CommitImportSummary().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CommitImportSummary().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CommitImportSummary, a, b);
    }
    constructor(data){
        super(), /**
   * pangaea Program id
   *
   * @generated from field: string contract_project_id = 1;
   */ _define_property(this, "contractProjectId", ""), /**
   * @generated from field: string change_set_id = 2;
   */ _define_property(this, "changeSetId", ""), /**
   * @generated from field: string activation_gate_id = 3;
   */ _define_property(this, "activationGateId", ""), /**
   * @generated from field: int32 lineage_rows_written = 4;
   */ _define_property(this, "lineageRowsWritten", 0), /**
   * @generated from field: int32 activation_gate_items_seeded = 5;
   */ _define_property(this, "activationGateItemsSeeded", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CommitImportSummary, "runtime", proto3);
_define_property(CommitImportSummary, "typeName", "mono.projectdata.v1.CommitImportSummary");
_define_property(CommitImportSummary, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contract_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "activation_gate_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "lineage_rows_written",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "activation_gate_items_seeded",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CommitImportResponse
 */ export class CommitImportResponse extends Message {
    static fromBinary(bytes, options) {
        return new CommitImportResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CommitImportResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CommitImportResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CommitImportResponse, a, b);
    }
    constructor(data){
        super(), /**
   * success path
   *
   * @generated from field: mono.projectdata.v1.CommitImportSummary summary = 1;
   */ _define_property(this, "summary", void 0), /**
   * failure path — populated when an invariant rejected the commit.
   *
   * @generated from field: repeated mono.projectdata.v1.CommitImportViolation violations = 2;
   */ _define_property(this, "violations", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CommitImportResponse, "runtime", proto3);
_define_property(CommitImportResponse, "typeName", "mono.projectdata.v1.CommitImportResponse");
_define_property(CommitImportResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "summary",
            kind: "message",
            T: CommitImportSummary
        },
        {
            no: 2,
            name: "violations",
            kind: "message",
            T: CommitImportViolation,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.BeginModificationComparisonRequest
 */ export class BeginModificationComparisonRequest extends Message {
    static fromBinary(bytes, options) {
        return new BeginModificationComparisonRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BeginModificationComparisonRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BeginModificationComparisonRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BeginModificationComparisonRequest, a, b);
    }
    constructor(data){
        super(), /**
   * The EXISTING contract Program the modification applies to (pangaea Program id).
   *
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * Deterministic field-level modification extraction from baltigo
   * AnalyzeModificationV2. The orchestrator maps its changes[] onto change items.
   *
   * @generated from field: mono.contractintel.v1.ParsedModificationV2 modification = 3;
   */ _define_property(this, "modification", void 0), /**
   * Source PDF artifact ids the modification was extracted from.
   *
   * @generated from field: repeated string modification_artifact_ids = 4;
   */ _define_property(this, "modificationArtifactIds", []), /**
   * @generated from field: string user_id = 5;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 6;
   */ _define_property(this, "companyId", ""), /**
   * The modification's own type and purpose as baltigo's judged analysis
   * settled them above its gate (AnalyzeModification, D103). Each is staged as
   * an Accepted, code-settled item on the set's own modification, written on
   * the registry row the apply creates. Empty when not settled: the
   * analysis's review items then ride modification.review_items.
   *
   * @generated from field: string settled_modification_type = 7;
   */ _define_property(this, "settledModificationType", ""), /**
   * @generated from field: string settled_purpose = 8;
   */ _define_property(this, "settledPurpose", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(BeginModificationComparisonRequest, "runtime", proto3);
_define_property(BeginModificationComparisonRequest, "typeName", "mono.projectdata.v1.BeginModificationComparisonRequest");
_define_property(BeginModificationComparisonRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "modification",
            kind: "message",
            T: ParsedModificationV2
        },
        {
            no: 4,
            name: "modification_artifact_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 5,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "settled_modification_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "settled_purpose",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.BeginModificationComparisonResponse
 */ export class BeginModificationComparisonResponse extends Message {
    static fromBinary(bytes, options) {
        return new BeginModificationComparisonResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BeginModificationComparisonResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BeginModificationComparisonResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BeginModificationComparisonResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.ModificationComparisonSummary summary = 1;
   */ _define_property(this, "summary", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(BeginModificationComparisonResponse, "runtime", proto3);
_define_property(BeginModificationComparisonResponse, "typeName", "mono.projectdata.v1.BeginModificationComparisonResponse");
_define_property(BeginModificationComparisonResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "summary",
            kind: "message",
            T: ModificationComparisonSummary
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ModificationComparisonSummary
 */ export class ModificationComparisonSummary extends Message {
    static fromBinary(bytes, options) {
        return new ModificationComparisonSummary().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ModificationComparisonSummary().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ModificationComparisonSummary().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ModificationComparisonSummary, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string change_set_id = 1;
   */ _define_property(this, "changeSetId", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string state = 3;
   */ _define_property(this, "state", ""), /**
   * @generated from field: int32 change_item_count = 4;
   */ _define_property(this, "changeItemCount", 0), /**
   * Items whose old value could not be established from the modification
   * document (ModifiedFieldV2.old_value_established=false) -- the reviewer must
   * confirm the baseline before commit (corrective spec 7.1).
   *
   * @generated from field: int32 unestablished_baseline_count = 5;
   */ _define_property(this, "unestablishedBaselineCount", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ModificationComparisonSummary, "runtime", proto3);
_define_property(ModificationComparisonSummary, "typeName", "mono.projectdata.v1.ModificationComparisonSummary");
_define_property(ModificationComparisonSummary, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "change_item_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "unestablished_baseline_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CommitModificationRequest
 */ export class CommitModificationRequest extends Message {
    static fromBinary(bytes, options) {
        return new CommitModificationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CommitModificationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CommitModificationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CommitModificationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string change_set_id = 1;
   */ _define_property(this, "changeSetId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 3;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CommitModificationRequest, "runtime", proto3);
_define_property(CommitModificationRequest, "typeName", "mono.projectdata.v1.CommitModificationRequest");
_define_property(CommitModificationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ModificationCommitSummary
 */ export class ModificationCommitSummary extends Message {
    static fromBinary(bytes, options) {
        return new ModificationCommitSummary().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ModificationCommitSummary().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ModificationCommitSummary().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ModificationCommitSummary, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string change_set_id = 1;
   */ _define_property(this, "changeSetId", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: int32 applied_count = 3;
   */ _define_property(this, "appliedCount", 0), /**
   * @generated from field: int32 skipped_count = 4;
   */ _define_property(this, "skippedCount", 0), /**
   * @generated from field: string applied_event_id = 5;
   */ _define_property(this, "appliedEventId", ""), /**
   * @generated from field: repeated string apply_warnings = 6;
   */ _define_property(this, "applyWarnings", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ModificationCommitSummary, "runtime", proto3);
_define_property(ModificationCommitSummary, "typeName", "mono.projectdata.v1.ModificationCommitSummary");
_define_property(ModificationCommitSummary, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "applied_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "skipped_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "applied_event_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "apply_warnings",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CommitModificationResponse
 */ export class CommitModificationResponse extends Message {
    static fromBinary(bytes, options) {
        return new CommitModificationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CommitModificationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CommitModificationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CommitModificationResponse, a, b);
    }
    constructor(data){
        super(), /**
   * success path
   *
   * @generated from field: mono.projectdata.v1.ModificationCommitSummary summary = 1;
   */ _define_property(this, "summary", void 0), /**
   * failure path -- reuses the award commit violation shape.
   *
   * @generated from field: repeated mono.projectdata.v1.CommitImportViolation violations = 2;
   */ _define_property(this, "violations", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CommitModificationResponse, "runtime", proto3);
_define_property(CommitModificationResponse, "typeName", "mono.projectdata.v1.CommitModificationResponse");
_define_property(CommitModificationResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "summary",
            kind: "message",
            T: ModificationCommitSummary
        },
        {
            no: 2,
            name: "violations",
            kind: "message",
            T: CommitImportViolation,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.DiscardChangeSetRequest
 */ export class DiscardChangeSetRequest extends Message {
    static fromBinary(bytes, options) {
        return new DiscardChangeSetRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DiscardChangeSetRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DiscardChangeSetRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DiscardChangeSetRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string change_set_id = 1;
   */ _define_property(this, "changeSetId", ""), /**
   * Required: why the set is being discarded. Kept as its state_reason.
   *
   * @generated from field: string reason = 2;
   */ _define_property(this, "reason", ""), /**
   * Also delete the uploaded document behind the set. Refused, naming what
   * references it, when anything still does; the plain discard is unaffected.
   *
   * @generated from field: bool remove_document = 3;
   */ _define_property(this, "removeDocument", false), /**
   * @generated from field: string user_id = 4;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 5;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DiscardChangeSetRequest, "runtime", proto3);
_define_property(DiscardChangeSetRequest, "typeName", "mono.projectdata.v1.DiscardChangeSetRequest");
_define_property(DiscardChangeSetRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "remove_document",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.DiscardChangeSetResponse
 */ export class DiscardChangeSetResponse extends Message {
    static fromBinary(bytes, options) {
        return new DiscardChangeSetResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DiscardChangeSetResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DiscardChangeSetResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DiscardChangeSetResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string change_set_id = 1;
   */ _define_property(this, "changeSetId", ""), /**
   * @generated from field: string state = 2;
   */ _define_property(this, "state", ""), /**
   * @generated from field: int32 closed_item_count = 3;
   */ _define_property(this, "closedItemCount", 0), /**
   * @generated from field: bool document_removed = 4;
   */ _define_property(this, "documentRemoved", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DiscardChangeSetResponse, "runtime", proto3);
_define_property(DiscardChangeSetResponse, "typeName", "mono.projectdata.v1.DiscardChangeSetResponse");
_define_property(DiscardChangeSetResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "closed_item_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "document_removed",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.PreviewDiscardChangeSetRequest
 */ export class PreviewDiscardChangeSetRequest extends Message {
    static fromBinary(bytes, options) {
        return new PreviewDiscardChangeSetRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PreviewDiscardChangeSetRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PreviewDiscardChangeSetRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PreviewDiscardChangeSetRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string change_set_id = 1;
   */ _define_property(this, "changeSetId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 3;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PreviewDiscardChangeSetRequest, "runtime", proto3);
_define_property(PreviewDiscardChangeSetRequest, "typeName", "mono.projectdata.v1.PreviewDiscardChangeSetRequest");
_define_property(PreviewDiscardChangeSetRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.PreviewDiscardChangeSetResponse
 */ export class PreviewDiscardChangeSetResponse extends Message {
    static fromBinary(bytes, options) {
        return new PreviewDiscardChangeSetResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PreviewDiscardChangeSetResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PreviewDiscardChangeSetResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PreviewDiscardChangeSetResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bool discardable = 1;
   */ _define_property(this, "discardable", false), /**
   * Why not, in the reviewer's words, when discardable is false.
   *
   * @generated from field: string not_discardable_reason = 2;
   */ _define_property(this, "notDiscardableReason", ""), /**
   * The set was staged from an uploaded document.
   *
   * @generated from field: bool has_document = 3;
   */ _define_property(this, "hasDocument", false), /**
   * @generated from field: bool document_removable = 4;
   */ _define_property(this, "documentRemovable", false), /**
   * What still references the document, one sentence each.
   *
   * @generated from field: repeated string document_references = 5;
   */ _define_property(this, "documentReferences", []), /**
   * The same references keyed by the record each names: render these.
   *
   * @generated from field: repeated mono.projectdata.v1.DiscardDocumentReference document_reference_records = 6;
   */ _define_property(this, "documentReferenceRecords", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PreviewDiscardChangeSetResponse, "runtime", proto3);
_define_property(PreviewDiscardChangeSetResponse, "typeName", "mono.projectdata.v1.PreviewDiscardChangeSetResponse");
_define_property(PreviewDiscardChangeSetResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "discardable",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 2,
            name: "not_discardable_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "has_document",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "document_removable",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "document_references",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 6,
            name: "document_reference_records",
            kind: "message",
            T: DiscardDocumentReference,
            repeated: true
        }
    ]));
/**
 * DiscardDocumentReference is one thing still citing a change set's
 * document: the citing record's id (or its table, for a counted group) and a
 * sentence distinct for distinct records.
 *
 * @generated from message mono.projectdata.v1.DiscardDocumentReference
 */ export class DiscardDocumentReference extends Message {
    static fromBinary(bytes, options) {
        return new DiscardDocumentReference().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DiscardDocumentReference().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DiscardDocumentReference().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DiscardDocumentReference, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string record_id = 1;
   */ _define_property(this, "recordId", ""), /**
   * @generated from field: string description = 2;
   */ _define_property(this, "description", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DiscardDocumentReference, "runtime", proto3);
_define_property(DiscardDocumentReference, "typeName", "mono.projectdata.v1.DiscardDocumentReference");
_define_property(DiscardDocumentReference, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "record_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * StageContractLineItemRequest is one reviewer action on an open intake or
 * modification set (SAD-768): add a missing line, or correct an existing one.
 *
 * @generated from message mono.projectdata.v1.StageContractLineItemRequest
 */ export class StageContractLineItemRequest extends Message {
    static fromBinary(bytes, options) {
        return new StageContractLineItemRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StageContractLineItemRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StageContractLineItemRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StageContractLineItemRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string user_id = 1;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 2;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string change_set_id = 3;
   */ _define_property(this, "changeSetId", ""), /**
   * "add" or "correct"
   *
   * @generated from field: string action = 4;
   */ _define_property(this, "action", ""), /**
   * @generated from field: string clin_number = 5;
   */ _define_property(this, "clinNumber", ""), /**
   * @generated from field: string title = 6;
   */ _define_property(this, "title", ""), /**
   * Exactly one of period_id or optional_task_number for add; optional on
   * correct when the period association is unchanged.
   *
   * @generated from field: string period_id = 7;
   */ _define_property(this, "periodId", ""), /**
   * @generated from field: int32 optional_task_number = 8;
   */ _define_property(this, "optionalTaskNumber", 0), /**
   * @generated from field: string contract_type = 9;
   */ _define_property(this, "contractType", ""), /**
   * Non-negative decimal as a string (e.g. "6401.70"). The line's VALUE
   * (extended price), never funded money.
   *
   * @generated from field: string price = 10;
   */ _define_property(this, "price", ""), /**
   * Required reason the reviewer gives (never the word "waive").
   *
   * @generated from field: string reason = 11;
   */ _define_property(this, "reason", ""), /**
   * Optional funded amount as a non-negative decimal string. Never inferred
   * from price; omit or leave empty when funding is unstated (SAD-768 H1).
   *
   * @generated from field: string funded_amount = 12;
   */ _define_property(this, "fundedAmount", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(StageContractLineItemRequest, "runtime", proto3);
_define_property(StageContractLineItemRequest, "typeName", "mono.projectdata.v1.StageContractLineItemRequest");
_define_property(StageContractLineItemRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "action",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "clin_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "period_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "optional_task_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 9,
            name: "contract_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "price",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "funded_amount",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.StageContractLineItemResponse
 */ export class StageContractLineItemResponse extends Message {
    static fromBinary(bytes, options) {
        return new StageContractLineItemResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StageContractLineItemResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StageContractLineItemResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StageContractLineItemResponse, a, b);
    }
    constructor(data){
        super(), /**
   * The staged item, projected as a discrepancy so the review drawer can
   * refresh without a second list call.
   *
   * @generated from field: mono.projectdata.v1.AwardComparisonDiscrepancy discrepancy = 1;
   */ _define_property(this, "discrepancy", void 0), /**
   * Set when action=add names a CLIN that already exists in the same period:
   * the UI should offer "Correct this line" for this CLIN number instead.
   *
   * @generated from field: string redirect_to_correct = 2;
   */ _define_property(this, "redirectToCorrect", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(StageContractLineItemResponse, "runtime", proto3);
_define_property(StageContractLineItemResponse, "typeName", "mono.projectdata.v1.StageContractLineItemResponse");
_define_property(StageContractLineItemResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "discrepancy",
            kind: "message",
            T: AwardComparisonDiscrepancy
        },
        {
            no: 2,
            name: "redirect_to_correct",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListProgramChangeSetsRequest
 */ export class ListProgramChangeSetsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListProgramChangeSetsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProgramChangeSetsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProgramChangeSetsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProgramChangeSetsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * optional filter, e.g. "Modification"; empty = all types
   *
   * @generated from field: string change_set_type = 3;
   */ _define_property(this, "changeSetType", ""), /**
   * @generated from field: string user_id = 4;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 5;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProgramChangeSetsRequest, "runtime", proto3);
_define_property(ListProgramChangeSetsRequest, "typeName", "mono.projectdata.v1.ListProgramChangeSetsRequest");
_define_property(ListProgramChangeSetsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "change_set_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ProgramChangeSetSummary
 */ export class ProgramChangeSetSummary extends Message {
    static fromBinary(bytes, options) {
        return new ProgramChangeSetSummary().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProgramChangeSetSummary().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProgramChangeSetSummary().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProgramChangeSetSummary, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string change_set_id = 1;
   */ _define_property(this, "changeSetId", ""), /**
   * @generated from field: string change_set_type = 2;
   */ _define_property(this, "changeSetType", ""), /**
   * @generated from field: string state = 3;
   */ _define_property(this, "state", ""), /**
   * @generated from field: string title = 4;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string applied_event_id = 5;
   */ _define_property(this, "appliedEventId", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp applied_at = 7;
   */ _define_property(this, "appliedAt", void 0), /**
   * Source document artifact ids (the mod SF30) so the review UI can open the
   * source document in the viewer to cross-check the extracted diff.
   *
   * @generated from field: repeated string source_artifact_ids = 8;
   */ _define_property(this, "sourceArtifactIds", []), /**
   * Review items (D93) on this set that still need a reviewer's call: any
   * state but Accepted, Corrected, Waived, Closed or Applied, the states the
   * commit gate counts as settled. 0 for an Applied, Cancelled, Rejected or
   * Superseded set, where nothing is left to decide.
   *
   * @generated from field: int32 open_review_count = 9;
   */ _define_property(this, "openReviewCount", 0), /**
   * Why the set ended without applying (a discard's reason); "" otherwise.
   *
   * @generated from field: string state_reason = 10;
   */ _define_property(this, "stateReason", ""), /**
   * Who last moved the set, and when: for a discarded set, who discarded it.
   *
   * @generated from field: string updated_by = 11;
   */ _define_property(this, "updatedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 12;
   */ _define_property(this, "updatedAt", void 0), /**
   * updated_by's name, resolved the way program History names an actor; ""
   * when it can't be resolved.
   *
   * @generated from field: string updated_by_display_name = 13;
   */ _define_property(this, "updatedByDisplayName", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProgramChangeSetSummary, "runtime", proto3);
_define_property(ProgramChangeSetSummary, "typeName", "mono.projectdata.v1.ProgramChangeSetSummary");
_define_property(ProgramChangeSetSummary, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "change_set_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "applied_event_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "applied_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "source_artifact_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 9,
            name: "open_review_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 10,
            name: "state_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "updated_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 13,
            name: "updated_by_display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListProgramChangeSetsResponse
 */ export class ListProgramChangeSetsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListProgramChangeSetsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProgramChangeSetsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProgramChangeSetsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProgramChangeSetsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.ProgramChangeSetSummary change_sets = 1;
   */ _define_property(this, "changeSets", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProgramChangeSetsResponse, "runtime", proto3);
_define_property(ListProgramChangeSetsResponse, "typeName", "mono.projectdata.v1.ListProgramChangeSetsResponse");
_define_property(ListProgramChangeSetsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "change_sets",
            kind: "message",
            T: ProgramChangeSetSummary,
            repeated: true
        }
    ]));
/**
 * ActivationGateItemView is the projection the UI renders. Maps 1:1 to
 * pangaea's ContractActivationGateItem row, plus a `display_label` for the
 * 15-row checklist (the proto carries item_key as a stable enum string;
 * display copy is computed server-side so the frontend never has to keep
 * in sync with the canonical labels).
 *
 * @generated from message mono.projectdata.v1.ActivationGateItemView
 */ export class ActivationGateItemView extends Message {
    static fromBinary(bytes, options) {
        return new ActivationGateItemView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ActivationGateItemView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ActivationGateItemView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ActivationGateItemView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * FinalContractAttached|PwsAttached|… (15 values)
   *
   * @generated from field: string item_key = 2;
   */ _define_property(this, "itemKey", ""), /**
   * SDS §4.4 human-readable label
   *
   * @generated from field: string display_label = 3;
   */ _define_property(this, "displayLabel", ""), /**
   * Pending|Complete|Waived
   *
   * @generated from field: string state = 4;
   */ _define_property(this, "state", ""), /**
   * @generated from field: string reason = 5;
   */ _define_property(this, "reason", ""), /**
   * @generated from field: string decided_by = 6;
   */ _define_property(this, "decidedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp decided_at = 7;
   */ _define_property(this, "decidedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ActivationGateItemView, "runtime", proto3);
_define_property(ActivationGateItemView, "typeName", "mono.projectdata.v1.ActivationGateItemView");
_define_property(ActivationGateItemView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "item_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "display_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "decided_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "decided_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * ActivationGateView wraps the gate row + its 15 items. `ready_to_activate`
 * is true iff every item is Complete or Waived — pre-computed so the UI
 * doesn't have to roll the rule on the client.
 *
 * @generated from message mono.projectdata.v1.ActivationGateView
 */ export class ActivationGateView extends Message {
    static fromBinary(bytes, options) {
        return new ActivationGateView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ActivationGateView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ActivationGateView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ActivationGateView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string contract_project_id = 2;
   */ _define_property(this, "contractProjectId", ""), /**
   * Pending|Activated|Closed
   *
   * @generated from field: string state = 3;
   */ _define_property(this, "state", ""), /**
   * @generated from field: google.protobuf.Timestamp activated_at = 4;
   */ _define_property(this, "activatedAt", void 0), /**
   * @generated from field: string activated_by = 5;
   */ _define_property(this, "activatedBy", ""), /**
   * @generated from field: repeated mono.projectdata.v1.ActivationGateItemView items = 6;
   */ _define_property(this, "items", []), /**
   * @generated from field: bool ready_to_activate = 7;
   */ _define_property(this, "readyToActivate", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ActivationGateView, "runtime", proto3);
_define_property(ActivationGateView, "typeName", "mono.projectdata.v1.ActivationGateView");
_define_property(ActivationGateView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "contract_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "activated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "activated_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "items",
            kind: "message",
            T: ActivationGateItemView,
            repeated: true
        },
        {
            no: 7,
            name: "ready_to_activate",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetActivationGateRequest
 */ export class GetActivationGateRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetActivationGateRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetActivationGateRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetActivationGateRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetActivationGateRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string contract_project_id = 1;
   */ _define_property(this, "contractProjectId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 3;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetActivationGateRequest, "runtime", proto3);
_define_property(GetActivationGateRequest, "typeName", "mono.projectdata.v1.GetActivationGateRequest");
_define_property(GetActivationGateRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contract_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetActivationGateResponse
 */ export class GetActivationGateResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetActivationGateResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetActivationGateResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetActivationGateResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetActivationGateResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.ActivationGateView gate = 1;
   */ _define_property(this, "gate", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetActivationGateResponse, "runtime", proto3);
_define_property(GetActivationGateResponse, "typeName", "mono.projectdata.v1.GetActivationGateResponse");
_define_property(GetActivationGateResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "gate",
            kind: "message",
            T: ActivationGateView
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpdateActivationGateItemRequest
 */ export class UpdateActivationGateItemRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateActivationGateItemRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateActivationGateItemRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateActivationGateItemRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateActivationGateItemRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string contract_project_id = 1;
   */ _define_property(this, "contractProjectId", ""), /**
   * must match one of the 15 canonical keys
   *
   * @generated from field: string item_key = 2;
   */ _define_property(this, "itemKey", ""), /**
   * Pending|Complete|Waived
   *
   * @generated from field: string state = 3;
   */ _define_property(this, "state", ""), /**
   * Required when state == "Waived"; surfaced in audit + lineage. May be
   * empty when transitioning to Complete.
   *
   * @generated from field: string reason = 4;
   */ _define_property(this, "reason", ""), /**
   * @generated from field: string user_id = 5;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 6;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateActivationGateItemRequest, "runtime", proto3);
_define_property(UpdateActivationGateItemRequest, "typeName", "mono.projectdata.v1.UpdateActivationGateItemRequest");
_define_property(UpdateActivationGateItemRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contract_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "item_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpdateActivationGateItemResponse
 */ export class UpdateActivationGateItemResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateActivationGateItemResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateActivationGateItemResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateActivationGateItemResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateActivationGateItemResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.ActivationGateView gate = 1;
   */ _define_property(this, "gate", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateActivationGateItemResponse, "runtime", proto3);
_define_property(UpdateActivationGateItemResponse, "typeName", "mono.projectdata.v1.UpdateActivationGateItemResponse");
_define_property(UpdateActivationGateItemResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "gate",
            kind: "message",
            T: ActivationGateView
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ActivateContractRequest
 */ export class ActivateContractRequest extends Message {
    static fromBinary(bytes, options) {
        return new ActivateContractRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ActivateContractRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ActivateContractRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ActivateContractRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string contract_project_id = 1;
   */ _define_property(this, "contractProjectId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 3;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ActivateContractRequest, "runtime", proto3);
_define_property(ActivateContractRequest, "typeName", "mono.projectdata.v1.ActivateContractRequest");
_define_property(ActivateContractRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contract_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ActivateContractResponse
 */ export class ActivateContractResponse extends Message {
    static fromBinary(bytes, options) {
        return new ActivateContractResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ActivateContractResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ActivateContractResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ActivateContractResponse, a, b);
    }
    constructor(data){
        super(), /**
   * Populated on success — gate.state will be "Activated".
   *
   * @generated from field: mono.projectdata.v1.ActivationGateView gate = 1;
   */ _define_property(this, "gate", void 0), /**
   * Populated on failure — item_keys that are still Pending. When non-empty,
   * gate is the pre-activation snapshot so the UI can highlight which rows
   * still need work.
   *
   * @generated from field: repeated string violations = 2;
   */ _define_property(this, "violations", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ActivateContractResponse, "runtime", proto3);
_define_property(ActivateContractResponse, "typeName", "mono.projectdata.v1.ActivateContractResponse");
_define_property(ActivateContractResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "gate",
            kind: "message",
            T: ActivationGateView
        },
        {
            no: 2,
            name: "violations",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * DeliverableEvidenceInput is the wire shape callers send to record one
 * piece of evidence in the close call. Mirrors the pangaea row but
 * trimmed of system fields (id / timestamps / validation_state).
 *
 * @generated from message mono.projectdata.v1.DeliverableEvidenceInput
 */ export class DeliverableEvidenceInput extends Message {
    static fromBinary(bytes, options) {
        return new DeliverableEvidenceInput().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeliverableEvidenceInput().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeliverableEvidenceInput().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeliverableEvidenceInput, a, b);
    }
    constructor(data){
        super(), /**
   * One of Artifact | ExternalReference.
   *
   * @generated from field: string evidence_type = 1;
   */ _define_property(this, "evidenceType", ""), /**
   * FK to pangaea Artifact when evidence_type == Artifact.
   *
   * @generated from field: string artifact_id = 2;
   */ _define_property(this, "artifactId", ""), /**
   * FK to ExternalArtifactReference when evidence_type == ExternalReference.
   * Mutually exclusive with artifact_id at the handler.
   *
   * @generated from field: string external_reference_id = 3;
   */ _define_property(this, "externalReferenceId", ""), /**
   * @generated from field: google.protobuf.Timestamp delivery_timestamp = 4;
   */ _define_property(this, "deliveryTimestamp", void 0), /**
   * @generated from field: repeated string submitted_to_emails = 5;
   */ _define_property(this, "submittedToEmails", []), /**
   * @generated from field: string source_system = 6;
   */ _define_property(this, "sourceSystem", ""), /**
   * @generated from field: string proof_method = 7;
   */ _define_property(this, "proofMethod", ""), /**
   * @generated from field: bool screenshot_attached = 8;
   */ _define_property(this, "screenshotAttached", false), /**
   * @generated from field: bool email_file_attached = 9;
   */ _define_property(this, "emailFileAttached", false), /**
   * @generated from field: bool customer_receipt_attached = 10;
   */ _define_property(this, "customerReceiptAttached", false), /**
   * Populated only on the approved-exception path (SDS §6.4 case 3).
   * When non-empty, the handler treats the close as exception-approved
   * and skips the artifact-and-POD rule. Audit retains the reason.
   *
   * @generated from field: string exception_reason = 11;
   */ _define_property(this, "exceptionReason", ""), /**
   * ---- SAD-106: customer acceptance + delivery notes ----
   * Exactly Accepted|No Response|Rejected, or "" for not-yet-recorded. The
   * handler rejects any other value with InvalidArgument.
   *
   * @generated from field: string customer_acceptance_status = 12;
   */ _define_property(this, "customerAcceptanceStatus", ""), /**
   * Free-text delivery notes / exceptions.
   *
   * @generated from field: string delivery_notes = 13;
   */ _define_property(this, "deliveryNotes", ""), /**
   * FK to a delivery.contacts row that must resolve to a GOVERNMENT
   * contact in the caller's tenant — the handler refuses a subcontractor
   * or internal contact. Distinct from (and does not populate)
   * submitted_to_emails above, which stays free text for backward
   * compatibility with rows recorded before this field existed.
   *
   * @generated from field: string submitted_to_contact_id = 14;
   */ _define_property(this, "submittedToContactId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeliverableEvidenceInput, "runtime", proto3);
_define_property(DeliverableEvidenceInput, "typeName", "mono.projectdata.v1.DeliverableEvidenceInput");
_define_property(DeliverableEvidenceInput, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "evidence_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "external_reference_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "delivery_timestamp",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "submitted_to_emails",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 6,
            name: "source_system",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "proof_method",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "screenshot_attached",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 9,
            name: "email_file_attached",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 10,
            name: "customer_receipt_attached",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 11,
            name: "exception_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "customer_acceptance_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "delivery_notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "submitted_to_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * DeliverableEvidenceView projects pangaea's DeliverableEvidence row
 * for read-paths. Adds a derived `pod_attached` boolean so the UI
 * doesn't have to OR the three POD flags.
 *
 * @generated from message mono.projectdata.v1.DeliverableEvidenceView
 */ export class DeliverableEvidenceView extends Message {
    static fromBinary(bytes, options) {
        return new DeliverableEvidenceView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeliverableEvidenceView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeliverableEvidenceView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeliverableEvidenceView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string program_task_id = 2;
   */ _define_property(this, "programTaskId", ""), /**
   * @generated from field: string evidence_type = 3;
   */ _define_property(this, "evidenceType", ""), /**
   * @generated from field: string artifact_id = 4;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: string external_reference_id = 5;
   */ _define_property(this, "externalReferenceId", ""), /**
   * @generated from field: google.protobuf.Timestamp delivery_timestamp = 6;
   */ _define_property(this, "deliveryTimestamp", void 0), /**
   * @generated from field: string submitted_by_user_id = 7;
   */ _define_property(this, "submittedByUserId", ""), /**
   * @generated from field: string validation_state = 8;
   */ _define_property(this, "validationState", ""), /**
   * @generated from field: string exception_reason = 9;
   */ _define_property(this, "exceptionReason", ""), /**
   * @generated from field: bool pod_attached = 10;
   */ _define_property(this, "podAttached", false), /**
   * @generated from field: google.protobuf.Timestamp created_at = 11;
   */ _define_property(this, "createdAt", void 0), /**
   * ---- SAD-106 ----
   *
   * @generated from field: string customer_acceptance_status = 12;
   */ _define_property(this, "customerAcceptanceStatus", ""), /**
   * @generated from field: string delivery_notes = 13;
   */ _define_property(this, "deliveryNotes", ""), /**
   * @generated from field: string submitted_to_contact_id = 14;
   */ _define_property(this, "submittedToContactId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeliverableEvidenceView, "runtime", proto3);
_define_property(DeliverableEvidenceView, "typeName", "mono.projectdata.v1.DeliverableEvidenceView");
_define_property(DeliverableEvidenceView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_task_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "evidence_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "external_reference_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "delivery_timestamp",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "submitted_by_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "validation_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "exception_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "pod_attached",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 11,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "customer_acceptance_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "delivery_notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "submitted_to_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * UpdateDeliverableEvidenceRequest (SAD-106) settable both at record time
 * (DeliverableEvidenceInput above) and here, after the fact. Field
 * presence (`optional`) means an omitted field is left untouched on the
 * underlying row — this is what makes a notes-only update preserve an
 * already-recorded customer_acceptance_status, and vice versa.
 *
 * @generated from message mono.projectdata.v1.UpdateDeliverableEvidenceRequest
 */ export class UpdateDeliverableEvidenceRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateDeliverableEvidenceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateDeliverableEvidenceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateDeliverableEvidenceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateDeliverableEvidenceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string evidence_id = 1;
   */ _define_property(this, "evidenceId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 3;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: optional string customer_acceptance_status = 4;
   */ _define_property(this, "customerAcceptanceStatus", void 0), /**
   * @generated from field: optional string delivery_notes = 5;
   */ _define_property(this, "deliveryNotes", void 0), /**
   * @generated from field: optional string submitted_to_contact_id = 6;
   */ _define_property(this, "submittedToContactId", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateDeliverableEvidenceRequest, "runtime", proto3);
_define_property(UpdateDeliverableEvidenceRequest, "typeName", "mono.projectdata.v1.UpdateDeliverableEvidenceRequest");
_define_property(UpdateDeliverableEvidenceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "evidence_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "customer_acceptance_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 5,
            name: "delivery_notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 6,
            name: "submitted_to_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpdateDeliverableEvidenceResponse
 */ export class UpdateDeliverableEvidenceResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateDeliverableEvidenceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateDeliverableEvidenceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateDeliverableEvidenceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateDeliverableEvidenceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.DeliverableEvidenceView evidence = 1;
   */ _define_property(this, "evidence", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateDeliverableEvidenceResponse, "runtime", proto3);
_define_property(UpdateDeliverableEvidenceResponse, "typeName", "mono.projectdata.v1.UpdateDeliverableEvidenceResponse");
_define_property(UpdateDeliverableEvidenceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "evidence",
            kind: "message",
            T: DeliverableEvidenceView
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CloseDeliverableWithEvidenceRequest
 */ export class CloseDeliverableWithEvidenceRequest extends Message {
    static fromBinary(bytes, options) {
        return new CloseDeliverableWithEvidenceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CloseDeliverableWithEvidenceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CloseDeliverableWithEvidenceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CloseDeliverableWithEvidenceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_task_id = 1;
   */ _define_property(this, "programTaskId", ""), /**
   * Optional — when omitted, the handler falls back to evidence rows
   * already recorded against the task. Callers usually pass a fresh
   * input so the close is atomic with the record.
   *
   * @generated from field: mono.projectdata.v1.DeliverableEvidenceInput evidence = 2;
   */ _define_property(this, "evidence", void 0), /**
   * @generated from field: string user_id = 3;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 4;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CloseDeliverableWithEvidenceRequest, "runtime", proto3);
_define_property(CloseDeliverableWithEvidenceRequest, "typeName", "mono.projectdata.v1.CloseDeliverableWithEvidenceRequest");
_define_property(CloseDeliverableWithEvidenceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_task_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "evidence",
            kind: "message",
            T: DeliverableEvidenceInput
        },
        {
            no: 3,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * CloseDeliverableWithEvidenceViolation explains why a close call was
 * rejected. The handler returns the full list rather than the first
 * failure so the UI can guide the reviewer to a single resolution.
 *
 * @generated from message mono.projectdata.v1.CloseDeliverableWithEvidenceViolation
 */ export class CloseDeliverableWithEvidenceViolation extends Message {
    static fromBinary(bytes, options) {
        return new CloseDeliverableWithEvidenceViolation().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CloseDeliverableWithEvidenceViolation().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CloseDeliverableWithEvidenceViolation().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CloseDeliverableWithEvidenceViolation, a, b);
    }
    constructor(data){
        super(), /**
   * Kind enum:
   *   MissingArtifactAndExternalRef | MissingProofOfDelivery
   * | InvalidEvidenceType | TaskAlreadyClosed | AmbiguousEvidence
   *
   * @generated from field: string kind = 1;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string detail = 2;
   */ _define_property(this, "detail", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CloseDeliverableWithEvidenceViolation, "runtime", proto3);
_define_property(CloseDeliverableWithEvidenceViolation, "typeName", "mono.projectdata.v1.CloseDeliverableWithEvidenceViolation");
_define_property(CloseDeliverableWithEvidenceViolation, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "detail",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CloseDeliverableWithEvidenceSummary
 */ export class CloseDeliverableWithEvidenceSummary extends Message {
    static fromBinary(bytes, options) {
        return new CloseDeliverableWithEvidenceSummary().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CloseDeliverableWithEvidenceSummary().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CloseDeliverableWithEvidenceSummary().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CloseDeliverableWithEvidenceSummary, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_task_id = 1;
   */ _define_property(this, "programTaskId", ""), /**
   * @generated from field: string evidence_id = 2;
   */ _define_property(this, "evidenceId", ""), /**
   * expected: "closed"
   *
   * @generated from field: string task_state = 3;
   */ _define_property(this, "taskState", ""), /**
   * @generated from field: google.protobuf.Timestamp closed_at = 4;
   */ _define_property(this, "closedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CloseDeliverableWithEvidenceSummary, "runtime", proto3);
_define_property(CloseDeliverableWithEvidenceSummary, "typeName", "mono.projectdata.v1.CloseDeliverableWithEvidenceSummary");
_define_property(CloseDeliverableWithEvidenceSummary, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_task_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "evidence_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "task_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "closed_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CloseDeliverableWithEvidenceResponse
 */ export class CloseDeliverableWithEvidenceResponse extends Message {
    static fromBinary(bytes, options) {
        return new CloseDeliverableWithEvidenceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CloseDeliverableWithEvidenceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CloseDeliverableWithEvidenceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CloseDeliverableWithEvidenceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * Success path.
   *
   * @generated from field: mono.projectdata.v1.CloseDeliverableWithEvidenceSummary summary = 1;
   */ _define_property(this, "summary", void 0), /**
   * Failure path — populated when the close rule rejected the call.
   *
   * @generated from field: repeated mono.projectdata.v1.CloseDeliverableWithEvidenceViolation violations = 2;
   */ _define_property(this, "violations", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CloseDeliverableWithEvidenceResponse, "runtime", proto3);
_define_property(CloseDeliverableWithEvidenceResponse, "typeName", "mono.projectdata.v1.CloseDeliverableWithEvidenceResponse");
_define_property(CloseDeliverableWithEvidenceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "summary",
            kind: "message",
            T: CloseDeliverableWithEvidenceSummary
        },
        {
            no: 2,
            name: "violations",
            kind: "message",
            T: CloseDeliverableWithEvidenceViolation,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListDeliverableEvidenceRequest
 */ export class ListDeliverableEvidenceRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListDeliverableEvidenceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListDeliverableEvidenceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListDeliverableEvidenceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListDeliverableEvidenceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_task_id = 1;
   */ _define_property(this, "programTaskId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 3;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListDeliverableEvidenceRequest, "runtime", proto3);
_define_property(ListDeliverableEvidenceRequest, "typeName", "mono.projectdata.v1.ListDeliverableEvidenceRequest");
_define_property(ListDeliverableEvidenceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_task_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListDeliverableEvidenceResponse
 */ export class ListDeliverableEvidenceResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListDeliverableEvidenceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListDeliverableEvidenceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListDeliverableEvidenceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListDeliverableEvidenceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.DeliverableEvidenceView evidence = 1;
   */ _define_property(this, "evidence", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListDeliverableEvidenceResponse, "runtime", proto3);
_define_property(ListDeliverableEvidenceResponse, "typeName", "mono.projectdata.v1.ListDeliverableEvidenceResponse");
_define_property(ListDeliverableEvidenceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "evidence",
            kind: "message",
            T: DeliverableEvidenceView,
            repeated: true
        }
    ]));
/**
 * FieldLineageEntryView projects pangaea's FieldLineage row into a UI
 * shape. Carries the raw value_json so the popover can render the
 * historical scalar; source_change_set_id / source_artifact_id are
 * optional links the UI dereferences when present.
 *
 * @generated from message mono.projectdata.v1.FieldLineageEntryView
 */ export class FieldLineageEntryView extends Message {
    static fromBinary(bytes, options) {
        return new FieldLineageEntryView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FieldLineageEntryView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FieldLineageEntryView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FieldLineageEntryView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * ProposalBaseline | PreAward | FinalContract | AwardComparison | Modification | Manual
   *
   * @generated from field: string source_kind = 2;
   */ _define_property(this, "sourceKind", ""), /**
   * @generated from field: string value_json = 3;
   */ _define_property(this, "valueJson", ""), /**
   * @generated from field: string source_artifact_id = 4;
   */ _define_property(this, "sourceArtifactId", ""), /**
   * @generated from field: string source_change_set_id = 5;
   */ _define_property(this, "sourceChangeSetId", ""), /**
   * @generated from field: string source_modification_id = 6;
   */ _define_property(this, "sourceModificationId", ""), /**
   * @generated from field: google.protobuf.Timestamp written_at = 7;
   */ _define_property(this, "writtenAt", void 0), /**
   * @generated from field: string written_by = 8;
   */ _define_property(this, "writtenBy", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(FieldLineageEntryView, "runtime", proto3);
_define_property(FieldLineageEntryView, "typeName", "mono.projectdata.v1.FieldLineageEntryView");
_define_property(FieldLineageEntryView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "source_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "value_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "source_artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "source_change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "source_modification_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "written_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "written_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * FieldLineageGroup bundles entries by source_kind so the popover can
 * render the history grouped by provenance (Modifications stack chronologically
 * inside their group; Final-Contract typically has one row).
 *
 * @generated from message mono.projectdata.v1.FieldLineageGroup
 */ export class FieldLineageGroup extends Message {
    static fromBinary(bytes, options) {
        return new FieldLineageGroup().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FieldLineageGroup().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FieldLineageGroup().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FieldLineageGroup, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string source_kind = 1;
   */ _define_property(this, "sourceKind", ""), /**
   * @generated from field: repeated mono.projectdata.v1.FieldLineageEntryView entries = 2;
   */ _define_property(this, "entries", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(FieldLineageGroup, "runtime", proto3);
_define_property(FieldLineageGroup, "typeName", "mono.projectdata.v1.FieldLineageGroup");
_define_property(FieldLineageGroup, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "source_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "entries",
            kind: "message",
            T: FieldLineageEntryView,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetFieldLineageRequest
 */ export class GetFieldLineageRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetFieldLineageRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetFieldLineageRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetFieldLineageRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetFieldLineageRequest, a, b);
    }
    constructor(data){
        super(), /**
   * Program | ContractCLIN | ProgramTask | …
   *
   * @generated from field: string target_object_type = 1;
   */ _define_property(this, "targetObjectType", ""), /**
   * @generated from field: string target_object_id = 2;
   */ _define_property(this, "targetObjectId", ""), /**
   * @generated from field: string target_field_path = 3;
   */ _define_property(this, "targetFieldPath", ""), /**
   * @generated from field: string user_id = 4;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 5;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetFieldLineageRequest, "runtime", proto3);
_define_property(GetFieldLineageRequest, "typeName", "mono.projectdata.v1.GetFieldLineageRequest");
_define_property(GetFieldLineageRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "target_object_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "target_object_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "target_field_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetFieldLineageResponse
 */ export class GetFieldLineageResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetFieldLineageResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetFieldLineageResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetFieldLineageResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetFieldLineageResponse, a, b);
    }
    constructor(data){
        super(), /**
   * Ordered by source_kind precedence (ProposalBaseline → PreAward →
   * AwardComparison → FinalContract → Modification → Manual).
   *
   * @generated from field: repeated mono.projectdata.v1.FieldLineageGroup groups = 1;
   */ _define_property(this, "groups", []), /**
   * @generated from field: int32 total = 2;
   */ _define_property(this, "total", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetFieldLineageResponse, "runtime", proto3);
_define_property(GetFieldLineageResponse, "typeName", "mono.projectdata.v1.GetFieldLineageResponse");
_define_property(GetFieldLineageResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "groups",
            kind: "message",
            T: FieldLineageGroup,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.PersistExtractionSourceRefsRequest
 */ export class PersistExtractionSourceRefsRequest extends Message {
    static fromBinary(bytes, options) {
        return new PersistExtractionSourceRefsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PersistExtractionSourceRefsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PersistExtractionSourceRefsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PersistExtractionSourceRefsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * Source PDF artifact the refs were extracted from — used as the fallback
   * when an individual ref carries no artifact id.
   *
   * @generated from field: string source_artifact_id = 2;
   */ _define_property(this, "sourceArtifactId", ""), /**
   * Per-field provenance from the V2 extractor (page/section/quote/confidence),
   * keyed by natural identity (clin_number, contract_number, field name).
   *
   * @generated from field: repeated mono.contractintel.v1.SourceMetadata refs = 3;
   */ _define_property(this, "refs", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PersistExtractionSourceRefsRequest, "runtime", proto3);
_define_property(PersistExtractionSourceRefsRequest, "typeName", "mono.projectdata.v1.PersistExtractionSourceRefsRequest");
_define_property(PersistExtractionSourceRefsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "source_artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "refs",
            kind: "message",
            T: SourceMetadata,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.PersistExtractionSourceRefsResponse
 */ export class PersistExtractionSourceRefsResponse extends Message {
    static fromBinary(bytes, options) {
        return new PersistExtractionSourceRefsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PersistExtractionSourceRefsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PersistExtractionSourceRefsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PersistExtractionSourceRefsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * Number of refs persisted (those carrying a non-empty target type + id).
   *
   * @generated from field: int32 persisted = 1;
   */ _define_property(this, "persisted", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PersistExtractionSourceRefsResponse, "runtime", proto3);
_define_property(PersistExtractionSourceRefsResponse, "typeName", "mono.projectdata.v1.PersistExtractionSourceRefsResponse");
_define_property(PersistExtractionSourceRefsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "persisted",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListSourceRefsForTargetRequest
 */ export class ListSourceRefsForTargetRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListSourceRefsForTargetRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListSourceRefsForTargetRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListSourceRefsForTargetRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListSourceRefsForTargetRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string target_object_type = 1;
   */ _define_property(this, "targetObjectType", ""), /**
   * @generated from field: string target_object_id = 2;
   */ _define_property(this, "targetObjectId", ""), /**
   * When true, only the current (non-superseded) ref per field.
   *
   * @generated from field: bool current_only = 3;
   */ _define_property(this, "currentOnly", false), /**
   * When set, target_object_id MUST be empty (the two are mutually
   * exclusive) and every ref whose id starts with this prefix is returned —
   * one query for a whole program's refs of a type, instead of one RPC per
   * chip.
   *
   * @generated from field: string target_object_id_prefix = 4;
   */ _define_property(this, "targetObjectIdPrefix", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListSourceRefsForTargetRequest, "runtime", proto3);
_define_property(ListSourceRefsForTargetRequest, "typeName", "mono.projectdata.v1.ListSourceRefsForTargetRequest");
_define_property(ListSourceRefsForTargetRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "target_object_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "target_object_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "current_only",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "target_object_id_prefix",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * SourceRefView is the browser-facing projection of a persisted SourceReference
 * — the fields a SourceChip needs, minus tenant/review plumbing.
 *
 * @generated from message mono.projectdata.v1.SourceRefView
 */ export class SourceRefView extends Message {
    static fromBinary(bytes, options) {
        return new SourceRefView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SourceRefView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SourceRefView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SourceRefView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string target_field_path = 2;
   */ _define_property(this, "targetFieldPath", ""), /**
   * @generated from field: int32 source_page = 3;
   */ _define_property(this, "sourcePage", 0), /**
   * @generated from field: string source_section = 4;
   */ _define_property(this, "sourceSection", ""), /**
   * @generated from field: string source_quote = 5;
   */ _define_property(this, "sourceQuote", ""), /**
   * @generated from field: string raw_value = 6;
   */ _define_property(this, "rawValue", ""), /**
   * @generated from field: string normalized_value = 7;
   */ _define_property(this, "normalizedValue", ""), /**
   * @generated from field: double confidence = 8;
   */ _define_property(this, "confidence", 0), /**
   * @generated from field: string source_kind = 9;
   */ _define_property(this, "sourceKind", ""), /**
   * @generated from field: string extractor_name = 10;
   */ _define_property(this, "extractorName", ""), /**
   * @generated from field: string source_artifact_id = 11;
   */ _define_property(this, "sourceArtifactId", ""), /**
   * Block-level span (e.g. {"blockId":"/page/19/Table/2"}) — page + bbox for
   * deep-linking the viewer when source_page is unset.
   *
   * @generated from field: string source_span = 12;
   */ _define_property(this, "sourceSpan", ""), /**
   * The ref's full target id — lets prefix-fetch consumers pick their own
   * rows client-side (e.g. "{programId}/{section}").
   *
   * @generated from field: string target_object_id = 13;
   */ _define_property(this, "targetObjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SourceRefView, "runtime", proto3);
_define_property(SourceRefView, "typeName", "mono.projectdata.v1.SourceRefView");
_define_property(SourceRefView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "target_field_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "source_page",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "source_section",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "source_quote",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "raw_value",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "normalized_value",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 9,
            name: "source_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "extractor_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "source_artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "source_span",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "target_object_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListSourceRefsForTargetResponse
 */ export class ListSourceRefsForTargetResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListSourceRefsForTargetResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListSourceRefsForTargetResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListSourceRefsForTargetResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListSourceRefsForTargetResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.SourceRefView refs = 1;
   */ _define_property(this, "refs", []), /**
   * @generated from field: int32 total = 2;
   */ _define_property(this, "total", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListSourceRefsForTargetResponse, "runtime", proto3);
_define_property(ListSourceRefsForTargetResponse, "typeName", "mono.projectdata.v1.ListSourceRefsForTargetResponse");
_define_property(ListSourceRefsForTargetResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "refs",
            kind: "message",
            T: SourceRefView,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * OpsAuditFieldDiff is one field-level before/after pair, projected
 * server-side from an event's previous/new state payloads. The stored
 * field_diffs_json column is written by no emitter, so the diff is derived
 * on read rather than plumbed: the timeline stays useful without every
 * writer having to remember to fill a second column.
 *
 * @generated from message mono.projectdata.v1.OpsAuditFieldDiff
 */ export class OpsAuditFieldDiff extends Message {
    static fromBinary(bytes, options) {
        return new OpsAuditFieldDiff().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OpsAuditFieldDiff().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OpsAuditFieldDiff().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OpsAuditFieldDiff, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string field = 1;
   */ _define_property(this, "field", ""), /**
   * @generated from field: string before = 2;
   */ _define_property(this, "before", ""), /**
   * @generated from field: string after = 3;
   */ _define_property(this, "after", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(OpsAuditFieldDiff, "runtime", proto3);
_define_property(OpsAuditFieldDiff, "typeName", "mono.projectdata.v1.OpsAuditFieldDiff");
_define_property(OpsAuditFieldDiff, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "field",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "before",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "after",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * OpsAuditEventView mirrors pangaea's OperationalAuditEvent but drops
 * the system fields the UI doesn't need (tenant_id is already implied
 * by the principal).
 *
 * @generated from message mono.projectdata.v1.OpsAuditEventView
 */ export class OpsAuditEventView extends Message {
    static fromBinary(bytes, options) {
        return new OpsAuditEventView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OpsAuditEventView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OpsAuditEventView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OpsAuditEventView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string actor_user_id = 2;
   */ _define_property(this, "actorUserId", ""), /**
   * @generated from field: string action_key = 3;
   */ _define_property(this, "actionKey", ""), /**
   * @generated from field: string object_type = 4;
   */ _define_property(this, "objectType", ""), /**
   * @generated from field: string object_id = 5;
   */ _define_property(this, "objectId", ""), /**
   * @generated from field: string previous_state_json = 6;
   */ _define_property(this, "previousStateJson", ""), /**
   * @generated from field: string new_state_json = 7;
   */ _define_property(this, "newStateJson", ""), /**
   * @generated from field: string policy_decision = 8;
   */ _define_property(this, "policyDecision", ""), /**
   * @generated from field: string correlation_id = 9;
   */ _define_property(this, "correlationId", ""), /**
   * @generated from field: string source = 10;
   */ _define_property(this, "source", ""), /**
   * @generated from field: google.protobuf.Timestamp timestamp = 11;
   */ _define_property(this, "timestamp", void 0), /**
   * WS5: set when the actor's authorizing grant was a DESIGNEE grant — the
   * delegated action is ledgered against both identities, and the reviewer
   * surfaces owe the trail both names (GDS traceability).
   *
   * @generated from field: string acting_on_behalf_of_user_id = 12;
   */ _define_property(this, "actingOnBehalfOfUserId", ""), /**
   * Projected from previous_state_json / new_state_json, sorted by field
   * name and capped server-side. CARRIES VALUES: suppressed under the exact
   * same masking gate that blanks the two state payloads, because a diff is
   * just those payloads in a friendlier shape.
   *
   * @generated from field: repeated mono.projectdata.v1.OpsAuditFieldDiff field_diffs = 13;
   */ _define_property(this, "fieldDiffs", []), /**
   * Resolved from the identity gateway on read (name, else email). Best
   * effort: an unresolvable id leaves these empty rather than failing the
   * read. NOT masked - a masked viewer already sees the raw actor id, so
   * the name is the same identity fact rendered legibly; only value
   * payloads are withheld.
   *
   * @generated from field: string actor_display_name = 14;
   */ _define_property(this, "actorDisplayName", ""), /**
   * @generated from field: string acting_on_behalf_of_display_name = 15;
   */ _define_property(this, "actingOnBehalfOfDisplayName", ""), /**
   * True when the server BLANKED the two state payloads and the diff for
   * this caller's view mode. Without it "the action recorded nothing" and
   * "you are not allowed to see what it recorded" arrive as the identical
   * empty view, and an audit surface that cannot tell those apart misreports
   * the record. Set inside the same gate that does the blanking.
   *
   * @generated from field: bool payloads_withheld = 16;
   */ _define_property(this, "payloadsWithheld", false), /**
   * Resolved display name for the event's OWN object (object_type/object_id),
   * when the object type is one the server can name (currently:
   * delivery.programs — fixes the row-expand's raw "Object:
   * delivery.programs/<uuid>"). NOT masked, same rule as actor_display_name:
   * object_type/object_id are already on every view including a masked one,
   * so naming them discloses no value a masked viewer couldn't already see
   * raw. Best effort: empty when unresolved.
   *
   * @generated from field: string object_display_name = 17;
   */ _define_property(this, "objectDisplayName", ""), /**
   * Resolved display names for identifiers embedded in the payload VALUES
   * (previous_state_json / new_state_json) - a bare user id or an
   * "objectType/objectId" path such as "delivery.programs/<uuid>" - keyed by
   * the EXACT raw token the payload carries, so the caller can look up
   * whatever it is about to render without re-deriving anything. MASKED:
   * populated only when payloads are not withheld, because these names are
   * derived from the same values redactPayloads blanks - a masked or
   * simplified viewer must not regain them through a side channel.
   *
   * @generated from field: map<string, string> reference_display_names = 18;
   */ _define_property(this, "referenceDisplayNames", {});
        proto3.util.initPartial(data, this);
    }
}
_define_property(OpsAuditEventView, "runtime", proto3);
_define_property(OpsAuditEventView, "typeName", "mono.projectdata.v1.OpsAuditEventView");
_define_property(OpsAuditEventView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "actor_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "action_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "object_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "object_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "previous_state_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "new_state_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "policy_decision",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "correlation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "timestamp",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "acting_on_behalf_of_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "field_diffs",
            kind: "message",
            T: OpsAuditFieldDiff,
            repeated: true
        },
        {
            no: 14,
            name: "actor_display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "acting_on_behalf_of_display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "payloads_withheld",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 17,
            name: "object_display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "reference_display_names",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "scalar",
                T: 9 /* ScalarType.STRING */ 
            }
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListOpsAuditEventsRequest
 */ export class ListOpsAuditEventsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListOpsAuditEventsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListOpsAuditEventsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListOpsAuditEventsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListOpsAuditEventsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * All filters are optional; empty filter falls back to "last 100
   * events in the tenant".
   *
   * @generated from field: string action_key_prefix = 1;
   */ _define_property(this, "actionKeyPrefix", ""), /**
   * @generated from field: string object_type = 2;
   */ _define_property(this, "objectType", ""), /**
   * @generated from field: string object_id = 3;
   */ _define_property(this, "objectId", ""), /**
   * @generated from field: string actor_user_id = 4;
   */ _define_property(this, "actorUserId", ""), /**
   * @generated from field: string correlation_id = 5;
   */ _define_property(this, "correlationId", ""), /**
   * @generated from field: google.protobuf.Timestamp since = 6;
   */ _define_property(this, "since", void 0), /**
   * @generated from field: google.protobuf.Timestamp until = 7;
   */ _define_property(this, "until", void 0), /**
   * 0 == server default (100)
   *
   * @generated from field: int32 limit = 8;
   */ _define_property(this, "limit", 0), /**
   * @generated from field: int32 offset = 9;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: string user_id = 10;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 11;
   */ _define_property(this, "companyId", ""), /**
   * SAD-777: the History Action filter's category - any event whose
   * action_key starts with one of these prefixes (OR'd, AND'd with
   * action_key_prefix and the rest). Empty = every category.
   *
   * @generated from field: repeated string action_key_prefixes = 12;
   */ _define_property(this, "actionKeyPrefixes", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListOpsAuditEventsRequest, "runtime", proto3);
_define_property(ListOpsAuditEventsRequest, "typeName", "mono.projectdata.v1.ListOpsAuditEventsRequest");
_define_property(ListOpsAuditEventsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "action_key_prefix",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "object_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "object_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "actor_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "correlation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "since",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "until",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 9,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 10,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "action_key_prefixes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListOpsAuditEventsResponse
 */ export class ListOpsAuditEventsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListOpsAuditEventsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListOpsAuditEventsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListOpsAuditEventsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListOpsAuditEventsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.OpsAuditEventView events = 1;
   */ _define_property(this, "events", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListOpsAuditEventsResponse, "runtime", proto3);
_define_property(ListOpsAuditEventsResponse, "typeName", "mono.projectdata.v1.ListOpsAuditEventsResponse");
_define_property(ListOpsAuditEventsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "events",
            kind: "message",
            T: OpsAuditEventView,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetOpsAuditByCorrelationRequest
 */ export class GetOpsAuditByCorrelationRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetOpsAuditByCorrelationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetOpsAuditByCorrelationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetOpsAuditByCorrelationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetOpsAuditByCorrelationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string correlation_id = 1;
   */ _define_property(this, "correlationId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 3;
   */ _define_property(this, "companyId", ""), /**
   * Optional program scope for callers without tenant-wide audit authority.
   * With it set, the thread is fetched narrowed to this program (and its
   * scope node) so a program manager can expand an operation on their own
   * program; the caller's view mode on the program decides masking exactly
   * as the program timeline lane does.
   *
   * @generated from field: string program_id = 4;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetOpsAuditByCorrelationRequest, "runtime", proto3);
_define_property(GetOpsAuditByCorrelationRequest, "typeName", "mono.projectdata.v1.GetOpsAuditByCorrelationRequest");
_define_property(GetOpsAuditByCorrelationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "correlation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ListMyActivityRequest pages the caller's own activity. There is no actor
 * field: the handler uses the authenticated principal.
 *
 * @generated from message mono.projectdata.v1.ListMyActivityRequest
 */ export class ListMyActivityRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListMyActivityRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListMyActivityRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListMyActivityRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListMyActivityRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string cursor = 1;
   */ _define_property(this, "cursor", ""), /**
   * @generated from field: int32 limit = 2;
   */ _define_property(this, "limit", 0), /**
   * action_key prefix. Empty returns every kind except the access-projection
   * churn the program History tab already hides.
   *
   * @generated from field: string kind = 3;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: google.protobuf.Timestamp since = 4;
   */ _define_property(this, "since", void 0), /**
   * @generated from field: google.protobuf.Timestamp until = 5;
   */ _define_property(this, "until", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListMyActivityRequest, "runtime", proto3);
_define_property(ListMyActivityRequest, "typeName", "mono.projectdata.v1.ListMyActivityRequest");
_define_property(ListMyActivityRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "cursor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "since",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "until",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * MyActivityEntry is one row of Settings → History. summary is a sentence.
 * previous_state_json, new_state_json and field_diffs are set only when the
 * caller can still read the values — the same gate as OpsAuditEventView.
 * record_hidden blanks the name and the record ids as well.
 *
 * @generated from message mono.projectdata.v1.MyActivityEntry
 */ export class MyActivityEntry extends Message {
    static fromBinary(bytes, options) {
        return new MyActivityEntry().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MyActivityEntry().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MyActivityEntry().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MyActivityEntry, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string kind = 2;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string action_key = 3;
   */ _define_property(this, "actionKey", ""), /**
   * @generated from field: string summary = 4;
   */ _define_property(this, "summary", ""), /**
   * @generated from field: google.protobuf.Timestamp occurred_at = 5;
   */ _define_property(this, "occurredAt", void 0), /**
   * @generated from field: string object_type = 6;
   */ _define_property(this, "objectType", ""), /**
   * @generated from field: string object_id = 7;
   */ _define_property(this, "objectId", ""), /**
   * @generated from field: string program_id = 8;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string record_name = 9;
   */ _define_property(this, "recordName", ""), /**
   * @generated from field: bool details_withheld = 10;
   */ _define_property(this, "detailsWithheld", false), /**
   * @generated from field: bool record_hidden = 11;
   */ _define_property(this, "recordHidden", false), /**
   * @generated from field: repeated mono.projectdata.v1.OpsAuditFieldDiff field_diffs = 12;
   */ _define_property(this, "fieldDiffs", []), /**
   * @generated from field: string previous_state_json = 13;
   */ _define_property(this, "previousStateJson", ""), /**
   * @generated from field: string new_state_json = 14;
   */ _define_property(this, "newStateJson", ""), /**
   * The program this record belongs to, when the caller can still read it.
   *
   * @generated from field: string program_name = 15;
   */ _define_property(this, "programName", ""), /**
   * The other person on a role grant or revoke. Empty for every other kind.
   *
   * @generated from field: string counterpart_name = 16;
   */ _define_property(this, "counterpartName", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(MyActivityEntry, "runtime", proto3);
_define_property(MyActivityEntry, "typeName", "mono.projectdata.v1.MyActivityEntry");
_define_property(MyActivityEntry, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "action_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "summary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "occurred_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "object_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "object_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "record_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "details_withheld",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 11,
            name: "record_hidden",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 12,
            name: "field_diffs",
            kind: "message",
            T: OpsAuditFieldDiff,
            repeated: true
        },
        {
            no: 13,
            name: "previous_state_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "new_state_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "program_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "counterpart_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListMyActivityResponse
 */ export class ListMyActivityResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListMyActivityResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListMyActivityResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListMyActivityResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListMyActivityResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.MyActivityEntry entries = 1;
   */ _define_property(this, "entries", []), /**
   * @generated from field: string next_cursor = 2;
   */ _define_property(this, "nextCursor", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListMyActivityResponse, "runtime", proto3);
_define_property(ListMyActivityResponse, "typeName", "mono.projectdata.v1.ListMyActivityResponse");
_define_property(ListMyActivityResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "entries",
            kind: "message",
            T: MyActivityEntry,
            repeated: true
        },
        {
            no: 2,
            name: "next_cursor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetOpsAuditByCorrelationResponse
 */ export class GetOpsAuditByCorrelationResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetOpsAuditByCorrelationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetOpsAuditByCorrelationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetOpsAuditByCorrelationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetOpsAuditByCorrelationResponse, a, b);
    }
    constructor(data){
        super(), /**
   * Returned in timestamp ascending order — the timeline renders
   * top-to-bottom matching causality.
   *
   * @generated from field: repeated mono.projectdata.v1.OpsAuditEventView events = 1;
   */ _define_property(this, "events", []), /**
   * How many events the correlation actually has in this lane's scope, before
   * the server-side cap. The program-scoped lane bounds its query (a change-set
   * apply can fan out to hundreds of item rows), and the rows come back newest
   * first, so a capped thread is missing its EARLIEST causal steps - the ones a
   * reader most needs. total tells the caller the difference; the tenant-wide
   * lane takes no cap, so there total equals events.
   *
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero), /**
   * Stated outright rather than left to a total-vs-length comparison: on an
   * audit trail, an incomplete thread that renders as complete is exactly the
   * failure this surface exists to prevent, so the reader has to be told.
   *
   * @generated from field: bool truncated = 3;
   */ _define_property(this, "truncated", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetOpsAuditByCorrelationResponse, "runtime", proto3);
_define_property(GetOpsAuditByCorrelationResponse, "typeName", "mono.projectdata.v1.GetOpsAuditByCorrelationResponse");
_define_property(GetOpsAuditByCorrelationResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "events",
            kind: "message",
            T: OpsAuditEventView,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 3,
            name: "truncated",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * CaptureProjectSummary — the CaptureProject row + its linked zou project.
 *
 * @generated from message mono.projectdata.v1.CaptureProjectSummary
 */ export class CaptureProjectSummary extends Message {
    static fromBinary(bytes, options) {
        return new CaptureProjectSummary().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureProjectSummary().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureProjectSummary().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureProjectSummary, a, b);
    }
    constructor(data){
        super(), /**
   * pangaea govcon.capture_projects.id
   *
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * zou.Project.id (type=capture)
   *
   * @generated from field: string zou_project_id = 2;
   */ _define_property(this, "zouProjectId", ""), /**
   * @generated from field: string tenant_id = 3;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string name = 4;
   */ _define_property(this, "name", ""), /**
   * optional CRM/account linkage
   *
   * @generated from field: string account_id = 5;
   */ _define_property(this, "accountId", ""), /**
   * government org being pursued
   *
   * @generated from field: string customer_org_id = 6;
   */ _define_property(this, "customerOrgId", ""), /**
   * Deprecated phase alias: shaping|qualifying|pursuing|unknown
   *
   * @generated from field: string stage = 7;
   */ _define_property(this, "stage", ""), /**
   * @generated from field: string opportunity_hypothesis = 8;
   */ _define_property(this, "opportunityHypothesis", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 10;
   */ _define_property(this, "updatedAt", void 0), /**
   * active|parked|closed; UI labels Active/Parked/Closed
   *
   * @generated from field: string lifecycle = 11;
   */ _define_property(this, "lifecycle", ""), /**
   * shaping|qualifying|pursuing|unknown (stage compatibility alias)
   *
   * @generated from field: string business_phase = 12;
   */ _define_property(this, "businessPhase", ""), /**
   * @generated from field: int64 lifecycle_revision = 13;
   */ _define_property(this, "lifecycleRevision", protoInt64.zero), /**
   * @generated from field: google.protobuf.Timestamp lifecycle_revisit_at = 14;
   */ _define_property(this, "lifecycleRevisitAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureProjectSummary, "runtime", proto3);
_define_property(CaptureProjectSummary, "typeName", "mono.projectdata.v1.CaptureProjectSummary");
_define_property(CaptureProjectSummary, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "zou_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "account_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "customer_org_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "stage",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "opportunity_hypothesis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "lifecycle",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "business_phase",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "lifecycle_revision",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 14,
            name: "lifecycle_revisit_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * RfiEventView — one RFI / sources-sought / draft-RFP event on the capture
 * timeline. impacted_requirements_json captures requirement drift across RFIs.
 *
 * @generated from message mono.projectdata.v1.RfiEventView
 */ export class RfiEventView extends Message {
    static fromBinary(bytes, options) {
        return new RfiEventView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RfiEventView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RfiEventView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RfiEventView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * SAM.gov notice id when known
   *
   * @generated from field: string source_notice_id = 3;
   */ _define_property(this, "sourceNoticeId", ""), /**
   * @generated from field: string title = 4;
   */ _define_property(this, "title", ""), /**
   * sources_sought|rfi|draft_rfp|industry_day|other
   *
   * @generated from field: string rfi_type = 5;
   */ _define_property(this, "rfiType", ""), /**
   * @generated from field: google.protobuf.Timestamp event_date = 6;
   */ _define_property(this, "eventDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp response_due = 7;
   */ _define_property(this, "responseDue", void 0), /**
   * @generated from field: string questions = 8;
   */ _define_property(this, "questions", ""), /**
   * pangaea Artifact id of our response
   *
   * @generated from field: string response_artifact_id = 9;
   */ _define_property(this, "responseArtifactId", ""), /**
   * @generated from field: string impacted_requirements_json = 10;
   */ _define_property(this, "impactedRequirementsJson", ""), /**
   * @generated from field: string impacted_vehicle_strategy = 11;
   */ _define_property(this, "impactedVehicleStrategy", ""), /**
   * @generated from field: string notes = 12;
   */ _define_property(this, "notes", ""), /**
   * pending|responded|not_responded|missed. Derived for rows saved before it
   * existed: responded when response_artifact_id is set, pending when the
   * due date is unset or in the future, else empty (unknown).
   *
   * @generated from field: string response_status = 13;
   */ _define_property(this, "responseStatus", ""), /**
   * why not_responded / missed
   *
   * @generated from field: string response_reason = 14;
   */ _define_property(this, "responseReason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RfiEventView, "runtime", proto3);
_define_property(RfiEventView, "typeName", "mono.projectdata.v1.RfiEventView");
_define_property(RfiEventView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "source_notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "rfi_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "event_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "response_due",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "questions",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "response_artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "impacted_requirements_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "impacted_vehicle_strategy",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "response_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "response_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * CustomerInteractionView — one logged customer-shaping interaction.
 *
 * @generated from message mono.projectdata.v1.CustomerInteractionView
 */ export class CustomerInteractionView extends Message {
    static fromBinary(bytes, options) {
        return new CustomerInteractionView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CustomerInteractionView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CustomerInteractionView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CustomerInteractionView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: google.protobuf.Timestamp interaction_date = 3;
   */ _define_property(this, "interactionDate", void 0), /**
   * meeting|email|call|conference|other
   *
   * @generated from field: string channel = 4;
   */ _define_property(this, "channel", ""), /**
   * @generated from field: string stakeholder = 5;
   */ _define_property(this, "stakeholder", ""), /**
   * @generated from field: string summary = 6;
   */ _define_property(this, "summary", ""), /**
   * positive|neutral|negative|unknown
   *
   * @generated from field: string sentiment = 7;
   */ _define_property(this, "sentiment", ""), /**
   * @generated from field: string follow_ups = 8;
   */ _define_property(this, "followUps", ""), /**
   * @generated from field: string notes = 9;
   */ _define_property(this, "notes", ""), /**
   * @generated from field: optional string title = 10;
   */ _define_property(this, "title", void 0), /**
   * @generated from field: optional bool is_draft = 11;
   */ _define_property(this, "isDraft", void 0), /**
   * @generated from field: repeated mono.projectdata.v1.TouchpointParticipant participants = 12;
   */ _define_property(this, "participants", []), /**
   * @generated from field: string inferred_need = 13;
   */ _define_property(this, "inferredNeed", ""), /**
   * GRW-36: the event this touchpoint happened at ("" = none) and its title
   * (read from govcon.events at request time).
   *
   * @generated from field: string event_id = 14;
   */ _define_property(this, "eventId", ""), /**
   * @generated from field: string event_title = 15;
   */ _define_property(this, "eventTitle", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CustomerInteractionView, "runtime", proto3);
_define_property(CustomerInteractionView, "typeName", "mono.projectdata.v1.CustomerInteractionView");
_define_property(CustomerInteractionView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "interaction_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 4,
            name: "channel",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "stakeholder",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "summary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "sentiment",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "follow_ups",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 11,
            name: "is_draft",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ ,
            opt: true
        },
        {
            no: 12,
            name: "participants",
            kind: "message",
            T: TouchpointParticipant,
            repeated: true
        },
        {
            no: 13,
            name: "inferred_need",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "event_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "event_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * CaptureWorkstreamItemView — one structured record under one of the 8
 * workstreams. ai_drafted carries the §12 Copilot-drafted state until a human
 * approves; data_json holds workstream-specific structured fields.
 *
 * @generated from message mono.projectdata.v1.CaptureWorkstreamItemView
 */ export class CaptureWorkstreamItemView extends Message {
    static fromBinary(bytes, options) {
        return new CaptureWorkstreamItemView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureWorkstreamItemView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureWorkstreamItemView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureWorkstreamItemView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: mono.projectdata.v1.CaptureWorkstreamType workstream_type = 3;
   */ _define_property(this, "workstreamType", 0), /**
   * @generated from field: string title = 4;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string body = 5;
   */ _define_property(this, "body", ""), /**
   * open|in_progress|done|parked
   *
   * @generated from field: string status = 6;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string data_json = 7;
   */ _define_property(this, "dataJson", ""), /**
   * @generated from field: bool ai_drafted = 8;
   */ _define_property(this, "aiDrafted", false), /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 10;
   */ _define_property(this, "updatedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureWorkstreamItemView, "runtime", proto3);
_define_property(CaptureWorkstreamItemView, "typeName", "mono.projectdata.v1.CaptureWorkstreamItemView");
_define_property(CaptureWorkstreamItemView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "workstream_type",
            kind: "enum",
            T: proto3.getEnumType(CaptureWorkstreamType)
        },
        {
            no: 4,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "body",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "data_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "ai_drafted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 9,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CreateCaptureProjectRequest
 */ export class CreateCaptureProjectRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateCaptureProjectRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateCaptureProjectRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateCaptureProjectRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateCaptureProjectRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string name = 1;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string account_id = 2;
   */ _define_property(this, "accountId", ""), /**
   * @generated from field: string customer_org_id = 3;
   */ _define_property(this, "customerOrgId", ""), /**
   * @generated from field: string opportunity_hypothesis = 4;
   */ _define_property(this, "opportunityHypothesis", ""), /**
   * @generated from field: string user_id = 5;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 6;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateCaptureProjectRequest, "runtime", proto3);
_define_property(CreateCaptureProjectRequest, "typeName", "mono.projectdata.v1.CreateCaptureProjectRequest");
_define_property(CreateCaptureProjectRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "account_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "customer_org_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "opportunity_hypothesis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CreateCaptureProjectResponse
 */ export class CreateCaptureProjectResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateCaptureProjectResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateCaptureProjectResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateCaptureProjectResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateCaptureProjectResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.CaptureProjectSummary summary = 1;
   */ _define_property(this, "summary", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateCaptureProjectResponse, "runtime", proto3);
_define_property(CreateCaptureProjectResponse, "typeName", "mono.projectdata.v1.CreateCaptureProjectResponse");
_define_property(CreateCaptureProjectResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "summary",
            kind: "message",
            T: CaptureProjectSummary
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpdateCaptureProjectRequest
 */ export class UpdateCaptureProjectRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateCaptureProjectRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateCaptureProjectRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateCaptureProjectRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateCaptureProjectRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * Business phase only: shaping|qualifying|pursuing|unknown
   *
   * @generated from field: string stage = 3;
   */ _define_property(this, "stage", ""), /**
   * @generated from field: string opportunity_hypothesis = 4;
   */ _define_property(this, "opportunityHypothesis", ""), /**
   * optional CRM/account linkage
   *
   * @generated from field: string account_id = 5;
   */ _define_property(this, "accountId", ""), /**
   * government org being pursued
   *
   * @generated from field: string customer_org_id = 6;
   */ _define_property(this, "customerOrgId", ""), /**
   * @generated from field: string user_id = 7;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 8;
   */ _define_property(this, "companyId", ""), /**
   * Preferred phase field; must match stage when both provided.
   *
   * @generated from field: string business_phase = 9;
   */ _define_property(this, "businessPhase", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateCaptureProjectRequest, "runtime", proto3);
_define_property(UpdateCaptureProjectRequest, "typeName", "mono.projectdata.v1.UpdateCaptureProjectRequest");
_define_property(UpdateCaptureProjectRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "stage",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "opportunity_hypothesis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "account_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "customer_org_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "business_phase",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpdateCaptureProjectResponse
 */ export class UpdateCaptureProjectResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateCaptureProjectResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateCaptureProjectResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateCaptureProjectResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateCaptureProjectResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.CaptureProjectSummary summary = 1;
   */ _define_property(this, "summary", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateCaptureProjectResponse, "runtime", proto3);
_define_property(UpdateCaptureProjectResponse, "typeName", "mono.projectdata.v1.UpdateCaptureProjectResponse");
_define_property(UpdateCaptureProjectResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "summary",
            kind: "message",
            T: CaptureProjectSummary
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListCaptureProjectsRequest
 */ export class ListCaptureProjectsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCaptureProjectsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCaptureProjectsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCaptureProjectsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCaptureProjectsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string user_id = 1;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 2;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCaptureProjectsRequest, "runtime", proto3);
_define_property(ListCaptureProjectsRequest, "typeName", "mono.projectdata.v1.ListCaptureProjectsRequest");
_define_property(ListCaptureProjectsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListCaptureProjectsResponse
 */ export class ListCaptureProjectsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCaptureProjectsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCaptureProjectsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCaptureProjectsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCaptureProjectsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.CaptureProjectSummary captures = 1;
   */ _define_property(this, "captures", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCaptureProjectsResponse, "runtime", proto3);
_define_property(ListCaptureProjectsResponse, "typeName", "mono.projectdata.v1.ListCaptureProjectsResponse");
_define_property(ListCaptureProjectsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "captures",
            kind: "message",
            T: CaptureProjectSummary,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetCaptureWorkspaceRequest
 */ export class GetCaptureWorkspaceRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetCaptureWorkspaceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCaptureWorkspaceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCaptureWorkspaceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCaptureWorkspaceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 3;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCaptureWorkspaceRequest, "runtime", proto3);
_define_property(GetCaptureWorkspaceRequest, "typeName", "mono.projectdata.v1.GetCaptureWorkspaceRequest");
_define_property(GetCaptureWorkspaceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetCaptureWorkspaceResponse
 */ export class GetCaptureWorkspaceResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetCaptureWorkspaceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCaptureWorkspaceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCaptureWorkspaceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCaptureWorkspaceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.CaptureProjectSummary summary = 1;
   */ _define_property(this, "summary", void 0), /**
   * @generated from field: repeated mono.projectdata.v1.RfiEventView rfi_events = 2;
   */ _define_property(this, "rfiEvents", []), /**
   * @generated from field: repeated mono.projectdata.v1.CustomerInteractionView interactions = 3;
   */ _define_property(this, "interactions", []), /**
   * @generated from field: repeated mono.projectdata.v1.CaptureWorkstreamItemView workstream_items = 4;
   */ _define_property(this, "workstreamItems", []), /**
   * P-L3b: scheduled go/no-go records on this pursuit (pending first).
   *
   * @generated from field: repeated mono.projectdata.v1.CaptureGoNoGoDecisionView go_no_go_decisions = 5;
   */ _define_property(this, "goNoGoDecisions", []), /**
   * @generated from field: mono.projectdata.v1.CaptureProfileView profile = 10;
   */ _define_property(this, "profile", void 0), /**
   * @generated from field: repeated mono.projectdata.v1.CaptureTeamingLinkView teaming_links = 11;
   */ _define_property(this, "teamingLinks", []), /**
   * @generated from field: repeated mono.projectdata.v1.CaptureCompetitionLinkView competition_links = 12;
   */ _define_property(this, "competitionLinks", []), /**
   * G-2: action-plan task rows on this pursuit (sort_order, then created).
   *
   * @generated from field: repeated mono.projectdata.v1.CaptureTaskView tasks = 13;
   */ _define_property(this, "tasks", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCaptureWorkspaceResponse, "runtime", proto3);
_define_property(GetCaptureWorkspaceResponse, "typeName", "mono.projectdata.v1.GetCaptureWorkspaceResponse");
_define_property(GetCaptureWorkspaceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "summary",
            kind: "message",
            T: CaptureProjectSummary
        },
        {
            no: 2,
            name: "rfi_events",
            kind: "message",
            T: RfiEventView,
            repeated: true
        },
        {
            no: 3,
            name: "interactions",
            kind: "message",
            T: CustomerInteractionView,
            repeated: true
        },
        {
            no: 4,
            name: "workstream_items",
            kind: "message",
            T: CaptureWorkstreamItemView,
            repeated: true
        },
        {
            no: 5,
            name: "go_no_go_decisions",
            kind: "message",
            T: CaptureGoNoGoDecisionView,
            repeated: true
        },
        {
            no: 10,
            name: "profile",
            kind: "message",
            T: CaptureProfileView
        },
        {
            no: 11,
            name: "teaming_links",
            kind: "message",
            T: CaptureTeamingLinkView,
            repeated: true
        },
        {
            no: 12,
            name: "competition_links",
            kind: "message",
            T: CaptureCompetitionLinkView,
            repeated: true
        },
        {
            no: 13,
            name: "tasks",
            kind: "message",
            T: CaptureTaskView,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RfiResponseSectionView
 */ export class RfiResponseSectionView extends Message {
    static fromBinary(bytes, options) {
        return new RfiResponseSectionView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RfiResponseSectionView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RfiResponseSectionView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RfiResponseSectionView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string title = 1;
   */ _define_property(this, "title", ""), /**
   * open|in_progress|done
   *
   * @generated from field: string status = 2;
   */ _define_property(this, "status", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RfiResponseSectionView, "runtime", proto3);
_define_property(RfiResponseSectionView, "typeName", "mono.projectdata.v1.RfiResponseSectionView");
_define_property(RfiResponseSectionView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RfiResponseProjectSummary
 */ export class RfiResponseProjectSummary extends Message {
    static fromBinary(bytes, options) {
        return new RfiResponseProjectSummary().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RfiResponseProjectSummary().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RfiResponseProjectSummary().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RfiResponseProjectSummary, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string zou_project_id = 2;
   */ _define_property(this, "zouProjectId", ""), /**
   * @generated from field: string tenant_id = 3;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string title = 4;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string source_notice_id = 5;
   */ _define_property(this, "sourceNoticeId", ""), /**
   * @generated from field: google.protobuf.Timestamp response_due = 6;
   */ _define_property(this, "responseDue", void 0), /**
   * @generated from field: string status = 7;
   */ _define_property(this, "status", ""), /**
   * @generated from field: repeated mono.projectdata.v1.RfiResponseSectionView sections = 8;
   */ _define_property(this, "sections", []), /**
   * @generated from field: string notes = 9;
   */ _define_property(this, "notes", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 11;
   */ _define_property(this, "updatedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RfiResponseProjectSummary, "runtime", proto3);
_define_property(RfiResponseProjectSummary, "typeName", "mono.projectdata.v1.RfiResponseProjectSummary");
_define_property(RfiResponseProjectSummary, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "zou_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "source_notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "response_due",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "sections",
            kind: "message",
            T: RfiResponseSectionView,
            repeated: true
        },
        {
            no: 9,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CaptureRfiResponseLinkView
 */ export class CaptureRfiResponseLinkView extends Message {
    static fromBinary(bytes, options) {
        return new CaptureRfiResponseLinkView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureRfiResponseLinkView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureRfiResponseLinkView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureRfiResponseLinkView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string link_id = 1;
   */ _define_property(this, "linkId", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string capture_name = 3;
   */ _define_property(this, "captureName", ""), /**
   * @generated from field: string rfi_response_project_id = 4;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string rfi_response_title = 5;
   */ _define_property(this, "rfiResponseTitle", ""), /**
   * @generated from field: string zou_project_id = 6;
   */ _define_property(this, "zouProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureRfiResponseLinkView, "runtime", proto3);
_define_property(CaptureRfiResponseLinkView, "typeName", "mono.projectdata.v1.CaptureRfiResponseLinkView");
_define_property(CaptureRfiResponseLinkView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "link_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "capture_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "rfi_response_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "zou_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CreateRfiResponseProjectRequest
 */ export class CreateRfiResponseProjectRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateRfiResponseProjectRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateRfiResponseProjectRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateRfiResponseProjectRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateRfiResponseProjectRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string title = 1;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string source_notice_id = 2;
   */ _define_property(this, "sourceNoticeId", ""), /**
   * @generated from field: google.protobuf.Timestamp response_due = 3;
   */ _define_property(this, "responseDue", void 0), /**
   * @generated from field: string status = 4;
   */ _define_property(this, "status", ""), /**
   * @generated from field: repeated mono.projectdata.v1.RfiResponseSectionView sections = 5;
   */ _define_property(this, "sections", []), /**
   * @generated from field: string notes = 6;
   */ _define_property(this, "notes", ""), /**
   * Optional: create an initial M:N link to this pursuit.
   *
   * @generated from field: string capture_project_id = 7;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string user_id = 8;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 9;
   */ _define_property(this, "companyId", ""), /**
   * Optional caller-chosen idempotency key. A retried create with the same key
   * (same tenant and user) returns the RFI Response the first call made instead
   * of creating a second one.
   *
   * @generated from field: string client_request_id = 10;
   */ _define_property(this, "clientRequestId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateRfiResponseProjectRequest, "runtime", proto3);
_define_property(CreateRfiResponseProjectRequest, "typeName", "mono.projectdata.v1.CreateRfiResponseProjectRequest");
_define_property(CreateRfiResponseProjectRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "source_notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "response_due",
            kind: "message",
            T: Timestamp
        },
        {
            no: 4,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "sections",
            kind: "message",
            T: RfiResponseSectionView,
            repeated: true
        },
        {
            no: 6,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "client_request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CreateRfiResponseProjectResponse
 */ export class CreateRfiResponseProjectResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateRfiResponseProjectResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateRfiResponseProjectResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateRfiResponseProjectResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateRfiResponseProjectResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.RfiResponseProjectSummary summary = 1;
   */ _define_property(this, "summary", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateRfiResponseProjectResponse, "runtime", proto3);
_define_property(CreateRfiResponseProjectResponse, "typeName", "mono.projectdata.v1.CreateRfiResponseProjectResponse");
_define_property(CreateRfiResponseProjectResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "summary",
            kind: "message",
            T: RfiResponseProjectSummary
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetRfiResponseWorkspaceRequest
 */ export class GetRfiResponseWorkspaceRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetRfiResponseWorkspaceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetRfiResponseWorkspaceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetRfiResponseWorkspaceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetRfiResponseWorkspaceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * Pangaea rfi_response_project id OR zou project id (resolver chip deep-link).
   *
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 3;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetRfiResponseWorkspaceRequest, "runtime", proto3);
_define_property(GetRfiResponseWorkspaceRequest, "typeName", "mono.projectdata.v1.GetRfiResponseWorkspaceRequest");
_define_property(GetRfiResponseWorkspaceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetRfiResponseWorkspaceResponse
 */ export class GetRfiResponseWorkspaceResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetRfiResponseWorkspaceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetRfiResponseWorkspaceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetRfiResponseWorkspaceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetRfiResponseWorkspaceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.RfiResponseProjectSummary summary = 1;
   */ _define_property(this, "summary", void 0), /**
   * @generated from field: repeated mono.projectdata.v1.CaptureRfiResponseLinkView linked_pursuits = 2;
   */ _define_property(this, "linkedPursuits", []), /**
   * @generated from field: repeated mono.projectdata.v1.OpportunityRfiResponseLinkView linked_opportunities = 3;
   */ _define_property(this, "linkedOpportunities", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetRfiResponseWorkspaceResponse, "runtime", proto3);
_define_property(GetRfiResponseWorkspaceResponse, "typeName", "mono.projectdata.v1.GetRfiResponseWorkspaceResponse");
_define_property(GetRfiResponseWorkspaceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "summary",
            kind: "message",
            T: RfiResponseProjectSummary
        },
        {
            no: 2,
            name: "linked_pursuits",
            kind: "message",
            T: CaptureRfiResponseLinkView,
            repeated: true
        },
        {
            no: 3,
            name: "linked_opportunities",
            kind: "message",
            T: OpportunityRfiResponseLinkView,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpdateRfiResponseProjectRequest
 */ export class UpdateRfiResponseProjectRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateRfiResponseProjectRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateRfiResponseProjectRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateRfiResponseProjectRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateRfiResponseProjectRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string source_notice_id = 3;
   */ _define_property(this, "sourceNoticeId", ""), /**
   * @generated from field: google.protobuf.Timestamp response_due = 4;
   */ _define_property(this, "responseDue", void 0), /**
   * @generated from field: string status = 5;
   */ _define_property(this, "status", ""), /**
   * @generated from field: repeated mono.projectdata.v1.RfiResponseSectionView sections = 6;
   */ _define_property(this, "sections", []), /**
   * Plain scalar, honored on CREATE-shaped full-row echoes only. It predates
   * explicit presence and cannot be changed to `optional` in place —
   * `buf breaking` (FILE category) flags a cardinality change on an existing
   * field number as breaking. UPDATE must use notes_v2; the server ignores
   * field 7 on update rather than let a status-only save send "" and wipe
   * stored notes.
   *
   * @generated from field: string notes = 7;
   */ _define_property(this, "notes", ""), /**
   * @generated from field: string user_id = 8;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 9;
   */ _define_property(this, "companyId", ""), /**
   * Presence-safe notes patch. Unset leaves stored notes; set to "" clears.
   *
   * @generated from field: optional string notes_v2 = 10;
   */ _define_property(this, "notesV2", void 0), /**
   * Presence-safe source notice patch. Unset leaves stored source_notice_id;
   * set to "" clears. Field 3 cannot become optional in place (buf breaking).
   *
   * @generated from field: optional string source_notice_id_v2 = 11;
   */ _define_property(this, "sourceNoticeIdV2", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateRfiResponseProjectRequest, "runtime", proto3);
_define_property(UpdateRfiResponseProjectRequest, "typeName", "mono.projectdata.v1.UpdateRfiResponseProjectRequest");
_define_property(UpdateRfiResponseProjectRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "source_notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "response_due",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "sections",
            kind: "message",
            T: RfiResponseSectionView,
            repeated: true
        },
        {
            no: 7,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "notes_v2",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 11,
            name: "source_notice_id_v2",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpdateRfiResponseProjectResponse
 */ export class UpdateRfiResponseProjectResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateRfiResponseProjectResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateRfiResponseProjectResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateRfiResponseProjectResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateRfiResponseProjectResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.RfiResponseProjectSummary summary = 1;
   */ _define_property(this, "summary", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateRfiResponseProjectResponse, "runtime", proto3);
_define_property(UpdateRfiResponseProjectResponse, "typeName", "mono.projectdata.v1.UpdateRfiResponseProjectResponse");
_define_property(UpdateRfiResponseProjectResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "summary",
            kind: "message",
            T: RfiResponseProjectSummary
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.LinkRfiResponseToCaptureRequest
 */ export class LinkRfiResponseToCaptureRequest extends Message {
    static fromBinary(bytes, options) {
        return new LinkRfiResponseToCaptureRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LinkRfiResponseToCaptureRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LinkRfiResponseToCaptureRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LinkRfiResponseToCaptureRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string rfi_response_project_id = 2;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string user_id = 3;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 4;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LinkRfiResponseToCaptureRequest, "runtime", proto3);
_define_property(LinkRfiResponseToCaptureRequest, "typeName", "mono.projectdata.v1.LinkRfiResponseToCaptureRequest");
_define_property(LinkRfiResponseToCaptureRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.LinkRfiResponseToCaptureResponse
 */ export class LinkRfiResponseToCaptureResponse extends Message {
    static fromBinary(bytes, options) {
        return new LinkRfiResponseToCaptureResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LinkRfiResponseToCaptureResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LinkRfiResponseToCaptureResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LinkRfiResponseToCaptureResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.CaptureRfiResponseLinkView link = 1;
   */ _define_property(this, "link", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(LinkRfiResponseToCaptureResponse, "runtime", proto3);
_define_property(LinkRfiResponseToCaptureResponse, "typeName", "mono.projectdata.v1.LinkRfiResponseToCaptureResponse");
_define_property(LinkRfiResponseToCaptureResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "link",
            kind: "message",
            T: CaptureRfiResponseLinkView
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UnlinkRfiResponseFromCaptureRequest
 */ export class UnlinkRfiResponseFromCaptureRequest extends Message {
    static fromBinary(bytes, options) {
        return new UnlinkRfiResponseFromCaptureRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UnlinkRfiResponseFromCaptureRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UnlinkRfiResponseFromCaptureRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UnlinkRfiResponseFromCaptureRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string rfi_response_project_id = 2;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string user_id = 3;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 4;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UnlinkRfiResponseFromCaptureRequest, "runtime", proto3);
_define_property(UnlinkRfiResponseFromCaptureRequest, "typeName", "mono.projectdata.v1.UnlinkRfiResponseFromCaptureRequest");
_define_property(UnlinkRfiResponseFromCaptureRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UnlinkRfiResponseFromCaptureResponse
 */ export class UnlinkRfiResponseFromCaptureResponse extends Message {
    static fromBinary(bytes, options) {
        return new UnlinkRfiResponseFromCaptureResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UnlinkRfiResponseFromCaptureResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UnlinkRfiResponseFromCaptureResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UnlinkRfiResponseFromCaptureResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(UnlinkRfiResponseFromCaptureResponse, "runtime", proto3);
_define_property(UnlinkRfiResponseFromCaptureResponse, "typeName", "mono.projectdata.v1.UnlinkRfiResponseFromCaptureResponse");
_define_property(UnlinkRfiResponseFromCaptureResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.projectdata.v1.ListRfiResponsesForCaptureRequest
 */ export class ListRfiResponsesForCaptureRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListRfiResponsesForCaptureRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRfiResponsesForCaptureRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRfiResponsesForCaptureRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRfiResponsesForCaptureRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 3;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRfiResponsesForCaptureRequest, "runtime", proto3);
_define_property(ListRfiResponsesForCaptureRequest, "typeName", "mono.projectdata.v1.ListRfiResponsesForCaptureRequest");
_define_property(ListRfiResponsesForCaptureRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListRfiResponsesForCaptureResponse
 */ export class ListRfiResponsesForCaptureResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListRfiResponsesForCaptureResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRfiResponsesForCaptureResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRfiResponsesForCaptureResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRfiResponsesForCaptureResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.RfiResponseProjectSummary workspaces = 1;
   */ _define_property(this, "workspaces", []), /**
   * @generated from field: repeated mono.projectdata.v1.RfiEventView legacy_rfi_events = 2;
   */ _define_property(this, "legacyRfiEvents", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRfiResponsesForCaptureResponse, "runtime", proto3);
_define_property(ListRfiResponsesForCaptureResponse, "typeName", "mono.projectdata.v1.ListRfiResponsesForCaptureResponse");
_define_property(ListRfiResponsesForCaptureResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "workspaces",
            kind: "message",
            T: RfiResponseProjectSummary,
            repeated: true
        },
        {
            no: 2,
            name: "legacy_rfi_events",
            kind: "message",
            T: RfiEventView,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListCaptureLinksForRfiResponseRequest
 */ export class ListCaptureLinksForRfiResponseRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCaptureLinksForRfiResponseRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCaptureLinksForRfiResponseRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCaptureLinksForRfiResponseRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCaptureLinksForRfiResponseRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 3;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCaptureLinksForRfiResponseRequest, "runtime", proto3);
_define_property(ListCaptureLinksForRfiResponseRequest, "typeName", "mono.projectdata.v1.ListCaptureLinksForRfiResponseRequest");
_define_property(ListCaptureLinksForRfiResponseRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListCaptureLinksForRfiResponseResponse
 */ export class ListCaptureLinksForRfiResponseResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCaptureLinksForRfiResponseResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCaptureLinksForRfiResponseResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCaptureLinksForRfiResponseResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCaptureLinksForRfiResponseResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.CaptureRfiResponseLinkView linked_pursuits = 1;
   */ _define_property(this, "linkedPursuits", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCaptureLinksForRfiResponseResponse, "runtime", proto3);
_define_property(ListCaptureLinksForRfiResponseResponse, "typeName", "mono.projectdata.v1.ListCaptureLinksForRfiResponseResponse");
_define_property(ListCaptureLinksForRfiResponseResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "linked_pursuits",
            kind: "message",
            T: CaptureRfiResponseLinkView,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ProposalRfiResponseLinkView
 */ export class ProposalRfiResponseLinkView extends Message {
    static fromBinary(bytes, options) {
        return new ProposalRfiResponseLinkView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposalRfiResponseLinkView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposalRfiResponseLinkView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposalRfiResponseLinkView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string link_id = 1;
   */ _define_property(this, "linkId", ""), /**
   * @generated from field: string proposal_project_id = 2;
   */ _define_property(this, "proposalProjectId", ""), /**
   * @generated from field: string proposal_name = 3;
   */ _define_property(this, "proposalName", ""), /**
   * @generated from field: string rfi_response_project_id = 4;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string rfi_response_title = 5;
   */ _define_property(this, "rfiResponseTitle", ""), /**
   * @generated from field: string zou_project_id = 6;
   */ _define_property(this, "zouProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposalRfiResponseLinkView, "runtime", proto3);
_define_property(ProposalRfiResponseLinkView, "typeName", "mono.projectdata.v1.ProposalRfiResponseLinkView");
_define_property(ProposalRfiResponseLinkView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "link_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "proposal_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "proposal_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "rfi_response_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "zou_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.LinkRfiResponseToProposalRequest
 */ export class LinkRfiResponseToProposalRequest extends Message {
    static fromBinary(bytes, options) {
        return new LinkRfiResponseToProposalRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LinkRfiResponseToProposalRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LinkRfiResponseToProposalRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LinkRfiResponseToProposalRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string proposal_project_id = 1;
   */ _define_property(this, "proposalProjectId", ""), /**
   * @generated from field: string rfi_response_project_id = 2;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string user_id = 3;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 4;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LinkRfiResponseToProposalRequest, "runtime", proto3);
_define_property(LinkRfiResponseToProposalRequest, "typeName", "mono.projectdata.v1.LinkRfiResponseToProposalRequest");
_define_property(LinkRfiResponseToProposalRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "proposal_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.LinkRfiResponseToProposalResponse
 */ export class LinkRfiResponseToProposalResponse extends Message {
    static fromBinary(bytes, options) {
        return new LinkRfiResponseToProposalResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LinkRfiResponseToProposalResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LinkRfiResponseToProposalResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LinkRfiResponseToProposalResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.ProposalRfiResponseLinkView link = 1;
   */ _define_property(this, "link", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(LinkRfiResponseToProposalResponse, "runtime", proto3);
_define_property(LinkRfiResponseToProposalResponse, "typeName", "mono.projectdata.v1.LinkRfiResponseToProposalResponse");
_define_property(LinkRfiResponseToProposalResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "link",
            kind: "message",
            T: ProposalRfiResponseLinkView
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UnlinkRfiResponseFromProposalRequest
 */ export class UnlinkRfiResponseFromProposalRequest extends Message {
    static fromBinary(bytes, options) {
        return new UnlinkRfiResponseFromProposalRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UnlinkRfiResponseFromProposalRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UnlinkRfiResponseFromProposalRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UnlinkRfiResponseFromProposalRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string proposal_project_id = 1;
   */ _define_property(this, "proposalProjectId", ""), /**
   * @generated from field: string rfi_response_project_id = 2;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string user_id = 3;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 4;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UnlinkRfiResponseFromProposalRequest, "runtime", proto3);
_define_property(UnlinkRfiResponseFromProposalRequest, "typeName", "mono.projectdata.v1.UnlinkRfiResponseFromProposalRequest");
_define_property(UnlinkRfiResponseFromProposalRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "proposal_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UnlinkRfiResponseFromProposalResponse
 */ export class UnlinkRfiResponseFromProposalResponse extends Message {
    static fromBinary(bytes, options) {
        return new UnlinkRfiResponseFromProposalResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UnlinkRfiResponseFromProposalResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UnlinkRfiResponseFromProposalResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UnlinkRfiResponseFromProposalResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(UnlinkRfiResponseFromProposalResponse, "runtime", proto3);
_define_property(UnlinkRfiResponseFromProposalResponse, "typeName", "mono.projectdata.v1.UnlinkRfiResponseFromProposalResponse");
_define_property(UnlinkRfiResponseFromProposalResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.projectdata.v1.ListRfiResponsesForProposalRequest
 */ export class ListRfiResponsesForProposalRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListRfiResponsesForProposalRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRfiResponsesForProposalRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRfiResponsesForProposalRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRfiResponsesForProposalRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string proposal_project_id = 1;
   */ _define_property(this, "proposalProjectId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 3;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRfiResponsesForProposalRequest, "runtime", proto3);
_define_property(ListRfiResponsesForProposalRequest, "typeName", "mono.projectdata.v1.ListRfiResponsesForProposalRequest");
_define_property(ListRfiResponsesForProposalRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "proposal_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListRfiResponsesForProposalResponse
 */ export class ListRfiResponsesForProposalResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListRfiResponsesForProposalResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRfiResponsesForProposalResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRfiResponsesForProposalResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRfiResponsesForProposalResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.RfiResponseProjectSummary workspaces = 1;
   */ _define_property(this, "workspaces", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRfiResponsesForProposalResponse, "runtime", proto3);
_define_property(ListRfiResponsesForProposalResponse, "typeName", "mono.projectdata.v1.ListRfiResponsesForProposalResponse");
_define_property(ListRfiResponsesForProposalResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "workspaces",
            kind: "message",
            T: RfiResponseProjectSummary,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListProposalLinksForRfiResponseRequest
 */ export class ListProposalLinksForRfiResponseRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListProposalLinksForRfiResponseRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProposalLinksForRfiResponseRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProposalLinksForRfiResponseRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProposalLinksForRfiResponseRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 3;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProposalLinksForRfiResponseRequest, "runtime", proto3);
_define_property(ListProposalLinksForRfiResponseRequest, "typeName", "mono.projectdata.v1.ListProposalLinksForRfiResponseRequest");
_define_property(ListProposalLinksForRfiResponseRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListProposalLinksForRfiResponseResponse
 */ export class ListProposalLinksForRfiResponseResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListProposalLinksForRfiResponseResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProposalLinksForRfiResponseResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProposalLinksForRfiResponseResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProposalLinksForRfiResponseResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.ProposalRfiResponseLinkView linked_proposals = 1;
   */ _define_property(this, "linkedProposals", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProposalLinksForRfiResponseResponse, "runtime", proto3);
_define_property(ListProposalLinksForRfiResponseResponse, "typeName", "mono.projectdata.v1.ListProposalLinksForRfiResponseResponse");
_define_property(ListProposalLinksForRfiResponseResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "linked_proposals",
            kind: "message",
            T: ProposalRfiResponseLinkView,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.OpportunityRfiResponseLinkView
 */ export class OpportunityRfiResponseLinkView extends Message {
    static fromBinary(bytes, options) {
        return new OpportunityRfiResponseLinkView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OpportunityRfiResponseLinkView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OpportunityRfiResponseLinkView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OpportunityRfiResponseLinkView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string link_id = 1;
   */ _define_property(this, "linkId", ""), /**
   * @generated from field: string notice_id = 2;
   */ _define_property(this, "noticeId", ""), /**
   * @generated from field: string rfi_response_project_id = 3;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string rfi_response_title = 4;
   */ _define_property(this, "rfiResponseTitle", ""), /**
   * @generated from field: string zou_project_id = 5;
   */ _define_property(this, "zouProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(OpportunityRfiResponseLinkView, "runtime", proto3);
_define_property(OpportunityRfiResponseLinkView, "typeName", "mono.projectdata.v1.OpportunityRfiResponseLinkView");
_define_property(OpportunityRfiResponseLinkView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "link_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "rfi_response_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "zou_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.LinkRfiResponseToOpportunityRequest
 */ export class LinkRfiResponseToOpportunityRequest extends Message {
    static fromBinary(bytes, options) {
        return new LinkRfiResponseToOpportunityRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LinkRfiResponseToOpportunityRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LinkRfiResponseToOpportunityRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LinkRfiResponseToOpportunityRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string notice_id = 1;
   */ _define_property(this, "noticeId", ""), /**
   * @generated from field: string rfi_response_project_id = 2;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string user_id = 3;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 4;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LinkRfiResponseToOpportunityRequest, "runtime", proto3);
_define_property(LinkRfiResponseToOpportunityRequest, "typeName", "mono.projectdata.v1.LinkRfiResponseToOpportunityRequest");
_define_property(LinkRfiResponseToOpportunityRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.LinkRfiResponseToOpportunityResponse
 */ export class LinkRfiResponseToOpportunityResponse extends Message {
    static fromBinary(bytes, options) {
        return new LinkRfiResponseToOpportunityResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LinkRfiResponseToOpportunityResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LinkRfiResponseToOpportunityResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LinkRfiResponseToOpportunityResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.OpportunityRfiResponseLinkView link = 1;
   */ _define_property(this, "link", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(LinkRfiResponseToOpportunityResponse, "runtime", proto3);
_define_property(LinkRfiResponseToOpportunityResponse, "typeName", "mono.projectdata.v1.LinkRfiResponseToOpportunityResponse");
_define_property(LinkRfiResponseToOpportunityResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "link",
            kind: "message",
            T: OpportunityRfiResponseLinkView
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UnlinkRfiResponseFromOpportunityRequest
 */ export class UnlinkRfiResponseFromOpportunityRequest extends Message {
    static fromBinary(bytes, options) {
        return new UnlinkRfiResponseFromOpportunityRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UnlinkRfiResponseFromOpportunityRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UnlinkRfiResponseFromOpportunityRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UnlinkRfiResponseFromOpportunityRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string notice_id = 1;
   */ _define_property(this, "noticeId", ""), /**
   * @generated from field: string rfi_response_project_id = 2;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string user_id = 3;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 4;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UnlinkRfiResponseFromOpportunityRequest, "runtime", proto3);
_define_property(UnlinkRfiResponseFromOpportunityRequest, "typeName", "mono.projectdata.v1.UnlinkRfiResponseFromOpportunityRequest");
_define_property(UnlinkRfiResponseFromOpportunityRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UnlinkRfiResponseFromOpportunityResponse
 */ export class UnlinkRfiResponseFromOpportunityResponse extends Message {
    static fromBinary(bytes, options) {
        return new UnlinkRfiResponseFromOpportunityResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UnlinkRfiResponseFromOpportunityResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UnlinkRfiResponseFromOpportunityResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UnlinkRfiResponseFromOpportunityResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(UnlinkRfiResponseFromOpportunityResponse, "runtime", proto3);
_define_property(UnlinkRfiResponseFromOpportunityResponse, "typeName", "mono.projectdata.v1.UnlinkRfiResponseFromOpportunityResponse");
_define_property(UnlinkRfiResponseFromOpportunityResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.projectdata.v1.ListRfiResponsesForOpportunityRequest
 */ export class ListRfiResponsesForOpportunityRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListRfiResponsesForOpportunityRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRfiResponsesForOpportunityRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRfiResponsesForOpportunityRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRfiResponsesForOpportunityRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string notice_id = 1;
   */ _define_property(this, "noticeId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 3;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRfiResponsesForOpportunityRequest, "runtime", proto3);
_define_property(ListRfiResponsesForOpportunityRequest, "typeName", "mono.projectdata.v1.ListRfiResponsesForOpportunityRequest");
_define_property(ListRfiResponsesForOpportunityRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListRfiResponsesForOpportunityResponse
 */ export class ListRfiResponsesForOpportunityResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListRfiResponsesForOpportunityResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRfiResponsesForOpportunityResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRfiResponsesForOpportunityResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRfiResponsesForOpportunityResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.RfiResponseProjectSummary workspaces = 1;
   */ _define_property(this, "workspaces", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRfiResponsesForOpportunityResponse, "runtime", proto3);
_define_property(ListRfiResponsesForOpportunityResponse, "typeName", "mono.projectdata.v1.ListRfiResponsesForOpportunityResponse");
_define_property(ListRfiResponsesForOpportunityResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "workspaces",
            kind: "message",
            T: RfiResponseProjectSummary,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListOpportunityLinksForRfiResponseRequest
 */ export class ListOpportunityLinksForRfiResponseRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListOpportunityLinksForRfiResponseRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListOpportunityLinksForRfiResponseRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListOpportunityLinksForRfiResponseRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListOpportunityLinksForRfiResponseRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 3;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListOpportunityLinksForRfiResponseRequest, "runtime", proto3);
_define_property(ListOpportunityLinksForRfiResponseRequest, "typeName", "mono.projectdata.v1.ListOpportunityLinksForRfiResponseRequest");
_define_property(ListOpportunityLinksForRfiResponseRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListOpportunityLinksForRfiResponseResponse
 */ export class ListOpportunityLinksForRfiResponseResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListOpportunityLinksForRfiResponseResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListOpportunityLinksForRfiResponseResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListOpportunityLinksForRfiResponseResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListOpportunityLinksForRfiResponseResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.OpportunityRfiResponseLinkView linked_opportunities = 1;
   */ _define_property(this, "linkedOpportunities", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListOpportunityLinksForRfiResponseResponse, "runtime", proto3);
_define_property(ListOpportunityLinksForRfiResponseResponse, "typeName", "mono.projectdata.v1.ListOpportunityLinksForRfiResponseResponse");
_define_property(ListOpportunityLinksForRfiResponseResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "linked_opportunities",
            kind: "message",
            T: OpportunityRfiResponseLinkView,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpsertRfiEventRequest
 */ export class UpsertRfiEventRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertRfiEventRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertRfiEventRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertRfiEventRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertRfiEventRequest, a, b);
    }
    constructor(data){
        super(), /**
   * Empty creates a new event; set to update an existing one.
   *
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string source_notice_id = 3;
   */ _define_property(this, "sourceNoticeId", ""), /**
   * @generated from field: string title = 4;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string rfi_type = 5;
   */ _define_property(this, "rfiType", ""), /**
   * @generated from field: google.protobuf.Timestamp event_date = 6;
   */ _define_property(this, "eventDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp response_due = 7;
   */ _define_property(this, "responseDue", void 0), /**
   * @generated from field: string questions = 8;
   */ _define_property(this, "questions", ""), /**
   * @generated from field: string response_artifact_id = 9;
   */ _define_property(this, "responseArtifactId", ""), /**
   * @generated from field: string impacted_requirements_json = 10;
   */ _define_property(this, "impactedRequirementsJson", ""), /**
   * @generated from field: string impacted_vehicle_strategy = 11;
   */ _define_property(this, "impactedVehicleStrategy", ""), /**
   * @generated from field: string notes = 12;
   */ _define_property(this, "notes", ""), /**
   * @generated from field: string user_id = 13;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 14;
   */ _define_property(this, "companyId", ""), /**
   * pending|responded|not_responded|missed. Empty leaves the stored value
   * unchanged on update.
   *
   * @generated from field: string response_status = 15;
   */ _define_property(this, "responseStatus", ""), /**
   * Why we did not respond (not_responded / missed). Ignored when
   * response_status is empty.
   *
   * @generated from field: string response_reason = 16;
   */ _define_property(this, "responseReason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertRfiEventRequest, "runtime", proto3);
_define_property(UpsertRfiEventRequest, "typeName", "mono.projectdata.v1.UpsertRfiEventRequest");
_define_property(UpsertRfiEventRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "source_notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "rfi_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "event_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "response_due",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "questions",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "response_artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "impacted_requirements_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "impacted_vehicle_strategy",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "response_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "response_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpsertRfiEventResponse
 */ export class UpsertRfiEventResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertRfiEventResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertRfiEventResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertRfiEventResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertRfiEventResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.RfiEventView rfi_event = 1;
   */ _define_property(this, "rfiEvent", void 0), /**
   * @generated from field: bool created = 2;
   */ _define_property(this, "created", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertRfiEventResponse, "runtime", proto3);
_define_property(UpsertRfiEventResponse, "typeName", "mono.projectdata.v1.UpsertRfiEventResponse");
_define_property(UpsertRfiEventResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_event",
            kind: "message",
            T: RfiEventView
        },
        {
            no: 2,
            name: "created",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListRfiEventsRequest
 */ export class ListRfiEventsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListRfiEventsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRfiEventsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRfiEventsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRfiEventsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 3;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRfiEventsRequest, "runtime", proto3);
_define_property(ListRfiEventsRequest, "typeName", "mono.projectdata.v1.ListRfiEventsRequest");
_define_property(ListRfiEventsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListRfiEventsResponse
 */ export class ListRfiEventsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListRfiEventsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRfiEventsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRfiEventsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRfiEventsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.RfiEventView rfi_events = 1;
   */ _define_property(this, "rfiEvents", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRfiEventsResponse, "runtime", proto3);
_define_property(ListRfiEventsResponse, "typeName", "mono.projectdata.v1.ListRfiEventsResponse");
_define_property(ListRfiEventsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_events",
            kind: "message",
            T: RfiEventView,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpsertCustomerInteractionRequest
 */ export class UpsertCustomerInteractionRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCustomerInteractionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCustomerInteractionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCustomerInteractionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCustomerInteractionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: google.protobuf.Timestamp interaction_date = 3;
   */ _define_property(this, "interactionDate", void 0), /**
   * @generated from field: string channel = 4;
   */ _define_property(this, "channel", ""), /**
   * @generated from field: string stakeholder = 5;
   */ _define_property(this, "stakeholder", ""), /**
   * @generated from field: string summary = 6;
   */ _define_property(this, "summary", ""), /**
   * @generated from field: string sentiment = 7;
   */ _define_property(this, "sentiment", ""), /**
   * @generated from field: string follow_ups = 8;
   */ _define_property(this, "followUps", ""), /**
   * @generated from field: string notes = 9;
   */ _define_property(this, "notes", ""), /**
   * @generated from field: string user_id = 10;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 11;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: optional string title = 12;
   */ _define_property(this, "title", void 0), /**
   * @generated from field: optional bool is_draft = 13;
   */ _define_property(this, "isDraft", void 0), /**
   * Atomic attendee patch. Omission preserves attendees for older clients.
   * Context on existing attendees is immutable. Remove + add to correct it.
   *
   * @generated from field: repeated mono.projectdata.v1.TouchpointParticipant participant_upserts = 14;
   */ _define_property(this, "participantUpserts", []), /**
   * @generated from field: repeated string participant_removals = 15;
   */ _define_property(this, "participantRemovals", []), /**
   * GRW-36: unset = keep the stored event; "" = clear (removes no links).
   *
   * @generated from field: optional string event_id = 16;
   */ _define_property(this, "eventId", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCustomerInteractionRequest, "runtime", proto3);
_define_property(UpsertCustomerInteractionRequest, "typeName", "mono.projectdata.v1.UpsertCustomerInteractionRequest");
_define_property(UpsertCustomerInteractionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "interaction_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 4,
            name: "channel",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "stakeholder",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "summary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "sentiment",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "follow_ups",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 13,
            name: "is_draft",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ ,
            opt: true
        },
        {
            no: 14,
            name: "participant_upserts",
            kind: "message",
            T: TouchpointParticipant,
            repeated: true
        },
        {
            no: 15,
            name: "participant_removals",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 16,
            name: "event_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpsertCustomerInteractionResponse
 */ export class UpsertCustomerInteractionResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCustomerInteractionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCustomerInteractionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCustomerInteractionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCustomerInteractionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.CustomerInteractionView interaction = 1;
   */ _define_property(this, "interaction", void 0), /**
   * @generated from field: bool created = 2;
   */ _define_property(this, "created", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCustomerInteractionResponse, "runtime", proto3);
_define_property(UpsertCustomerInteractionResponse, "typeName", "mono.projectdata.v1.UpsertCustomerInteractionResponse");
_define_property(UpsertCustomerInteractionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "interaction",
            kind: "message",
            T: CustomerInteractionView
        },
        {
            no: 2,
            name: "created",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListCustomerInteractionsRequest
 */ export class ListCustomerInteractionsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCustomerInteractionsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCustomerInteractionsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCustomerInteractionsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCustomerInteractionsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 3;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCustomerInteractionsRequest, "runtime", proto3);
_define_property(ListCustomerInteractionsRequest, "typeName", "mono.projectdata.v1.ListCustomerInteractionsRequest");
_define_property(ListCustomerInteractionsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListCustomerInteractionsResponse
 */ export class ListCustomerInteractionsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCustomerInteractionsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCustomerInteractionsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCustomerInteractionsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCustomerInteractionsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.CustomerInteractionView interactions = 1;
   */ _define_property(this, "interactions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCustomerInteractionsResponse, "runtime", proto3);
_define_property(ListCustomerInteractionsResponse, "typeName", "mono.projectdata.v1.ListCustomerInteractionsResponse");
_define_property(ListCustomerInteractionsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "interactions",
            kind: "message",
            T: CustomerInteractionView,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpsertWorkstreamItemRequest
 */ export class UpsertWorkstreamItemRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertWorkstreamItemRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertWorkstreamItemRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertWorkstreamItemRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertWorkstreamItemRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: mono.projectdata.v1.CaptureWorkstreamType workstream_type = 3;
   */ _define_property(this, "workstreamType", 0), /**
   * @generated from field: string title = 4;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string body = 5;
   */ _define_property(this, "body", ""), /**
   * @generated from field: string status = 6;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string data_json = 7;
   */ _define_property(this, "dataJson", ""), /**
   * @generated from field: bool ai_drafted = 8;
   */ _define_property(this, "aiDrafted", false), /**
   * @generated from field: string user_id = 9;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 10;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertWorkstreamItemRequest, "runtime", proto3);
_define_property(UpsertWorkstreamItemRequest, "typeName", "mono.projectdata.v1.UpsertWorkstreamItemRequest");
_define_property(UpsertWorkstreamItemRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "workstream_type",
            kind: "enum",
            T: proto3.getEnumType(CaptureWorkstreamType)
        },
        {
            no: 4,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "body",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "data_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "ai_drafted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 9,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpsertWorkstreamItemResponse
 */ export class UpsertWorkstreamItemResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertWorkstreamItemResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertWorkstreamItemResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertWorkstreamItemResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertWorkstreamItemResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.CaptureWorkstreamItemView item = 1;
   */ _define_property(this, "item", void 0), /**
   * @generated from field: bool created = 2;
   */ _define_property(this, "created", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertWorkstreamItemResponse, "runtime", proto3);
_define_property(UpsertWorkstreamItemResponse, "typeName", "mono.projectdata.v1.UpsertWorkstreamItemResponse");
_define_property(UpsertWorkstreamItemResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "item",
            kind: "message",
            T: CaptureWorkstreamItemView
        },
        {
            no: 2,
            name: "created",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListWorkstreamItemsRequest
 */ export class ListWorkstreamItemsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListWorkstreamItemsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListWorkstreamItemsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListWorkstreamItemsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListWorkstreamItemsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * Optional filter; UNSPECIFIED returns all workstreams.
   *
   * @generated from field: mono.projectdata.v1.CaptureWorkstreamType workstream_type = 2;
   */ _define_property(this, "workstreamType", 0), /**
   * @generated from field: string user_id = 3;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 4;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListWorkstreamItemsRequest, "runtime", proto3);
_define_property(ListWorkstreamItemsRequest, "typeName", "mono.projectdata.v1.ListWorkstreamItemsRequest");
_define_property(ListWorkstreamItemsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "workstream_type",
            kind: "enum",
            T: proto3.getEnumType(CaptureWorkstreamType)
        },
        {
            no: 3,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListWorkstreamItemsResponse
 */ export class ListWorkstreamItemsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListWorkstreamItemsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListWorkstreamItemsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListWorkstreamItemsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListWorkstreamItemsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.CaptureWorkstreamItemView items = 1;
   */ _define_property(this, "items", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListWorkstreamItemsResponse, "runtime", proto3);
_define_property(ListWorkstreamItemsResponse, "typeName", "mono.projectdata.v1.ListWorkstreamItemsResponse");
_define_property(ListWorkstreamItemsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "items",
            kind: "message",
            T: CaptureWorkstreamItemView,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GoNoGoFactor
 */ export class GoNoGoFactor extends Message {
    static fromBinary(bytes, options) {
        return new GoNoGoFactor().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GoNoGoFactor().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GoNoGoFactor().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GoNoGoFactor, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string body = 3;
   */ _define_property(this, "body", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GoNoGoFactor, "runtime", proto3);
_define_property(GoNoGoFactor, "typeName", "mono.projectdata.v1.GoNoGoFactor");
_define_property(GoNoGoFactor, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "body",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CaptureGoNoGoDecisionView
 */ export class CaptureGoNoGoDecisionView extends Message {
    static fromBinary(bytes, options) {
        return new CaptureGoNoGoDecisionView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureGoNoGoDecisionView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureGoNoGoDecisionView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureGoNoGoDecisionView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: repeated mono.projectdata.v1.GoNoGoFactor factors = 3;
   */ _define_property(this, "factors", []), /**
   * @generated from field: google.protobuf.Timestamp due_at = 4;
   */ _define_property(this, "dueAt", void 0), /**
   * pending|go|defer
   *
   * @generated from field: string outcome = 5;
   */ _define_property(this, "outcome", ""), /**
   * @generated from field: google.protobuf.Timestamp decided_at = 6;
   */ _define_property(this, "decidedAt", void 0), /**
   * @generated from field: string notes = 7;
   */ _define_property(this, "notes", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 9;
   */ _define_property(this, "updatedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureGoNoGoDecisionView, "runtime", proto3);
_define_property(CaptureGoNoGoDecisionView, "typeName", "mono.projectdata.v1.CaptureGoNoGoDecisionView");
_define_property(CaptureGoNoGoDecisionView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "factors",
            kind: "message",
            T: GoNoGoFactor,
            repeated: true
        },
        {
            no: 4,
            name: "due_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "outcome",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "decided_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpsertCaptureGoNoGoDecisionRequest
 */ export class UpsertCaptureGoNoGoDecisionRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCaptureGoNoGoDecisionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCaptureGoNoGoDecisionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCaptureGoNoGoDecisionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCaptureGoNoGoDecisionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * Empty creates; set to update an existing record.
   *
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: repeated mono.projectdata.v1.GoNoGoFactor factors = 3;
   */ _define_property(this, "factors", []), /**
   * @generated from field: google.protobuf.Timestamp due_at = 4;
   */ _define_property(this, "dueAt", void 0), /**
   * pending|go|defer
   *
   * @generated from field: string outcome = 5;
   */ _define_property(this, "outcome", ""), /**
   * @generated from field: string notes = 6;
   */ _define_property(this, "notes", ""), /**
   * @generated from field: string user_id = 7;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 8;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCaptureGoNoGoDecisionRequest, "runtime", proto3);
_define_property(UpsertCaptureGoNoGoDecisionRequest, "typeName", "mono.projectdata.v1.UpsertCaptureGoNoGoDecisionRequest");
_define_property(UpsertCaptureGoNoGoDecisionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "factors",
            kind: "message",
            T: GoNoGoFactor,
            repeated: true
        },
        {
            no: 4,
            name: "due_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "outcome",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpsertCaptureGoNoGoDecisionResponse
 */ export class UpsertCaptureGoNoGoDecisionResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCaptureGoNoGoDecisionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCaptureGoNoGoDecisionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCaptureGoNoGoDecisionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCaptureGoNoGoDecisionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.CaptureGoNoGoDecisionView decision = 1;
   */ _define_property(this, "decision", void 0), /**
   * @generated from field: bool created = 2;
   */ _define_property(this, "created", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCaptureGoNoGoDecisionResponse, "runtime", proto3);
_define_property(UpsertCaptureGoNoGoDecisionResponse, "typeName", "mono.projectdata.v1.UpsertCaptureGoNoGoDecisionResponse");
_define_property(UpsertCaptureGoNoGoDecisionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "decision",
            kind: "message",
            T: CaptureGoNoGoDecisionView
        },
        {
            no: 2,
            name: "created",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListCaptureGoNoGoDecisionsRequest
 */ export class ListCaptureGoNoGoDecisionsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCaptureGoNoGoDecisionsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCaptureGoNoGoDecisionsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCaptureGoNoGoDecisionsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCaptureGoNoGoDecisionsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 3;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCaptureGoNoGoDecisionsRequest, "runtime", proto3);
_define_property(ListCaptureGoNoGoDecisionsRequest, "typeName", "mono.projectdata.v1.ListCaptureGoNoGoDecisionsRequest");
_define_property(ListCaptureGoNoGoDecisionsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListCaptureGoNoGoDecisionsResponse
 */ export class ListCaptureGoNoGoDecisionsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCaptureGoNoGoDecisionsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCaptureGoNoGoDecisionsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCaptureGoNoGoDecisionsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCaptureGoNoGoDecisionsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.CaptureGoNoGoDecisionView decisions = 1;
   */ _define_property(this, "decisions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCaptureGoNoGoDecisionsResponse, "runtime", proto3);
_define_property(ListCaptureGoNoGoDecisionsResponse, "typeName", "mono.projectdata.v1.ListCaptureGoNoGoDecisionsResponse");
_define_property(ListCaptureGoNoGoDecisionsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "decisions",
            kind: "message",
            T: CaptureGoNoGoDecisionView,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.EntityNodeView
 */ export class EntityNodeView extends Message {
    static fromBinary(bytes, options) {
        return new EntityNodeView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EntityNodeView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EntityNodeView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EntityNodeView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * company|gov_org|vehicle|partner
   *
   * @generated from field: string node_type = 2;
   */ _define_property(this, "nodeType", ""), /**
   * @generated from field: string display_name = 3;
   */ _define_property(this, "displayName", ""), /**
   * @generated from field: string ryugu_ref = 4;
   */ _define_property(this, "ryuguRef", ""), /**
   * @generated from field: string attributes_json = 5;
   */ _define_property(this, "attributesJson", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(EntityNodeView, "runtime", proto3);
_define_property(EntityNodeView, "typeName", "mono.projectdata.v1.EntityNodeView");
_define_property(EntityNodeView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "node_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "ryugu_ref",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "attributes_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.EntityEdgeView
 */ export class EntityEdgeView extends Message {
    static fromBinary(bytes, options) {
        return new EntityEdgeView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EntityEdgeView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EntityEdgeView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EntityEdgeView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string from_node = 2;
   */ _define_property(this, "fromNode", ""), /**
   * @generated from field: string to_node = 3;
   */ _define_property(this, "toNode", ""), /**
   * @generated from field: string edge_type = 4;
   */ _define_property(this, "edgeType", ""), /**
   * public_data|user_intel|sds_truth|inferred
   *
   * @generated from field: string provenance = 5;
   */ _define_property(this, "provenance", ""), /**
   * @generated from field: double confidence = 6;
   */ _define_property(this, "confidence", 0), /**
   * @generated from field: string source = 7;
   */ _define_property(this, "source", ""), /**
   * none|user_confirmed|superseded
   *
   * @generated from field: string override_status = 8;
   */ _define_property(this, "overrideStatus", ""), /**
   * @generated from field: string overridden_by = 9;
   */ _define_property(this, "overriddenBy", ""), /**
   * @generated from field: google.protobuf.Timestamp effective_date = 10;
   */ _define_property(this, "effectiveDate", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(EntityEdgeView, "runtime", proto3);
_define_property(EntityEdgeView, "typeName", "mono.projectdata.v1.EntityEdgeView");
_define_property(EntityEdgeView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "from_node",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "to_node",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "edge_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "provenance",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 7,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "override_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "overridden_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "effective_date",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.EntityGraphView
 */ export class EntityGraphView extends Message {
    static fromBinary(bytes, options) {
        return new EntityGraphView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EntityGraphView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EntityGraphView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EntityGraphView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.EntityNodeView nodes = 1;
   */ _define_property(this, "nodes", []), /**
   * @generated from field: repeated mono.projectdata.v1.EntityEdgeView edges = 2;
   */ _define_property(this, "edges", []), /**
   * @generated from field: repeated mono.datagateway.v1.GraphSourceStatus source_statuses = 3;
   */ _define_property(this, "sourceStatuses", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(EntityGraphView, "runtime", proto3);
_define_property(EntityGraphView, "typeName", "mono.projectdata.v1.EntityGraphView");
_define_property(EntityGraphView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "nodes",
            kind: "message",
            T: EntityNodeView,
            repeated: true
        },
        {
            no: 2,
            name: "edges",
            kind: "message",
            T: EntityEdgeView,
            repeated: true
        },
        {
            no: 3,
            name: "source_statuses",
            kind: "message",
            T: GraphSourceStatus,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetEntityGraphRequest
 */ export class GetEntityGraphRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetEntityGraphRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetEntityGraphRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetEntityGraphRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetEntityGraphRequest, a, b);
    }
    constructor(data){
        super(), /**
   * Optional node_type filter; empty returns the whole tenant graph.
   *
   * @generated from field: string node_type = 1;
   */ _define_property(this, "nodeType", ""), /**
   * Include superseded edges so the UI can render the resolved-conflict trail.
   *
   * @generated from field: bool include_superseded = 2;
   */ _define_property(this, "includeSuperseded", false), /**
   * @generated from field: string user_id = 3;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 4;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetEntityGraphRequest, "runtime", proto3);
_define_property(GetEntityGraphRequest, "typeName", "mono.projectdata.v1.GetEntityGraphRequest");
_define_property(GetEntityGraphRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "node_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "include_superseded",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 3,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetEntityGraphResponse
 */ export class GetEntityGraphResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetEntityGraphResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetEntityGraphResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetEntityGraphResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetEntityGraphResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.EntityGraphView graph = 1;
   */ _define_property(this, "graph", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetEntityGraphResponse, "runtime", proto3);
_define_property(GetEntityGraphResponse, "typeName", "mono.projectdata.v1.GetEntityGraphResponse");
_define_property(GetEntityGraphResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "graph",
            kind: "message",
            T: EntityGraphView
        }
    ]));
/**
 * GRW-35: pursuit-filtered graph.
 *
 * @generated from message mono.projectdata.v1.GetPursuitGraphRequest
 */ export class GetPursuitGraphRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetPursuitGraphRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPursuitGraphRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPursuitGraphRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPursuitGraphRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * 1 or 2 (the UI always sends one)
   *
   * @generated from field: int32 hops = 2;
   */ _define_property(this, "hops", 0), /**
   * @generated from field: bool include_superseded = 3;
   */ _define_property(this, "includeSuperseded", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetPursuitGraphRequest, "runtime", proto3);
_define_property(GetPursuitGraphRequest, "typeName", "mono.projectdata.v1.GetPursuitGraphRequest");
_define_property(GetPursuitGraphRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "hops",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "include_superseded",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.PursuitGraphSeedView
 */ export class PursuitGraphSeedView extends Message {
    static fromBinary(bytes, options) {
        return new PursuitGraphSeedView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PursuitGraphSeedView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PursuitGraphSeedView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PursuitGraphSeedView, a, b);
    }
    constructor(data){
        super(), /**
   * CONTACT | COMPANY | GOVERNMENT_ORG | VEHICLE
   *
   * @generated from field: string kind = 1;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string registry_id = 2;
   */ _define_property(this, "registryId", ""), /**
   * @generated from field: repeated string seed_roles = 3;
   */ _define_property(this, "seedRoles", []), /**
   * "" = not in the graph yet
   *
   * @generated from field: string node_id = 4;
   */ _define_property(this, "nodeId", ""), /**
   * @generated from field: string label = 5;
   */ _define_property(this, "label", ""), /**
   * the registry record route (§3.2)
   *
   * @generated from field: string href = 6;
   */ _define_property(this, "href", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PursuitGraphSeedView, "runtime", proto3);
_define_property(PursuitGraphSeedView, "typeName", "mono.projectdata.v1.PursuitGraphSeedView");
_define_property(PursuitGraphSeedView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "registry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "seed_roles",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 4,
            name: "node_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "href",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetPursuitGraphResponse
 */ export class GetPursuitGraphResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetPursuitGraphResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPursuitGraphResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPursuitGraphResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPursuitGraphResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.EntityGraphView graph = 1;
   */ _define_property(this, "graph", void 0), /**
   * @generated from field: repeated mono.projectdata.v1.PursuitGraphSeedView seeds = 2;
   */ _define_property(this, "seeds", []), /**
   * @generated from field: bool truncated = 3;
   */ _define_property(this, "truncated", false), /**
   * RFC3339, "" when never projected
   *
   * @generated from field: string projected_through = 4;
   */ _define_property(this, "projectedThrough", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetPursuitGraphResponse, "runtime", proto3);
_define_property(GetPursuitGraphResponse, "typeName", "mono.projectdata.v1.GetPursuitGraphResponse");
_define_property(GetPursuitGraphResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "graph",
            kind: "message",
            T: EntityGraphView
        },
        {
            no: 2,
            name: "seeds",
            kind: "message",
            T: PursuitGraphSeedView,
            repeated: true
        },
        {
            no: 3,
            name: "truncated",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "projected_through",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpsertEntityNodeRequest
 */ export class UpsertEntityNodeRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertEntityNodeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertEntityNodeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertEntityNodeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertEntityNodeRequest, a, b);
    }
    constructor(data){
        super(), /**
   * Empty creates; set to update.
   *
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string node_type = 2;
   */ _define_property(this, "nodeType", ""), /**
   * @generated from field: string display_name = 3;
   */ _define_property(this, "displayName", ""), /**
   * @generated from field: string ryugu_ref = 4;
   */ _define_property(this, "ryuguRef", ""), /**
   * @generated from field: string attributes_json = 5;
   */ _define_property(this, "attributesJson", ""), /**
   * @generated from field: string user_id = 6;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 7;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertEntityNodeRequest, "runtime", proto3);
_define_property(UpsertEntityNodeRequest, "typeName", "mono.projectdata.v1.UpsertEntityNodeRequest");
_define_property(UpsertEntityNodeRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "node_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "ryugu_ref",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "attributes_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpsertEntityNodeResponse
 */ export class UpsertEntityNodeResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertEntityNodeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertEntityNodeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertEntityNodeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertEntityNodeResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.EntityNodeView node = 1;
   */ _define_property(this, "node", void 0), /**
   * @generated from field: bool created = 2;
   */ _define_property(this, "created", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertEntityNodeResponse, "runtime", proto3);
_define_property(UpsertEntityNodeResponse, "typeName", "mono.projectdata.v1.UpsertEntityNodeResponse");
_define_property(UpsertEntityNodeResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "node",
            kind: "message",
            T: EntityNodeView
        },
        {
            no: 2,
            name: "created",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpsertEntityEdgeRequest
 */ export class UpsertEntityEdgeRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertEntityEdgeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertEntityEdgeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertEntityEdgeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertEntityEdgeRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string from_node = 2;
   */ _define_property(this, "fromNode", ""), /**
   * @generated from field: string to_node = 3;
   */ _define_property(this, "toNode", ""), /**
   * @generated from field: string edge_type = 4;
   */ _define_property(this, "edgeType", ""), /**
   * @generated from field: string provenance = 5;
   */ _define_property(this, "provenance", ""), /**
   * @generated from field: double confidence = 6;
   */ _define_property(this, "confidence", 0), /**
   * @generated from field: string source = 7;
   */ _define_property(this, "source", ""), /**
   * @generated from field: google.protobuf.Timestamp effective_date = 8;
   */ _define_property(this, "effectiveDate", void 0), /**
   * @generated from field: string attributes_json = 9;
   */ _define_property(this, "attributesJson", ""), /**
   * @generated from field: string user_id = 10;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 11;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertEntityEdgeRequest, "runtime", proto3);
_define_property(UpsertEntityEdgeRequest, "typeName", "mono.projectdata.v1.UpsertEntityEdgeRequest");
_define_property(UpsertEntityEdgeRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "from_node",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "to_node",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "edge_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "provenance",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 7,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "effective_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "attributes_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpsertEntityEdgeResponse
 */ export class UpsertEntityEdgeResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertEntityEdgeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertEntityEdgeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertEntityEdgeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertEntityEdgeResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.EntityEdgeView edge = 1;
   */ _define_property(this, "edge", void 0), /**
   * @generated from field: bool created = 2;
   */ _define_property(this, "created", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertEntityEdgeResponse, "runtime", proto3);
_define_property(UpsertEntityEdgeResponse, "typeName", "mono.projectdata.v1.UpsertEntityEdgeResponse");
_define_property(UpsertEntityEdgeResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "edge",
            kind: "message",
            T: EntityEdgeView
        },
        {
            no: 2,
            name: "created",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.OverrideEntityEdgeRequest
 */ export class OverrideEntityEdgeRequest extends Message {
    static fromBinary(bytes, options) {
        return new OverrideEntityEdgeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OverrideEntityEdgeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OverrideEntityEdgeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OverrideEntityEdgeRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string edge_id = 1;
   */ _define_property(this, "edgeId", ""), /**
   * @generated from field: string rationale = 2;
   */ _define_property(this, "rationale", ""), /**
   * @generated from field: string user_id = 3;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 4;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(OverrideEntityEdgeRequest, "runtime", proto3);
_define_property(OverrideEntityEdgeRequest, "typeName", "mono.projectdata.v1.OverrideEntityEdgeRequest");
_define_property(OverrideEntityEdgeRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "edge_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "rationale",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.OverrideEntityEdgeResponse
 */ export class OverrideEntityEdgeResponse extends Message {
    static fromBinary(bytes, options) {
        return new OverrideEntityEdgeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OverrideEntityEdgeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OverrideEntityEdgeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OverrideEntityEdgeResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.EntityEdgeView edge = 1;
   */ _define_property(this, "edge", void 0), /**
   * @generated from field: repeated string superseded_edge_ids = 2;
   */ _define_property(this, "supersededEdgeIds", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(OverrideEntityEdgeResponse, "runtime", proto3);
_define_property(OverrideEntityEdgeResponse, "typeName", "mono.projectdata.v1.OverrideEntityEdgeResponse");
_define_property(OverrideEntityEdgeResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "edge",
            kind: "message",
            T: EntityEdgeView
        },
        {
            no: 2,
            name: "superseded_edge_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.MergeEntityNodesRequest
 */ export class MergeEntityNodesRequest extends Message {
    static fromBinary(bytes, options) {
        return new MergeEntityNodesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MergeEntityNodesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MergeEntityNodesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MergeEntityNodesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string primary_node_id = 1;
   */ _define_property(this, "primaryNodeId", ""), /**
   * @generated from field: string secondary_node_id = 2;
   */ _define_property(this, "secondaryNodeId", ""), /**
   * @generated from field: string rationale = 3;
   */ _define_property(this, "rationale", ""), /**
   * @generated from field: string user_id = 4;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 5;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(MergeEntityNodesRequest, "runtime", proto3);
_define_property(MergeEntityNodesRequest, "typeName", "mono.projectdata.v1.MergeEntityNodesRequest");
_define_property(MergeEntityNodesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "primary_node_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "secondary_node_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "rationale",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.MergeEntityNodesResponse
 */ export class MergeEntityNodesResponse extends Message {
    static fromBinary(bytes, options) {
        return new MergeEntityNodesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MergeEntityNodesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MergeEntityNodesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MergeEntityNodesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.EntityNodeView primary_node = 1;
   */ _define_property(this, "primaryNode", void 0), /**
   * @generated from field: int32 edges_repointed = 2;
   */ _define_property(this, "edgesRepointed", 0), /**
   * Resolution-log id of this merge — pass to UnmergeEntityNodes to reverse it.
   *
   * @generated from field: string log_entry_id = 3;
   */ _define_property(this, "logEntryId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(MergeEntityNodesResponse, "runtime", proto3);
_define_property(MergeEntityNodesResponse, "typeName", "mono.projectdata.v1.MergeEntityNodesResponse");
_define_property(MergeEntityNodesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "primary_node",
            kind: "message",
            T: EntityNodeView
        },
        {
            no: 2,
            name: "edges_repointed",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "log_entry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetGovOrgChartRequest
 */ export class GetGovOrgChartRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetGovOrgChartRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetGovOrgChartRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetGovOrgChartRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetGovOrgChartRequest, a, b);
    }
    constructor(data){
        super(), /**
   * a gov_org node to root the chart at
   *
   * @generated from field: string root_node_id = 1;
   */ _define_property(this, "rootNodeId", ""), /**
   * 0 => server cap
   *
   * @generated from field: int32 max_depth = 2;
   */ _define_property(this, "maxDepth", 0), /**
   * @generated from field: string user_id = 3;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 4;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetGovOrgChartRequest, "runtime", proto3);
_define_property(GetGovOrgChartRequest, "typeName", "mono.projectdata.v1.GetGovOrgChartRequest");
_define_property(GetGovOrgChartRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "root_node_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "max_depth",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GovOrgChartEntryView
 */ export class GovOrgChartEntryView extends Message {
    static fromBinary(bytes, options) {
        return new GovOrgChartEntryView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GovOrgChartEntryView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GovOrgChartEntryView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GovOrgChartEntryView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.EntityNodeView node = 1;
   */ _define_property(this, "node", void 0), /**
   * agency|bureau|program_office|contracting_office
   *
   * @generated from field: string org_level = 2;
   */ _define_property(this, "orgLevel", ""), /**
   * empty at the requested root
   *
   * @generated from field: string parent_node_id = 3;
   */ _define_property(this, "parentNodeId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GovOrgChartEntryView, "runtime", proto3);
_define_property(GovOrgChartEntryView, "typeName", "mono.projectdata.v1.GovOrgChartEntryView");
_define_property(GovOrgChartEntryView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "node",
            kind: "message",
            T: EntityNodeView
        },
        {
            no: 2,
            name: "org_level",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "parent_node_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GovOrgChartPersonView
 */ export class GovOrgChartPersonView extends Message {
    static fromBinary(bytes, options) {
        return new GovOrgChartPersonView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GovOrgChartPersonView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GovOrgChartPersonView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GovOrgChartPersonView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.EntityNodeView person = 1;
   */ _define_property(this, "person", void 0), /**
   * @generated from field: string gov_org_node_id = 2;
   */ _define_property(this, "govOrgNodeId", ""), /**
   * edge_type: contracting_officer|cor|program_manager|...
   *
   * @generated from field: string role = 3;
   */ _define_property(this, "role", ""), /**
   * @generated from field: string source = 4;
   */ _define_property(this, "source", ""), /**
   * @generated from field: double confidence = 5;
   */ _define_property(this, "confidence", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GovOrgChartPersonView, "runtime", proto3);
_define_property(GovOrgChartPersonView, "typeName", "mono.projectdata.v1.GovOrgChartPersonView");
_define_property(GovOrgChartPersonView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "person",
            kind: "message",
            T: EntityNodeView
        },
        {
            no: 2,
            name: "gov_org_node_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetGovOrgChartResponse
 */ export class GetGovOrgChartResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetGovOrgChartResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetGovOrgChartResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetGovOrgChartResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetGovOrgChartResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.GovOrgChartEntryView orgs = 1;
   */ _define_property(this, "orgs", []), /**
   * @generated from field: repeated mono.projectdata.v1.GovOrgChartPersonView people = 2;
   */ _define_property(this, "people", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetGovOrgChartResponse, "runtime", proto3);
_define_property(GetGovOrgChartResponse, "typeName", "mono.projectdata.v1.GetGovOrgChartResponse");
_define_property(GetGovOrgChartResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "orgs",
            kind: "message",
            T: GovOrgChartEntryView,
            repeated: true
        },
        {
            no: 2,
            name: "people",
            kind: "message",
            T: GovOrgChartPersonView,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UnmergeEntityNodesRequest
 */ export class UnmergeEntityNodesRequest extends Message {
    static fromBinary(bytes, options) {
        return new UnmergeEntityNodesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UnmergeEntityNodesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UnmergeEntityNodesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UnmergeEntityNodesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * the merge log entry to reverse
   *
   * @generated from field: string resolution_log_id = 1;
   */ _define_property(this, "resolutionLogId", ""), /**
   * @generated from field: string rationale = 2;
   */ _define_property(this, "rationale", ""), /**
   * @generated from field: string user_id = 3;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 4;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UnmergeEntityNodesRequest, "runtime", proto3);
_define_property(UnmergeEntityNodesRequest, "typeName", "mono.projectdata.v1.UnmergeEntityNodesRequest");
_define_property(UnmergeEntityNodesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "resolution_log_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "rationale",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UnmergeEntityNodesResponse
 */ export class UnmergeEntityNodesResponse extends Message {
    static fromBinary(bytes, options) {
        return new UnmergeEntityNodesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UnmergeEntityNodesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UnmergeEntityNodesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UnmergeEntityNodesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * restored
   *
   * @generated from field: mono.projectdata.v1.EntityNodeView secondary_node = 1;
   */ _define_property(this, "secondaryNode", void 0), /**
   * @generated from field: int32 edges_restored = 2;
   */ _define_property(this, "edgesRestored", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UnmergeEntityNodesResponse, "runtime", proto3);
_define_property(UnmergeEntityNodesResponse, "typeName", "mono.projectdata.v1.UnmergeEntityNodesResponse");
_define_property(UnmergeEntityNodesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "secondary_node",
            kind: "message",
            T: EntityNodeView
        },
        {
            no: 2,
            name: "edges_restored",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.DeleteEntityNodeRequest
 */ export class DeleteEntityNodeRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteEntityNodeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteEntityNodeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteEntityNodeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteEntityNodeRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 3;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteEntityNodeRequest, "runtime", proto3);
_define_property(DeleteEntityNodeRequest, "typeName", "mono.projectdata.v1.DeleteEntityNodeRequest");
_define_property(DeleteEntityNodeRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.DeleteEntityNodeResponse
 */ export class DeleteEntityNodeResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteEntityNodeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteEntityNodeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteEntityNodeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteEntityNodeResponse, a, b);
    }
    constructor(data){
        super(), /**
   * Number of incident edges soft-deleted alongside the node.
   *
   * @generated from field: int32 edges_deleted = 1;
   */ _define_property(this, "edgesDeleted", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteEntityNodeResponse, "runtime", proto3);
_define_property(DeleteEntityNodeResponse, "typeName", "mono.projectdata.v1.DeleteEntityNodeResponse");
_define_property(DeleteEntityNodeResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "edges_deleted",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.DeleteEntityEdgeRequest
 */ export class DeleteEntityEdgeRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteEntityEdgeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteEntityEdgeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteEntityEdgeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteEntityEdgeRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 3;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteEntityEdgeRequest, "runtime", proto3);
_define_property(DeleteEntityEdgeRequest, "typeName", "mono.projectdata.v1.DeleteEntityEdgeRequest");
_define_property(DeleteEntityEdgeRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.DeleteEntityEdgeResponse
 */ export class DeleteEntityEdgeResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteEntityEdgeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteEntityEdgeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteEntityEdgeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteEntityEdgeResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteEntityEdgeResponse, "runtime", proto3);
_define_property(DeleteEntityEdgeResponse, "typeName", "mono.projectdata.v1.DeleteEntityEdgeResponse");
_define_property(DeleteEntityEdgeResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * EntityResolutionLogEntryView is one row of the tenant's resolution history
 * (merge / split / override / pin). payload_json + tenant_id are intentionally
 * omitted — the browser only needs to display the action and offer unmerge.
 *
 * @generated from message mono.projectdata.v1.EntityResolutionLogEntryView
 */ export class EntityResolutionLogEntryView extends Message {
    static fromBinary(bytes, options) {
        return new EntityResolutionLogEntryView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EntityResolutionLogEntryView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EntityResolutionLogEntryView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EntityResolutionLogEntryView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * merge|split|override|pin
   *
   * @generated from field: string action = 2;
   */ _define_property(this, "action", ""), /**
   * @generated from field: string primary_node_id = 3;
   */ _define_property(this, "primaryNodeId", ""), /**
   * @generated from field: string secondary_node_id = 4;
   */ _define_property(this, "secondaryNodeId", ""), /**
   * @generated from field: string edge_id = 5;
   */ _define_property(this, "edgeId", ""), /**
   * @generated from field: string rationale = 6;
   */ _define_property(this, "rationale", ""), /**
   * @generated from field: string actor_user_id = 7;
   */ _define_property(this, "actorUserId", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(EntityResolutionLogEntryView, "runtime", proto3);
_define_property(EntityResolutionLogEntryView, "typeName", "mono.projectdata.v1.EntityResolutionLogEntryView");
_define_property(EntityResolutionLogEntryView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "action",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "primary_node_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "secondary_node_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "edge_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "rationale",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "actor_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListEntityResolutionLogRequest
 */ export class ListEntityResolutionLogRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListEntityResolutionLogRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListEntityResolutionLogRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListEntityResolutionLogRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListEntityResolutionLogRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string user_id = 1;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 2;
   */ _define_property(this, "companyId", ""), /**
   * optional cap on rows returned; server clamps
   *
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListEntityResolutionLogRequest, "runtime", proto3);
_define_property(ListEntityResolutionLogRequest, "typeName", "mono.projectdata.v1.ListEntityResolutionLogRequest");
_define_property(ListEntityResolutionLogRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListEntityResolutionLogResponse
 */ export class ListEntityResolutionLogResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListEntityResolutionLogResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListEntityResolutionLogResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListEntityResolutionLogResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListEntityResolutionLogResponse, a, b);
    }
    constructor(data){
        super(), /**
   * newest first
   *
   * @generated from field: repeated mono.projectdata.v1.EntityResolutionLogEntryView entries = 1;
   */ _define_property(this, "entries", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListEntityResolutionLogResponse, "runtime", proto3);
_define_property(ListEntityResolutionLogResponse, "typeName", "mono.projectdata.v1.ListEntityResolutionLogResponse");
_define_property(ListEntityResolutionLogResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "entries",
            kind: "message",
            T: EntityResolutionLogEntryView,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ProposalMilestone
 */ export class ProposalMilestone extends Message {
    static fromBinary(bytes, options) {
        return new ProposalMilestone().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposalMilestone().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposalMilestone().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposalMilestone, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string project_id = 3;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string milestone_type = 4;
   */ _define_property(this, "milestoneType", ""), /**
   * @generated from field: string label = 5;
   */ _define_property(this, "label", ""), /**
   * @generated from field: google.protobuf.Timestamp scheduled_at = 6;
   */ _define_property(this, "scheduledAt", void 0), /**
   * @generated from field: string source = 7;
   */ _define_property(this, "source", ""), /**
   * @generated from field: string notes = 8;
   */ _define_property(this, "notes", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 10;
   */ _define_property(this, "updatedAt", void 0), /**
   * unset = not done
   *
   * @generated from field: google.protobuf.Timestamp completed_at = 11;
   */ _define_property(this, "completedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposalMilestone, "runtime", proto3);
_define_property(ProposalMilestone, "typeName", "mono.projectdata.v1.ProposalMilestone");
_define_property(ProposalMilestone, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "milestone_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "scheduled_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "completed_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpsertProposalMilestoneRequest
 */ export class UpsertProposalMilestoneRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertProposalMilestoneRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertProposalMilestoneRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertProposalMilestoneRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertProposalMilestoneRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.ProposalMilestone milestone = 1;
   */ _define_property(this, "milestone", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertProposalMilestoneRequest, "runtime", proto3);
_define_property(UpsertProposalMilestoneRequest, "typeName", "mono.projectdata.v1.UpsertProposalMilestoneRequest");
_define_property(UpsertProposalMilestoneRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "milestone",
            kind: "message",
            T: ProposalMilestone
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpsertProposalMilestoneResponse
 */ export class UpsertProposalMilestoneResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertProposalMilestoneResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertProposalMilestoneResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertProposalMilestoneResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertProposalMilestoneResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.ProposalMilestone milestone = 1;
   */ _define_property(this, "milestone", void 0), /**
   * @generated from field: bool created = 2;
   */ _define_property(this, "created", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertProposalMilestoneResponse, "runtime", proto3);
_define_property(UpsertProposalMilestoneResponse, "typeName", "mono.projectdata.v1.UpsertProposalMilestoneResponse");
_define_property(UpsertProposalMilestoneResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "milestone",
            kind: "message",
            T: ProposalMilestone
        },
        {
            no: 2,
            name: "created",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListProposalMilestonesRequest
 */ export class ListProposalMilestonesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListProposalMilestonesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProposalMilestonesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProposalMilestonesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProposalMilestonesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string company_id = 2;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProposalMilestonesRequest, "runtime", proto3);
_define_property(ListProposalMilestonesRequest, "typeName", "mono.projectdata.v1.ListProposalMilestonesRequest");
_define_property(ListProposalMilestonesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListProposalMilestonesResponse
 */ export class ListProposalMilestonesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListProposalMilestonesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProposalMilestonesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProposalMilestonesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProposalMilestonesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.ProposalMilestone milestones = 1;
   */ _define_property(this, "milestones", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProposalMilestonesResponse, "runtime", proto3);
_define_property(ListProposalMilestonesResponse, "typeName", "mono.projectdata.v1.ListProposalMilestonesResponse");
_define_property(ListProposalMilestonesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "milestones",
            kind: "message",
            T: ProposalMilestone,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.DeleteProposalMilestoneRequest
 */ export class DeleteProposalMilestoneRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteProposalMilestoneRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteProposalMilestoneRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteProposalMilestoneRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteProposalMilestoneRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string company_id = 2;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string project_id = 3;
   */ _define_property(this, "projectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteProposalMilestoneRequest, "runtime", proto3);
_define_property(DeleteProposalMilestoneRequest, "typeName", "mono.projectdata.v1.DeleteProposalMilestoneRequest");
_define_property(DeleteProposalMilestoneRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.DeleteProposalMilestoneResponse
 */ export class DeleteProposalMilestoneResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteProposalMilestoneResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteProposalMilestoneResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteProposalMilestoneResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteProposalMilestoneResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteProposalMilestoneResponse, "runtime", proto3);
_define_property(DeleteProposalMilestoneResponse, "typeName", "mono.projectdata.v1.DeleteProposalMilestoneResponse");
_define_property(DeleteProposalMilestoneResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.projectdata.v1.CaptureProfileView
 */ export class CaptureProfileView extends Message {
    static fromBinary(bytes, options) {
        return new CaptureProfileView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureProfileView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureProfileView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureProfileView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string solicitation_number = 3;
   */ _define_property(this, "solicitationNumber", ""), /**
   * @generated from field: string crm_number = 4;
   */ _define_property(this, "crmNumber", ""), /**
   * @generated from field: string business_developer_id = 5;
   */ _define_property(this, "businessDeveloperId", ""), /**
   * @generated from field: string capture_manager_id = 6;
   */ _define_property(this, "captureManagerId", ""), /**
   * @generated from field: string customer_agency_names = 7;
   */ _define_property(this, "customerAgencyNames", ""), /**
   * prime|sub|jv
   *
   * @generated from field: string bid_position = 8;
   */ _define_property(this, "bidPosition", ""), /**
   * @generated from field: string vehicle = 9;
   */ _define_property(this, "vehicle", ""), /**
   * @generated from field: string procurement_type = 10;
   */ _define_property(this, "procurementType", ""), /**
   * @generated from field: string contract_type = 11;
   */ _define_property(this, "contractType", ""), /**
   * @generated from field: string period_of_performance = 12;
   */ _define_property(this, "periodOfPerformance", ""), /**
   * @generated from field: string total_program_value = 13;
   */ _define_property(this, "totalProgramValue", ""), /**
   * qualifying|solutioning|pursuing|strategy|bid_review
   *
   * @generated from field: string stage_label = 14;
   */ _define_property(this, "stageLabel", ""), /**
   * @generated from field: string pwin_percent = 15;
   */ _define_property(this, "pwinPercent", ""), /**
   * @generated from field: string risks = 16;
   */ _define_property(this, "risks", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 17;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 18;
   */ _define_property(this, "updatedAt", void 0), /**
   * GRW-09: registry vehicle id and its name (empty when free text only).
   *
   * @generated from field: string vehicle_id = 19;
   */ _define_property(this, "vehicleId", ""), /**
   * @generated from field: string vehicle_label = 20;
   */ _define_property(this, "vehicleLabel", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureProfileView, "runtime", proto3);
_define_property(CaptureProfileView, "typeName", "mono.projectdata.v1.CaptureProfileView");
_define_property(CaptureProfileView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "solicitation_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "crm_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "business_developer_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "capture_manager_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "customer_agency_names",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "bid_position",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "vehicle",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "procurement_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "contract_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "period_of_performance",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "total_program_value",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "stage_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "pwin_percent",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "risks",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 18,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 19,
            name: "vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "vehicle_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetCaptureProfileRequest
 */ export class GetCaptureProfileRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetCaptureProfileRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCaptureProfileRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCaptureProfileRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCaptureProfileRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 3;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCaptureProfileRequest, "runtime", proto3);
_define_property(GetCaptureProfileRequest, "typeName", "mono.projectdata.v1.GetCaptureProfileRequest");
_define_property(GetCaptureProfileRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetCaptureProfileResponse
 */ export class GetCaptureProfileResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetCaptureProfileResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCaptureProfileResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCaptureProfileResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCaptureProfileResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.CaptureProfileView profile = 1;
   */ _define_property(this, "profile", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCaptureProfileResponse, "runtime", proto3);
_define_property(GetCaptureProfileResponse, "typeName", "mono.projectdata.v1.GetCaptureProfileResponse");
_define_property(GetCaptureProfileResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "profile",
            kind: "message",
            T: CaptureProfileView
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpsertCaptureProfileRequest
 */ export class UpsertCaptureProfileRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCaptureProfileRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCaptureProfileRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCaptureProfileRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCaptureProfileRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string solicitation_number = 3;
   */ _define_property(this, "solicitationNumber", ""), /**
   * @generated from field: string crm_number = 4;
   */ _define_property(this, "crmNumber", ""), /**
   * @generated from field: string business_developer_id = 5;
   */ _define_property(this, "businessDeveloperId", ""), /**
   * @generated from field: string capture_manager_id = 6;
   */ _define_property(this, "captureManagerId", ""), /**
   * @generated from field: string customer_agency_names = 7;
   */ _define_property(this, "customerAgencyNames", ""), /**
   * @generated from field: string bid_position = 8;
   */ _define_property(this, "bidPosition", ""), /**
   * @generated from field: string vehicle = 9;
   */ _define_property(this, "vehicle", ""), /**
   * @generated from field: string procurement_type = 10;
   */ _define_property(this, "procurementType", ""), /**
   * @generated from field: string contract_type = 11;
   */ _define_property(this, "contractType", ""), /**
   * @generated from field: string period_of_performance = 12;
   */ _define_property(this, "periodOfPerformance", ""), /**
   * @generated from field: string total_program_value = 13;
   */ _define_property(this, "totalProgramValue", ""), /**
   * @generated from field: string stage_label = 14;
   */ _define_property(this, "stageLabel", ""), /**
   * @generated from field: string pwin_percent = 15;
   */ _define_property(this, "pwinPercent", ""), /**
   * @generated from field: string risks = 16;
   */ _define_property(this, "risks", ""), /**
   * @generated from field: string user_id = 17;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 18;
   */ _define_property(this, "companyId", ""), /**
   * GRW-09: registry vehicle id (must be this tenant's); vehicle carries its name.
   * Unset keeps the stored link (older clients never send it); "" clears it.
   *
   * @generated from field: optional string vehicle_id = 19;
   */ _define_property(this, "vehicleId", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCaptureProfileRequest, "runtime", proto3);
_define_property(UpsertCaptureProfileRequest, "typeName", "mono.projectdata.v1.UpsertCaptureProfileRequest");
_define_property(UpsertCaptureProfileRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "solicitation_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "crm_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "business_developer_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "capture_manager_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "customer_agency_names",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "bid_position",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "vehicle",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "procurement_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "contract_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "period_of_performance",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "total_program_value",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "stage_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "pwin_percent",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "risks",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpsertCaptureProfileResponse
 */ export class UpsertCaptureProfileResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCaptureProfileResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCaptureProfileResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCaptureProfileResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCaptureProfileResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.CaptureProfileView profile = 1;
   */ _define_property(this, "profile", void 0), /**
   * @generated from field: bool created = 2;
   */ _define_property(this, "created", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCaptureProfileResponse, "runtime", proto3);
_define_property(UpsertCaptureProfileResponse, "typeName", "mono.projectdata.v1.UpsertCaptureProfileResponse");
_define_property(UpsertCaptureProfileResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "profile",
            kind: "message",
            T: CaptureProfileView
        },
        {
            no: 2,
            name: "created",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CaptureTeamingLinkView
 */ export class CaptureTeamingLinkView extends Message {
    static fromBinary(bytes, options) {
        return new CaptureTeamingLinkView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureTeamingLinkView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureTeamingLinkView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureTeamingLinkView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string company_profile_id = 3;
   */ _define_property(this, "companyProfileId", ""), /**
   * @generated from field: string workshare = 4;
   */ _define_property(this, "workshare", ""), /**
   * @generated from field: bool nda = 5;
   */ _define_property(this, "nda", false), /**
   * @generated from field: bool ta = 6;
   */ _define_property(this, "ta", false), /**
   * @generated from field: string rationale = 7;
   */ _define_property(this, "rationale", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 9;
   */ _define_property(this, "updatedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureTeamingLinkView, "runtime", proto3);
_define_property(CaptureTeamingLinkView, "typeName", "mono.projectdata.v1.CaptureTeamingLinkView");
_define_property(CaptureTeamingLinkView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "workshare",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "nda",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 6,
            name: "ta",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 7,
            name: "rationale",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpsertCaptureTeamingLinkRequest
 */ export class UpsertCaptureTeamingLinkRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCaptureTeamingLinkRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCaptureTeamingLinkRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCaptureTeamingLinkRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCaptureTeamingLinkRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string company_profile_id = 3;
   */ _define_property(this, "companyProfileId", ""), /**
   * @generated from field: string workshare = 4;
   */ _define_property(this, "workshare", ""), /**
   * @generated from field: bool nda = 5;
   */ _define_property(this, "nda", false), /**
   * @generated from field: bool ta = 6;
   */ _define_property(this, "ta", false), /**
   * @generated from field: string rationale = 7;
   */ _define_property(this, "rationale", ""), /**
   * @generated from field: string user_id = 8;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 9;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCaptureTeamingLinkRequest, "runtime", proto3);
_define_property(UpsertCaptureTeamingLinkRequest, "typeName", "mono.projectdata.v1.UpsertCaptureTeamingLinkRequest");
_define_property(UpsertCaptureTeamingLinkRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "workshare",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "nda",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 6,
            name: "ta",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 7,
            name: "rationale",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpsertCaptureTeamingLinkResponse
 */ export class UpsertCaptureTeamingLinkResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCaptureTeamingLinkResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCaptureTeamingLinkResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCaptureTeamingLinkResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCaptureTeamingLinkResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.CaptureTeamingLinkView link = 1;
   */ _define_property(this, "link", void 0), /**
   * @generated from field: bool created = 2;
   */ _define_property(this, "created", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCaptureTeamingLinkResponse, "runtime", proto3);
_define_property(UpsertCaptureTeamingLinkResponse, "typeName", "mono.projectdata.v1.UpsertCaptureTeamingLinkResponse");
_define_property(UpsertCaptureTeamingLinkResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "link",
            kind: "message",
            T: CaptureTeamingLinkView
        },
        {
            no: 2,
            name: "created",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListCaptureTeamingLinksRequest
 */ export class ListCaptureTeamingLinksRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCaptureTeamingLinksRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCaptureTeamingLinksRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCaptureTeamingLinksRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCaptureTeamingLinksRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 3;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCaptureTeamingLinksRequest, "runtime", proto3);
_define_property(ListCaptureTeamingLinksRequest, "typeName", "mono.projectdata.v1.ListCaptureTeamingLinksRequest");
_define_property(ListCaptureTeamingLinksRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListCaptureTeamingLinksResponse
 */ export class ListCaptureTeamingLinksResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCaptureTeamingLinksResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCaptureTeamingLinksResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCaptureTeamingLinksResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCaptureTeamingLinksResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.CaptureTeamingLinkView links = 1;
   */ _define_property(this, "links", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCaptureTeamingLinksResponse, "runtime", proto3);
_define_property(ListCaptureTeamingLinksResponse, "typeName", "mono.projectdata.v1.ListCaptureTeamingLinksResponse");
_define_property(ListCaptureTeamingLinksResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "links",
            kind: "message",
            T: CaptureTeamingLinkView,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.DeleteCaptureTeamingLinkRequest
 */ export class DeleteCaptureTeamingLinkRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteCaptureTeamingLinkRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteCaptureTeamingLinkRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteCaptureTeamingLinkRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteCaptureTeamingLinkRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string user_id = 3;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 4;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteCaptureTeamingLinkRequest, "runtime", proto3);
_define_property(DeleteCaptureTeamingLinkRequest, "typeName", "mono.projectdata.v1.DeleteCaptureTeamingLinkRequest");
_define_property(DeleteCaptureTeamingLinkRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.DeleteCaptureTeamingLinkResponse
 */ export class DeleteCaptureTeamingLinkResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteCaptureTeamingLinkResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteCaptureTeamingLinkResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteCaptureTeamingLinkResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteCaptureTeamingLinkResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteCaptureTeamingLinkResponse, "runtime", proto3);
_define_property(DeleteCaptureTeamingLinkResponse, "typeName", "mono.projectdata.v1.DeleteCaptureTeamingLinkResponse");
_define_property(DeleteCaptureTeamingLinkResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.projectdata.v1.CaptureCompetitionLinkView
 */ export class CaptureCompetitionLinkView extends Message {
    static fromBinary(bytes, options) {
        return new CaptureCompetitionLinkView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureCompetitionLinkView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureCompetitionLinkView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureCompetitionLinkView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string company_profile_id = 3;
   */ _define_property(this, "companyProfileId", ""), /**
   * incumbent|prime|sub
   *
   * @generated from field: string role = 4;
   */ _define_property(this, "role", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */ _define_property(this, "updatedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureCompetitionLinkView, "runtime", proto3);
_define_property(CaptureCompetitionLinkView, "typeName", "mono.projectdata.v1.CaptureCompetitionLinkView");
_define_property(CaptureCompetitionLinkView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpsertCaptureCompetitionLinkRequest
 */ export class UpsertCaptureCompetitionLinkRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCaptureCompetitionLinkRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCaptureCompetitionLinkRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCaptureCompetitionLinkRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCaptureCompetitionLinkRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string company_profile_id = 3;
   */ _define_property(this, "companyProfileId", ""), /**
   * @generated from field: string role = 4;
   */ _define_property(this, "role", ""), /**
   * @generated from field: string user_id = 5;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 6;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCaptureCompetitionLinkRequest, "runtime", proto3);
_define_property(UpsertCaptureCompetitionLinkRequest, "typeName", "mono.projectdata.v1.UpsertCaptureCompetitionLinkRequest");
_define_property(UpsertCaptureCompetitionLinkRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpsertCaptureCompetitionLinkResponse
 */ export class UpsertCaptureCompetitionLinkResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCaptureCompetitionLinkResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCaptureCompetitionLinkResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCaptureCompetitionLinkResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCaptureCompetitionLinkResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.CaptureCompetitionLinkView link = 1;
   */ _define_property(this, "link", void 0), /**
   * @generated from field: bool created = 2;
   */ _define_property(this, "created", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCaptureCompetitionLinkResponse, "runtime", proto3);
_define_property(UpsertCaptureCompetitionLinkResponse, "typeName", "mono.projectdata.v1.UpsertCaptureCompetitionLinkResponse");
_define_property(UpsertCaptureCompetitionLinkResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "link",
            kind: "message",
            T: CaptureCompetitionLinkView
        },
        {
            no: 2,
            name: "created",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListCaptureCompetitionLinksRequest
 */ export class ListCaptureCompetitionLinksRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCaptureCompetitionLinksRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCaptureCompetitionLinksRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCaptureCompetitionLinksRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCaptureCompetitionLinksRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 3;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCaptureCompetitionLinksRequest, "runtime", proto3);
_define_property(ListCaptureCompetitionLinksRequest, "typeName", "mono.projectdata.v1.ListCaptureCompetitionLinksRequest");
_define_property(ListCaptureCompetitionLinksRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListCaptureCompetitionLinksResponse
 */ export class ListCaptureCompetitionLinksResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCaptureCompetitionLinksResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCaptureCompetitionLinksResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCaptureCompetitionLinksResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCaptureCompetitionLinksResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.CaptureCompetitionLinkView links = 1;
   */ _define_property(this, "links", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCaptureCompetitionLinksResponse, "runtime", proto3);
_define_property(ListCaptureCompetitionLinksResponse, "typeName", "mono.projectdata.v1.ListCaptureCompetitionLinksResponse");
_define_property(ListCaptureCompetitionLinksResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "links",
            kind: "message",
            T: CaptureCompetitionLinkView,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.DeleteCaptureCompetitionLinkRequest
 */ export class DeleteCaptureCompetitionLinkRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteCaptureCompetitionLinkRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteCaptureCompetitionLinkRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteCaptureCompetitionLinkRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteCaptureCompetitionLinkRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string user_id = 3;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 4;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteCaptureCompetitionLinkRequest, "runtime", proto3);
_define_property(DeleteCaptureCompetitionLinkRequest, "typeName", "mono.projectdata.v1.DeleteCaptureCompetitionLinkRequest");
_define_property(DeleteCaptureCompetitionLinkRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.DeleteCaptureCompetitionLinkResponse
 */ export class DeleteCaptureCompetitionLinkResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteCaptureCompetitionLinkResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteCaptureCompetitionLinkResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteCaptureCompetitionLinkResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteCaptureCompetitionLinkResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteCaptureCompetitionLinkResponse, "runtime", proto3);
_define_property(DeleteCaptureCompetitionLinkResponse, "typeName", "mono.projectdata.v1.DeleteCaptureCompetitionLinkResponse");
_define_property(DeleteCaptureCompetitionLinkResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.projectdata.v1.CaptureTaskView
 */ export class CaptureTaskView extends Message {
    static fromBinary(bytes, options) {
        return new CaptureTaskView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureTaskView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureTaskView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureTaskView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string title = 3;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string owner_user_id = 4;
   */ _define_property(this, "ownerUserId", ""), /**
   * @generated from field: google.protobuf.Timestamp due_at = 5;
   */ _define_property(this, "dueAt", void 0), /**
   * open|in_progress|done|parked
   *
   * @generated from field: string status = 6;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string notes = 7;
   */ _define_property(this, "notes", ""), /**
   * @generated from field: int32 sort_order = 8;
   */ _define_property(this, "sortOrder", 0), /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 10;
   */ _define_property(this, "updatedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureTaskView, "runtime", proto3);
_define_property(CaptureTaskView, "typeName", "mono.projectdata.v1.CaptureTaskView");
_define_property(CaptureTaskView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "owner_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "due_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "sort_order",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 9,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpsertCaptureTaskRequest
 */ export class UpsertCaptureTaskRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCaptureTaskRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCaptureTaskRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCaptureTaskRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCaptureTaskRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string title = 3;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string owner_user_id = 4;
   */ _define_property(this, "ownerUserId", ""), /**
   * @generated from field: google.protobuf.Timestamp due_at = 5;
   */ _define_property(this, "dueAt", void 0), /**
   * @generated from field: string status = 6;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string notes = 7;
   */ _define_property(this, "notes", ""), /**
   * @generated from field: int32 sort_order = 8;
   */ _define_property(this, "sortOrder", 0), /**
   * @generated from field: string user_id = 9;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 10;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCaptureTaskRequest, "runtime", proto3);
_define_property(UpsertCaptureTaskRequest, "typeName", "mono.projectdata.v1.UpsertCaptureTaskRequest");
_define_property(UpsertCaptureTaskRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "owner_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "due_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "sort_order",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 9,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpsertCaptureTaskResponse
 */ export class UpsertCaptureTaskResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCaptureTaskResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCaptureTaskResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCaptureTaskResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCaptureTaskResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.CaptureTaskView task = 1;
   */ _define_property(this, "task", void 0), /**
   * @generated from field: bool created = 2;
   */ _define_property(this, "created", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCaptureTaskResponse, "runtime", proto3);
_define_property(UpsertCaptureTaskResponse, "typeName", "mono.projectdata.v1.UpsertCaptureTaskResponse");
_define_property(UpsertCaptureTaskResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "task",
            kind: "message",
            T: CaptureTaskView
        },
        {
            no: 2,
            name: "created",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListCaptureTasksRequest
 */ export class ListCaptureTasksRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCaptureTasksRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCaptureTasksRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCaptureTasksRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCaptureTasksRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 3;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCaptureTasksRequest, "runtime", proto3);
_define_property(ListCaptureTasksRequest, "typeName", "mono.projectdata.v1.ListCaptureTasksRequest");
_define_property(ListCaptureTasksRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListCaptureTasksResponse
 */ export class ListCaptureTasksResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCaptureTasksResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCaptureTasksResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCaptureTasksResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCaptureTasksResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.CaptureTaskView tasks = 1;
   */ _define_property(this, "tasks", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCaptureTasksResponse, "runtime", proto3);
_define_property(ListCaptureTasksResponse, "typeName", "mono.projectdata.v1.ListCaptureTasksResponse");
_define_property(ListCaptureTasksResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tasks",
            kind: "message",
            T: CaptureTaskView,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.DeleteCaptureTaskRequest
 */ export class DeleteCaptureTaskRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteCaptureTaskRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteCaptureTaskRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteCaptureTaskRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteCaptureTaskRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string user_id = 3;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 4;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteCaptureTaskRequest, "runtime", proto3);
_define_property(DeleteCaptureTaskRequest, "typeName", "mono.projectdata.v1.DeleteCaptureTaskRequest");
_define_property(DeleteCaptureTaskRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.DeleteCaptureTaskResponse
 */ export class DeleteCaptureTaskResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteCaptureTaskResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteCaptureTaskResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteCaptureTaskResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteCaptureTaskResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteCaptureTaskResponse, "runtime", proto3);
_define_property(DeleteCaptureTaskResponse, "typeName", "mono.projectdata.v1.DeleteCaptureTaskResponse");
_define_property(DeleteCaptureTaskResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.projectdata.v1.CompetitiveFieldParticipantView
 */ export class CompetitiveFieldParticipantView extends Message {
    static fromBinary(bytes, options) {
        return new CompetitiveFieldParticipantView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompetitiveFieldParticipantView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompetitiveFieldParticipantView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompetitiveFieldParticipantView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string company_profile_id = 3;
   */ _define_property(this, "companyProfileId", ""), /**
   * incumbent|prior_award|capability_match|market_signal|customer_mention|teaming_signal
   *
   * @generated from field: string inclusion_basis = 4;
   */ _define_property(this, "inclusionBasis", ""), /**
   * @generated from field: string basis_note = 5;
   */ _define_property(this, "basisNote", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 7;
   */ _define_property(this, "updatedAt", void 0), /**
   * GRW-08: prime|sub|jv|unknown.
   *
   * @generated from field: string expected_role = 8;
   */ _define_property(this, "expectedRole", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CompetitiveFieldParticipantView, "runtime", proto3);
_define_property(CompetitiveFieldParticipantView, "typeName", "mono.projectdata.v1.CompetitiveFieldParticipantView");
_define_property(CompetitiveFieldParticipantView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "inclusion_basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "basis_note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "expected_role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CompetitiveFieldAssessmentView
 */ export class CompetitiveFieldAssessmentView extends Message {
    static fromBinary(bytes, options) {
        return new CompetitiveFieldAssessmentView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompetitiveFieldAssessmentView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompetitiveFieldAssessmentView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompetitiveFieldAssessmentView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string participant_id = 2;
   */ _define_property(this, "participantId", ""), /**
   * possible|likely|confirmed
   *
   * @generated from field: string likelihood_band = 3;
   */ _define_property(this, "likelihoodBand", ""), /**
   * hypothesis|corroborated|established
   *
   * @generated from field: string assertion_status = 4;
   */ _define_property(this, "assertionStatus", ""), /**
   * low|medium|high
   *
   * @generated from field: string confidence = 5;
   */ _define_property(this, "confidence", ""), /**
   * @generated from field: string rationale = 6;
   */ _define_property(this, "rationale", ""), /**
   * @generated from field: google.protobuf.Timestamp as_of_date = 7;
   */ _define_property(this, "asOfDate", void 0), /**
   * @generated from field: string supersedes_id = 8;
   */ _define_property(this, "supersedesId", ""), /**
   * @generated from field: google.protobuf.Timestamp superseded_at = 9;
   */ _define_property(this, "supersededAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 11;
   */ _define_property(this, "updatedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CompetitiveFieldAssessmentView, "runtime", proto3);
_define_property(CompetitiveFieldAssessmentView, "typeName", "mono.projectdata.v1.CompetitiveFieldAssessmentView");
_define_property(CompetitiveFieldAssessmentView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "participant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "likelihood_band",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "assertion_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "confidence",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "rationale",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "as_of_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "supersedes_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "superseded_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CompetitiveFieldStrategyView
 */ export class CompetitiveFieldStrategyView extends Message {
    static fromBinary(bytes, options) {
        return new CompetitiveFieldStrategyView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompetitiveFieldStrategyView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompetitiveFieldStrategyView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompetitiveFieldStrategyView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string participant_id = 3;
   */ _define_property(this, "participantId", ""), /**
   * @generated from field: string positioning = 4;
   */ _define_property(this, "positioning", ""), /**
   * @generated from field: string discriminators = 5;
   */ _define_property(this, "discriminators", ""), /**
   * @generated from field: string response = 6;
   */ _define_property(this, "response", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 8;
   */ _define_property(this, "updatedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CompetitiveFieldStrategyView, "runtime", proto3);
_define_property(CompetitiveFieldStrategyView, "typeName", "mono.projectdata.v1.CompetitiveFieldStrategyView");
_define_property(CompetitiveFieldStrategyView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "participant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "positioning",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "discriminators",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "response",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * CompetitorEvidenceView is append-only: no update or delete RPC, only
 * RecordCompetitorEvidence. No numeric price/rate field (B3.4-08); a derived
 * numeric claim travels only as claim_type = "rate_or_price_inference" plus
 * non-empty inference_assumptions (B3.4-09.3).
 *
 * @generated from message mono.projectdata.v1.CompetitorEvidenceView
 */ export class CompetitorEvidenceView extends Message {
    static fromBinary(bytes, options) {
        return new CompetitorEvidenceView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompetitorEvidenceView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompetitorEvidenceView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompetitorEvidenceView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string participant_id = 2;
   */ _define_property(this, "participantId", ""), /**
   * rate_sheet|public_award|web_reference|internal_observation|manual_entry
   *
   * @generated from field: string source_kind = 3;
   */ _define_property(this, "sourceKind", ""), /**
   * @generated from field: string source_ref = 4;
   */ _define_property(this, "sourceRef", ""), /**
   * @generated from field: google.protobuf.Timestamp source_date = 5;
   */ _define_property(this, "sourceDate", void 0), /**
   * strength|vulnerability|customer_position|likely_strategy|capability|rate_or_price_inference|pricing_posture|other
   *
   * @generated from field: string claim_type = 6;
   */ _define_property(this, "claimType", ""), /**
   * supports|contradicts
   *
   * @generated from field: string stance = 7;
   */ _define_property(this, "stance", ""), /**
   * low|medium|high
   *
   * @generated from field: string confidence = 8;
   */ _define_property(this, "confidence", ""), /**
   * @generated from field: string rationale = 9;
   */ _define_property(this, "rationale", ""), /**
   * @generated from field: string inference_assumptions = 10;
   */ _define_property(this, "inferenceAssumptions", ""), /**
   * @generated from field: string supersedes_evidence_id = 11;
   */ _define_property(this, "supersedesEvidenceId", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 12;
   */ _define_property(this, "createdAt", void 0), /**
   * evidenced|assumption
   *
   * @generated from field: string basis = 13;
   */ _define_property(this, "basis", ""), /**
   * @generated from field: string actor_user_id = 14;
   */ _define_property(this, "actorUserId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CompetitorEvidenceView, "runtime", proto3);
_define_property(CompetitorEvidenceView, "typeName", "mono.projectdata.v1.CompetitorEvidenceView");
_define_property(CompetitorEvidenceView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "participant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "source_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "source_ref",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "source_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "claim_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "stance",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "confidence",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "rationale",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "inference_assumptions",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "supersedes_evidence_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 13,
            name: "basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "actor_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * BlackHatInputView carries no numeric price/rate field — see B3.4-08 above.
 *
 * @generated from message mono.projectdata.v1.BlackHatInputView
 */ export class BlackHatInputView extends Message {
    static fromBinary(bytes, options) {
        return new BlackHatInputView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BlackHatInputView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BlackHatInputView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BlackHatInputView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string participant_id = 3;
   */ _define_property(this, "participantId", ""), /**
   * @generated from field: string competitor_advantages = 4;
   */ _define_property(this, "competitorAdvantages", ""), /**
   * @generated from field: string competitor_vulnerabilities = 5;
   */ _define_property(this, "competitorVulnerabilities", ""), /**
   * @generated from field: string likely_approaches = 6;
   */ _define_property(this, "likelyApproaches", ""), /**
   * @generated from field: string our_response = 7;
   */ _define_property(this, "ourResponse", ""), /**
   * @generated from field: string open_questions = 8;
   */ _define_property(this, "openQuestions", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 10;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: string actor_user_id = 11;
   */ _define_property(this, "actorUserId", ""), /**
   * @generated from field: string supersedes_id = 12;
   */ _define_property(this, "supersedesId", ""), /**
   * @generated from field: google.protobuf.Timestamp superseded_at = 13;
   */ _define_property(this, "supersededAt", void 0), /**
   * @generated from field: string reviewed_by = 14;
   */ _define_property(this, "reviewedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp reviewed_at = 15;
   */ _define_property(this, "reviewedAt", void 0), /**
   * @generated from field: string review_note = 16;
   */ _define_property(this, "reviewNote", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(BlackHatInputView, "runtime", proto3);
_define_property(BlackHatInputView, "typeName", "mono.projectdata.v1.BlackHatInputView");
_define_property(BlackHatInputView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "participant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "competitor_advantages",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "competitor_vulnerabilities",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "likely_approaches",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "our_response",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "open_questions",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "actor_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "supersedes_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "superseded_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 14,
            name: "reviewed_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "reviewed_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 16,
            name: "review_note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * CompetitiveFieldEntryView is one row of the GetCompetitiveField aggregate
 * read: a participant with its current (live, non-superseded) assessment,
 * its evidence list and its strategy. current_assessment and strategy are
 * unset when none has been recorded yet.
 *
 * @generated from message mono.projectdata.v1.CompetitiveFieldEntryView
 */ export class CompetitiveFieldEntryView extends Message {
    static fromBinary(bytes, options) {
        return new CompetitiveFieldEntryView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompetitiveFieldEntryView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompetitiveFieldEntryView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompetitiveFieldEntryView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.CompetitiveFieldParticipantView participant = 1;
   */ _define_property(this, "participant", void 0), /**
   * @generated from field: mono.projectdata.v1.CompetitiveFieldAssessmentView current_assessment = 2;
   */ _define_property(this, "currentAssessment", void 0), /**
   * @generated from field: repeated mono.projectdata.v1.CompetitorEvidenceView evidence = 3;
   */ _define_property(this, "evidence", []), /**
   * @generated from field: mono.projectdata.v1.CompetitiveFieldStrategyView strategy = 4;
   */ _define_property(this, "strategy", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CompetitiveFieldEntryView, "runtime", proto3);
_define_property(CompetitiveFieldEntryView, "typeName", "mono.projectdata.v1.CompetitiveFieldEntryView");
_define_property(CompetitiveFieldEntryView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "participant",
            kind: "message",
            T: CompetitiveFieldParticipantView
        },
        {
            no: 2,
            name: "current_assessment",
            kind: "message",
            T: CompetitiveFieldAssessmentView
        },
        {
            no: 3,
            name: "evidence",
            kind: "message",
            T: CompetitorEvidenceView,
            repeated: true
        },
        {
            no: 4,
            name: "strategy",
            kind: "message",
            T: CompetitiveFieldStrategyView
        }
    ]));
/**
 * GetCompetitiveField is the single aggregate read the UI uses: every
 * participant in the field plus the pursuit's Black Hat inputs. A denied
 * capture_project_id returns the same error the single-row read produces —
 * never a partial field, never an id, never a company name.
 *
 * @generated from message mono.projectdata.v1.GetCompetitiveFieldRequest
 */ export class GetCompetitiveFieldRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetCompetitiveFieldRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCompetitiveFieldRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCompetitiveFieldRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCompetitiveFieldRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 3;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCompetitiveFieldRequest, "runtime", proto3);
_define_property(GetCompetitiveFieldRequest, "typeName", "mono.projectdata.v1.GetCompetitiveFieldRequest");
_define_property(GetCompetitiveFieldRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetCompetitiveFieldResponse
 */ export class GetCompetitiveFieldResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetCompetitiveFieldResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCompetitiveFieldResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCompetitiveFieldResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCompetitiveFieldResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.CompetitiveFieldEntryView entries = 1;
   */ _define_property(this, "entries", []), /**
   * @generated from field: repeated mono.projectdata.v1.BlackHatInputView black_hat_inputs = 2;
   */ _define_property(this, "blackHatInputs", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCompetitiveFieldResponse, "runtime", proto3);
_define_property(GetCompetitiveFieldResponse, "typeName", "mono.projectdata.v1.GetCompetitiveFieldResponse");
_define_property(GetCompetitiveFieldResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "entries",
            kind: "message",
            T: CompetitiveFieldEntryView,
            repeated: true
        },
        {
            no: 2,
            name: "black_hat_inputs",
            kind: "message",
            T: BlackHatInputView,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpsertCompetitiveFieldParticipantRequest
 */ export class UpsertCompetitiveFieldParticipantRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCompetitiveFieldParticipantRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCompetitiveFieldParticipantRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCompetitiveFieldParticipantRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCompetitiveFieldParticipantRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string company_profile_id = 3;
   */ _define_property(this, "companyProfileId", ""), /**
   * @generated from field: string inclusion_basis = 4;
   */ _define_property(this, "inclusionBasis", ""), /**
   * @generated from field: string basis_note = 5;
   */ _define_property(this, "basisNote", ""), /**
   * @generated from field: string user_id = 6;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 7;
   */ _define_property(this, "companyId", ""), /**
   * GRW-08: prime|sub|jv|unknown; empty = unknown.
   *
   * @generated from field: string expected_role = 8;
   */ _define_property(this, "expectedRole", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCompetitiveFieldParticipantRequest, "runtime", proto3);
_define_property(UpsertCompetitiveFieldParticipantRequest, "typeName", "mono.projectdata.v1.UpsertCompetitiveFieldParticipantRequest");
_define_property(UpsertCompetitiveFieldParticipantRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "inclusion_basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "basis_note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "expected_role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpsertCompetitiveFieldParticipantResponse
 */ export class UpsertCompetitiveFieldParticipantResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCompetitiveFieldParticipantResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCompetitiveFieldParticipantResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCompetitiveFieldParticipantResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCompetitiveFieldParticipantResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.CompetitiveFieldParticipantView participant = 1;
   */ _define_property(this, "participant", void 0), /**
   * @generated from field: bool created = 2;
   */ _define_property(this, "created", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCompetitiveFieldParticipantResponse, "runtime", proto3);
_define_property(UpsertCompetitiveFieldParticipantResponse, "typeName", "mono.projectdata.v1.UpsertCompetitiveFieldParticipantResponse");
_define_property(UpsertCompetitiveFieldParticipantResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "participant",
            kind: "message",
            T: CompetitiveFieldParticipantView
        },
        {
            no: 2,
            name: "created",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.DeleteCompetitiveFieldParticipantRequest
 */ export class DeleteCompetitiveFieldParticipantRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteCompetitiveFieldParticipantRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteCompetitiveFieldParticipantRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteCompetitiveFieldParticipantRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteCompetitiveFieldParticipantRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string user_id = 3;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 4;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteCompetitiveFieldParticipantRequest, "runtime", proto3);
_define_property(DeleteCompetitiveFieldParticipantRequest, "typeName", "mono.projectdata.v1.DeleteCompetitiveFieldParticipantRequest");
_define_property(DeleteCompetitiveFieldParticipantRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.DeleteCompetitiveFieldParticipantResponse
 */ export class DeleteCompetitiveFieldParticipantResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteCompetitiveFieldParticipantResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteCompetitiveFieldParticipantResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteCompetitiveFieldParticipantResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteCompetitiveFieldParticipantResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteCompetitiveFieldParticipantResponse, "runtime", proto3);
_define_property(DeleteCompetitiveFieldParticipantResponse, "typeName", "mono.projectdata.v1.DeleteCompetitiveFieldParticipantResponse");
_define_property(DeleteCompetitiveFieldParticipantResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * RecordCompetitiveFieldAssessment creates the first assessment for a
 * participant, or revises the live one by new row when one already exists.
 * It never updates an assessment in place.
 *
 * @generated from message mono.projectdata.v1.RecordCompetitiveFieldAssessmentRequest
 */ export class RecordCompetitiveFieldAssessmentRequest extends Message {
    static fromBinary(bytes, options) {
        return new RecordCompetitiveFieldAssessmentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordCompetitiveFieldAssessmentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordCompetitiveFieldAssessmentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordCompetitiveFieldAssessmentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string participant_id = 2;
   */ _define_property(this, "participantId", ""), /**
   * @generated from field: string likelihood_band = 3;
   */ _define_property(this, "likelihoodBand", ""), /**
   * @generated from field: string assertion_status = 4;
   */ _define_property(this, "assertionStatus", ""), /**
   * @generated from field: string confidence = 5;
   */ _define_property(this, "confidence", ""), /**
   * @generated from field: string rationale = 6;
   */ _define_property(this, "rationale", ""), /**
   * @generated from field: google.protobuf.Timestamp as_of_date = 7;
   */ _define_property(this, "asOfDate", void 0), /**
   * @generated from field: string user_id = 8;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 9;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordCompetitiveFieldAssessmentRequest, "runtime", proto3);
_define_property(RecordCompetitiveFieldAssessmentRequest, "typeName", "mono.projectdata.v1.RecordCompetitiveFieldAssessmentRequest");
_define_property(RecordCompetitiveFieldAssessmentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "participant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "likelihood_band",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "assertion_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "confidence",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "rationale",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "as_of_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RecordCompetitiveFieldAssessmentResponse
 */ export class RecordCompetitiveFieldAssessmentResponse extends Message {
    static fromBinary(bytes, options) {
        return new RecordCompetitiveFieldAssessmentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordCompetitiveFieldAssessmentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordCompetitiveFieldAssessmentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordCompetitiveFieldAssessmentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.CompetitiveFieldAssessmentView assessment = 1;
   */ _define_property(this, "assessment", void 0), /**
   * @generated from field: bool created = 2;
   */ _define_property(this, "created", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordCompetitiveFieldAssessmentResponse, "runtime", proto3);
_define_property(RecordCompetitiveFieldAssessmentResponse, "typeName", "mono.projectdata.v1.RecordCompetitiveFieldAssessmentResponse");
_define_property(RecordCompetitiveFieldAssessmentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "assessment",
            kind: "message",
            T: CompetitiveFieldAssessmentView
        },
        {
            no: 2,
            name: "created",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpsertCompetitiveFieldStrategyRequest
 */ export class UpsertCompetitiveFieldStrategyRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCompetitiveFieldStrategyRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCompetitiveFieldStrategyRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCompetitiveFieldStrategyRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCompetitiveFieldStrategyRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string participant_id = 3;
   */ _define_property(this, "participantId", ""), /**
   * @generated from field: string positioning = 4;
   */ _define_property(this, "positioning", ""), /**
   * @generated from field: string discriminators = 5;
   */ _define_property(this, "discriminators", ""), /**
   * @generated from field: string response = 6;
   */ _define_property(this, "response", ""), /**
   * @generated from field: string user_id = 7;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 8;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCompetitiveFieldStrategyRequest, "runtime", proto3);
_define_property(UpsertCompetitiveFieldStrategyRequest, "typeName", "mono.projectdata.v1.UpsertCompetitiveFieldStrategyRequest");
_define_property(UpsertCompetitiveFieldStrategyRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "participant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "positioning",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "discriminators",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "response",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpsertCompetitiveFieldStrategyResponse
 */ export class UpsertCompetitiveFieldStrategyResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCompetitiveFieldStrategyResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCompetitiveFieldStrategyResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCompetitiveFieldStrategyResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCompetitiveFieldStrategyResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.CompetitiveFieldStrategyView strategy = 1;
   */ _define_property(this, "strategy", void 0), /**
   * @generated from field: bool created = 2;
   */ _define_property(this, "created", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCompetitiveFieldStrategyResponse, "runtime", proto3);
_define_property(UpsertCompetitiveFieldStrategyResponse, "typeName", "mono.projectdata.v1.UpsertCompetitiveFieldStrategyResponse");
_define_property(UpsertCompetitiveFieldStrategyResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "strategy",
            kind: "message",
            T: CompetitiveFieldStrategyView
        },
        {
            no: 2,
            name: "created",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * RecordCompetitorEvidence appends one evidence row. There is no update or
 * delete RPC — a correction or contradiction is always a new row.
 *
 * @generated from message mono.projectdata.v1.RecordCompetitorEvidenceRequest
 */ export class RecordCompetitorEvidenceRequest extends Message {
    static fromBinary(bytes, options) {
        return new RecordCompetitorEvidenceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordCompetitorEvidenceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordCompetitorEvidenceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordCompetitorEvidenceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string participant_id = 2;
   */ _define_property(this, "participantId", ""), /**
   * @generated from field: string source_kind = 3;
   */ _define_property(this, "sourceKind", ""), /**
   * @generated from field: string source_ref = 4;
   */ _define_property(this, "sourceRef", ""), /**
   * @generated from field: google.protobuf.Timestamp source_date = 5;
   */ _define_property(this, "sourceDate", void 0), /**
   * @generated from field: string claim_type = 6;
   */ _define_property(this, "claimType", ""), /**
   * @generated from field: string stance = 7;
   */ _define_property(this, "stance", ""), /**
   * @generated from field: string confidence = 8;
   */ _define_property(this, "confidence", ""), /**
   * @generated from field: string rationale = 9;
   */ _define_property(this, "rationale", ""), /**
   * @generated from field: string inference_assumptions = 10;
   */ _define_property(this, "inferenceAssumptions", ""), /**
   * @generated from field: string supersedes_evidence_id = 11;
   */ _define_property(this, "supersedesEvidenceId", ""), /**
   * @generated from field: string user_id = 12;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 13;
   */ _define_property(this, "companyId", ""), /**
   * evidenced|assumption; defaults to evidenced
   *
   * @generated from field: string basis = 14;
   */ _define_property(this, "basis", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordCompetitorEvidenceRequest, "runtime", proto3);
_define_property(RecordCompetitorEvidenceRequest, "typeName", "mono.projectdata.v1.RecordCompetitorEvidenceRequest");
_define_property(RecordCompetitorEvidenceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "participant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "source_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "source_ref",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "source_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "claim_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "stance",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "confidence",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "rationale",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "inference_assumptions",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "supersedes_evidence_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RecordCompetitorEvidenceResponse
 */ export class RecordCompetitorEvidenceResponse extends Message {
    static fromBinary(bytes, options) {
        return new RecordCompetitorEvidenceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordCompetitorEvidenceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordCompetitorEvidenceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordCompetitorEvidenceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.CompetitorEvidenceView evidence = 1;
   */ _define_property(this, "evidence", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordCompetitorEvidenceResponse, "runtime", proto3);
_define_property(RecordCompetitorEvidenceResponse, "typeName", "mono.projectdata.v1.RecordCompetitorEvidenceResponse");
_define_property(RecordCompetitorEvidenceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "evidence",
            kind: "message",
            T: CompetitorEvidenceView
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpsertBlackHatInputRequest
 */ export class UpsertBlackHatInputRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertBlackHatInputRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertBlackHatInputRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertBlackHatInputRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertBlackHatInputRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string participant_id = 3;
   */ _define_property(this, "participantId", ""), /**
   * @generated from field: string competitor_advantages = 4;
   */ _define_property(this, "competitorAdvantages", ""), /**
   * @generated from field: string competitor_vulnerabilities = 5;
   */ _define_property(this, "competitorVulnerabilities", ""), /**
   * @generated from field: string likely_approaches = 6;
   */ _define_property(this, "likelyApproaches", ""), /**
   * @generated from field: string our_response = 7;
   */ _define_property(this, "ourResponse", ""), /**
   * @generated from field: string open_questions = 8;
   */ _define_property(this, "openQuestions", ""), /**
   * @generated from field: string user_id = 9;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 10;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertBlackHatInputRequest, "runtime", proto3);
_define_property(UpsertBlackHatInputRequest, "typeName", "mono.projectdata.v1.UpsertBlackHatInputRequest");
_define_property(UpsertBlackHatInputRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "participant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "competitor_advantages",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "competitor_vulnerabilities",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "likely_approaches",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "our_response",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "open_questions",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpsertBlackHatInputResponse
 */ export class UpsertBlackHatInputResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertBlackHatInputResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertBlackHatInputResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertBlackHatInputResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertBlackHatInputResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.BlackHatInputView input = 1;
   */ _define_property(this, "input", void 0), /**
   * @generated from field: bool created = 2;
   */ _define_property(this, "created", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertBlackHatInputResponse, "runtime", proto3);
_define_property(UpsertBlackHatInputResponse, "typeName", "mono.projectdata.v1.UpsertBlackHatInputResponse");
_define_property(UpsertBlackHatInputResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "input",
            kind: "message",
            T: BlackHatInputView
        },
        {
            no: 2,
            name: "created",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.DeleteBlackHatInputRequest
 */ export class DeleteBlackHatInputRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteBlackHatInputRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteBlackHatInputRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteBlackHatInputRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteBlackHatInputRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string user_id = 3;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 4;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteBlackHatInputRequest, "runtime", proto3);
_define_property(DeleteBlackHatInputRequest, "typeName", "mono.projectdata.v1.DeleteBlackHatInputRequest");
_define_property(DeleteBlackHatInputRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.DeleteBlackHatInputResponse
 */ export class DeleteBlackHatInputResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteBlackHatInputResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteBlackHatInputResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteBlackHatInputResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteBlackHatInputResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteBlackHatInputResponse, "runtime", proto3);
_define_property(DeleteBlackHatInputResponse, "typeName", "mono.projectdata.v1.DeleteBlackHatInputResponse");
_define_property(DeleteBlackHatInputResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.projectdata.v1.ReviewBlackHatInputRequest
 */ export class ReviewBlackHatInputRequest extends Message {
    static fromBinary(bytes, options) {
        return new ReviewBlackHatInputRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReviewBlackHatInputRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReviewBlackHatInputRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReviewBlackHatInputRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string review_note = 3;
   */ _define_property(this, "reviewNote", ""), /**
   * @generated from field: string user_id = 4;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 5;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReviewBlackHatInputRequest, "runtime", proto3);
_define_property(ReviewBlackHatInputRequest, "typeName", "mono.projectdata.v1.ReviewBlackHatInputRequest");
_define_property(ReviewBlackHatInputRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "review_note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ReviewBlackHatInputResponse
 */ export class ReviewBlackHatInputResponse extends Message {
    static fromBinary(bytes, options) {
        return new ReviewBlackHatInputResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReviewBlackHatInputResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReviewBlackHatInputResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReviewBlackHatInputResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.BlackHatInputView input = 1;
   */ _define_property(this, "input", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReviewBlackHatInputResponse, "runtime", proto3);
_define_property(ReviewBlackHatInputResponse, "typeName", "mono.projectdata.v1.ReviewBlackHatInputResponse");
_define_property(ReviewBlackHatInputResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "input",
            kind: "message",
            T: BlackHatInputView
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.LibraryItemReferenceView
 */ export class LibraryItemReferenceView extends Message {
    static fromBinary(bytes, options) {
        return new LibraryItemReferenceView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LibraryItemReferenceView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LibraryItemReferenceView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LibraryItemReferenceView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string library_item_id = 2;
   */ _define_property(this, "libraryItemId", ""), /**
   * artifact|artifact_version|external
   *
   * @generated from field: string reference_kind = 3;
   */ _define_property(this, "referenceKind", ""), /**
   * @generated from field: string artifact_id = 4;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: string artifact_version_id = 5;
   */ _define_property(this, "artifactVersionId", ""), /**
   * @generated from field: string content_sha256 = 6;
   */ _define_property(this, "contentSha256", ""), /**
   * @generated from field: string block_id = 7;
   */ _define_property(this, "blockId", ""), /**
   * @generated from field: int32 page = 8;
   */ _define_property(this, "page", 0), /**
   * @generated from field: string span = 9;
   */ _define_property(this, "span", ""), /**
   * @generated from field: string section = 10;
   */ _define_property(this, "section", ""), /**
   * @generated from field: string quote = 11;
   */ _define_property(this, "quote", ""), /**
   * @generated from field: string external_reference = 12;
   */ _define_property(this, "externalReference", ""), /**
   * @generated from field: string label = 13;
   */ _define_property(this, "label", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 14;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(LibraryItemReferenceView, "runtime", proto3);
_define_property(LibraryItemReferenceView, "typeName", "mono.projectdata.v1.LibraryItemReferenceView");
_define_property(LibraryItemReferenceView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "library_item_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "reference_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "artifact_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "content_sha256",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "block_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "page",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 9,
            name: "span",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "section",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "quote",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "external_reference",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * LibraryItemReferenceInput is the write-side shape for a reference attached
 * at CreateLibraryItem — no id/created_at, those are server-assigned.
 *
 * @generated from message mono.projectdata.v1.LibraryItemReferenceInput
 */ export class LibraryItemReferenceInput extends Message {
    static fromBinary(bytes, options) {
        return new LibraryItemReferenceInput().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LibraryItemReferenceInput().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LibraryItemReferenceInput().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LibraryItemReferenceInput, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string reference_kind = 1;
   */ _define_property(this, "referenceKind", ""), /**
   * @generated from field: string artifact_id = 2;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: string artifact_version_id = 3;
   */ _define_property(this, "artifactVersionId", ""), /**
   * @generated from field: string content_sha256 = 4;
   */ _define_property(this, "contentSha256", ""), /**
   * @generated from field: string block_id = 5;
   */ _define_property(this, "blockId", ""), /**
   * @generated from field: int32 page = 6;
   */ _define_property(this, "page", 0), /**
   * @generated from field: string span = 7;
   */ _define_property(this, "span", ""), /**
   * @generated from field: string section = 8;
   */ _define_property(this, "section", ""), /**
   * @generated from field: string quote = 9;
   */ _define_property(this, "quote", ""), /**
   * @generated from field: string external_reference = 10;
   */ _define_property(this, "externalReference", ""), /**
   * @generated from field: string label = 11;
   */ _define_property(this, "label", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LibraryItemReferenceInput, "runtime", proto3);
_define_property(LibraryItemReferenceInput, "typeName", "mono.projectdata.v1.LibraryItemReferenceInput");
_define_property(LibraryItemReferenceInput, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "reference_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "artifact_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "content_sha256",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "block_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "page",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "span",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "section",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "quote",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "external_reference",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * LibraryItemView is one reusable-item record as the browser sees it. status
 * is draft|released|withdrawn; a draft/withdrawn item is visible only to
 * owner_user_id, never in discovery (C6-01) — see library.go's
 * libraryItemDenialReason, the single predicate GetLibraryItem and
 * SearchLibraryItems both apply.
 *
 * @generated from message mono.projectdata.v1.LibraryItemView
 */ export class LibraryItemView extends Message {
    static fromBinary(bytes, options) {
        return new LibraryItemView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LibraryItemView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LibraryItemView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LibraryItemView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string summary = 3;
   */ _define_property(this, "summary", ""), /**
   * evidence|template|proof_point|narrative|reference|asset
   *
   * @generated from field: string item_type = 4;
   */ _define_property(this, "itemType", ""), /**
   * @generated from field: string customer_agency_name = 5;
   */ _define_property(this, "customerAgencyName", ""), /**
   * @generated from field: string provider_company_profile_id = 6;
   */ _define_property(this, "providerCompanyProfileId", ""), /**
   * @generated from field: string scope_context = 7;
   */ _define_property(this, "scopeContext", ""), /**
   * @generated from field: string capability_context = 8;
   */ _define_property(this, "capabilityContext", ""), /**
   * @generated from field: string status = 9;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string owner_user_id = 10;
   */ _define_property(this, "ownerUserId", ""), /**
   * @generated from field: string owning_scope_object_type = 11;
   */ _define_property(this, "owningScopeObjectType", ""), /**
   * @generated from field: string owning_scope_object_id = 12;
   */ _define_property(this, "owningScopeObjectId", ""), /**
   * @generated from field: string prepared_content = 13;
   */ _define_property(this, "preparedContent", ""), /**
   * plain_text|markdown|html
   *
   * @generated from field: string prepared_content_format = 14;
   */ _define_property(this, "preparedContentFormat", ""), /**
   * @generated from field: google.protobuf.Timestamp effective_date = 15;
   */ _define_property(this, "effectiveDate", void 0), /**
   * @generated from field: string released_by = 16;
   */ _define_property(this, "releasedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp released_at = 17;
   */ _define_property(this, "releasedAt", void 0), /**
   * @generated from field: string release_audience = 18;
   */ _define_property(this, "releaseAudience", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 19;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 20;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: string created_by = 21;
   */ _define_property(this, "createdBy", ""), /**
   * @generated from field: string updated_by = 22;
   */ _define_property(this, "updatedBy", ""), /**
   * SAD-464 (C6-11): set only when the viewer lacks raw-source access to the
   * owning Program — owning_scope_object_* and prepared_content are then
   * withheld and this carries a generic basis (never the Program's name/id).
   *
   * @generated from field: string source_basis = 23;
   */ _define_property(this, "sourceBasis", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LibraryItemView, "runtime", proto3);
_define_property(LibraryItemView, "typeName", "mono.projectdata.v1.LibraryItemView");
_define_property(LibraryItemView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "summary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "item_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "customer_agency_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "provider_company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "scope_context",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "capability_context",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "owner_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "owning_scope_object_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "owning_scope_object_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "prepared_content",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "prepared_content_format",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "effective_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 16,
            name: "released_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "released_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 18,
            name: "release_audience",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 20,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 21,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 22,
            name: "updated_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 23,
            name: "source_basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CreateLibraryItemRequest
 */ export class CreateLibraryItemRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateLibraryItemRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateLibraryItemRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateLibraryItemRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateLibraryItemRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string title = 1;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string summary = 2;
   */ _define_property(this, "summary", ""), /**
   * @generated from field: string item_type = 3;
   */ _define_property(this, "itemType", ""), /**
   * @generated from field: string customer_agency_name = 4;
   */ _define_property(this, "customerAgencyName", ""), /**
   * @generated from field: string provider_company_profile_id = 5;
   */ _define_property(this, "providerCompanyProfileId", ""), /**
   * @generated from field: string scope_context = 6;
   */ _define_property(this, "scopeContext", ""), /**
   * @generated from field: string capability_context = 7;
   */ _define_property(this, "capabilityContext", ""), /**
   * @generated from field: string owning_scope_object_type = 8;
   */ _define_property(this, "owningScopeObjectType", ""), /**
   * @generated from field: string owning_scope_object_id = 9;
   */ _define_property(this, "owningScopeObjectId", ""), /**
   * @generated from field: string prepared_content = 10;
   */ _define_property(this, "preparedContent", ""), /**
   * @generated from field: string prepared_content_format = 11;
   */ _define_property(this, "preparedContentFormat", ""), /**
   * @generated from field: google.protobuf.Timestamp effective_date = 12;
   */ _define_property(this, "effectiveDate", void 0), /**
   * @generated from field: repeated mono.projectdata.v1.LibraryItemReferenceInput references = 13;
   */ _define_property(this, "references", []), /**
   * @generated from field: string user_id = 14;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 15;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateLibraryItemRequest, "runtime", proto3);
_define_property(CreateLibraryItemRequest, "typeName", "mono.projectdata.v1.CreateLibraryItemRequest");
_define_property(CreateLibraryItemRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "summary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "item_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "customer_agency_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "provider_company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "scope_context",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "capability_context",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "owning_scope_object_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "owning_scope_object_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "prepared_content",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "prepared_content_format",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "effective_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 13,
            name: "references",
            kind: "message",
            T: LibraryItemReferenceInput,
            repeated: true
        },
        {
            no: 14,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CreateLibraryItemResponse
 */ export class CreateLibraryItemResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateLibraryItemResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateLibraryItemResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateLibraryItemResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateLibraryItemResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.LibraryItemView item = 1;
   */ _define_property(this, "item", void 0), /**
   * @generated from field: repeated mono.projectdata.v1.LibraryItemReferenceView references = 2;
   */ _define_property(this, "references", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateLibraryItemResponse, "runtime", proto3);
_define_property(CreateLibraryItemResponse, "typeName", "mono.projectdata.v1.CreateLibraryItemResponse");
_define_property(CreateLibraryItemResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "item",
            kind: "message",
            T: LibraryItemView
        },
        {
            no: 2,
            name: "references",
            kind: "message",
            T: LibraryItemReferenceView,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetLibraryItemRequest
 */ export class GetLibraryItemRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetLibraryItemRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetLibraryItemRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetLibraryItemRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetLibraryItemRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 3;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetLibraryItemRequest, "runtime", proto3);
_define_property(GetLibraryItemRequest, "typeName", "mono.projectdata.v1.GetLibraryItemRequest");
_define_property(GetLibraryItemRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetLibraryItemResponse
 */ export class GetLibraryItemResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetLibraryItemResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetLibraryItemResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetLibraryItemResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetLibraryItemResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.LibraryItemView item = 1;
   */ _define_property(this, "item", void 0), /**
   * The files and passages the item points at (a template's .docx, an
   * asset's image). Returned only with an item the caller may read.
   *
   * @generated from field: repeated mono.projectdata.v1.LibraryItemReferenceView references = 2;
   */ _define_property(this, "references", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetLibraryItemResponse, "runtime", proto3);
_define_property(GetLibraryItemResponse, "typeName", "mono.projectdata.v1.GetLibraryItemResponse");
_define_property(GetLibraryItemResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "item",
            kind: "message",
            T: LibraryItemView
        },
        {
            no: 2,
            name: "references",
            kind: "message",
            T: LibraryItemReferenceView,
            repeated: true
        }
    ]));
/**
 * LibrarySearchFilterView mirrors LibrarySearchFilter (library_repository.go)
 * field-for-field, minus owner_user_id: an "owner" search is always the
 * viewer's own drafts/history, so zou derives it from the resolved identity
 * rather than accepting it as a client-supplied field (see SearchLibraryItems
 * in library.go).
 *
 * @generated from message mono.projectdata.v1.LibrarySearchFilterView
 */ export class LibrarySearchFilterView extends Message {
    static fromBinary(bytes, options) {
        return new LibrarySearchFilterView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LibrarySearchFilterView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LibrarySearchFilterView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LibrarySearchFilterView, a, b);
    }
    constructor(data){
        super(), /**
   * discovery|owner. Empty defaults to "discovery".
   *
   * @generated from field: string scope = 1;
   */ _define_property(this, "scope", ""), /**
   * @generated from field: string query = 2;
   */ _define_property(this, "query", ""), /**
   * @generated from field: string item_type = 3;
   */ _define_property(this, "itemType", ""), /**
   * @generated from field: string customer_agency_name = 4;
   */ _define_property(this, "customerAgencyName", ""), /**
   * @generated from field: string provider_company_profile_id = 5;
   */ _define_property(this, "providerCompanyProfileId", ""), /**
   * @generated from field: string scope_context = 6;
   */ _define_property(this, "scopeContext", ""), /**
   * @generated from field: string capability_context = 7;
   */ _define_property(this, "capabilityContext", ""), /**
   * @generated from field: string status = 8;
   */ _define_property(this, "status", ""), /**
   * @generated from field: google.protobuf.Timestamp updated_since = 9;
   */ _define_property(this, "updatedSince", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(LibrarySearchFilterView, "runtime", proto3);
_define_property(LibrarySearchFilterView, "typeName", "mono.projectdata.v1.LibrarySearchFilterView");
_define_property(LibrarySearchFilterView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "scope",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "query",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "item_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "customer_agency_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "provider_company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "scope_context",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "capability_context",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "updated_since",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SearchLibraryItemsRequest
 */ export class SearchLibraryItemsRequest extends Message {
    static fromBinary(bytes, options) {
        return new SearchLibraryItemsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SearchLibraryItemsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SearchLibraryItemsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SearchLibraryItemsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.LibrarySearchFilterView filter = 1;
   */ _define_property(this, "filter", void 0), /**
   * @generated from field: int32 offset = 2;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0), /**
   * @generated from field: string user_id = 4;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 5;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SearchLibraryItemsRequest, "runtime", proto3);
_define_property(SearchLibraryItemsRequest, "typeName", "mono.projectdata.v1.SearchLibraryItemsRequest");
_define_property(SearchLibraryItemsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: LibrarySearchFilterView
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SearchLibraryItemsResponse
 */ export class SearchLibraryItemsResponse extends Message {
    static fromBinary(bytes, options) {
        return new SearchLibraryItemsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SearchLibraryItemsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SearchLibraryItemsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SearchLibraryItemsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.LibraryItemView items = 1;
   */ _define_property(this, "items", []), /**
   * total is the count of rows actually permitted and returned to THIS
   * viewer — never pangaea's DB-predicate match count
   * (datagateway.v1.SearchLibraryItemsResponse.total). Forwarding that value
   * would leak the existence of rows the viewer cannot see (C7A-14). See
   * library.go's SearchLibraryItems.
   *
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SearchLibraryItemsResponse, "runtime", proto3);
_define_property(SearchLibraryItemsResponse, "typeName", "mono.projectdata.v1.SearchLibraryItemsResponse");
_define_property(SearchLibraryItemsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "items",
            kind: "message",
            T: LibraryItemView,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * CapturePlanAreaHealthEventView is one append-only health-ledger row.
 * origin "human" rows are decisions (applied=true); origin "ai" rows are
 * suggestions (applied=false) that never moved the area's health.
 *
 * @generated from message mono.projectdata.v1.CapturePlanAreaHealthEventView
 */ export class CapturePlanAreaHealthEventView extends Message {
    static fromBinary(bytes, options) {
        return new CapturePlanAreaHealthEventView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CapturePlanAreaHealthEventView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CapturePlanAreaHealthEventView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CapturePlanAreaHealthEventView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string from_health = 2;
   */ _define_property(this, "fromHealth", ""), /**
   * @generated from field: string proposed_health = 3;
   */ _define_property(this, "proposedHealth", ""), /**
   * @generated from field: string reasons = 4;
   */ _define_property(this, "reasons", ""), /**
   * human|ai
   *
   * @generated from field: string origin = 5;
   */ _define_property(this, "origin", ""), /**
   * @generated from field: string decided_by_user_id = 6;
   */ _define_property(this, "decidedByUserId", ""), /**
   * @generated from field: google.protobuf.Timestamp decided_at = 7;
   */ _define_property(this, "decidedAt", void 0), /**
   * @generated from field: bool applied = 8;
   */ _define_property(this, "applied", false), /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CapturePlanAreaHealthEventView, "runtime", proto3);
_define_property(CapturePlanAreaHealthEventView, "typeName", "mono.projectdata.v1.CapturePlanAreaHealthEventView");
_define_property(CapturePlanAreaHealthEventView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "from_health",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "proposed_health",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "reasons",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "origin",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "decided_by_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "decided_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "applied",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 9,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * CapturePlanAreaView — the only owned Capture Plan state. task_ids groups
 * this area's linked capture tasks (read from ListCaptureTaskPlanAreaLinks),
 * not a copy of the task rows themselves (see GetCapturePlanResponse.tasks).
 *
 * @generated from message mono.projectdata.v1.CapturePlanAreaView
 */ export class CapturePlanAreaView extends Message {
    static fromBinary(bytes, options) {
        return new CapturePlanAreaView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CapturePlanAreaView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CapturePlanAreaView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CapturePlanAreaView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string lead_user_id = 3;
   */ _define_property(this, "leadUserId", ""), /**
   * @generated from field: google.protobuf.Timestamp target_date = 4;
   */ _define_property(this, "targetDate", void 0), /**
   * @generated from field: string summary = 5;
   */ _define_property(this, "summary", ""), /**
   * not_started|in_progress|at_risk|complete|not_applicable
   *
   * @generated from field: string health = 6;
   */ _define_property(this, "health", ""), /**
   * @generated from field: string health_set_by_user_id = 7;
   */ _define_property(this, "healthSetByUserId", ""), /**
   * @generated from field: google.protobuf.Timestamp health_set_at = 8;
   */ _define_property(this, "healthSetAt", void 0), /**
   * @generated from field: int32 sort_order = 9;
   */ _define_property(this, "sortOrder", 0), /**
   * The basis of the displayed health, most-recent first, capped server-side.
   *
   * @generated from field: repeated mono.projectdata.v1.CapturePlanAreaHealthEventView recent_health_events = 10;
   */ _define_property(this, "recentHealthEvents", []), /**
   * @generated from field: repeated string task_ids = 11;
   */ _define_property(this, "taskIds", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CapturePlanAreaView, "runtime", proto3);
_define_property(CapturePlanAreaView, "typeName", "mono.projectdata.v1.CapturePlanAreaView");
_define_property(CapturePlanAreaView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "lead_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "target_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "summary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "health",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "health_set_by_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "health_set_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "sort_order",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 10,
            name: "recent_health_events",
            kind: "message",
            T: CapturePlanAreaHealthEventView,
            repeated: true
        },
        {
            no: 11,
            name: "task_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * CapturePlanUpcomingReviewView — read from govcon.proposal_milestones
 * (ListProposalMilestones) keyed on the capture's own ZOU project id,
 * filtered to scheduled_at in the future, sorted ascending, capped.
 *
 * @generated from message mono.projectdata.v1.CapturePlanUpcomingReviewView
 */ export class CapturePlanUpcomingReviewView extends Message {
    static fromBinary(bytes, options) {
        return new CapturePlanUpcomingReviewView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CapturePlanUpcomingReviewView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CapturePlanUpcomingReviewView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CapturePlanUpcomingReviewView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string milestone_type = 2;
   */ _define_property(this, "milestoneType", ""), /**
   * @generated from field: string label = 3;
   */ _define_property(this, "label", ""), /**
   * @generated from field: google.protobuf.Timestamp scheduled_at = 4;
   */ _define_property(this, "scheduledAt", void 0), /**
   * pipeline|user
   *
   * @generated from field: string source = 5;
   */ _define_property(this, "source", ""), /**
   * @generated from field: string notes = 6;
   */ _define_property(this, "notes", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CapturePlanUpcomingReviewView, "runtime", proto3);
_define_property(CapturePlanUpcomingReviewView, "typeName", "mono.projectdata.v1.CapturePlanUpcomingReviewView");
_define_property(CapturePlanUpcomingReviewView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "milestone_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "scheduled_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * CapturePlanUpcomingDecisionView — read from ListCaptureGoNoGoDecisions,
 * filtered to pending decisions carrying a due_at.
 *
 * @generated from message mono.projectdata.v1.CapturePlanUpcomingDecisionView
 */ export class CapturePlanUpcomingDecisionView extends Message {
    static fromBinary(bytes, options) {
        return new CapturePlanUpcomingDecisionView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CapturePlanUpcomingDecisionView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CapturePlanUpcomingDecisionView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CapturePlanUpcomingDecisionView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: google.protobuf.Timestamp due_at = 2;
   */ _define_property(this, "dueAt", void 0), /**
   * pending
   *
   * @generated from field: string outcome = 3;
   */ _define_property(this, "outcome", ""), /**
   * @generated from field: string notes = 4;
   */ _define_property(this, "notes", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CapturePlanUpcomingDecisionView, "runtime", proto3);
_define_property(CapturePlanUpcomingDecisionView, "typeName", "mono.projectdata.v1.CapturePlanUpcomingDecisionView");
_define_property(CapturePlanUpcomingDecisionView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "due_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 3,
            name: "outcome",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * CapturePlanPartnerRefView is a REFERENCE ONLY — the teaming link's own id
 * plus the company it points at. No workshare/nda/rationale copy; open the
 * teaming panel (ListCaptureTeamingLinks) for that.
 *
 * @generated from message mono.projectdata.v1.CapturePlanPartnerRefView
 */ export class CapturePlanPartnerRefView extends Message {
    static fromBinary(bytes, options) {
        return new CapturePlanPartnerRefView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CapturePlanPartnerRefView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CapturePlanPartnerRefView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CapturePlanPartnerRefView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string teaming_link_id = 1;
   */ _define_property(this, "teamingLinkId", ""), /**
   * @generated from field: string company_profile_id = 2;
   */ _define_property(this, "companyProfileId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CapturePlanPartnerRefView, "runtime", proto3);
_define_property(CapturePlanPartnerRefView, "typeName", "mono.projectdata.v1.CapturePlanPartnerRefView");
_define_property(CapturePlanPartnerRefView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "teaming_link_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * CapturePlanSolutionOutputRefView is a REFERENCE ONLY into ListWorkstreamItems.
 *
 * @generated from message mono.projectdata.v1.CapturePlanSolutionOutputRefView
 */ export class CapturePlanSolutionOutputRefView extends Message {
    static fromBinary(bytes, options) {
        return new CapturePlanSolutionOutputRefView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CapturePlanSolutionOutputRefView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CapturePlanSolutionOutputRefView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CapturePlanSolutionOutputRefView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string workstream_item_id = 1;
   */ _define_property(this, "workstreamItemId", ""), /**
   * @generated from field: mono.projectdata.v1.CaptureWorkstreamType workstream_type = 2;
   */ _define_property(this, "workstreamType", 0), /**
   * @generated from field: string title = 3;
   */ _define_property(this, "title", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CapturePlanSolutionOutputRefView, "runtime", proto3);
_define_property(CapturePlanSolutionOutputRefView, "typeName", "mono.projectdata.v1.CapturePlanSolutionOutputRefView");
_define_property(CapturePlanSolutionOutputRefView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "workstream_item_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "workstream_type",
            kind: "enum",
            T: proto3.getEnumType(CaptureWorkstreamType)
        },
        {
            no: 3,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * CapturePlanCustomerRefView is a REFERENCE ONLY into GetCaptureProfile —
 * unset when no profile has been recorded yet.
 *
 * @generated from message mono.projectdata.v1.CapturePlanCustomerRefView
 */ export class CapturePlanCustomerRefView extends Message {
    static fromBinary(bytes, options) {
        return new CapturePlanCustomerRefView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CapturePlanCustomerRefView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CapturePlanCustomerRefView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CapturePlanCustomerRefView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_profile_id = 1;
   */ _define_property(this, "captureProfileId", ""), /**
   * @generated from field: string customer_agency_names = 2;
   */ _define_property(this, "customerAgencyNames", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CapturePlanCustomerRefView, "runtime", proto3);
_define_property(CapturePlanCustomerRefView, "typeName", "mono.projectdata.v1.CapturePlanCustomerRefView");
_define_property(CapturePlanCustomerRefView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "customer_agency_names",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CapturePlanReferencesView
 */ export class CapturePlanReferencesView extends Message {
    static fromBinary(bytes, options) {
        return new CapturePlanReferencesView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CapturePlanReferencesView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CapturePlanReferencesView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CapturePlanReferencesView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.CapturePlanPartnerRefView partners = 1;
   */ _define_property(this, "partners", []), /**
   * @generated from field: repeated mono.projectdata.v1.CapturePlanSolutionOutputRefView solutions_and_outputs = 2;
   */ _define_property(this, "solutionsAndOutputs", []), /**
   * @generated from field: mono.projectdata.v1.CapturePlanCustomerRefView customer = 3;
   */ _define_property(this, "customer", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CapturePlanReferencesView, "runtime", proto3);
_define_property(CapturePlanReferencesView, "typeName", "mono.projectdata.v1.CapturePlanReferencesView");
_define_property(CapturePlanReferencesView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "partners",
            kind: "message",
            T: CapturePlanPartnerRefView,
            repeated: true
        },
        {
            no: 2,
            name: "solutions_and_outputs",
            kind: "message",
            T: CapturePlanSolutionOutputRefView,
            repeated: true
        },
        {
            no: 3,
            name: "customer",
            kind: "message",
            T: CapturePlanCustomerRefView
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetCapturePlanRequest
 */ export class GetCapturePlanRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetCapturePlanRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCapturePlanRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCapturePlanRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCapturePlanRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 3;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCapturePlanRequest, "runtime", proto3);
_define_property(GetCapturePlanRequest, "typeName", "mono.projectdata.v1.GetCapturePlanRequest");
_define_property(GetCapturePlanRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetCapturePlanResponse
 */ export class GetCapturePlanResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetCapturePlanResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCapturePlanResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCapturePlanResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCapturePlanResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.CapturePlanAreaView areas = 1;
   */ _define_property(this, "areas", []), /**
   * @generated from field: repeated mono.projectdata.v1.CaptureTaskView tasks = 2;
   */ _define_property(this, "tasks", []), /**
   * @generated from field: repeated mono.projectdata.v1.CapturePlanUpcomingReviewView upcoming_reviews = 3;
   */ _define_property(this, "upcomingReviews", []), /**
   * @generated from field: repeated mono.projectdata.v1.CapturePlanUpcomingDecisionView upcoming_decisions = 4;
   */ _define_property(this, "upcomingDecisions", []), /**
   * @generated from field: mono.projectdata.v1.CapturePlanReferencesView references = 5;
   */ _define_property(this, "references", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCapturePlanResponse, "runtime", proto3);
_define_property(GetCapturePlanResponse, "typeName", "mono.projectdata.v1.GetCapturePlanResponse");
_define_property(GetCapturePlanResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "areas",
            kind: "message",
            T: CapturePlanAreaView,
            repeated: true
        },
        {
            no: 2,
            name: "tasks",
            kind: "message",
            T: CaptureTaskView,
            repeated: true
        },
        {
            no: 3,
            name: "upcoming_reviews",
            kind: "message",
            T: CapturePlanUpcomingReviewView,
            repeated: true
        },
        {
            no: 4,
            name: "upcoming_decisions",
            kind: "message",
            T: CapturePlanUpcomingDecisionView,
            repeated: true
        },
        {
            no: 5,
            name: "references",
            kind: "message",
            T: CapturePlanReferencesView
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpsertCapturePlanAreaRequest
 */ export class UpsertCapturePlanAreaRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCapturePlanAreaRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCapturePlanAreaRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCapturePlanAreaRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCapturePlanAreaRequest, a, b);
    }
    constructor(data){
        super(), /**
   * Empty creates; set to update an existing area.
   *
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string lead_user_id = 4;
   */ _define_property(this, "leadUserId", ""), /**
   * @generated from field: google.protobuf.Timestamp target_date = 5;
   */ _define_property(this, "targetDate", void 0), /**
   * @generated from field: string summary = 6;
   */ _define_property(this, "summary", ""), /**
   * @generated from field: int32 sort_order = 7;
   */ _define_property(this, "sortOrder", 0), /**
   * @generated from field: string user_id = 8;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 9;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCapturePlanAreaRequest, "runtime", proto3);
_define_property(UpsertCapturePlanAreaRequest, "typeName", "mono.projectdata.v1.UpsertCapturePlanAreaRequest");
_define_property(UpsertCapturePlanAreaRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "lead_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "target_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "summary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "sort_order",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 8,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpsertCapturePlanAreaResponse
 */ export class UpsertCapturePlanAreaResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCapturePlanAreaResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCapturePlanAreaResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCapturePlanAreaResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCapturePlanAreaResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.CapturePlanAreaView area = 1;
   */ _define_property(this, "area", void 0), /**
   * @generated from field: bool created = 2;
   */ _define_property(this, "created", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCapturePlanAreaResponse, "runtime", proto3);
_define_property(UpsertCapturePlanAreaResponse, "typeName", "mono.projectdata.v1.UpsertCapturePlanAreaResponse");
_define_property(UpsertCapturePlanAreaResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "area",
            kind: "message",
            T: CapturePlanAreaView
        },
        {
            no: 2,
            name: "created",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.DeleteCapturePlanAreaRequest
 */ export class DeleteCapturePlanAreaRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteCapturePlanAreaRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteCapturePlanAreaRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteCapturePlanAreaRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteCapturePlanAreaRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string user_id = 3;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 4;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteCapturePlanAreaRequest, "runtime", proto3);
_define_property(DeleteCapturePlanAreaRequest, "typeName", "mono.projectdata.v1.DeleteCapturePlanAreaRequest");
_define_property(DeleteCapturePlanAreaRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.DeleteCapturePlanAreaResponse
 */ export class DeleteCapturePlanAreaResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteCapturePlanAreaResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteCapturePlanAreaResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteCapturePlanAreaResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteCapturePlanAreaResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteCapturePlanAreaResponse, "runtime", proto3);
_define_property(DeleteCapturePlanAreaResponse, "typeName", "mono.projectdata.v1.DeleteCapturePlanAreaResponse");
_define_property(DeleteCapturePlanAreaResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * SetCapturePlanAreaHealth is the human decision: requires a resolved
 * decider (taken from the authenticated caller, not a request field) and
 * rejects any health value outside the five accepted strings.
 *
 * @generated from message mono.projectdata.v1.SetCapturePlanAreaHealthRequest
 */ export class SetCapturePlanAreaHealthRequest extends Message {
    static fromBinary(bytes, options) {
        return new SetCapturePlanAreaHealthRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetCapturePlanAreaHealthRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetCapturePlanAreaHealthRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetCapturePlanAreaHealthRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string area_id = 2;
   */ _define_property(this, "areaId", ""), /**
   * not_started|in_progress|at_risk|complete|not_applicable
   *
   * @generated from field: string health = 3;
   */ _define_property(this, "health", ""), /**
   * @generated from field: string reasons = 4;
   */ _define_property(this, "reasons", ""), /**
   * @generated from field: string user_id = 5;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 6;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetCapturePlanAreaHealthRequest, "runtime", proto3);
_define_property(SetCapturePlanAreaHealthRequest, "typeName", "mono.projectdata.v1.SetCapturePlanAreaHealthRequest");
_define_property(SetCapturePlanAreaHealthRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "area_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "health",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "reasons",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SetCapturePlanAreaHealthResponse
 */ export class SetCapturePlanAreaHealthResponse extends Message {
    static fromBinary(bytes, options) {
        return new SetCapturePlanAreaHealthResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetCapturePlanAreaHealthResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetCapturePlanAreaHealthResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetCapturePlanAreaHealthResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.CapturePlanAreaView area = 1;
   */ _define_property(this, "area", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetCapturePlanAreaHealthResponse, "runtime", proto3);
_define_property(SetCapturePlanAreaHealthResponse, "typeName", "mono.projectdata.v1.SetCapturePlanAreaHealthResponse");
_define_property(SetCapturePlanAreaHealthResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "area",
            kind: "message",
            T: CapturePlanAreaView
        }
    ]));
/**
 * SuggestCapturePlanAreaHealth records an AI proposal onto the health
 * ledger only. There is no decider field — the wire contract itself makes
 * an AI-decided health change unrepresentable, and the area's health is
 * never touched.
 *
 * @generated from message mono.projectdata.v1.SuggestCapturePlanAreaHealthRequest
 */ export class SuggestCapturePlanAreaHealthRequest extends Message {
    static fromBinary(bytes, options) {
        return new SuggestCapturePlanAreaHealthRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SuggestCapturePlanAreaHealthRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SuggestCapturePlanAreaHealthRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SuggestCapturePlanAreaHealthRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string area_id = 2;
   */ _define_property(this, "areaId", ""), /**
   * @generated from field: string health = 3;
   */ _define_property(this, "health", ""), /**
   * @generated from field: string reasons = 4;
   */ _define_property(this, "reasons", ""), /**
   * @generated from field: string user_id = 5;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 6;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SuggestCapturePlanAreaHealthRequest, "runtime", proto3);
_define_property(SuggestCapturePlanAreaHealthRequest, "typeName", "mono.projectdata.v1.SuggestCapturePlanAreaHealthRequest");
_define_property(SuggestCapturePlanAreaHealthRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "area_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "health",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "reasons",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SuggestCapturePlanAreaHealthResponse
 */ export class SuggestCapturePlanAreaHealthResponse extends Message {
    static fromBinary(bytes, options) {
        return new SuggestCapturePlanAreaHealthResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SuggestCapturePlanAreaHealthResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SuggestCapturePlanAreaHealthResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SuggestCapturePlanAreaHealthResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.CapturePlanAreaHealthEventView event = 1;
   */ _define_property(this, "event", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SuggestCapturePlanAreaHealthResponse, "runtime", proto3);
_define_property(SuggestCapturePlanAreaHealthResponse, "typeName", "mono.projectdata.v1.SuggestCapturePlanAreaHealthResponse");
_define_property(SuggestCapturePlanAreaHealthResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "event",
            kind: "message",
            T: CapturePlanAreaHealthEventView
        }
    ]));
/**
 * SetCaptureTaskPlanArea links (or, with an empty area_id, unlinks) one
 * capture task to a Capture Plan area.
 *
 * @generated from message mono.projectdata.v1.SetCaptureTaskPlanAreaRequest
 */ export class SetCaptureTaskPlanAreaRequest extends Message {
    static fromBinary(bytes, options) {
        return new SetCaptureTaskPlanAreaRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetCaptureTaskPlanAreaRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetCaptureTaskPlanAreaRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetCaptureTaskPlanAreaRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string task_id = 2;
   */ _define_property(this, "taskId", ""), /**
   * @generated from field: string area_id = 3;
   */ _define_property(this, "areaId", ""), /**
   * @generated from field: string user_id = 4;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 5;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetCaptureTaskPlanAreaRequest, "runtime", proto3);
_define_property(SetCaptureTaskPlanAreaRequest, "typeName", "mono.projectdata.v1.SetCaptureTaskPlanAreaRequest");
_define_property(SetCaptureTaskPlanAreaRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "task_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "area_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SetCaptureTaskPlanAreaResponse
 */ export class SetCaptureTaskPlanAreaResponse extends Message {
    static fromBinary(bytes, options) {
        return new SetCaptureTaskPlanAreaResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetCaptureTaskPlanAreaResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetCaptureTaskPlanAreaResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetCaptureTaskPlanAreaResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetCaptureTaskPlanAreaResponse, "runtime", proto3);
_define_property(SetCaptureTaskPlanAreaResponse, "typeName", "mono.projectdata.v1.SetCaptureTaskPlanAreaResponse");
_define_property(SetCaptureTaskPlanAreaResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.projectdata.v1.CustomerThemeView
 */ export class CustomerThemeView extends Message {
    static fromBinary(bytes, options) {
        return new CustomerThemeView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CustomerThemeView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CustomerThemeView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CustomerThemeView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * suggested|accepted
   *
   * @generated from field: string record_state = 3;
   */ _define_property(this, "recordState", ""), /**
   * manual|ai_draft|touchpoint|notice_rfi_rfp|internal_note|web_research
   *
   * @generated from field: string origin_source = 4;
   */ _define_property(this, "originSource", ""), /**
   * @generated from field: string origin_reference = 5;
   */ _define_property(this, "originReference", ""), /**
   * @generated from field: string proposed_revision_of_id = 6;
   */ _define_property(this, "proposedRevisionOfId", ""), /**
   * @generated from field: string current_version_id = 7;
   */ _define_property(this, "currentVersionId", ""), /**
   * output-only, never client-settable
   *
   * @generated from field: string current_version_authorship = 8;
   */ _define_property(this, "currentVersionAuthorship", ""), /**
   * @generated from field: string accepted_by = 9;
   */ _define_property(this, "acceptedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp accepted_at = 10;
   */ _define_property(this, "acceptedAt", void 0), /**
   * @generated from field: string dismissed_by = 11;
   */ _define_property(this, "dismissedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp dismissed_at = 12;
   */ _define_property(this, "dismissedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp created_at = 13;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: string created_by = 14;
   */ _define_property(this, "createdBy", ""), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 15;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: string updated_by = 16;
   */ _define_property(this, "updatedBy", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CustomerThemeView, "runtime", proto3);
_define_property(CustomerThemeView, "typeName", "mono.projectdata.v1.CustomerThemeView");
_define_property(CustomerThemeView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "record_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "origin_source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "origin_reference",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "proposed_revision_of_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "current_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "current_version_authorship",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "accepted_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "accepted_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "dismissed_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "dismissed_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 13,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 14,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 16,
            name: "updated_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CustomerThemeVersionView
 */ export class CustomerThemeVersionView extends Message {
    static fromBinary(bytes, options) {
        return new CustomerThemeVersionView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CustomerThemeVersionView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CustomerThemeVersionView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CustomerThemeVersionView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string theme_id = 2;
   */ _define_property(this, "themeId", ""), /**
   * @generated from field: int32 version = 3;
   */ _define_property(this, "version", 0), /**
   * human|ai_suggested
   *
   * @generated from field: string authorship = 4;
   */ _define_property(this, "authorship", ""), /**
   * @generated from field: string title = 5;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string narrative = 6;
   */ _define_property(this, "narrative", ""), /**
   * @generated from field: string why_evidence_supports = 7;
   */ _define_property(this, "whyEvidenceSupports", ""), /**
   * @generated from field: string why_it_matters = 8;
   */ _define_property(this, "whyItMatters", ""), /**
   * @generated from field: string implications = 9;
   */ _define_property(this, "implications", ""), /**
   * pain_point|hot_button|desired_outcome|constraint|other
   *
   * @generated from field: string category = 10;
   */ _define_property(this, "category", ""), /**
   * draft|emerging|established
   *
   * @generated from field: string maturity = 11;
   */ _define_property(this, "maturity", ""), /**
   * low|medium|high
   *
   * @generated from field: string confidence = 12;
   */ _define_property(this, "confidence", ""), /**
   * @generated from field: string change_note = 13;
   */ _define_property(this, "changeNote", ""), /**
   * @generated from field: string authored_by = 14;
   */ _define_property(this, "authoredBy", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 15;
   */ _define_property(this, "createdAt", void 0), /**
   * Empty means unprioritized; otherwise low, medium or high.
   *
   * @generated from field: string priority = 16;
   */ _define_property(this, "priority", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CustomerThemeVersionView, "runtime", proto3);
_define_property(CustomerThemeVersionView, "typeName", "mono.projectdata.v1.CustomerThemeVersionView");
_define_property(CustomerThemeVersionView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "theme_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "authorship",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "narrative",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "why_evidence_supports",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "why_it_matters",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "implications",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "maturity",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "confidence",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "change_note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "authored_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 16,
            name: "priority",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * CustomerThemeVersionInput carries the substance a caller submits on
 * create/suggest/accept/revise. No authorship field — the server derives it
 * on every path (see the RPC block comment above).
 *
 * @generated from message mono.projectdata.v1.CustomerThemeVersionInput
 */ export class CustomerThemeVersionInput extends Message {
    static fromBinary(bytes, options) {
        return new CustomerThemeVersionInput().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CustomerThemeVersionInput().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CustomerThemeVersionInput().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CustomerThemeVersionInput, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string title = 1;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string narrative = 2;
   */ _define_property(this, "narrative", ""), /**
   * @generated from field: string why_evidence_supports = 3;
   */ _define_property(this, "whyEvidenceSupports", ""), /**
   * @generated from field: string why_it_matters = 4;
   */ _define_property(this, "whyItMatters", ""), /**
   * @generated from field: string implications = 5;
   */ _define_property(this, "implications", ""), /**
   * @generated from field: string category = 6;
   */ _define_property(this, "category", ""), /**
   * @generated from field: string maturity = 7;
   */ _define_property(this, "maturity", ""), /**
   * @generated from field: string confidence = 8;
   */ _define_property(this, "confidence", ""), /**
   * @generated from field: string change_note = 9;
   */ _define_property(this, "changeNote", ""), /**
   * @generated from field: string authored_by = 10;
   */ _define_property(this, "authoredBy", ""), /**
   * Empty means unprioritized; otherwise low, medium or high.
   *
   * @generated from field: string priority = 11;
   */ _define_property(this, "priority", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CustomerThemeVersionInput, "runtime", proto3);
_define_property(CustomerThemeVersionInput, "typeName", "mono.projectdata.v1.CustomerThemeVersionInput");
_define_property(CustomerThemeVersionInput, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "narrative",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "why_evidence_supports",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "why_it_matters",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "implications",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "maturity",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "confidence",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "change_note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "authored_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "priority",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CustomerThemeEvidenceView
 */ export class CustomerThemeEvidenceView extends Message {
    static fromBinary(bytes, options) {
        return new CustomerThemeEvidenceView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CustomerThemeEvidenceView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CustomerThemeEvidenceView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CustomerThemeEvidenceView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string theme_id = 2;
   */ _define_property(this, "themeId", ""), /**
   * supports|contradicts
   *
   * @generated from field: string stance = 3;
   */ _define_property(this, "stance", ""), /**
   * customer_statement|internal_assessment|inference|unverified_report
   *
   * @generated from field: string assertion_kind = 4;
   */ _define_property(this, "assertionKind", ""), /**
   * manual|ai_draft|touchpoint|notice_rfi_rfp|internal_note|web_research|document
   *
   * @generated from field: string source_kind = 5;
   */ _define_property(this, "sourceKind", ""), /**
   * @generated from field: string source_ref = 6;
   */ _define_property(this, "sourceRef", ""), /**
   * @generated from field: string source_excerpt = 7;
   */ _define_property(this, "sourceExcerpt", ""), /**
   * @generated from field: google.protobuf.Timestamp source_date = 8;
   */ _define_property(this, "sourceDate", void 0), /**
   * low|medium|high
   *
   * @generated from field: string confidence = 9;
   */ _define_property(this, "confidence", ""), /**
   * @generated from field: string rationale = 10;
   */ _define_property(this, "rationale", ""), /**
   * @generated from field: string supersedes_evidence_id = 11;
   */ _define_property(this, "supersedesEvidenceId", ""), /**
   * @generated from field: string provenance_record_id = 12;
   */ _define_property(this, "provenanceRecordId", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 13;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: string created_by = 14;
   */ _define_property(this, "createdBy", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CustomerThemeEvidenceView, "runtime", proto3);
_define_property(CustomerThemeEvidenceView, "typeName", "mono.projectdata.v1.CustomerThemeEvidenceView");
_define_property(CustomerThemeEvidenceView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "theme_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "stance",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "assertion_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "source_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "source_ref",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "source_excerpt",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "source_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "confidence",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "rationale",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "supersedes_evidence_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "provenance_record_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 14,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.PursuitStakeholderView
 */ export class PursuitStakeholderView extends Message {
    static fromBinary(bytes, options) {
        return new PursuitStakeholderView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PursuitStakeholderView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PursuitStakeholderView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PursuitStakeholderView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string contact_id = 3;
   */ _define_property(this, "contactId", ""), /**
   * @generated from field: string unresolved_name = 4;
   */ _define_property(this, "unresolvedName", ""), /**
   * @generated from field: string unresolved_organization = 5;
   */ _define_property(this, "unresolvedOrganization", ""), /**
   * customer|internal|partner|unknown
   *
   * @generated from field: string affiliation = 6;
   */ _define_property(this, "affiliation", ""), /**
   * @generated from field: string pursuit_role = 7;
   */ _define_property(this, "pursuitRole", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 9;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: repeated mono.projectdata.v1.StakeholderRoleChange role_history = 10;
   */ _define_property(this, "roleHistory", []), /**
   * GRW-37: set while the typed name waits on a REG-54 match candidate.
   *
   * @generated from field: string registry_candidate_id = 11;
   */ _define_property(this, "registryCandidateId", ""), /**
   * GRW-37: the open candidate (status + options), batch-read from REG-54 at
   * request time; unset for linked rows.
   *
   * @generated from field: mono.projectdata.v1.EntityResolutionView resolution = 12;
   */ _define_property(this, "resolution", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PursuitStakeholderView, "runtime", proto3);
_define_property(PursuitStakeholderView, "typeName", "mono.projectdata.v1.PursuitStakeholderView");
_define_property(PursuitStakeholderView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "unresolved_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "unresolved_organization",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "affiliation",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "pursuit_role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "role_history",
            kind: "message",
            T: StakeholderRoleChange,
            repeated: true
        },
        {
            no: 11,
            name: "registry_candidate_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "resolution",
            kind: "message",
            T: EntityResolutionView
        }
    ]));
/**
 * StakeholderAssessmentView is the sensitive pursuit-specific layer gated by
 * the "view_sensitive" Cerbos action: influence_band, relationship_posture,
 * priorities, rationale and uncertainty_note are blanked for a principal who
 * lacks it, on EVERY row of a list, never just the first.
 *
 * @generated from message mono.projectdata.v1.StakeholderAssessmentView
 */ export class StakeholderAssessmentView extends Message {
    static fromBinary(bytes, options) {
        return new StakeholderAssessmentView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StakeholderAssessmentView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StakeholderAssessmentView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StakeholderAssessmentView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string stakeholder_id = 2;
   */ _define_property(this, "stakeholderId", ""), /**
   * low|medium|high|unknown
   *
   * @generated from field: string influence_band = 3;
   */ _define_property(this, "influenceBand", ""), /**
   * advocate|neutral|skeptic|blocker|unknown
   *
   * @generated from field: string relationship_posture = 4;
   */ _define_property(this, "relationshipPosture", ""), /**
   * @generated from field: string priorities = 5;
   */ _define_property(this, "priorities", ""), /**
   * @generated from field: string rationale = 6;
   */ _define_property(this, "rationale", ""), /**
   * @generated from field: string uncertainty_note = 7;
   */ _define_property(this, "uncertaintyNote", ""), /**
   * low|medium|high
   *
   * @generated from field: string confidence = 8;
   */ _define_property(this, "confidence", ""), /**
   * @generated from field: string source_kind = 9;
   */ _define_property(this, "sourceKind", ""), /**
   * @generated from field: string source_ref = 10;
   */ _define_property(this, "sourceRef", ""), /**
   * human|ai_suggested
   *
   * @generated from field: string authorship = 11;
   */ _define_property(this, "authorship", ""), /**
   * suggested|accepted
   *
   * @generated from field: string assessment_state = 12;
   */ _define_property(this, "assessmentState", ""), /**
   * @generated from field: string supersedes_id = 13;
   */ _define_property(this, "supersedesId", ""), /**
   * @generated from field: google.protobuf.Timestamp superseded_at = 14;
   */ _define_property(this, "supersededAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp as_of_date = 15;
   */ _define_property(this, "asOfDate", void 0), /**
   * @generated from field: string provenance_record_id = 16;
   */ _define_property(this, "provenanceRecordId", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 17;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: string created_by = 18;
   */ _define_property(this, "createdBy", ""), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 19;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: repeated string theme_ids = 20;
   */ _define_property(this, "themeIds", []), /**
   * @generated from field: string pursuit_role = 21;
   */ _define_property(this, "pursuitRole", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(StakeholderAssessmentView, "runtime", proto3);
_define_property(StakeholderAssessmentView, "typeName", "mono.projectdata.v1.StakeholderAssessmentView");
_define_property(StakeholderAssessmentView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "stakeholder_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "influence_band",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "relationship_posture",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "priorities",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "rationale",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "uncertainty_note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "confidence",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "source_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "source_ref",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "authorship",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "assessment_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "supersedes_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "superseded_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 15,
            name: "as_of_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 16,
            name: "provenance_record_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 18,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 20,
            name: "theme_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 21,
            name: "pursuit_role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * --- ListCustomerThemes ---
 *
 * @generated from message mono.projectdata.v1.ListCustomerThemesRequest
 */ export class ListCustomerThemesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCustomerThemesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCustomerThemesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCustomerThemesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCustomerThemesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 3;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCustomerThemesRequest, "runtime", proto3);
_define_property(ListCustomerThemesRequest, "typeName", "mono.projectdata.v1.ListCustomerThemesRequest");
_define_property(ListCustomerThemesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListCustomerThemesResponse
 */ export class ListCustomerThemesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCustomerThemesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCustomerThemesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCustomerThemesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCustomerThemesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.CustomerThemeView themes = 1;
   */ _define_property(this, "themes", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCustomerThemesResponse, "runtime", proto3);
_define_property(ListCustomerThemesResponse, "typeName", "mono.projectdata.v1.ListCustomerThemesResponse");
_define_property(ListCustomerThemesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "themes",
            kind: "message",
            T: CustomerThemeView,
            repeated: true
        }
    ]));
/**
 * --- GetCustomerTheme ---
 * Aggregate read: the theme plus its full version history and evidence, in
 * one call — the UI's theme detail panel.
 *
 * @generated from message mono.projectdata.v1.GetCustomerThemeRequest
 */ export class GetCustomerThemeRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetCustomerThemeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCustomerThemeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCustomerThemeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCustomerThemeRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string theme_id = 2;
   */ _define_property(this, "themeId", ""), /**
   * @generated from field: string user_id = 3;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 4;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCustomerThemeRequest, "runtime", proto3);
_define_property(GetCustomerThemeRequest, "typeName", "mono.projectdata.v1.GetCustomerThemeRequest");
_define_property(GetCustomerThemeRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "theme_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetCustomerThemeResponse
 */ export class GetCustomerThemeResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetCustomerThemeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCustomerThemeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCustomerThemeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCustomerThemeResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.CustomerThemeView theme = 1;
   */ _define_property(this, "theme", void 0), /**
   * @generated from field: repeated mono.projectdata.v1.CustomerThemeVersionView versions = 2;
   */ _define_property(this, "versions", []), /**
   * @generated from field: repeated mono.projectdata.v1.CustomerThemeEvidenceView evidence = 3;
   */ _define_property(this, "evidence", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCustomerThemeResponse, "runtime", proto3);
_define_property(GetCustomerThemeResponse, "typeName", "mono.projectdata.v1.GetCustomerThemeResponse");
_define_property(GetCustomerThemeResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "theme",
            kind: "message",
            T: CustomerThemeView
        },
        {
            no: 2,
            name: "versions",
            kind: "message",
            T: CustomerThemeVersionView,
            repeated: true
        },
        {
            no: 3,
            name: "evidence",
            kind: "message",
            T: CustomerThemeEvidenceView,
            repeated: true
        }
    ]));
/**
 * --- ListStakeholderAssessments ---
 *
 * @generated from message mono.projectdata.v1.ListStakeholderAssessmentsRequest
 */ export class ListStakeholderAssessmentsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListStakeholderAssessmentsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListStakeholderAssessmentsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListStakeholderAssessmentsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListStakeholderAssessmentsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string stakeholder_id = 2;
   */ _define_property(this, "stakeholderId", ""), /**
   * @generated from field: string user_id = 3;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 4;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListStakeholderAssessmentsRequest, "runtime", proto3);
_define_property(ListStakeholderAssessmentsRequest, "typeName", "mono.projectdata.v1.ListStakeholderAssessmentsRequest");
_define_property(ListStakeholderAssessmentsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "stakeholder_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListStakeholderAssessmentsResponse
 */ export class ListStakeholderAssessmentsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListStakeholderAssessmentsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListStakeholderAssessmentsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListStakeholderAssessmentsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListStakeholderAssessmentsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.StakeholderAssessmentView assessments = 1;
   */ _define_property(this, "assessments", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListStakeholderAssessmentsResponse, "runtime", proto3);
_define_property(ListStakeholderAssessmentsResponse, "typeName", "mono.projectdata.v1.ListStakeholderAssessmentsResponse");
_define_property(ListStakeholderAssessmentsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "assessments",
            kind: "message",
            T: StakeholderAssessmentView,
            repeated: true
        }
    ]));
/**
 * --- CreateCustomerTheme ---
 * Creates a human-authored, accepted theme in one shot (pangaea's
 * CreateManualCustomerTheme).
 *
 * @generated from message mono.projectdata.v1.CreateCustomerThemeRequest
 */ export class CreateCustomerThemeRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateCustomerThemeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateCustomerThemeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateCustomerThemeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateCustomerThemeRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string origin_source = 2;
   */ _define_property(this, "originSource", ""), /**
   * @generated from field: mono.projectdata.v1.CustomerThemeVersionInput version = 3;
   */ _define_property(this, "version", void 0), /**
   * @generated from field: string user_id = 4;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 5;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateCustomerThemeRequest, "runtime", proto3);
_define_property(CreateCustomerThemeRequest, "typeName", "mono.projectdata.v1.CreateCustomerThemeRequest");
_define_property(CreateCustomerThemeRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "origin_source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "version",
            kind: "message",
            T: CustomerThemeVersionInput
        },
        {
            no: 4,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CreateCustomerThemeResponse
 */ export class CreateCustomerThemeResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateCustomerThemeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateCustomerThemeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateCustomerThemeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateCustomerThemeResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.CustomerThemeView theme = 1;
   */ _define_property(this, "theme", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateCustomerThemeResponse, "runtime", proto3);
_define_property(CreateCustomerThemeResponse, "typeName", "mono.projectdata.v1.CreateCustomerThemeResponse");
_define_property(CreateCustomerThemeResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "theme",
            kind: "message",
            T: CustomerThemeView
        }
    ]));
/**
 * --- SuggestCustomerTheme ---
 * Creates a theme in record_state "suggested". authorship is the one
 * caller-supplied authorship value in this RPC block — it can never produce
 * an accepted theme (see AcceptCustomerThemeSuggestion).
 *
 * @generated from message mono.projectdata.v1.SuggestCustomerThemeRequest
 */ export class SuggestCustomerThemeRequest extends Message {
    static fromBinary(bytes, options) {
        return new SuggestCustomerThemeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SuggestCustomerThemeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SuggestCustomerThemeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SuggestCustomerThemeRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string origin_source = 2;
   */ _define_property(this, "originSource", ""), /**
   * @generated from field: string proposed_revision_of_id = 3;
   */ _define_property(this, "proposedRevisionOfId", ""), /**
   * human|ai_suggested
   *
   * @generated from field: string authorship = 4;
   */ _define_property(this, "authorship", ""), /**
   * @generated from field: mono.projectdata.v1.CustomerThemeVersionInput version = 5;
   */ _define_property(this, "version", void 0), /**
   * @generated from field: string user_id = 6;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 7;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SuggestCustomerThemeRequest, "runtime", proto3);
_define_property(SuggestCustomerThemeRequest, "typeName", "mono.projectdata.v1.SuggestCustomerThemeRequest");
_define_property(SuggestCustomerThemeRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "origin_source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "proposed_revision_of_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "authorship",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "version",
            kind: "message",
            T: CustomerThemeVersionInput
        },
        {
            no: 6,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SuggestCustomerThemeResponse
 */ export class SuggestCustomerThemeResponse extends Message {
    static fromBinary(bytes, options) {
        return new SuggestCustomerThemeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SuggestCustomerThemeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SuggestCustomerThemeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SuggestCustomerThemeResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.CustomerThemeView theme = 1;
   */ _define_property(this, "theme", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SuggestCustomerThemeResponse, "runtime", proto3);
_define_property(SuggestCustomerThemeResponse, "typeName", "mono.projectdata.v1.SuggestCustomerThemeResponse");
_define_property(SuggestCustomerThemeResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "theme",
            kind: "message",
            T: CustomerThemeView
        }
    ]));
/**
 * --- AcceptCustomerThemeSuggestion ---
 *
 * @generated from message mono.projectdata.v1.AcceptCustomerThemeSuggestionRequest
 */ export class AcceptCustomerThemeSuggestionRequest extends Message {
    static fromBinary(bytes, options) {
        return new AcceptCustomerThemeSuggestionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AcceptCustomerThemeSuggestionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AcceptCustomerThemeSuggestionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AcceptCustomerThemeSuggestionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string theme_id = 2;
   */ _define_property(this, "themeId", ""), /**
   * @generated from field: mono.projectdata.v1.CustomerThemeVersionInput version = 3;
   */ _define_property(this, "version", void 0), /**
   * @generated from field: string user_id = 4;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 5;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AcceptCustomerThemeSuggestionRequest, "runtime", proto3);
_define_property(AcceptCustomerThemeSuggestionRequest, "typeName", "mono.projectdata.v1.AcceptCustomerThemeSuggestionRequest");
_define_property(AcceptCustomerThemeSuggestionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "theme_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "version",
            kind: "message",
            T: CustomerThemeVersionInput
        },
        {
            no: 4,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.AcceptCustomerThemeSuggestionResponse
 */ export class AcceptCustomerThemeSuggestionResponse extends Message {
    static fromBinary(bytes, options) {
        return new AcceptCustomerThemeSuggestionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AcceptCustomerThemeSuggestionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AcceptCustomerThemeSuggestionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AcceptCustomerThemeSuggestionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.CustomerThemeView theme = 1;
   */ _define_property(this, "theme", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AcceptCustomerThemeSuggestionResponse, "runtime", proto3);
_define_property(AcceptCustomerThemeSuggestionResponse, "typeName", "mono.projectdata.v1.AcceptCustomerThemeSuggestionResponse");
_define_property(AcceptCustomerThemeSuggestionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "theme",
            kind: "message",
            T: CustomerThemeView
        }
    ]));
/**
 * --- ReviseCustomerTheme ---
 *
 * @generated from message mono.projectdata.v1.ReviseCustomerThemeRequest
 */ export class ReviseCustomerThemeRequest extends Message {
    static fromBinary(bytes, options) {
        return new ReviseCustomerThemeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReviseCustomerThemeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReviseCustomerThemeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReviseCustomerThemeRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string theme_id = 2;
   */ _define_property(this, "themeId", ""), /**
   * @generated from field: mono.projectdata.v1.CustomerThemeVersionInput version = 3;
   */ _define_property(this, "version", void 0), /**
   * @generated from field: string user_id = 4;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 5;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReviseCustomerThemeRequest, "runtime", proto3);
_define_property(ReviseCustomerThemeRequest, "typeName", "mono.projectdata.v1.ReviseCustomerThemeRequest");
_define_property(ReviseCustomerThemeRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "theme_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "version",
            kind: "message",
            T: CustomerThemeVersionInput
        },
        {
            no: 4,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ReviseCustomerThemeResponse
 */ export class ReviseCustomerThemeResponse extends Message {
    static fromBinary(bytes, options) {
        return new ReviseCustomerThemeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReviseCustomerThemeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReviseCustomerThemeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReviseCustomerThemeResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.CustomerThemeView theme = 1;
   */ _define_property(this, "theme", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReviseCustomerThemeResponse, "runtime", proto3);
_define_property(ReviseCustomerThemeResponse, "typeName", "mono.projectdata.v1.ReviseCustomerThemeResponse");
_define_property(ReviseCustomerThemeResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "theme",
            kind: "message",
            T: CustomerThemeView
        }
    ]));
/**
 * --- AttachCustomerThemeEvidence ---
 *
 * @generated from message mono.projectdata.v1.AttachCustomerThemeEvidenceRequest
 */ export class AttachCustomerThemeEvidenceRequest extends Message {
    static fromBinary(bytes, options) {
        return new AttachCustomerThemeEvidenceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AttachCustomerThemeEvidenceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AttachCustomerThemeEvidenceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AttachCustomerThemeEvidenceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string theme_id = 2;
   */ _define_property(this, "themeId", ""), /**
   * @generated from field: string stance = 3;
   */ _define_property(this, "stance", ""), /**
   * @generated from field: string assertion_kind = 4;
   */ _define_property(this, "assertionKind", ""), /**
   * @generated from field: string source_kind = 5;
   */ _define_property(this, "sourceKind", ""), /**
   * @generated from field: string source_ref = 6;
   */ _define_property(this, "sourceRef", ""), /**
   * @generated from field: string source_excerpt = 7;
   */ _define_property(this, "sourceExcerpt", ""), /**
   * @generated from field: google.protobuf.Timestamp source_date = 8;
   */ _define_property(this, "sourceDate", void 0), /**
   * @generated from field: string confidence = 9;
   */ _define_property(this, "confidence", ""), /**
   * @generated from field: string rationale = 10;
   */ _define_property(this, "rationale", ""), /**
   * @generated from field: string supersedes_evidence_id = 11;
   */ _define_property(this, "supersedesEvidenceId", ""), /**
   * @generated from field: string provenance_record_id = 12;
   */ _define_property(this, "provenanceRecordId", ""), /**
   * @generated from field: string user_id = 13;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 14;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AttachCustomerThemeEvidenceRequest, "runtime", proto3);
_define_property(AttachCustomerThemeEvidenceRequest, "typeName", "mono.projectdata.v1.AttachCustomerThemeEvidenceRequest");
_define_property(AttachCustomerThemeEvidenceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "theme_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "stance",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "assertion_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "source_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "source_ref",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "source_excerpt",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "source_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "confidence",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "rationale",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "supersedes_evidence_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "provenance_record_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.AttachCustomerThemeEvidenceResponse
 */ export class AttachCustomerThemeEvidenceResponse extends Message {
    static fromBinary(bytes, options) {
        return new AttachCustomerThemeEvidenceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AttachCustomerThemeEvidenceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AttachCustomerThemeEvidenceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AttachCustomerThemeEvidenceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.CustomerThemeEvidenceView evidence = 1;
   */ _define_property(this, "evidence", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AttachCustomerThemeEvidenceResponse, "runtime", proto3);
_define_property(AttachCustomerThemeEvidenceResponse, "typeName", "mono.projectdata.v1.AttachCustomerThemeEvidenceResponse");
_define_property(AttachCustomerThemeEvidenceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "evidence",
            kind: "message",
            T: CustomerThemeEvidenceView
        }
    ]));
/**
 * --- UpsertPursuitStakeholder ---
 *
 * @generated from message mono.projectdata.v1.UpsertPursuitStakeholderRequest
 */ export class UpsertPursuitStakeholderRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertPursuitStakeholderRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertPursuitStakeholderRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertPursuitStakeholderRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertPursuitStakeholderRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string contact_id = 3;
   */ _define_property(this, "contactId", ""), /**
   * @generated from field: string unresolved_name = 4;
   */ _define_property(this, "unresolvedName", ""), /**
   * @generated from field: string unresolved_organization = 5;
   */ _define_property(this, "unresolvedOrganization", ""), /**
   * @generated from field: string affiliation = 6;
   */ _define_property(this, "affiliation", ""), /**
   * @generated from field: string pursuit_role = 7;
   */ _define_property(this, "pursuitRole", ""), /**
   * @generated from field: string user_id = 8;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 9;
   */ _define_property(this, "companyId", ""), /**
   * GRW-37 (D-SOR): the typed person when contact_id is empty. With an email
   * zou resolves MATCH_OR_CREATE (links with no prompt); without one
   * MATCH_OR_CANDIDATE, so a name never binds silently. unresolved_name /
   * unresolved_organization (legacy clients) are mapped into a draft.
   *
   * @generated from field: mono.projectdata.v1.PersonDraft person_draft = 10;
   */ _define_property(this, "personDraft", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertPursuitStakeholderRequest, "runtime", proto3);
_define_property(UpsertPursuitStakeholderRequest, "typeName", "mono.projectdata.v1.UpsertPursuitStakeholderRequest");
_define_property(UpsertPursuitStakeholderRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "unresolved_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "unresolved_organization",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "affiliation",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "pursuit_role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "person_draft",
            kind: "message",
            T: PersonDraft
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpsertPursuitStakeholderResponse
 */ export class UpsertPursuitStakeholderResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertPursuitStakeholderResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertPursuitStakeholderResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertPursuitStakeholderResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertPursuitStakeholderResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.PursuitStakeholderView stakeholder = 1;
   */ _define_property(this, "stakeholder", void 0), /**
   * @generated from field: bool created = 2;
   */ _define_property(this, "created", false), /**
   * GRW-37: how person_draft resolved (unset when contact_id was sent).
   *
   * @generated from field: mono.projectdata.v1.EntityResolutionView resolution = 3;
   */ _define_property(this, "resolution", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertPursuitStakeholderResponse, "runtime", proto3);
_define_property(UpsertPursuitStakeholderResponse, "typeName", "mono.projectdata.v1.UpsertPursuitStakeholderResponse");
_define_property(UpsertPursuitStakeholderResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "stakeholder",
            kind: "message",
            T: PursuitStakeholderView
        },
        {
            no: 2,
            name: "created",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 3,
            name: "resolution",
            kind: "message",
            T: EntityResolutionView
        }
    ]));
/**
 * A person typed on a pursuit surface. Strong id = email.
 *
 * @generated from message mono.projectdata.v1.PersonDraft
 */ export class PersonDraft extends Message {
    static fromBinary(bytes, options) {
        return new PersonDraft().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PersonDraft().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PersonDraft().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PersonDraft, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string first_name = 1;
   */ _define_property(this, "firstName", ""), /**
   * @generated from field: string last_name = 2;
   */ _define_property(this, "lastName", ""), /**
   * @generated from field: string email = 3;
   */ _define_property(this, "email", ""), /**
   * @generated from field: string phone = 4;
   */ _define_property(this, "phone", ""), /**
   * @generated from field: string title = 5;
   */ _define_property(this, "title", ""), /**
   * employer as written (a hint, never stored on the link)
   *
   * @generated from field: string organization = 6;
   */ _define_property(this, "organization", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PersonDraft, "runtime", proto3);
_define_property(PersonDraft, "typeName", "mono.projectdata.v1.PersonDraft");
_define_property(PersonDraft, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "first_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "last_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "email",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "phone",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "organization",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * A company typed on a pursuit surface. Strong ids = UEI, CAGE.
 *
 * @generated from message mono.projectdata.v1.CompanyDraft
 */ export class CompanyDraft extends Message {
    static fromBinary(bytes, options) {
        return new CompanyDraft().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompanyDraft().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompanyDraft().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompanyDraft, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string name = 1;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string uei = 2;
   */ _define_property(this, "uei", ""), /**
   * @generated from field: string cage = 3;
   */ _define_property(this, "cage", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CompanyDraft, "runtime", proto3);
_define_property(CompanyDraft, "typeName", "mono.projectdata.v1.CompanyDraft");
_define_property(CompanyDraft, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "uei",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "cage",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * One registry record a typed name might be. Labels are read from the
 * registry at response time and never stored.
 *
 * @generated from message mono.projectdata.v1.EntityCandidateView
 */ export class EntityCandidateView extends Message {
    static fromBinary(bytes, options) {
        return new EntityCandidateView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EntityCandidateView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EntityCandidateView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EntityCandidateView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string registry_id = 1;
   */ _define_property(this, "registryId", ""), /**
   * @generated from field: string label = 2;
   */ _define_property(this, "label", ""), /**
   * person: "{employer} · {email}"; company: "UEI …" | "CAGE …"
   *
   * @generated from field: string detail = 3;
   */ _define_property(this, "detail", ""), /**
   * first evidence line, e.g. "Same name"
   *
   * @generated from field: string basis = 4;
   */ _define_property(this, "basis", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(EntityCandidateView, "runtime", proto3);
_define_property(EntityCandidateView, "typeName", "mono.projectdata.v1.EntityCandidateView");
_define_property(EntityCandidateView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "registry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "detail",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.EntityResolutionView
 */ export class EntityResolutionView extends Message {
    static fromBinary(bytes, options) {
        return new EntityResolutionView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EntityResolutionView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EntityResolutionView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EntityResolutionView, a, b);
    }
    constructor(data){
        super(), /**
   * MATCHED | CREATED | CANDIDATE | AMBIGUOUS | UNRESOLVED (REG-54)
   *
   * @generated from field: string status = 1;
   */ _define_property(this, "status", ""), /**
   * MATCHED / CREATED (survivor id)
   *
   * @generated from field: string registry_id = 2;
   */ _define_property(this, "registryId", ""), /**
   * delivery.registry_match_candidates.id while undecided
   *
   * @generated from field: string candidate_id = 3;
   */ _define_property(this, "candidateId", ""), /**
   * ≤ 5, best first
   *
   * @generated from field: repeated mono.projectdata.v1.EntityCandidateView candidates = 4;
   */ _define_property(this, "candidates", []), /**
   * email | uei | cage | name_in_context …
   *
   * @generated from field: string basis = 5;
   */ _define_property(this, "basis", ""), /**
   * "Is this John Smith (DISA)?" (REG-54 copy)
   *
   * @generated from field: string question = 6;
   */ _define_property(this, "question", ""), /**
   * the typed name, for the prompt
   *
   * @generated from field: string display_name = 7;
   */ _define_property(this, "displayName", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(EntityResolutionView, "runtime", proto3);
_define_property(EntityResolutionView, "typeName", "mono.projectdata.v1.EntityResolutionView");
_define_property(EntityResolutionView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "registry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "candidate_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "candidates",
            kind: "message",
            T: EntityCandidateView,
            repeated: true
        },
        {
            no: 5,
            name: "basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "question",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * Confirms an unresolved stakeholder / touchpoint attendee ("Is this John
 * Smith (DISA)?" → PICK, or "None of these — create new" → CREATE_NEW).
 * Needs capture_project update. "Later" is not an RPC: the candidate stays
 * open in the registry review queue and on the pursuit.
 *
 * @generated from message mono.projectdata.v1.ResolvePursuitEntityRequest
 */ export class ResolvePursuitEntityRequest extends Message {
    static fromBinary(bytes, options) {
        return new ResolvePursuitEntityRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResolvePursuitEntityRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResolvePursuitEntityRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResolvePursuitEntityRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * STAKEHOLDER | TOUCHPOINT_PARTICIPANT
   *
   * @generated from field: string link_kind = 2;
   */ _define_property(this, "linkKind", ""), /**
   * pursuit_stakeholders.id | customer_interaction_participants.id
   *
   * @generated from field: string link_id = 3;
   */ _define_property(this, "linkId", ""), /**
   * PICK | CREATE_NEW
   *
   * @generated from field: string decision = 4;
   */ _define_property(this, "decision", ""), /**
   * required for PICK
   *
   * @generated from field: string registry_id = 5;
   */ _define_property(this, "registryId", ""), /**
   * optional for CREATE_NEW (reserved: REG-54 creates from the observation)
   *
   * @generated from field: mono.projectdata.v1.PersonDraft person_draft = 6;
   */ _define_property(this, "personDraft", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResolvePursuitEntityRequest, "runtime", proto3);
_define_property(ResolvePursuitEntityRequest, "typeName", "mono.projectdata.v1.ResolvePursuitEntityRequest");
_define_property(ResolvePursuitEntityRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "link_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "link_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "decision",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "registry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "person_draft",
            kind: "message",
            T: PersonDraft
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ResolvePursuitEntityResponse
 */ export class ResolvePursuitEntityResponse extends Message {
    static fromBinary(bytes, options) {
        return new ResolvePursuitEntityResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResolvePursuitEntityResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResolvePursuitEntityResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResolvePursuitEntityResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string contact_id = 1;
   */ _define_property(this, "contactId", ""), /**
   * @generated from field: bool merged_into_existing_stakeholder = 2;
   */ _define_property(this, "mergedIntoExistingStakeholder", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResolvePursuitEntityResponse, "runtime", proto3);
_define_property(ResolvePursuitEntityResponse, "typeName", "mono.projectdata.v1.ResolvePursuitEntityResponse");
_define_property(ResolvePursuitEntityResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "merged_into_existing_stakeholder",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GovconEventView
 */ export class GovconEventView extends Message {
    static fromBinary(bytes, options) {
        return new GovconEventView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GovconEventView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GovconEventView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GovconEventView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * INDUSTRY_DAY | CONFERENCE | MEETING | CALL | SITE_VISIT | OTHER
   *
   * @generated from field: string kind = 2;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string title = 3;
   */ _define_property(this, "title", ""), /**
   * RFC3339
   *
   * @generated from field: string starts_at = 4;
   */ _define_property(this, "startsAt", ""), /**
   * @generated from field: string ends_at = 5;
   */ _define_property(this, "endsAt", ""), /**
   * @generated from field: string host_government_organization_id = 6;
   */ _define_property(this, "hostGovernmentOrganizationId", ""), /**
   * @generated from field: string host_label = 7;
   */ _define_property(this, "hostLabel", ""), /**
   * @generated from field: string notice_id = 8;
   */ _define_property(this, "noticeId", ""), /**
   * @generated from field: string location_text = 9;
   */ _define_property(this, "locationText", ""), /**
   * @generated from field: string created_by = 10;
   */ _define_property(this, "createdBy", ""), /**
   * @generated from field: string created_at = 11;
   */ _define_property(this, "createdAt", ""), /**
   * @generated from field: string updated_at = 12;
   */ _define_property(this, "updatedAt", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GovconEventView, "runtime", proto3);
_define_property(GovconEventView, "typeName", "mono.projectdata.v1.GovconEventView");
_define_property(GovconEventView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "starts_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "ends_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "host_government_organization_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "host_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "location_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "created_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "updated_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.EventLinkView
 */ export class EventLinkView extends Message {
    static fromBinary(bytes, options) {
        return new EventLinkView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EventLinkView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EventLinkView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EventLinkView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string link_role = 1;
   */ _define_property(this, "linkRole", ""), /**
   * @generated from field: string target_kind = 2;
   */ _define_property(this, "targetKind", ""), /**
   * @generated from field: string target_id = 3;
   */ _define_property(this, "targetId", ""), /**
   * @generated from field: string participant_role = 4;
   */ _define_property(this, "participantRole", ""), /**
   * @generated from field: string source = 5;
   */ _define_property(this, "source", ""), /**
   * @generated from field: string label = 6;
   */ _define_property(this, "label", ""), /**
   * @generated from field: string created_by = 7;
   */ _define_property(this, "createdBy", ""), /**
   * @generated from field: string created_at = 8;
   */ _define_property(this, "createdAt", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(EventLinkView, "runtime", proto3);
_define_property(EventLinkView, "typeName", "mono.projectdata.v1.EventLinkView");
_define_property(EventLinkView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "link_role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "target_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "target_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "participant_role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "created_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListEventsRequest
 */ export class ListEventsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListEventsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListEventsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListEventsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListEventsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string search = 1;
   */ _define_property(this, "search", ""), /**
   * @generated from field: string notice_id = 2;
   */ _define_property(this, "noticeId", ""), /**
   * @generated from field: string relevant_to_kind = 3;
   */ _define_property(this, "relevantToKind", ""), /**
   * @generated from field: string relevant_to_id = 4;
   */ _define_property(this, "relevantToId", ""), /**
   * @generated from field: string starts_after = 5;
   */ _define_property(this, "startsAfter", ""), /**
   * @generated from field: int32 limit = 6;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListEventsRequest, "runtime", proto3);
_define_property(ListEventsRequest, "typeName", "mono.projectdata.v1.ListEventsRequest");
_define_property(ListEventsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "search",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "relevant_to_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "relevant_to_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "starts_after",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListEventsResponse
 */ export class ListEventsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListEventsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListEventsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListEventsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListEventsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.GovconEventView events = 1;
   */ _define_property(this, "events", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListEventsResponse, "runtime", proto3);
_define_property(ListEventsResponse, "typeName", "mono.projectdata.v1.ListEventsResponse");
_define_property(ListEventsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "events",
            kind: "message",
            T: GovconEventView,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetEventRequest
 */ export class GetEventRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetEventRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetEventRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetEventRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetEventRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string event_id = 1;
   */ _define_property(this, "eventId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetEventRequest, "runtime", proto3);
_define_property(GetEventRequest, "typeName", "mono.projectdata.v1.GetEventRequest");
_define_property(GetEventRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "event_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetEventResponse
 */ export class GetEventResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetEventResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetEventResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetEventResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetEventResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.GovconEventView event = 1;
   */ _define_property(this, "event", void 0), /**
   * relevance targets the viewer cannot read are dropped (never counted)
   *
   * @generated from field: repeated mono.projectdata.v1.EventLinkView links = 2;
   */ _define_property(this, "links", []), /**
   * only touchpoints of pursuits the viewer can read
   *
   * @generated from field: repeated string touchpoint_ids = 3;
   */ _define_property(this, "touchpointIds", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetEventResponse, "runtime", proto3);
_define_property(GetEventResponse, "typeName", "mono.projectdata.v1.GetEventResponse");
_define_property(GetEventResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "event",
            kind: "message",
            T: GovconEventView
        },
        {
            no: 2,
            name: "links",
            kind: "message",
            T: EventLinkView,
            repeated: true
        },
        {
            no: 3,
            name: "touchpoint_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpsertEventRequest
 */ export class UpsertEventRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertEventRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertEventRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertEventRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertEventRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.GovconEventView event = 1;
   */ _define_property(this, "event", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertEventRequest, "runtime", proto3);
_define_property(UpsertEventRequest, "typeName", "mono.projectdata.v1.UpsertEventRequest");
_define_property(UpsertEventRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "event",
            kind: "message",
            T: GovconEventView
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpsertEventResponse
 */ export class UpsertEventResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertEventResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertEventResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertEventResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertEventResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.GovconEventView event = 1;
   */ _define_property(this, "event", void 0), /**
   * @generated from field: bool created = 2;
   */ _define_property(this, "created", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertEventResponse, "runtime", proto3);
_define_property(UpsertEventResponse, "typeName", "mono.projectdata.v1.UpsertEventResponse");
_define_property(UpsertEventResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "event",
            kind: "message",
            T: GovconEventView
        },
        {
            no: 2,
            name: "created",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SetEventLinkRequest
 */ export class SetEventLinkRequest extends Message {
    static fromBinary(bytes, options) {
        return new SetEventLinkRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetEventLinkRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetEventLinkRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetEventLinkRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string event_id = 1;
   */ _define_property(this, "eventId", ""), /**
   * @generated from field: string link_role = 2;
   */ _define_property(this, "linkRole", ""), /**
   * @generated from field: string target_kind = 3;
   */ _define_property(this, "targetKind", ""), /**
   * @generated from field: string target_id = 4;
   */ _define_property(this, "targetId", ""), /**
   * @generated from field: string participant_role = 5;
   */ _define_property(this, "participantRole", ""), /**
   * @generated from field: string source = 6;
   */ _define_property(this, "source", ""), /**
   * @generated from field: bool remove = 7;
   */ _define_property(this, "remove", false), /**
   * GRW-36 + GRW-37: an attendee / host typed instead of picked. zou resolves it
   * through REG-54 (email / UEI present ⇒ MATCH_OR_CREATE, else
   * MATCH_OR_CANDIDATE) and links only on MATCHED / CREATED.
   *
   * @generated from field: mono.projectdata.v1.PersonDraft person_draft = 8;
   */ _define_property(this, "personDraft", void 0), /**
   * @generated from field: mono.projectdata.v1.CompanyDraft company_draft = 9;
   */ _define_property(this, "companyDraft", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetEventLinkRequest, "runtime", proto3);
_define_property(SetEventLinkRequest, "typeName", "mono.projectdata.v1.SetEventLinkRequest");
_define_property(SetEventLinkRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "event_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "link_role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "target_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "target_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "participant_role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "remove",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 8,
            name: "person_draft",
            kind: "message",
            T: PersonDraft
        },
        {
            no: 9,
            name: "company_draft",
            kind: "message",
            T: CompanyDraft
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SetEventLinkResponse
 */ export class SetEventLinkResponse extends Message {
    static fromBinary(bytes, options) {
        return new SetEventLinkResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetEventLinkResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetEventLinkResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetEventLinkResponse, a, b);
    }
    constructor(data){
        super(), /**
   * unset when the typed entity is waiting on a candidate
   *
   * @generated from field: mono.projectdata.v1.EventLinkView link = 1;
   */ _define_property(this, "link", void 0), /**
   * set when a draft was resolved
   *
   * @generated from field: mono.projectdata.v1.EntityResolutionView resolution = 2;
   */ _define_property(this, "resolution", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetEventLinkResponse, "runtime", proto3);
_define_property(SetEventLinkResponse, "typeName", "mono.projectdata.v1.SetEventLinkResponse");
_define_property(SetEventLinkResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "link",
            kind: "message",
            T: EventLinkView
        },
        {
            no: 2,
            name: "resolution",
            kind: "message",
            T: EntityResolutionView
        }
    ]));
/**
 * --- RecordStakeholderAssessment ---
 *
 * @generated from message mono.projectdata.v1.RecordStakeholderAssessmentRequest
 */ export class RecordStakeholderAssessmentRequest extends Message {
    static fromBinary(bytes, options) {
        return new RecordStakeholderAssessmentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordStakeholderAssessmentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordStakeholderAssessmentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordStakeholderAssessmentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string stakeholder_id = 2;
   */ _define_property(this, "stakeholderId", ""), /**
   * @generated from field: string influence_band = 3;
   */ _define_property(this, "influenceBand", ""), /**
   * @generated from field: string relationship_posture = 4;
   */ _define_property(this, "relationshipPosture", ""), /**
   * @generated from field: string priorities = 5;
   */ _define_property(this, "priorities", ""), /**
   * @generated from field: string rationale = 6;
   */ _define_property(this, "rationale", ""), /**
   * @generated from field: string uncertainty_note = 7;
   */ _define_property(this, "uncertaintyNote", ""), /**
   * @generated from field: string confidence = 8;
   */ _define_property(this, "confidence", ""), /**
   * @generated from field: string source_kind = 9;
   */ _define_property(this, "sourceKind", ""), /**
   * @generated from field: string source_ref = 10;
   */ _define_property(this, "sourceRef", ""), /**
   * @generated from field: string authorship = 11;
   */ _define_property(this, "authorship", ""), /**
   * @generated from field: string assessment_state = 12;
   */ _define_property(this, "assessmentState", ""), /**
   * @generated from field: google.protobuf.Timestamp as_of_date = 13;
   */ _define_property(this, "asOfDate", void 0), /**
   * @generated from field: string provenance_record_id = 14;
   */ _define_property(this, "provenanceRecordId", ""), /**
   * @generated from field: string user_id = 15;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 16;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: repeated string theme_ids = 17;
   */ _define_property(this, "themeIds", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordStakeholderAssessmentRequest, "runtime", proto3);
_define_property(RecordStakeholderAssessmentRequest, "typeName", "mono.projectdata.v1.RecordStakeholderAssessmentRequest");
_define_property(RecordStakeholderAssessmentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "stakeholder_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "influence_band",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "relationship_posture",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "priorities",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "rationale",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "uncertainty_note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "confidence",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "source_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "source_ref",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "authorship",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "assessment_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "as_of_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 14,
            name: "provenance_record_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "theme_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RecordStakeholderAssessmentResponse
 */ export class RecordStakeholderAssessmentResponse extends Message {
    static fromBinary(bytes, options) {
        return new RecordStakeholderAssessmentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordStakeholderAssessmentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordStakeholderAssessmentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordStakeholderAssessmentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.StakeholderAssessmentView assessment = 1;
   */ _define_property(this, "assessment", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordStakeholderAssessmentResponse, "runtime", proto3);
_define_property(RecordStakeholderAssessmentResponse, "typeName", "mono.projectdata.v1.RecordStakeholderAssessmentResponse");
_define_property(RecordStakeholderAssessmentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "assessment",
            kind: "message",
            T: StakeholderAssessmentView
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetDocumentSourceScopesRequest
 */ export class GetDocumentSourceScopesRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetDocumentSourceScopesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetDocumentSourceScopesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetDocumentSourceScopesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetDocumentSourceScopesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string document_id = 1;
   */ _define_property(this, "documentId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetDocumentSourceScopesRequest, "runtime", proto3);
_define_property(GetDocumentSourceScopesRequest, "typeName", "mono.projectdata.v1.GetDocumentSourceScopesRequest");
_define_property(GetDocumentSourceScopesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetDocumentSourceScopesResponse
 */ export class GetDocumentSourceScopesResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetDocumentSourceScopesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetDocumentSourceScopesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetDocumentSourceScopesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetDocumentSourceScopesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated string project_ids = 1;
   */ _define_property(this, "projectIds", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetDocumentSourceScopesResponse, "runtime", proto3);
_define_property(GetDocumentSourceScopesResponse, "typeName", "mono.projectdata.v1.GetDocumentSourceScopesResponse");
_define_property(GetDocumentSourceScopesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * Canonical identity is optional independently for each role. Source names and
 * manual context survive resolution. Selected source references must target this
 * Opportunity and this role's field path; raw quotes stay in source_references.
 *
 * @generated from message mono.projectdata.v1.OpportunityOrganizationContext
 */ export class OpportunityOrganizationContext extends Message {
    static fromBinary(bytes, options) {
        return new OpportunityOrganizationContext().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OpportunityOrganizationContext().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OpportunityOrganizationContext().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OpportunityOrganizationContext, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string organization_id = 1;
   */ _define_property(this, "organizationId", ""), /**
   * @generated from field: string source_name = 2;
   */ _define_property(this, "sourceName", ""), /**
   * @generated from field: string manual_context = 3;
   */ _define_property(this, "manualContext", ""), /**
   * @generated from field: repeated string source_reference_ids = 4;
   */ _define_property(this, "sourceReferenceIds", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(OpportunityOrganizationContext, "runtime", proto3);
_define_property(OpportunityOrganizationContext, "typeName", "mono.projectdata.v1.OpportunityOrganizationContext");
_define_property(OpportunityOrganizationContext, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "organization_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "source_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "manual_context",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "source_reference_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.OpportunityContext
 */ export class OpportunityContext extends Message {
    static fromBinary(bytes, options) {
        return new OpportunityContext().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OpportunityContext().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OpportunityContext().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OpportunityContext, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string opportunity_id = 1;
   */ _define_property(this, "opportunityId", ""), /**
   * @generated from field: mono.projectdata.v1.OpportunityOrganizationContext customer = 2;
   */ _define_property(this, "customer", void 0), /**
   * @generated from field: mono.projectdata.v1.OpportunityOrganizationContext contracting = 3;
   */ _define_property(this, "contracting", void 0), /**
   * @generated from field: string customer_confirmed_by = 4;
   */ _define_property(this, "customerConfirmedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp customer_confirmed_at = 5;
   */ _define_property(this, "customerConfirmedAt", void 0), /**
   * @generated from field: int32 version = 6;
   */ _define_property(this, "version", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(OpportunityContext, "runtime", proto3);
_define_property(OpportunityContext, "typeName", "mono.projectdata.v1.OpportunityContext");
_define_property(OpportunityContext, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "customer",
            kind: "message",
            T: OpportunityOrganizationContext
        },
        {
            no: 3,
            name: "contracting",
            kind: "message",
            T: OpportunityOrganizationContext
        },
        {
            no: 4,
            name: "customer_confirmed_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "customer_confirmed_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetOpportunityContextRequest
 */ export class GetOpportunityContextRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetOpportunityContextRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetOpportunityContextRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetOpportunityContextRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetOpportunityContextRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string opportunity_id = 2;
   */ _define_property(this, "opportunityId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetOpportunityContextRequest, "runtime", proto3);
_define_property(GetOpportunityContextRequest, "typeName", "mono.projectdata.v1.GetOpportunityContextRequest");
_define_property(GetOpportunityContextRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetOpportunityContextResponse
 */ export class GetOpportunityContextResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetOpportunityContextResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetOpportunityContextResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetOpportunityContextResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetOpportunityContextResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.OpportunityContext context = 1;
   */ _define_property(this, "context", void 0), /**
   * GRW-06: the opportunity's RFP-expected value (carries the version the
   * RfpExpectedDialog sends back as expected_version).
   *
   * @generated from field: mono.projectdata.v1.OpportunityRfpExpected rfp_expected = 2;
   */ _define_property(this, "rfpExpected", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetOpportunityContextResponse, "runtime", proto3);
_define_property(GetOpportunityContextResponse, "typeName", "mono.projectdata.v1.GetOpportunityContextResponse");
_define_property(GetOpportunityContextResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "context",
            kind: "message",
            T: OpportunityContext
        },
        {
            no: 2,
            name: "rfp_expected",
            kind: "message",
            T: OpportunityRfpExpected
        }
    ]));
/**
 * Full replacement, optimistic version check (zero for first write). Setting or
 * changing a customer ID requires confirm_customer=true, including equal IDs.
 * Clearing the ID clears confirmation. No public-source inference is performed.
 *
 * @generated from message mono.projectdata.v1.UpdateOpportunityContextRequest
 */ export class UpdateOpportunityContextRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateOpportunityContextRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateOpportunityContextRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateOpportunityContextRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateOpportunityContextRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string opportunity_id = 2;
   */ _define_property(this, "opportunityId", ""), /**
   * @generated from field: mono.projectdata.v1.OpportunityOrganizationContext customer = 4;
   */ _define_property(this, "customer", void 0), /**
   * @generated from field: mono.projectdata.v1.OpportunityOrganizationContext contracting = 5;
   */ _define_property(this, "contracting", void 0), /**
   * @generated from field: bool confirm_customer = 6;
   */ _define_property(this, "confirmCustomer", false), /**
   * @generated from field: int32 expected_version = 7;
   */ _define_property(this, "expectedVersion", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateOpportunityContextRequest, "runtime", proto3);
_define_property(UpdateOpportunityContextRequest, "typeName", "mono.projectdata.v1.UpdateOpportunityContextRequest");
_define_property(UpdateOpportunityContextRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "customer",
            kind: "message",
            T: OpportunityOrganizationContext
        },
        {
            no: 5,
            name: "contracting",
            kind: "message",
            T: OpportunityOrganizationContext
        },
        {
            no: 6,
            name: "confirm_customer",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 7,
            name: "expected_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpdateOpportunityContextResponse
 */ export class UpdateOpportunityContextResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateOpportunityContextResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateOpportunityContextResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateOpportunityContextResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateOpportunityContextResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.OpportunityContext context = 1;
   */ _define_property(this, "context", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateOpportunityContextResponse, "runtime", proto3);
_define_property(UpdateOpportunityContextResponse, "typeName", "mono.projectdata.v1.UpdateOpportunityContextResponse");
_define_property(UpdateOpportunityContextResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "context",
            kind: "message",
            T: OpportunityContext
        }
    ]));
/**
 * An append-only user assessment, always a candidate, never proof of absence.
 * Tracking Profile is morgans' TrackingProfile (NOT CaptureProfile). Its intent
 * snapshot is supplied by the trusted orchestrator after its authorized
 * TrackingProfile read; pangaea does not call morgans or authorize Profile access.
 *
 * @generated from message mono.projectdata.v1.OpportunityWhitespaceAssessment
 */ export class OpportunityWhitespaceAssessment extends Message {
    static fromBinary(bytes, options) {
        return new OpportunityWhitespaceAssessment().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OpportunityWhitespaceAssessment().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OpportunityWhitespaceAssessment().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OpportunityWhitespaceAssessment, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string opportunity_id = 2;
   */ _define_property(this, "opportunityId", ""), /**
   * @generated from field: string tracking_profile_id = 3;
   */ _define_property(this, "trackingProfileId", ""), /**
   * @generated from field: string profile_intent = 4;
   */ _define_property(this, "profileIntent", ""), /**
   * @generated from field: string company_id = 5;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: repeated string company_source_reference_ids = 6;
   */ _define_property(this, "companySourceReferenceIds", []), /**
   * @generated from field: repeated string market_source_reference_ids = 7;
   */ _define_property(this, "marketSourceReferenceIds", []), /**
   * @generated from field: repeated string coverage_ids = 8;
   */ _define_property(this, "coverageIds", []), /**
   * @generated from field: string coverage_state = 9;
   */ _define_property(this, "coverageState", ""), /**
   * @generated from field: string limitations = 10;
   */ _define_property(this, "limitations", ""), /**
   * undecided | matters | does_not_matter. Human decision, not evidence truth.
   *
   * @generated from field: string gap_decision = 11;
   */ _define_property(this, "gapDecision", ""), /**
   * @generated from field: string decision_reason = 12;
   */ _define_property(this, "decisionReason", ""), /**
   * @generated from field: string state = 13;
   */ _define_property(this, "state", ""), /**
   * @generated from field: string explanation = 14;
   */ _define_property(this, "explanation", ""), /**
   * @generated from field: string assessed_by = 15;
   */ _define_property(this, "assessedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp assessed_at = 16;
   */ _define_property(this, "assessedAt", void 0), /**
   * Server-generated snapshot of selected source coverage, not company history.
   *
   * @generated from field: string coverage_summary = 17;
   */ _define_property(this, "coverageSummary", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(OpportunityWhitespaceAssessment, "runtime", proto3);
_define_property(OpportunityWhitespaceAssessment, "typeName", "mono.projectdata.v1.OpportunityWhitespaceAssessment");
_define_property(OpportunityWhitespaceAssessment, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "tracking_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "profile_intent",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "company_source_reference_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 7,
            name: "market_source_reference_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 8,
            name: "coverage_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 9,
            name: "coverage_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "limitations",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "gap_decision",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "decision_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "explanation",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "assessed_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "assessed_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 17,
            name: "coverage_summary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RecordOpportunityWhitespaceAssessmentRequest
 */ export class RecordOpportunityWhitespaceAssessmentRequest extends Message {
    static fromBinary(bytes, options) {
        return new RecordOpportunityWhitespaceAssessmentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordOpportunityWhitespaceAssessmentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordOpportunityWhitespaceAssessmentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordOpportunityWhitespaceAssessmentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string opportunity_id = 2;
   */ _define_property(this, "opportunityId", ""), /**
   * @generated from field: string tracking_profile_id = 4;
   */ _define_property(this, "trackingProfileId", ""), /**
   * @generated from field: string company_id = 5;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: repeated string company_source_reference_ids = 6;
   */ _define_property(this, "companySourceReferenceIds", []), /**
   * @generated from field: repeated string market_source_reference_ids = 7;
   */ _define_property(this, "marketSourceReferenceIds", []), /**
   * @generated from field: repeated string coverage_ids = 8;
   */ _define_property(this, "coverageIds", []), /**
   * @generated from field: string limitations = 9;
   */ _define_property(this, "limitations", ""), /**
   * @generated from field: string gap_decision = 10;
   */ _define_property(this, "gapDecision", ""), /**
   * @generated from field: string decision_reason = 11;
   */ _define_property(this, "decisionReason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordOpportunityWhitespaceAssessmentRequest, "runtime", proto3);
_define_property(RecordOpportunityWhitespaceAssessmentRequest, "typeName", "mono.projectdata.v1.RecordOpportunityWhitespaceAssessmentRequest");
_define_property(RecordOpportunityWhitespaceAssessmentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "tracking_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "company_source_reference_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 7,
            name: "market_source_reference_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 8,
            name: "coverage_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 9,
            name: "limitations",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "gap_decision",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "decision_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RecordOpportunityWhitespaceAssessmentResponse
 */ export class RecordOpportunityWhitespaceAssessmentResponse extends Message {
    static fromBinary(bytes, options) {
        return new RecordOpportunityWhitespaceAssessmentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordOpportunityWhitespaceAssessmentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordOpportunityWhitespaceAssessmentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordOpportunityWhitespaceAssessmentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.OpportunityWhitespaceAssessment assessment = 1;
   */ _define_property(this, "assessment", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordOpportunityWhitespaceAssessmentResponse, "runtime", proto3);
_define_property(RecordOpportunityWhitespaceAssessmentResponse, "typeName", "mono.projectdata.v1.RecordOpportunityWhitespaceAssessmentResponse");
_define_property(RecordOpportunityWhitespaceAssessmentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "assessment",
            kind: "message",
            T: OpportunityWhitespaceAssessment
        }
    ]));
/**
 * Exact-ID read only. No unrestricted evidence/list projection. Zou reauthorizes
 * ALL saved inputs (Opportunity, Profile, company, source/coverage IDs and
 * associated source artifacts) before returning any snapshot to the browser.
 *
 * @generated from message mono.projectdata.v1.GetOpportunityWhitespaceAssessmentRequest
 */ export class GetOpportunityWhitespaceAssessmentRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetOpportunityWhitespaceAssessmentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetOpportunityWhitespaceAssessmentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetOpportunityWhitespaceAssessmentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetOpportunityWhitespaceAssessmentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string opportunity_id = 2;
   */ _define_property(this, "opportunityId", ""), /**
   * @generated from field: string assessment_id = 3;
   */ _define_property(this, "assessmentId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetOpportunityWhitespaceAssessmentRequest, "runtime", proto3);
_define_property(GetOpportunityWhitespaceAssessmentRequest, "typeName", "mono.projectdata.v1.GetOpportunityWhitespaceAssessmentRequest");
_define_property(GetOpportunityWhitespaceAssessmentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "assessment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetOpportunityWhitespaceAssessmentResponse
 */ export class GetOpportunityWhitespaceAssessmentResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetOpportunityWhitespaceAssessmentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetOpportunityWhitespaceAssessmentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetOpportunityWhitespaceAssessmentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetOpportunityWhitespaceAssessmentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.OpportunityWhitespaceAssessment assessment = 1;
   */ _define_property(this, "assessment", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetOpportunityWhitespaceAssessmentResponse, "runtime", proto3);
_define_property(GetOpportunityWhitespaceAssessmentResponse, "typeName", "mono.projectdata.v1.GetOpportunityWhitespaceAssessmentResponse");
_define_property(GetOpportunityWhitespaceAssessmentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "assessment",
            kind: "message",
            T: OpportunityWhitespaceAssessment
        }
    ]));
/**
 * Candidates are filtered through Opportunity and artifact source authorization.
 *
 * @generated from message mono.projectdata.v1.ListOpportunityContextEvidenceRequest
 */ export class ListOpportunityContextEvidenceRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListOpportunityContextEvidenceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListOpportunityContextEvidenceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListOpportunityContextEvidenceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListOpportunityContextEvidenceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string opportunity_id = 1;
   */ _define_property(this, "opportunityId", ""), /**
   * @generated from field: string company_id = 2;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListOpportunityContextEvidenceRequest, "runtime", proto3);
_define_property(ListOpportunityContextEvidenceRequest, "typeName", "mono.projectdata.v1.ListOpportunityContextEvidenceRequest");
_define_property(ListOpportunityContextEvidenceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.OpportunityContextEvidence
 */ export class OpportunityContextEvidence extends Message {
    static fromBinary(bytes, options) {
        return new OpportunityContextEvidence().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OpportunityContextEvidence().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OpportunityContextEvidence().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OpportunityContextEvidence, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string target_field = 2;
   */ _define_property(this, "targetField", ""), /**
   * @generated from field: string source_kind = 3;
   */ _define_property(this, "sourceKind", ""), /**
   * @generated from field: string quote = 4;
   */ _define_property(this, "quote", ""), /**
   * @generated from field: string source_artifact_id = 5;
   */ _define_property(this, "sourceArtifactId", ""), /**
   * @generated from field: int32 source_page = 6;
   */ _define_property(this, "sourcePage", 0), /**
   * @generated from field: string source_section = 7;
   */ _define_property(this, "sourceSection", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(OpportunityContextEvidence, "runtime", proto3);
_define_property(OpportunityContextEvidence, "typeName", "mono.projectdata.v1.OpportunityContextEvidence");
_define_property(OpportunityContextEvidence, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "target_field",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "source_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "quote",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "source_artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "source_page",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "source_section",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListOpportunityContextEvidenceResponse
 */ export class ListOpportunityContextEvidenceResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListOpportunityContextEvidenceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListOpportunityContextEvidenceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListOpportunityContextEvidenceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListOpportunityContextEvidenceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.OpportunityContextEvidence market = 1;
   */ _define_property(this, "market", []), /**
   * @generated from field: repeated mono.projectdata.v1.OpportunityContextEvidence company = 2;
   */ _define_property(this, "company", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListOpportunityContextEvidenceResponse, "runtime", proto3);
_define_property(ListOpportunityContextEvidenceResponse, "typeName", "mono.projectdata.v1.ListOpportunityContextEvidenceResponse");
_define_property(ListOpportunityContextEvidenceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "market",
            kind: "message",
            T: OpportunityContextEvidence,
            repeated: true
        },
        {
            no: 2,
            name: "company",
            kind: "message",
            T: OpportunityContextEvidence,
            repeated: true
        }
    ]));
/**
 * Immutable history, independent of go/no-go and review records. Migrated rows
 * preserve exact legacy_stage; no_bid is an outcome, converted is never inferred closed.
 *
 * @generated from message mono.projectdata.v1.CaptureLifecycleEvent
 */ export class CaptureLifecycleEvent extends Message {
    static fromBinary(bytes, options) {
        return new CaptureLifecycleEvent().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureLifecycleEvent().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureLifecycleEvent().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureLifecycleEvent, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string request_id = 3;
   */ _define_property(this, "requestId", ""), /**
   * @generated from field: string action = 4;
   */ _define_property(this, "action", ""), /**
   * @generated from field: string from_lifecycle = 5;
   */ _define_property(this, "fromLifecycle", ""), /**
   * @generated from field: string to_lifecycle = 6;
   */ _define_property(this, "toLifecycle", ""), /**
   * @generated from field: int64 revision = 7;
   */ _define_property(this, "revision", protoInt64.zero), /**
   * @generated from field: string actor_user_id = 8;
   */ _define_property(this, "actorUserId", ""), /**
   * @generated from field: string reason = 9;
   */ _define_property(this, "reason", ""), /**
   * @generated from field: google.protobuf.Timestamp revisit_at = 10;
   */ _define_property(this, "revisitAt", void 0), /**
   * @generated from field: string outcome = 11;
   */ _define_property(this, "outcome", ""), /**
   * @generated from field: repeated string paused_task_ids = 12;
   */ _define_property(this, "pausedTaskIds", []), /**
   * @generated from field: optional string legacy_stage = 13;
   */ _define_property(this, "legacyStage", void 0), /**
   * @generated from field: google.protobuf.Timestamp created_at = 14;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureLifecycleEvent, "runtime", proto3);
_define_property(CaptureLifecycleEvent, "typeName", "mono.projectdata.v1.CaptureLifecycleEvent");
_define_property(CaptureLifecycleEvent, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "action",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "from_lifecycle",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "to_lifecycle",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "revision",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 8,
            name: "actor_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "revisit_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "outcome",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "paused_task_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 13,
            name: "legacy_stage",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 14,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ChangeCaptureLifecycleRequest
 */ export class ChangeCaptureLifecycleRequest extends Message {
    static fromBinary(bytes, options) {
        return new ChangeCaptureLifecycleRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ChangeCaptureLifecycleRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ChangeCaptureLifecycleRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ChangeCaptureLifecycleRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string company_id = 2;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string request_id = 4;
   */ _define_property(this, "requestId", ""), /**
   * @generated from field: int64 expected_revision = 5;
   */ _define_property(this, "expectedRevision", protoInt64.zero), /**
   * park|close|resume|record_outcome
   *
   * @generated from field: string action = 6;
   */ _define_property(this, "action", ""), /**
   * required for every action
   *
   * @generated from field: string reason = 7;
   */ _define_property(this, "reason", ""), /**
   * optional, park/close only
   *
   * @generated from field: google.protobuf.Timestamp revisit_at = 8;
   */ _define_property(this, "revisitAt", void 0), /**
   * optional on close; required for record_outcome
   *
   * @generated from field: string outcome = 9;
   */ _define_property(this, "outcome", ""), /**
   * optional, park/close only
   *
   * @generated from field: repeated string pause_task_ids = 10;
   */ _define_property(this, "pauseTaskIds", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ChangeCaptureLifecycleRequest, "runtime", proto3);
_define_property(ChangeCaptureLifecycleRequest, "typeName", "mono.projectdata.v1.ChangeCaptureLifecycleRequest");
_define_property(ChangeCaptureLifecycleRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "expected_revision",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 6,
            name: "action",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "revisit_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "outcome",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "pause_task_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ChangeCaptureLifecycleResponse
 */ export class ChangeCaptureLifecycleResponse extends Message {
    static fromBinary(bytes, options) {
        return new ChangeCaptureLifecycleResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ChangeCaptureLifecycleResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ChangeCaptureLifecycleResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ChangeCaptureLifecycleResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.CaptureProjectSummary summary = 1;
   */ _define_property(this, "summary", void 0), /**
   * @generated from field: mono.projectdata.v1.CaptureLifecycleEvent event = 2;
   */ _define_property(this, "event", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ChangeCaptureLifecycleResponse, "runtime", proto3);
_define_property(ChangeCaptureLifecycleResponse, "typeName", "mono.projectdata.v1.ChangeCaptureLifecycleResponse");
_define_property(ChangeCaptureLifecycleResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "summary",
            kind: "message",
            T: CaptureProjectSummary
        },
        {
            no: 2,
            name: "event",
            kind: "message",
            T: CaptureLifecycleEvent
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListCaptureLifecycleEventsRequest
 */ export class ListCaptureLifecycleEventsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCaptureLifecycleEventsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCaptureLifecycleEventsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCaptureLifecycleEventsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCaptureLifecycleEventsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string company_id = 2;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCaptureLifecycleEventsRequest, "runtime", proto3);
_define_property(ListCaptureLifecycleEventsRequest, "typeName", "mono.projectdata.v1.ListCaptureLifecycleEventsRequest");
_define_property(ListCaptureLifecycleEventsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListCaptureLifecycleEventsResponse
 */ export class ListCaptureLifecycleEventsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCaptureLifecycleEventsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCaptureLifecycleEventsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCaptureLifecycleEventsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCaptureLifecycleEventsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.CaptureLifecycleEvent events = 1;
   */ _define_property(this, "events", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCaptureLifecycleEventsResponse, "runtime", proto3);
_define_property(ListCaptureLifecycleEventsResponse, "typeName", "mono.projectdata.v1.ListCaptureLifecycleEventsResponse");
_define_property(ListCaptureLifecycleEventsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "events",
            kind: "message",
            T: CaptureLifecycleEvent,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ReadProposalSolicitationReviewRequest
 */ export class ReadProposalSolicitationReviewRequest extends Message {
    static fromBinary(bytes, options) {
        return new ReadProposalSolicitationReviewRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReadProposalSolicitationReviewRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReadProposalSolicitationReviewRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReadProposalSolicitationReviewRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReadProposalSolicitationReviewRequest, "runtime", proto3);
_define_property(ReadProposalSolicitationReviewRequest, "typeName", "mono.projectdata.v1.ReadProposalSolicitationReviewRequest");
_define_property(ReadProposalSolicitationReviewRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.IssueProposalSolicitationVersionRequest
 */ export class IssueProposalSolicitationVersionRequest extends Message {
    static fromBinary(bytes, options) {
        return new IssueProposalSolicitationVersionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new IssueProposalSolicitationVersionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new IssueProposalSolicitationVersionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(IssueProposalSolicitationVersionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string attachment_id = 2;
   */ _define_property(this, "attachmentId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(IssueProposalSolicitationVersionRequest, "runtime", proto3);
_define_property(IssueProposalSolicitationVersionRequest, "typeName", "mono.projectdata.v1.IssueProposalSolicitationVersionRequest");
_define_property(IssueProposalSolicitationVersionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "attachment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RecordProposalSolicitationImpactRequest
 */ export class RecordProposalSolicitationImpactRequest extends Message {
    static fromBinary(bytes, options) {
        return new RecordProposalSolicitationImpactRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordProposalSolicitationImpactRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordProposalSolicitationImpactRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordProposalSolicitationImpactRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: mono.datagateway.v1.SolicitationImpact impact = 2;
   */ _define_property(this, "impact", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordProposalSolicitationImpactRequest, "runtime", proto3);
_define_property(RecordProposalSolicitationImpactRequest, "typeName", "mono.projectdata.v1.RecordProposalSolicitationImpactRequest");
_define_property(RecordProposalSolicitationImpactRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "impact",
            kind: "message",
            T: SolicitationImpact
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CaptureProposalMaterialReviewRequest
 */ export class CaptureProposalMaterialReviewRequest extends Message {
    static fromBinary(bytes, options) {
        return new CaptureProposalMaterialReviewRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureProposalMaterialReviewRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureProposalMaterialReviewRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureProposalMaterialReviewRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string version_id = 2;
   */ _define_property(this, "versionId", ""), /**
   * @generated from field: string material_kind = 3;
   */ _define_property(this, "materialKind", ""), /**
   * @generated from field: string material_id = 4;
   */ _define_property(this, "materialId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureProposalMaterialReviewRequest, "runtime", proto3);
_define_property(CaptureProposalMaterialReviewRequest, "typeName", "mono.projectdata.v1.CaptureProposalMaterialReviewRequest");
_define_property(CaptureProposalMaterialReviewRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "material_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "material_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListMyProposalAssignedActionsRequest
 */ export class ListMyProposalAssignedActionsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListMyProposalAssignedActionsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListMyProposalAssignedActionsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListMyProposalAssignedActionsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListMyProposalAssignedActionsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * Defaults to 50, capped at 200. Ordered by date (null last), role, identity.
   *
   * @generated from field: int32 limit = 2;
   */ _define_property(this, "limit", 0), /**
   * @generated from field: int32 offset = 3;
   */ _define_property(this, "offset", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListMyProposalAssignedActionsRequest, "runtime", proto3);
_define_property(ListMyProposalAssignedActionsRequest, "typeName", "mono.projectdata.v1.ListMyProposalAssignedActionsRequest");
_define_property(ListMyProposalAssignedActionsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListMyProposalAssignedActionsResponse
 */ export class ListMyProposalAssignedActionsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListMyProposalAssignedActionsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListMyProposalAssignedActionsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListMyProposalAssignedActionsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListMyProposalAssignedActionsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.AssignedAction actions = 1;
   */ _define_property(this, "actions", []), /**
   * @generated from field: bool has_more = 2;
   */ _define_property(this, "hasMore", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListMyProposalAssignedActionsResponse, "runtime", proto3);
_define_property(ListMyProposalAssignedActionsResponse, "typeName", "mono.projectdata.v1.ListMyProposalAssignedActionsResponse");
_define_property(ListMyProposalAssignedActionsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "actions",
            kind: "message",
            T: AssignedAction,
            repeated: true
        },
        {
            no: 2,
            name: "has_more",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * Submit every current project volume exactly once. Reload and retry on a
 * concurrent create/delete InvalidArgument. Identical retries are idempotent.
 *
 * @generated from message mono.projectdata.v1.ReorderProposalVolumesRequest
 */ export class ReorderProposalVolumesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ReorderProposalVolumesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReorderProposalVolumesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReorderProposalVolumesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReorderProposalVolumesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: repeated string volume_ids = 2;
   */ _define_property(this, "volumeIds", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReorderProposalVolumesRequest, "runtime", proto3);
_define_property(ReorderProposalVolumesRequest, "typeName", "mono.projectdata.v1.ReorderProposalVolumesRequest");
_define_property(ReorderProposalVolumesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "volume_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ReorderProposalVolumesResponse
 */ export class ReorderProposalVolumesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ReorderProposalVolumesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReorderProposalVolumesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReorderProposalVolumesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReorderProposalVolumesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.ProjectVolume volumes = 1;
   */ _define_property(this, "volumes", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReorderProposalVolumesResponse, "runtime", proto3);
_define_property(ReorderProposalVolumesResponse, "typeName", "mono.projectdata.v1.ReorderProposalVolumesResponse");
_define_property(ReorderProposalVolumesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "volumes",
            kind: "message",
            T: ProjectVolume,
            repeated: true
        }
    ]));
/**
 * Meeting context is independent of registry identity and grants no permission.
 *
 * @generated from message mono.projectdata.v1.TouchpointAttendeeContext
 */ export class TouchpointAttendeeContext extends Message {
    static fromBinary(bytes, options) {
        return new TouchpointAttendeeContext().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TouchpointAttendeeContext().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TouchpointAttendeeContext().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TouchpointAttendeeContext, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string attendee_id = 1;
   */ _define_property(this, "attendeeId", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string organization = 3;
   */ _define_property(this, "organization", ""), /**
   * @generated from field: string role = 4;
   */ _define_property(this, "role", ""), /**
   * customer|internal|partner, or unspecified
   *
   * @generated from field: string kind = 5;
   */ _define_property(this, "kind", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(TouchpointAttendeeContext, "runtime", proto3);
_define_property(TouchpointAttendeeContext, "typeName", "mono.projectdata.v1.TouchpointAttendeeContext");
_define_property(TouchpointAttendeeContext, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "attendee_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "organization",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.TouchpointParticipant
 */ export class TouchpointParticipant extends Message {
    static fromBinary(bytes, options) {
        return new TouchpointParticipant().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TouchpointParticipant().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TouchpointParticipant().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TouchpointParticipant, a, b);
    }
    constructor(data){
        super(), /**
   * Stable client-minted UUID for adds; existing row ID for resolution.
   *
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * Existing canonical Person only; empty leaves this attendee unresolved.
   *
   * @generated from field: string contact_id = 2;
   */ _define_property(this, "contactId", ""), /**
   * @generated from field: string attendee_name = 3;
   */ _define_property(this, "attendeeName", ""), /**
   * @generated from field: string organization = 4;
   */ _define_property(this, "organization", ""), /**
   * @generated from field: string participant_role = 5;
   */ _define_property(this, "participantRole", ""), /**
   * @generated from field: string participation_kind = 6;
   */ _define_property(this, "participationKind", ""), /**
   * Read-only immutable contexts; combines originals on duplicate resolution.
   *
   * @generated from field: repeated mono.projectdata.v1.TouchpointAttendeeContext original_contexts = 7;
   */ _define_property(this, "originalContexts", []), /**
   * GRW-37: request-only strong id. zou passes it into the REG-54 observation
   * (an email links or creates with no prompt) and never persists it.
   *
   * @generated from field: string email = 8;
   */ _define_property(this, "email", ""), /**
   * GRW-37: the open REG-54 candidate while the attendee is unresolved.
   *
   * @generated from field: string registry_candidate_id = 9;
   */ _define_property(this, "registryCandidateId", ""), /**
   * GRW-37 (response): MATCHED | CREATED | CANDIDATE | AMBIGUOUS | UNRESOLVED.
   *
   * @generated from field: string resolution_status = 10;
   */ _define_property(this, "resolutionStatus", ""), /**
   * GRW-37 (response): ≤ 5 registry options for an unresolved attendee.
   *
   * @generated from field: repeated mono.projectdata.v1.EntityCandidateView candidates = 11;
   */ _define_property(this, "candidates", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(TouchpointParticipant, "runtime", proto3);
_define_property(TouchpointParticipant, "typeName", "mono.projectdata.v1.TouchpointParticipant");
_define_property(TouchpointParticipant, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "attendee_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "organization",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "participant_role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "participation_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "original_contexts",
            kind: "message",
            T: TouchpointAttendeeContext,
            repeated: true
        },
        {
            no: 8,
            name: "email",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "registry_candidate_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "resolution_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "candidates",
            kind: "message",
            T: EntityCandidateView,
            repeated: true
        }
    ]));
/**
 * Browser facades accept no tenant, actor or timestamp; all are server-derived.
 *
 * @generated from message mono.projectdata.v1.ReadProposalComplianceCoverageRequest
 */ export class ReadProposalComplianceCoverageRequest extends Message {
    static fromBinary(bytes, options) {
        return new ReadProposalComplianceCoverageRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReadProposalComplianceCoverageRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReadProposalComplianceCoverageRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReadProposalComplianceCoverageRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReadProposalComplianceCoverageRequest, "runtime", proto3);
_define_property(ReadProposalComplianceCoverageRequest, "typeName", "mono.projectdata.v1.ReadProposalComplianceCoverageRequest");
_define_property(ReadProposalComplianceCoverageRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.MapProposalComplianceCoverageRequest
 */ export class MapProposalComplianceCoverageRequest extends Message {
    static fromBinary(bytes, options) {
        return new MapProposalComplianceCoverageRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MapProposalComplianceCoverageRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MapProposalComplianceCoverageRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MapProposalComplianceCoverageRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string version_id = 2;
   */ _define_property(this, "versionId", ""), /**
   * @generated from field: string requirement_id = 3;
   */ _define_property(this, "requirementId", ""), /**
   * @generated from field: int64 expected_revision = 4;
   */ _define_property(this, "expectedRevision", protoInt64.zero), /**
   * @generated from field: repeated mono.datagateway.v1.ComplianceResponseLocation locations = 5;
   */ _define_property(this, "locations", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(MapProposalComplianceCoverageRequest, "runtime", proto3);
_define_property(MapProposalComplianceCoverageRequest, "typeName", "mono.projectdata.v1.MapProposalComplianceCoverageRequest");
_define_property(MapProposalComplianceCoverageRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "requirement_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "expected_revision",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 5,
            name: "locations",
            kind: "message",
            T: ComplianceResponseLocation,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ConfirmProposalComplianceCoverageRequest
 */ export class ConfirmProposalComplianceCoverageRequest extends Message {
    static fromBinary(bytes, options) {
        return new ConfirmProposalComplianceCoverageRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ConfirmProposalComplianceCoverageRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ConfirmProposalComplianceCoverageRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ConfirmProposalComplianceCoverageRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string version_id = 2;
   */ _define_property(this, "versionId", ""), /**
   * @generated from field: string requirement_id = 3;
   */ _define_property(this, "requirementId", ""), /**
   * @generated from field: int64 expected_revision = 4;
   */ _define_property(this, "expectedRevision", protoInt64.zero), /**
   * @generated from field: string substantive_state = 5;
   */ _define_property(this, "substantiveState", ""), /**
   * @generated from field: string evidence = 6;
   */ _define_property(this, "evidence", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ConfirmProposalComplianceCoverageRequest, "runtime", proto3);
_define_property(ConfirmProposalComplianceCoverageRequest, "typeName", "mono.projectdata.v1.ConfirmProposalComplianceCoverageRequest");
_define_property(ConfirmProposalComplianceCoverageRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "requirement_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "expected_revision",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 5,
            name: "substantive_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "evidence",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetLandscapePatternStateRequest
 */ export class GetLandscapePatternStateRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetLandscapePatternStateRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetLandscapePatternStateRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetLandscapePatternStateRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetLandscapePatternStateRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string landscape_id = 1;
   */ _define_property(this, "landscapeId", ""), /**
   * @generated from field: string pattern_key = 2;
   */ _define_property(this, "patternKey", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetLandscapePatternStateRequest, "runtime", proto3);
_define_property(GetLandscapePatternStateRequest, "typeName", "mono.projectdata.v1.GetLandscapePatternStateRequest");
_define_property(GetLandscapePatternStateRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "landscape_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "pattern_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SaveLandscapePatternStateRequest
 */ export class SaveLandscapePatternStateRequest extends Message {
    static fromBinary(bytes, options) {
        return new SaveLandscapePatternStateRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveLandscapePatternStateRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveLandscapePatternStateRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveLandscapePatternStateRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string landscape_id = 1;
   */ _define_property(this, "landscapeId", ""), /**
   * @generated from field: mono.datagateway.v1.LandscapePatternState state = 2;
   */ _define_property(this, "state", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveLandscapePatternStateRequest, "runtime", proto3);
_define_property(SaveLandscapePatternStateRequest, "typeName", "mono.projectdata.v1.SaveLandscapePatternStateRequest");
_define_property(SaveLandscapePatternStateRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "landscape_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "state",
            kind: "message",
            T: LandscapePatternState
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetLandscapePatternStateResponse
 */ export class GetLandscapePatternStateResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetLandscapePatternStateResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetLandscapePatternStateResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetLandscapePatternStateResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetLandscapePatternStateResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.LandscapePatternState state = 1;
   */ _define_property(this, "state", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetLandscapePatternStateResponse, "runtime", proto3);
_define_property(GetLandscapePatternStateResponse, "typeName", "mono.projectdata.v1.GetLandscapePatternStateResponse");
_define_property(GetLandscapePatternStateResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "state",
            kind: "message",
            T: LandscapePatternState
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SaveLandscapePatternStateResponse
 */ export class SaveLandscapePatternStateResponse extends Message {
    static fromBinary(bytes, options) {
        return new SaveLandscapePatternStateResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveLandscapePatternStateResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveLandscapePatternStateResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveLandscapePatternStateResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.LandscapePatternState state = 1;
   */ _define_property(this, "state", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveLandscapePatternStateResponse, "runtime", proto3);
_define_property(SaveLandscapePatternStateResponse, "typeName", "mono.projectdata.v1.SaveLandscapePatternStateResponse");
_define_property(SaveLandscapePatternStateResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "state",
            kind: "message",
            T: LandscapePatternState
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListPursuitStakeholdersRequest
 */ export class ListPursuitStakeholdersRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListPursuitStakeholdersRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPursuitStakeholdersRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPursuitStakeholdersRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPursuitStakeholdersRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 3;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListPursuitStakeholdersRequest, "runtime", proto3);
_define_property(ListPursuitStakeholdersRequest, "typeName", "mono.projectdata.v1.ListPursuitStakeholdersRequest");
_define_property(ListPursuitStakeholdersRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListPursuitStakeholdersResponse
 */ export class ListPursuitStakeholdersResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListPursuitStakeholdersResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPursuitStakeholdersResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPursuitStakeholdersResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPursuitStakeholdersResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.PursuitStakeholderView stakeholders = 1;
   */ _define_property(this, "stakeholders", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListPursuitStakeholdersResponse, "runtime", proto3);
_define_property(ListPursuitStakeholdersResponse, "typeName", "mono.projectdata.v1.ListPursuitStakeholdersResponse");
_define_property(ListPursuitStakeholdersResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "stakeholders",
            kind: "message",
            T: PursuitStakeholderView,
            repeated: true
        }
    ]));
/**
 * Server-owned journal of standalone Pursuit role changes; independent of assessments.
 *
 * @generated from message mono.projectdata.v1.StakeholderRoleChange
 */ export class StakeholderRoleChange extends Message {
    static fromBinary(bytes, options) {
        return new StakeholderRoleChange().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StakeholderRoleChange().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StakeholderRoleChange().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StakeholderRoleChange, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string previous_role = 1;
   */ _define_property(this, "previousRole", ""), /**
   * @generated from field: string new_role = 2;
   */ _define_property(this, "newRole", ""), /**
   * @generated from field: google.protobuf.Timestamp changed_at = 3;
   */ _define_property(this, "changedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(StakeholderRoleChange, "runtime", proto3);
_define_property(StakeholderRoleChange, "typeName", "mono.projectdata.v1.StakeholderRoleChange");
_define_property(StakeholderRoleChange, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "previous_role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "new_role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "changed_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * One live recompete link, as a pursuit reader sees it. Only links whose
 * program the caller may read are ever returned.
 *
 * @generated from message mono.projectdata.v1.PursuitRecompeteView
 */ export class PursuitRecompeteView extends Message {
    static fromBinary(bytes, options) {
        return new PursuitRecompeteView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PursuitRecompeteView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PursuitRecompeteView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PursuitRecompeteView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string link_id = 1;
   */ _define_property(this, "linkId", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string program_id = 3;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string program_label = 4;
   */ _define_property(this, "programLabel", ""), /**
   * @generated from field: string contract_number = 5;
   */ _define_property(this, "contractNumber", ""), /**
   * YYYY-MM-DD or ""
   *
   * @generated from field: string ultimate_end = 6;
   */ _define_property(this, "ultimateEnd", ""), /**
   * @generated from field: string opened_from = 7;
   */ _define_property(this, "openedFrom", ""), /**
   * RFC3339
   *
   * @generated from field: string created_at = 8;
   */ _define_property(this, "createdAt", ""), /**
   * /delivery/programs/{program_id}
   *
   * @generated from field: string href = 9;
   */ _define_property(this, "href", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PursuitRecompeteView, "runtime", proto3);
_define_property(PursuitRecompeteView, "typeName", "mono.projectdata.v1.PursuitRecompeteView");
_define_property(PursuitRecompeteView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "link_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "program_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "contract_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "ultimate_end",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "opened_from",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "created_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "href",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.LinkPursuitRecompeteRequest
 */ export class LinkPursuitRecompeteRequest extends Message {
    static fromBinary(bytes, options) {
        return new LinkPursuitRecompeteRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LinkPursuitRecompeteRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LinkPursuitRecompeteRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LinkPursuitRecompeteRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string request_id = 3;
   */ _define_property(this, "requestId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LinkPursuitRecompeteRequest, "runtime", proto3);
_define_property(LinkPursuitRecompeteRequest, "typeName", "mono.projectdata.v1.LinkPursuitRecompeteRequest");
_define_property(LinkPursuitRecompeteRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.LinkPursuitRecompeteResponse
 */ export class LinkPursuitRecompeteResponse extends Message {
    static fromBinary(bytes, options) {
        return new LinkPursuitRecompeteResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LinkPursuitRecompeteResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LinkPursuitRecompeteResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LinkPursuitRecompeteResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.PursuitRecompeteView recompete = 1;
   */ _define_property(this, "recompete", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(LinkPursuitRecompeteResponse, "runtime", proto3);
_define_property(LinkPursuitRecompeteResponse, "typeName", "mono.projectdata.v1.LinkPursuitRecompeteResponse");
_define_property(LinkPursuitRecompeteResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "recompete",
            kind: "message",
            T: PursuitRecompeteView
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UnlinkPursuitRecompeteRequest
 */ export class UnlinkPursuitRecompeteRequest extends Message {
    static fromBinary(bytes, options) {
        return new UnlinkPursuitRecompeteRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UnlinkPursuitRecompeteRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UnlinkPursuitRecompeteRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UnlinkPursuitRecompeteRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string link_id = 2;
   */ _define_property(this, "linkId", ""), /**
   * @generated from field: string reason = 3;
   */ _define_property(this, "reason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UnlinkPursuitRecompeteRequest, "runtime", proto3);
_define_property(UnlinkPursuitRecompeteRequest, "typeName", "mono.projectdata.v1.UnlinkPursuitRecompeteRequest");
_define_property(UnlinkPursuitRecompeteRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "link_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UnlinkPursuitRecompeteResponse
 */ export class UnlinkPursuitRecompeteResponse extends Message {
    static fromBinary(bytes, options) {
        return new UnlinkPursuitRecompeteResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UnlinkPursuitRecompeteResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UnlinkPursuitRecompeteResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UnlinkPursuitRecompeteResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(UnlinkPursuitRecompeteResponse, "runtime", proto3);
_define_property(UnlinkPursuitRecompeteResponse, "typeName", "mono.projectdata.v1.UnlinkPursuitRecompeteResponse");
_define_property(UnlinkPursuitRecompeteResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.projectdata.v1.ListPursuitRecompetesRequest
 */ export class ListPursuitRecompetesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListPursuitRecompetesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPursuitRecompetesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPursuitRecompetesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPursuitRecompetesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListPursuitRecompetesRequest, "runtime", proto3);
_define_property(ListPursuitRecompetesRequest, "typeName", "mono.projectdata.v1.ListPursuitRecompetesRequest");
_define_property(ListPursuitRecompetesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListPursuitRecompetesResponse
 */ export class ListPursuitRecompetesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListPursuitRecompetesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPursuitRecompetesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPursuitRecompetesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPursuitRecompetesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.PursuitRecompeteView recompetes = 1;
   */ _define_property(this, "recompetes", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListPursuitRecompetesResponse, "runtime", proto3);
_define_property(ListPursuitRecompetesResponse, "typeName", "mono.projectdata.v1.ListPursuitRecompetesResponse");
_define_property(ListPursuitRecompetesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "recompetes",
            kind: "message",
            T: PursuitRecompeteView,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.OpenRecompetePursuitRequest
 */ export class OpenRecompetePursuitRequest extends Message {
    static fromBinary(bytes, options) {
        return new OpenRecompetePursuitRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OpenRecompetePursuitRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OpenRecompetePursuitRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OpenRecompetePursuitRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * defaults to "<program label> Recompete"
   *
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string request_id = 3;
   */ _define_property(this, "requestId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(OpenRecompetePursuitRequest, "runtime", proto3);
_define_property(OpenRecompetePursuitRequest, "typeName", "mono.projectdata.v1.OpenRecompetePursuitRequest");
_define_property(OpenRecompetePursuitRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.OpenRecompetePursuitResponse
 */ export class OpenRecompetePursuitResponse extends Message {
    static fromBinary(bytes, options) {
        return new OpenRecompetePursuitResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OpenRecompetePursuitResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OpenRecompetePursuitResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OpenRecompetePursuitResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: mono.projectdata.v1.PursuitRecompeteView recompete = 2;
   */ _define_property(this, "recompete", void 0), /**
   * @generated from field: bool created = 3;
   */ _define_property(this, "created", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(OpenRecompetePursuitResponse, "runtime", proto3);
_define_property(OpenRecompetePursuitResponse, "typeName", "mono.projectdata.v1.OpenRecompetePursuitResponse");
_define_property(OpenRecompetePursuitResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "recompete",
            kind: "message",
            T: PursuitRecompeteView
        },
        {
            no: 3,
            name: "created",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SetPursuitGrowthHintRequest
 */ export class SetPursuitGrowthHintRequest extends Message {
    static fromBinary(bytes, options) {
        return new SetPursuitGrowthHintRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetPursuitGrowthHintRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetPursuitGrowthHintRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetPursuitGrowthHintRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: bool show_growth_hint_to_delivery = 2;
   */ _define_property(this, "showGrowthHintToDelivery", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetPursuitGrowthHintRequest, "runtime", proto3);
_define_property(SetPursuitGrowthHintRequest, "typeName", "mono.projectdata.v1.SetPursuitGrowthHintRequest");
_define_property(SetPursuitGrowthHintRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "show_growth_hint_to_delivery",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SetPursuitGrowthHintResponse
 */ export class SetPursuitGrowthHintResponse extends Message {
    static fromBinary(bytes, options) {
        return new SetPursuitGrowthHintResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetPursuitGrowthHintResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetPursuitGrowthHintResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetPursuitGrowthHintResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bool show_growth_hint_to_delivery = 1;
   */ _define_property(this, "showGrowthHintToDelivery", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetPursuitGrowthHintResponse, "runtime", proto3);
_define_property(SetPursuitGrowthHintResponse, "typeName", "mono.projectdata.v1.SetPursuitGrowthHintResponse");
_define_property(SetPursuitGrowthHintResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "show_growth_hint_to_delivery",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * ---- GRW-06 (SAD-1124): RFP expected on the canonical opportunity ---------
 *
 * @generated from message mono.projectdata.v1.SetOpportunityRfpExpectedRequest
 */ export class SetOpportunityRfpExpectedRequest extends Message {
    static fromBinary(bytes, options) {
        return new SetOpportunityRfpExpectedRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetOpportunityRfpExpectedRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetOpportunityRfpExpectedRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetOpportunityRfpExpectedRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string opportunity_id = 2;
   */ _define_property(this, "opportunityId", ""), /**
   * YYYY-MM-DD, or "" to clear
   *
   * @generated from field: string rfp_expected_on = 3;
   */ _define_property(this, "rfpExpectedOn", ""), /**
   * customer_said | agency_forecast | notice | our_estimate
   *
   * @generated from field: string basis = 4;
   */ _define_property(this, "basis", ""), /**
   * @generated from field: string note = 5;
   */ _define_property(this, "note", ""), /**
   * @generated from field: int32 expected_version = 6;
   */ _define_property(this, "expectedVersion", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetOpportunityRfpExpectedRequest, "runtime", proto3);
_define_property(SetOpportunityRfpExpectedRequest, "typeName", "mono.projectdata.v1.SetOpportunityRfpExpectedRequest");
_define_property(SetOpportunityRfpExpectedRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "rfp_expected_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "expected_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SetOpportunityRfpExpectedResponse
 */ export class SetOpportunityRfpExpectedResponse extends Message {
    static fromBinary(bytes, options) {
        return new SetOpportunityRfpExpectedResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetOpportunityRfpExpectedResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetOpportunityRfpExpectedResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetOpportunityRfpExpectedResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.OpportunityRfpExpected value = 1;
   */ _define_property(this, "value", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetOpportunityRfpExpectedResponse, "runtime", proto3);
_define_property(SetOpportunityRfpExpectedResponse, "typeName", "mono.projectdata.v1.SetOpportunityRfpExpectedResponse");
_define_property(SetOpportunityRfpExpectedResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "value",
            kind: "message",
            T: OpportunityRfpExpected
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.OpportunityRfpExpected
 */ export class OpportunityRfpExpected extends Message {
    static fromBinary(bytes, options) {
        return new OpportunityRfpExpected().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OpportunityRfpExpected().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OpportunityRfpExpected().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OpportunityRfpExpected, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string opportunity_id = 1;
   */ _define_property(this, "opportunityId", ""), /**
   * YYYY-MM-DD or "" when unset
   *
   * @generated from field: string rfp_expected_on = 2;
   */ _define_property(this, "rfpExpectedOn", ""), /**
   * @generated from field: string basis = 3;
   */ _define_property(this, "basis", ""), /**
   * @generated from field: string note = 4;
   */ _define_property(this, "note", ""), /**
   * @generated from field: string set_by = 5;
   */ _define_property(this, "setBy", ""), /**
   * RFC3339 or ""
   *
   * @generated from field: string set_at = 6;
   */ _define_property(this, "setAt", ""), /**
   * 0 = never set
   *
   * @generated from field: int32 version = 7;
   */ _define_property(this, "version", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(OpportunityRfpExpected, "runtime", proto3);
_define_property(OpportunityRfpExpected, "typeName", "mono.projectdata.v1.OpportunityRfpExpected");
_define_property(OpportunityRfpExpected, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "rfp_expected_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "set_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "set_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
